{
  "reporting.title": "Custom Data Export",
  "reporting.description": "Choose your report, reporting period and columns, then download a spreadsheet-ready CSV.",
  "reporting.builder": "Back to report builder",
  "reporting.queue": "My Report Queue",
  "reporting.queueEmpty": "Your generated reports will appear here.",
  "reporting.design.emptyQueuePage": "There are no reports on this page.",
  "reporting.design.firstQueuePage": "Return to the first page",
  "reporting.reportType": "Report type",
  "reporting.layout": "CSV layout",
  "reporting.layout.SPREADSHEET": "Spreadsheet — tests in columns",
  "reporting.layout.RESULT_LIST": "Detailed list — results in rows",
  "reporting.layout.TABLE": "Table",
  "reporting.meaning.SPREADSHEET": "Tests appear as columns for each specimen. Repeated results use extra rows; unrelated repeat readings are kept separate.",
  "reporting.meaning.RESULT_LIST": "Each independent result appears on its own row. Repeated results are preserved.",
  "reporting.meaning.TABLE": "Each recorded occurrence appears on its own row.",
  "reporting.dateFrom": "Date from",
  "reporting.dateTo": "Date to",
  "reporting.dates.required": "Required",
  "reporting.dates.requiredFrom": "Choose a start date.",
  "reporting.dates.requiredTo": "Choose an end date.",
  "reporting.dates.invalid": "Choose a valid calendar date.",
  "reporting.dates.reversed": "End date must be on or after the start date.",
  "reporting.dates.tooLong": "Choose a period of {days} days or fewer, including both dates.",
  "reporting.dates.range": "Choose an ordered period within the maximum shown above.",
  "reporting.periodHelp": "Uses {dateMeaning} in {timezone}, including both dates. Maximum period: {days} days.",
  "reporting.dateAnchor.collectionDate": "specimen collection dates",
  "reporting.dateAnchor.requestDate": "referral request dates",
  "reporting.dateAnchor.sentDate": "referral sent dates",
  "reporting.dateAnchor.eventOrRecordedDate": "event dates when known, otherwise recorded dates (identified by Date Basis)",
  "reporting.dateAnchor.dateOfEvent": "non-conformance event dates",
  "reporting.dateAnchor.enteredDate": "recorded rejection dates",
  "reporting.labSections": "Lab sections",
  "reporting.allAccessibleSections": "All accessible lab sections",
  "reporting.tests": "检测项目",
  "reporting.allTests": "All tests",
  "reporting.resultStatuses": "Result statuses",
  "reporting.finalized": "最终确定",
  "reporting.all": "所有分析仪",
  "reporting.available": "Available columns",
  "reporting.search": "Search columns",
  "reporting.selected": "Selected columns",
  "reporting.selectedCount": "Selected columns ({count})",
  "reporting.group.sample": "Sample and order",
  "reporting.group.referrals": "转诊",
  "reporting.group.nonConformance": "Non-Conformance / Rejections",
  "reporting.group.patient": "患者",
  "reporting.group.result": "Result details",
  "reporting.group.tests": "Configured tests",
  "reporting.group.components": "Configured result components",
  "reporting.group.turnaround": "Turnaround time",
  "reporting.group.testTurnaround": "Turnaround by test",
  "reporting.group.componentTurnaround": "Turnaround by result component",
  "reporting.group.observations": "Additional questions",
  "reporting.headerPreview": "CSV header preview",
  "reporting.moveUp": "Move {field} up",
  "reporting.moveDown": "Move {field} down",
  "reporting.remove": "Remove {field}",
  "reporting.position": "{field}: position {position} of {count}",
  "reporting.review": "Review report",
  "reporting.edit": "Edit report",
  "reporting.generate": "生成 CSV",
  "reporting.submitting": "Submitting report…",
  "reporting.generating": "Preparing your CSV…",
  "reporting.download": "Download CSV",
  "reporting.loading": "Loading report options…",
  "reporting.currentReport": "Your current report",
  "reporting.previous": "上一个",
  "reporting.next": "下一个",
  "reporting.rows": "{count, plural, one {# row} other {# rows}}",
  "reporting.state.QUEUED": "Queued",
  "reporting.state.GENERATING": "Generating",
  "reporting.state.READY": "Ready to download",
  "reporting.state.FAILED": "失败数量",
  "reporting.state.EXPIRED": "已过期",
  "reporting.state.CANCELLED": "已取消",
  "reporting.loadError": "Could not load reporting information",
  "reporting.submitError": "Could not generate the report",
  "reporting.requestError": "The request could not be completed. Your choices have been retained; try again.",
  "reporting.networkError": "The server could not be reached. Your choices have been retained; try again.",
  "reporting.request.invalid": "Check your reporting period, filters and selected columns, then try again.",
  "reporting.request.conflict": "This submission identifier was already used for different report choices. Start a new report.",
  "reporting.columns.stale": "Some selected columns are no longer available. Remove them and choose from the current catalog.",
  "reporting.jobs.limit": "You have reached the active-report limit. Wait for a report to finish, then try again.",
  "reporting.access.denied": "Your current OpenELIS access does not permit this report.",
  "reporting.access.scopeChanged": "Your access to the selected lab sections has changed. Review the report with your current access.",
  "reporting.access.noSections": "No accessible lab sections are available for this report.",
  "reporting.access.signIn": "Sign in to OpenELIS to continue.",
  "reporting.definition.changed": "The report definition has changed. Review the current report options before running again.",
  "reporting.definition.unavailable": "This report type is no longer available.",
  "reporting.tests.stale": "Some selected tests are no longer available. Review your test selection.",
  "reporting.status.invalid": "Choose an available result status.",
  "reporting.filters.unsupported": "Some requested filters are unavailable for this report. Review the current report options.",
  "reporting.filters.unavailable": "Some previous filters are unavailable for this report. Review the current filters before generating.",
  "reporting.job.generationFailed": "The CSV could not be generated. Your report request has been retained.",
  "reporting.job.expired": "This file has expired. Run the report again with a new reporting period.",
  "reporting.job.notReady": "This report is not ready to download yet.",
  "reporting.job.notFound": "This report could not be found.",
  "reporting.saved.library": "Shared reports",
  "reporting.saved.search": "Search shared reports",
  "reporting.saved.loading": "Loading shared reports…",
  "reporting.saved.loadError": "Could not load shared reports",
  "reporting.saved.empty": "No shared reports have been saved yet.",
  "reporting.saved.shared": "Available to everyone who can use reports.",
  "reporting.saved.open": "待处理",
  "reporting.saved.save": "Save report",
  "reporting.saved.update": "Update shared report",
  "reporting.saved.copy": "Save a copy",
  "reporting.saved.delete": "Delete shared report",
  "reporting.saved.name": "Report name",
  "reporting.saved.confirmSave": "Save shared report",
  "reporting.saved.confirmDelete": "删除",
  "reporting.saved.confirmUpdate": "更新",
  "reporting.saved.cancel": "取消",
  "reporting.saved.copyName": "{name} 的副本",
  "reporting.saved.created": "Saved as {name}.",
  "reporting.saved.updated": "Updated {name}.",
  "reporting.saved.freshDates": "Choose fresh dates before running this report.",
  "reporting.saved.deleteHelp": "Delete {name} from the shared report library? Existing generated files are retained.",
  "reporting.saved.updateHelp": "Replace {name} with the choices currently shown in the builder?",
  "reporting.saved.changed": "Someone changed this shared report after you opened it. Your choices are still here; reopen the current saved report or save a copy.",
  "reporting.saved.invalid": "Review the report choices before saving.",
  "reporting.saved.nameInvalid": "Enter a report name of 200 characters or fewer.",
  "reporting.saved.notFound": "This shared report is no longer available.",
  "reporting.saved.pageInvalid": "The shared report list request was invalid.",
  "accept.action.button": "接受",
  "accessDenied.message": "您无权访问此模块，请联系系统管理员",
  "accessDenied.okButton": "确定",
  "accessDenied.title": "访问被拒绝",
  "accession.entry": "订单号录入",
  "activityReportByPanel": "按检测组别统计活动报告",
  "activityReportByTest": "按检测项目统计活动报告",
  "activityReportByTestSection": "按检测科室统计活动报告",
  "add.age.range": "添加另一个年龄范围 +",
  "add.aliquot": "添加分装样本",
  "add.new.dictionary.menu": "添加新字典菜单",
  "address.search.label": "快速地址搜索",
  "adjustment.button": "调整数量",
  "adjustment.newQuantity": "新数量",
  "adjustment.notes": "备注",
  "adjustment.notes.placeholder": "提供关于此调整的详细信息",
  "adjustment.reason": "调整原因",
  "adjustment.reason.select": "选择原因",
  "adjustment.success": "批次数量调整成功",
  "adjustment.title": "调整批次数量",
  "admin.dashboard.subtitle": "选择一个管理区域来配置 OpenELIS。",
  "admin.dashboard.title": "管理仪表板",
  "admin.formEntryConfig": "通用配置",
  "admin.programs.title": "计划",
  "admin.programs.subtitle": "The initiatives that orders are filed under — each with a domain, one or more lab units, and an optional order-entry questionnaire.",
  "admin.programs.add": "添加计划",
  "admin.programs.search": "Search by name",
  "admin.programs.selector.new": "新程序",
  "admin.programs.row.expand.aria": "Edit program",
  "admin.programs.row.actions.aria": "Program actions",
  "admin.programs.list.column.name": "名称",
  "admin.programs.list.column.domain": "域名",
  "admin.programs.list.column.active": "状态",
  "admin.programs.list.column.units": "Lab unit(s)",
  "admin.programs.list.status.active": "活跃",
  "admin.programs.list.status.inactive": "非活跃",
  "admin.programs.list.filter.domain.label": "域名",
  "admin.programs.list.filter.domain.all": "所有域名",
  "admin.programs.list.toggle.showDeactivated": "显示已停用",
  "admin.programs.action.deactivate": "停用",
  "admin.programs.action.reactivate": "重新激活",
  "admin.programs.deactivate.modal.title": "Deactivate this Program?",
  "admin.programs.deactivate.modal.body.noOrders": "\"{programName}\" has no orders and will simply stop appearing for new orders. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.confirm": "停用",
  "admin.programs.deactivate.modal.cancel": "取消",
  "admin.programs.reactivate.success": "{programName} reactivated",
  "admin.programs.deactivate.success": "{programName} deactivated",
  "admin.programs.domain.confirm.heading": "Change Program Domain?",
  "admin.programs.domain.confirm.body": "Historical orders were evaluated against the {from} domain's rules. Changing to {to} is forward-looking: existing orders keep their program coding and are not re-coded, and the program will only be offered on {to} orders from now on.",
  "admin.programs.list.empty": "No programs match the current search and filters.",
  "admin.programs.basicInfo.labUnits.selectAll": "Select all",
  "admin.programs.basicInfo.labUnits.placeholder": "Type to filter lab units",
  "orderEntry.programPicker.empty": "No programs are currently active. An administrator can activate one under Admin › Programs.",
  "orderEntry.programPicker.empty.domain": "No {domain} programs are currently active. An administrator can activate one under Admin › Programs.",
  "admin.programs.basicInfo.programName.label": "项目名称",
  "admin.programs.basicInfo.programName.placeholder": "e.g. HBV Antenatal Screening",
  "admin.programs.basicInfo.code.label": "Programme Code",
  "admin.programs.basicInfo.code.placeholder": "e.g. HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "Use letters, digits, spaces, or underscores only.",
  "admin.programs.basicInfo.programName.tooLong": "Use at most {max} characters.",
  "admin.programs.basicInfo.labUnits.label": "Lab unit(s)",
  "admin.programs.basicInfo.domain.label": "域名",
  "admin.programs.basicInfo.domain.required": "必须填写域名",
  "admin.programs.editor.status.label": "Status:",
  "admin.programs.guidance.domain.toggle.show": "What does each Domain mean?",
  "admin.programs.guidance.domain.toggle.hide": "Hide",
  "admin.programs.guidance.domain.clinical": "Patient testing — form captures patient identifiers, provider, prior history.",
  "admin.programs.guidance.domain.environmental": "Compliance/surveillance sampling (water, food, air). No patient fields.",
  "admin.programs.guidance.domain.vector": "Specimen surveillance (mosquito, tick) — species, pool manifest.",
  "admin.programs.guidance.gui.emptyState.body": "No questions yet — add questions one at a time, or paste a Questionnaire in JSON mode.",
  "admin.programs.guidance.gui.emptyState.action": "Add First Question",
  "admin.programs.guidance.json.referenceCard.format": "Format: FHIR R4 Questionnaire",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "— allowed item.type: {allowed}.",
  "admin.programs.questionnaire.mode.visualBuilder": "Visual Builder",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "Question Text",
  "admin.programs.questionnaire.question.type.label": "Question Type",
  "admin.programs.questionnaire.question.addNew": "Add New Question",
  "admin.programs.questionnaire.question.actions.aria": "Question actions",
  "admin.programs.questionnaire.question.actions.delete": "Delete question",
  "admin.programs.questionnaire.answerOptions.section.title": "Answer options",
  "admin.programs.questionnaire.answerOptions.addOption": "添加选项",
  "admin.programs.questionnaire.answerOptions.deleteOption": "Delete option",
  "admin.programs.questionnaire.answerOptions.empty": "No options yet — add at least one so reception can pick a value.",
  "admin.programs.questionnaire.answerOptions.coded": "coded",
  "admin.programs.questionnaire.answerOptions.codedHelp": "Coded options come from a terminology and are shown read-only here. Edit them in JSON mode.",
  "admin.programs.questionnaire.preview.label": "示例",
  "admin.programs.questionnaire.preview.empty": "No questions yet — start adding questions to see the preview.",
  "admin.programs.questionnaire.preview.untitled": "(untitled)",
  "admin.programs.questionnaire.preview.boolean.example": "◯ Yes ◯ No",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "number",
  "admin.programs.questionnaire.preview.quantity.unit": "unit",
  "admin.programs.questionnaire.json.validate": "Validate JSON",
  "admin.programs.questionnaire.json.reformat": "Reformat",
  "admin.programs.questionnaire.json.validated": "Validated — {count} question(s)",
  "admin.programs.questionnaire.json.error.title": "Invalid Questionnaire",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType must be \"Questionnaire\"",
  "admin.programs.questionnaire.json.error.itemArray": "item must be an array",
  "admin.programs.questionnaire.json.error.itemShape": "each item must have linkId, text, and type in [{allowed}]",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "duplicate linkId \"{linkId}\" — each item must have a unique linkId",
  "admin.programs.guidance.json.referenceCard.advanced": "Advanced features (enableWhen, Quantity units via unit/unitOption, nested items) are edited here in JSON — the Visual Builder preserves them but does not surface them.",
  "admin.programs.basicInfo.domain.helper": "Controls where this program appears — reception only sees programs matching the order's domain.",
  "admin.programs.editor.status.noHardDelete": "No hard delete — deactivate preserves history.",
  "admin.programs.deactivate.modal.body": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. {orderCount, plural, one {Its # historical order keeps its program coding} other {Its # historical orders keep their program coding}} and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.body.unknownCount": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. Historical orders keep their program coding and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.questionnaire.question.unsupported": "This is a \"{type}\" item, which this builder does not edit. It is kept exactly as it is when you save. Edit it in JSON mode.",
  "admin.programs.questionnaire.question.type.boolean": "Yes / No",
  "admin.programs.questionnaire.question.type.choice": "Choice",
  "admin.programs.questionnaire.question.type.checkbox": "Checkbox",
  "admin.programs.questionnaire.question.type.integer": "Whole number",
  "admin.programs.questionnaire.question.type.decimal": "Decimal number",
  "admin.programs.questionnaire.question.type.date": "日期",
  "admin.programs.questionnaire.question.type.time": "时间",
  "admin.programs.questionnaire.question.type.string": "Short text",
  "admin.programs.questionnaire.question.type.text": "Long text",
  "admin.programs.questionnaire.question.type.quantity": "数量",
  "admin.programs.questionnaire.question.typeExample.boolean": "Yes/no answer. Example: \"First antenatal visit?\"",
  "admin.programs.questionnaire.question.typeExample.choice": "One option from a fixed list. Example: \"Specimen condition\".",
  "admin.programs.questionnaire.question.typeExample.checkbox": "Multiple options can be selected. Example: \"Symptoms present\".",
  "admin.programs.questionnaire.question.typeExample.integer": "Whole numbers only. Example: \"Gestational age (weeks)\".",
  "admin.programs.questionnaire.question.typeExample.decimal": "Numbers with decimals. Example: \"Maternal weight (kg)\".",
  "admin.programs.questionnaire.question.typeExample.date": "Calendar date. Example: \"Date of last menstrual period\".",
  "admin.programs.questionnaire.question.typeExample.time": "Time of day. Example: \"Time of sample collection\".",
  "admin.programs.questionnaire.question.typeExample.string": "Short free-text. Example: \"Provider name\".",
  "admin.programs.questionnaire.question.typeExample.text": "Long free-text. Example: \"Clinical notes\".",
  "admin.programs.questionnaire.question.typeExample.quantity": "A number plus a unit (e.g. \"Volume collected — 5 mL\"). The allowed unit(s) come from a FHIR extension set in JSON mode; a GUI-only Quantity accepts any unit.",
  "admin.config.logo.error.fileTooLarge": "图片太大。最大尺寸为 2MB。",
  "admin.config.logo.formats": "文件格式：JPG、PNG、GIF（最大2MB）",
  "admin.label": "管理",
  "admin.labUnit.basicInfo.domain.clinical": "临床",
  "admin.labUnit.basicInfo.domain.environmental": "环境",
  "admin.labUnit.basicInfo.domain.label": "域名",
  "admin.labUnit.basicInfo.domain.vector": "Vector",
  "admin.labUnit.domain.confirm.body": "历史订单/结果是根据原域的规则进行评估的。新订单将采用新域的规则。",
  "admin.labUnit.domain.confirm.heading": "更改实验室单元域？",
  "admin.labUnit.edit.select": "选择实验室单元",
  "admin.labUnit.edit.title": "编辑实验室单元域",
  "admin.labUnit.list.filter.domain": "按域名筛选",
  "admin.legacy": "传统管理",
  "button.back": "← 返回列表",
  "button.labUnit.add": "添加实验室单元",
  "button.labUnit.create": "创建实验室单元",
  "button.labUnit.creating": "创建中...",
  "button.labUnit.tests.assign": "分配检测",
  "button.labUnit.tests.assign.confirm": "Assign {count, plural, one {# test} other {# tests}}",
  "button.labUnit.tests.reassign": "重新分配已选择项（{count}）",
  "button.labUnit.tests.reassign.confirm": "Reassign {count, plural, one {# test} other {# tests}}",
  "configuration.labUnit.manage": "实验室单元管理",
  "error.labUnit.description.maxLength": "描述内容必须不超过{max}个字符",
  "error.labUnit.domain.required": "必须填写域名",
  "error.labUnit.list.load": "加载实验室单元时出错",
  "error.labUnit.name.duplicate": "该实验室单元名称已存在",
  "error.labUnit.name.maxLength": "名称必须包含{max}个字符或更少",
  "error.labUnit.name.required": "名称为必填项",
  "heading.labUnit.add": "添加新的实验室单元",
  "heading.labUnit.editing": "编辑中",
  "heading.labUnit.filtered": "显示 {filtered}，共 {total} 个实验室单元",
  "heading.labUnit.management": "实验室单元管理",
  "heading.labUnit.subtitle": "配置实验室单元（检测科室）、领域分类、检测分配及显示顺序。",
  "heading.labUnit.total": "总计：{total}实验室单元",
  "helper.labUnit.description": "本实验室单元的简短内部描述，供实验室工作人员参考",
  "helper.labUnit.domain": "确定哪些订单录入和样本采集字段适用于转至该实验室单元的订单。",
  "helper.labUnit.name": "请为此实验室单元输入一个唯一的名称（例如，“血液学”、“微生物学”）",
  "label.labUnit.actions": "操作",
  "label.labUnit.active": "活跃",
  "label.labUnit.description": "描述",
  "label.labUnit.displayOrder": "位置",
  "label.labUnit.displayOrder.addHint": "请先保存该实验室单元，然后设置其显示顺序。",
  "label.labUnit.displayOrder.current": "当前",
  "label.labUnit.displayOrder.intro": "在全系统的实验室单元菜单和下拉列表中为该实验室单元设置位置。输入位置并保存——其余实验室单元将自动重新编号。",
  "label.labUnit.displayOrder.loading": "正在加载显示顺序...",
  "label.labUnit.displayOrder.saved": "已保存显示顺序",
  "label.labUnit.displayOrder.saveError": "保存失败",
  "label.labUnit.domain": "域名",
  "label.labUnit.filterStatus": "按状态筛选",
  "label.labUnit.list.loading": "正在加载实验室单元……",
  "label.labUnit.loading": "正在加载实验室单元……",
  "label.labUnit.name": "名称",
  "label.labUnit.nameInLocale": "名称（{language}）",
  "error.labUnit.tests.action": "检测分配操作失败",
  "heading.labUnit.tests.assign": "将检测分配给本实验室单元",
  "heading.labUnit.tests.reassign": "重新分配检测项目",
  "label.labUnit.tests.assign.explain": "每项检测都隶属于且仅隶属于一个实验室单元。在此分配检测会将其从当前所属的实验室单元中移出（每个检测旁均显示所属实验室单元）。",
  "label.labUnit.tests.assign.none": "未找到可分配的检测项目。",
  "label.labUnit.tests.reassign.destination": "目的地实验室单元",
  "label.labUnit.tests.reassign.explain": "重新分配即刻生效。新订单将转发至目标实验室单元；已完成检测结果将保留其原始数据。",
  "label.labUnit.tests.reassign.moving": "{count, plural, one {# test} other {# tests}} will be moved:",
  "message.labUnit.tests.assigned": "本实验室单元所安排的检测项目。",
  "message.labUnit.tests.reassigned": "检测项目已成功重新分配。",
  "placeholder.labUnit.tests.reassign.destination": "选择目的地...",
  "placeholder.labUnit.tests.search": "搜索检测...",
  "label.labUnit.section.assigned-tests": "检测",
  "label.labUnit.section.basic-info": "基本信息",
  "label.labUnit.section.display-order": "显示顺序",
  "label.labUnit.status": "状态",
  "label.labUnit.testCount": "检测项目",
  "label.labUnit.tests.addHint": "请先保存该实验室单元，然后再为其分配检测项目。",
  "label.labUnit.tests.count": "{count, plural, one {# test assigned} other {# tests assigned}}",
  "label.labUnit.tests.loadError": "无法加载已分配的检测项目",
  "label.labUnit.tests.loading": "正在加载已分配的检测...",
  "label.labUnit.tests.none": "该实验室单元目前尚未分配任何检测项目。",
  "label.labUnit.tests.testName": "检测名称",
  "message.labUnit.add.success": "实验室单元已成功创建。",
  "message.labUnit.edit.success": "实验室单元已成功保存。",
  "message.labUnit.noResults": "未找到符合您条件的实验室单元",
  "placeholder.labUnit.filter.domain": "所有域名",
  "placeholder.labUnit.filter.status": "所有状态",
  "placeholder.labUnit.search": "搜索实验室单元……",
  "sidenav.label.admin.labUnit.addingNew": "添加新的实验室单元",
  "sidenav.label.admin.labUnit.backToList": "← 所有实验室单元",
  "sidenav.label.admin.labUnit.editing": "编辑中",
  "sidenav.label.admin.labUnit.editingGeneric": "编辑实验室单元",
  "sidenav.label.admin.labUnit.sectionsHelper": "点击一个实验室单元以编辑其各部分",
  "sidenav.label.admin.labUnitManagement": "实验室科室",
  "warning.labUnit.deactivateInUse": "{count, plural, one {# active test is assigned to this lab unit. Deactivating hides it from ordering but keeps the assignment.} other {# active tests are assigned to this lab unit. Deactivating hides it from ordering but keeps the assignments.}}",
  "admin.page.configuration.formEntryConfigMenu.button.add": "添加",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "停用",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "退出",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "修改",
  "admin.page.configuration.formEntryConfigMenu.button.save": "保存",
  "admin.page.configuration.formEntryConfigMenu.description": "描述",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "编辑记录",
  "admin.page.configuration.formEntryConfigMenu.name": "名称",
  "admin.page.configuration.formEntryConfigMenu.select": "选择",
  "admin.page.configuration.formEntryConfigMenu.value": "值",
  "admin.labelPresets.title": "标签预设",
  "admin.labelPresets.addButton": "添加预设",
  "admin.labelPresets.search.placeholder": "搜索预设...",
  "admin.labelPresets.col.name": "名称",
  "admin.labelPresets.col.barcodeType": "条码类型",
  "admin.labelPresets.col.dimensions": "尺寸",
  "admin.labelPresets.col.scope": "范围",
  "admin.labelPresets.col.status": "状态",
  "admin.labelPresets.col.actions": "操作",
  "admin.labelPresets.systemTag": "系统",
  "admin.labelPresets.status.active": "活跃",
  "admin.labelPresets.status.inactive": "非活跃",
  "admin.labelPresets.scope.order": "接收样本",
  "admin.labelPresets.scope.sample": "样本",
  "admin.labelPresets.action.edit": "编辑",
  "admin.labelPresets.action.duplicate": "重复项",
  "admin.labelPresets.action.activate": "激活",
  "admin.labelPresets.action.deactivate": "停用",
  "admin.labelPresets.duplicateName": "{name} 的副本",
  "admin.labelPresets.duplicated": "预设已重复",
  "admin.labelPresets.duplicateFailed": "复制失败",
  "admin.labelPresets.activated": "预设已激活",
  "admin.labelPresets.deactivated": "预设已停用",
  "admin.labelPresets.toggleFailed": "状态更改失败",
  "admin.labelPresets.saveFailed": "保存失败",
  "admin.labelPresets.editor.titleAdd": "添加标签预设",
  "admin.labelPresets.editor.titleEdit": "编辑标签预设",
  "admin.labelPresets.editor.section.basicInfo": "基本信息",
  "admin.labelPresets.editor.section.dimensions": "尺寸（毫米）",
  "admin.labelPresets.editor.section.barcodeSettings": "条码设置",
  "admin.labelPresets.editor.section.printScope": "打印范围与数量",
  "admin.labelPresets.field.name": "预设名称",
  "admin.labelPresets.field.isActive": "活跃",
  "admin.labelPresets.field.heightMm": "高度（毫米）",
  "admin.labelPresets.field.widthMm": "宽度（毫米）",
  "admin.labelPresets.field.barcodeType": "条码类型",
  "admin.labelPresets.field.defaultPerOrder": "每笔订单的默认值",
  "admin.labelPresets.field.maxPerOrder": "每笔订单的最大值",
  "admin.labelPresets.field.defaultPerSample": "每样本的默认值",
  "admin.labelPresets.field.maxPerSample": "每个样本的最大值",
  "admin.labelPresets.validation.name.required": "名称为必填项",
  "admin.labelPresets.validation.name.toolong": "名称不得超过120个字符",
  "admin.labelPresets.validation.dimension.range": "尺寸必须在5至200毫米之间",
  "admin.labelPresets.validation.barcodeType.required": "必须选择条码类型",
  "admin.labelPresets.validation.scope.required": "必须至少选择一个打印范围（订单或样本）",
  "admin.labelPresets.validation.max.lte": "最大值必须大于或等于默认值",
  "advanced.search": "高级搜索",
  "alert.expired.title": "已过期物品",
  "alert.expiring.title": "即将过期",
  "alert.lowStock.title": "低库存警报",
  "alerts.acknowledge.button": "确认",
  "alerts.acknowledge.comment": "备注",
  "alerts.acknowledge.comment.placeholder": "输入确认备注...",
  "alerts.acknowledge.comment.required": "确认备注为必填项",
  "alerts.acknowledge.error": "确认警报失败",
  "alerts.acknowledge.success": "警报已成功确认",
  "alerts.acknowledge.title": "确认警报",
  "alerts.autoRefresh": "自动刷新",
  "alerts.dashboard.title": "警报仪表板",
  "alerts.empty": "暂无警报",
  "alerts.eqaDeadlineSummary.critical": "紧急",
  "alerts.eqaDeadlineSummary.deadlineCount": "截止日期数量",
  "alerts.eqaDeadlineSummary.subtitle": "即将到期的EQA截止日期概要",
  "alerts.eqaDeadlineSummary.title": "EQA截止日期概要",
  "alerts.eqaDeadlineSummary.viewAll": "查看全部",
  "alerts.filter.myAlerts": "我的警报",
  "alerts.filter.search": "搜索",
  "alerts.filter.severity": "严重程度",
  "alerts.filter.status": "状态",
  "alerts.filter.type": "类型",
  "alerts.severity.critical": "紧急",
  "alerts.severity.warning": "警告",
  "alerts.status.acknowledged": "已确认",
  "alerts.status.open": "待处理",
  "alerts.status.resolved": "已解决",
  "alerts.summary.critical": "紧急",
  "alerts.summary.eqaDeadlines": "EQA截止日期",
  "alerts.summary.sampleExpiration": "样本过期",
  "alerts.summary.statOverdue": "加急逾期",
  "alerts.summary.totalOpen": "待处理总数",
  "alerts.table.actions": "操作",
  "alerts.table.created": "创建时间",
  "alerts.table.message": "消息",
  "alerts.table.severity": "严重程度",
  "alerts.table.status": "状态",
  "alerts.table.type": "类型",
  "alerts.type.critical_result": "Critical Result",
  "alerts.type.equipment_failure": "设备警报",
  "alerts.type.freezer_humidity": "Freezer Humidity",
  "alerts.type.freezer_offline": "Freezer Offline",
  "alerts.type.freezer_temperature": "Freezer Temperature",
  "alerts.type.inventory_low": "Inventory Low",
  "alerts.type.other": "其他原因",
  "alerts.type.referral_critical_result": "Referral Critical Result",
  "alerts.type.referral_rejected": "Referral Rejected",
  "alerts.type.sample_tracking": "Sample Tracking",
  "alerts.type.critical_unacknowledged": "紧急未确认",
  "alerts.type.eqa_deadline": "EQA截止日期",
  "alerts.type.microbiology_critical": "微生物学 紧急",
  "alerts.type.required_by_deadline": "截止日期前必须提交",
  "alerts.type.sample_expiration": "样本过期",
  "alerts.type.stat_overdue": "加急逾期",
  "alerts.type.stat_upcoming": "即将到期的加急",
  "aliquot": "分装样本",
  "aliquot.analyses.count": "分析: {count}",
  "aliquot.id": "分装样本ID",
  "aliquot.quantity": "分装样本数量",
  "aliquot.quantity.not.balanced": "样本类型的数量不平衡",
  "aliquot.save.error": "保存分装样本数据时出错。",
  "aliquot.save.success": "分装样本数据保存成功。",
  "aliquot.tests.not.assigned": "样本类型未分配检测",
  "aliquot.validation.errors": "验证错误",
  "aliquoting": "样本分装",
  "aliquoting.section": "样本分装部分",
  "all.label": "全部",
  "all.tests.assigned": "所有检测已分配",
  "allocated.to.aliquots": "分配到分装样本",
  "analysis.count": "分析计数",
  "analysis.details": "分析详情",
  "analyzer.action.add": "添加",
  "analyzer.action.configureConnection": "配置连接",
  "analyzer.action.deactivate": "停用",
  "analyzer.action.editSetup": "编辑设置",
  "analyzer.action.qualityControl": "质控",
  "analyzer.action.reactivate": "重新激活",
  "analyzer.combinationName.notification": "分析仪和分析仪检测名称的组合必须唯一",
  "analyzer.fhirImport.error.importFailed": "FHIR数据导入失败",
  "analyzer.fhirImport.error.invalidBundleType": "FHIR Bundle类型无效",
  "analyzer.fhirImport.error.noObservations": "FHIR Bundle中无检验观测数据",
  "analyzer.deliveryIssues.attention.review": "Review undelivered results",
  "analyzer.deliveryIssues.attention.subtitle": "The Analyzer Bridge is holding results it could not deliver to OpenELIS.",
  "analyzer.deliveryIssues.attention.title": "{count, plural, one {# analyzer result was} other {# analyzer results were}} not delivered",
  "analyzer.deliveryIssues.column.actions": "操作",
  "analyzer.deliveryIssues.column.analyzer": "分析仪",
  "analyzer.deliveryIssues.column.detail": "详情",
  "analyzer.deliveryIssues.column.reason": "理由",
  "analyzer.deliveryIssues.column.received": "已接收",
  "analyzer.deliveryIssues.column.status": "状态",
  "analyzer.deliveryIssues.description": "Results the Analyzer Bridge received but has not delivered to OpenELIS. Retry sends a result again once its cause is fixed; Dismiss hides it and keeps it in the Bridge for audit.",
  "analyzer.deliveryIssues.dismiss": "关闭",
  "analyzer.deliveryIssues.empty": "The Bridge has no undelivered results.",
  "analyzer.deliveryIssues.error.actionFailed": "The action could not be completed. Reload and try again.",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "The Analyzer Bridge sent a response OpenELIS could not read.",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "OpenELIS has no Analyzer Bridge address configured.",
  "analyzer.deliveryIssues.error.bridgeRefused": "The Bridge refused this action ({reason}). Reload to see its current state.",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "The Analyzer Bridge could not be reached.",
  "analyzer.deliveryIssues.error.invalidId": "This result reference is not valid.",
  "analyzer.deliveryIssues.loadFailed": "Undelivered results could not be loaded from the Analyzer Bridge.",
  "analyzer.deliveryIssues.loading": "Checking the Analyzer Bridge for undelivered results",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "More than one analyzer connection could own this message. Give each analyzer a distinct address, then retry.",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "The analyzer sent over a connection type its setup does not accept.",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "OpenELIS declined the result because of its own setup. Fix the analyzer setup, then retry.",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS rejected the result.",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS answered with a redirect, so the result was not delivered. Check the Bridge's OpenELIS address.",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "The message contained no results to deliver.",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "The Bridge could not convert the message for OpenELIS.",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "OpenELIS stayed unreachable until every retry was used. The result is intact; retry once OpenELIS is reachable.",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "The analyzer's connection has no analyzer type revision, so its results cannot be read.",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "The sender matches no saved analyzer connection. Set up the analyzer, then retry.",
  "analyzer.deliveryIssues.reason.none": "OpenELIS has not accepted the result yet; the Bridge keeps retrying.",
  "analyzer.deliveryIssues.reason.unknown": "The Bridge could not deliver this result ({code}).",
  "analyzer.deliveryIssues.retry": "重试",
  "analyzer.deliveryIssues.state.deadLettered": "Not delivered",
  "analyzer.deliveryIssues.state.retrying": "Retrying",
  "analyzer.deliveryIssues.title": "Undelivered analyzer results",
  "analyzer.deliveryIssues.unrecognizedSender": "Unrecognized sender {source}",
  "analyzer.importIssues.accession": "订单号",
  "analyzer.importIssues.action": "操作",
  "analyzer.importIssues.description": "审查无法匹配或处理的微生物分析仪事件。暂存的结果可在各分析仪的结果工作列表中进行审查。",
  "analyzer.importIssues.empty": "没有需要关注的微生物分析仪故障事件",
  "analyzer.importIssues.event": "活动",
  "analyzer.importIssues.event.astQcFail": "AST质控失效",
  "analyzer.importIssues.event.astResultAvailable": "AST结果已出",
  "analyzer.importIssues.event.unknown": "分析仪事件（{code}）",
  "analyzer.importIssues.events.description": "在源端再次发送结果之前，请更正分析仪的映射或目标信息。",
  "analyzer.importIssues.events.title": "分析仪事件卡住",
  "analyzer.importIssues.failure.astRunNotMatched": "没有哪个 AST 运行与分析仪和卡片的标识符匹配。",
  "analyzer.importIssues.failure.processingFailed": "无法处理该分析仪事件。",
  "analyzer.importIssues.failure.unknown": "无法处理分析仪事件（{code}）。",
  "analyzer.importIssues.loadFailed": "无法加载分析仪导入文件",
  "analyzer.importIssues.loading": "加载分析仪时的导入问题",
  "analyzer.importIssues.openMappings": "开放映射",
  "analyzer.importIssues.openResults": "查看分析仪结果",
  "analyzer.importIssues.reason": "失败原因",
  "analyzer.importIssues.received": "已接收",
  "analyzer.importIssues.result": "结果",
  "analyzer.importIssues.source": "源ID",
  "analyzer.importIssues.staging.description": "在验证这些导入的结果行之前，需要先修正分析仪的配置。",
  "analyzer.importIssues.staging.title": "分阶段结果问题",
  "analyzer.importIssues.target": "目标参考",
  "analyzer.importIssues.test": "检测",
  "analyzer.importIssues.title": "分析仪导入问题",
  "analyzer.fieldCreation.acceptedUnits.label": "可接受单位",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "输入可接受的单位",
  "analyzer.fieldCreation.cancel": "取消",
  "analyzer.fieldCreation.confirmation": "字段创建成功",
  "analyzer.fieldCreation.create": "创建",
  "analyzer.fieldCreation.createNew": "新建字段",
  "analyzer.fieldCreation.description.label": "描述",
  "analyzer.fieldCreation.description.placeholder": "输入字段描述",
  "analyzer.fieldCreation.entityType.label": "实体类型",
  "analyzer.fieldCreation.entityType.placeholder": "选择实体类型",
  "analyzer.fieldCreation.error.generic": "创建字段时出错",
  "analyzer.fieldCreation.error.title": "创建失败",
  "analyzer.fieldCreation.fieldName.label": "字段名称",
  "analyzer.fieldCreation.fieldName.placeholder": "输入字段名称",
  "analyzer.fieldCreation.fieldType.label": "字段类型",
  "analyzer.fieldCreation.fieldType.placeholder": "选择字段类型",
  "analyzer.fieldCreation.loincCode.label": "LOINC代码",
  "analyzer.fieldCreation.loincCode.placeholder": "输入LOINC代码",
  "analyzer.fieldCreation.modal.subtitle": "定义新的分析仪字段",
  "analyzer.fieldCreation.modal.title": "创建新字段",
  "analyzer.fieldCreation.success.message": "字段已成功创建",
  "analyzer.fieldCreation.success.title": "创建成功",
  "analyzer.fieldCreation.validation.entityType.required": "实体类型为必填项",
  "analyzer.fieldCreation.validation.fieldName.required": "字段名称为必填项",
  "analyzer.fieldCreation.validation.unique": "字段名称必须唯一",
  "analyzer.fieldCreation.validation.units.required": "单位为必填项",
  "analyzer.filter.lifecycleStage.all": "全部",
  "analyzer.filter.lifecycleStage.label": "生命周期阶段",
  "analyzer.filter.status": "状态",
  "analyzer.filter.status.all": "全部",
  "analyzer.filter.status.label": "状态",
  "analyzer.filter.testUnit": "检测科室",
  "analyzer.filter.type": "类型",
  "analyzer.form.activeStatus": "活跃状态",
  "analyzer.form.activeStatus.description": "设置分析仪为活跃或非活跃状态",
  "analyzer.form.addTitle": "添加分析仪",
  "analyzer.form.cancel": "取消",
  "analyzer.form.communicationMode": "通信模式",
  "analyzer.form.communicationMode.analyzerInitiated": "分析仪发起",
  "analyzer.form.communicationMode.both": "双向",
  "analyzer.form.communicationMode.help": "选择此分析仪的通信启动方向",
  "analyzer.form.communicationMode.lisInitiated": "LIS发起",
  "analyzer.form.createdBy": "创建人",
  "analyzer.form.createdDate": "创建日期",
  "analyzer.form.defaults.error": "加载默认配置失败",
  "analyzer.form.defaults.loaded": "默认配置已加载",
  "analyzer.form.defaults.loaded.subtitle": "默认配置已成功应用",
  "analyzer.form.editTitle": "编辑分析仪",
  "analyzer.form.error.invalidCommunicationMode": "通信模式无效",
  "analyzer.form.error.invalidProtocolVersion": "协议版本无效",
  "analyzer.form.error.save": "保存分析仪时出错",
  "analyzer.form.error.unknown": "发生未知错误",
  "analyzer.form.fileProtocol.description": "配置基于文件的通信协议设置",
  "analyzer.form.fileProtocol.title": "文件协议",
  "analyzer.form.identifierPattern": "标识符模式",
  "analyzer.form.identifierPattern.helperText": "用于识别分析仪消息的正则表达式模式",
  "analyzer.form.identifierPattern.placeholder": "输入标识符模式",
  "analyzer.form.ipAddress": "IP地址",
  "analyzer.form.ipAddress.placeholder": "输入IP地址",
  "analyzer.form.lastModified": "最后修改",
  "analyzer.form.loadDefaultConfig": "加载默认配置",
  "analyzer.form.loadDefaultConfig.helperText": "从预定义模板加载默认配置",
  "analyzer.form.loadDefaultConfig.placeholder": "选择默认配置",
  "analyzer.form.name": "名称",
  "analyzer.form.name.placeholder": "输入分析仪名称",
  "analyzer.form.pluginType": "插件类型",
  "analyzer.form.pluginType.helperText": "选择此分析仪使用的插件类型",
  "analyzer.form.pluginType.placeholder": "选择插件类型",
  "analyzer.form.port": "端口",
  "analyzer.form.port.placeholder": "输入端口号",
  "analyzer.form.protocolVersion": "协议版本",
  "analyzer.form.save": "保存",
  "analyzer.form.status": "状态",
  "analyzer.form.status.helperText": "分析仪的当前状态",
  "analyzer.form.subtitle": "分析仪配置",
  "analyzer.form.success.save": "分析仪保存成功",
  "analyzer.form.testConnection": "测试连接",
  "analyzer.form.testConnection.error": "连接测试失败",
  "analyzer.form.testUnits": "检测科室",
  "analyzer.form.testUnits.helper": "选择此分析仪关联的检测科室",
  "analyzer.form.testUnits.placeholder": "选择检测科室",
  "analyzer.form.type": "类型",
  "analyzer.form.type.helperText": "为该已安装的连接选择可重用的分析仪类型。",
  "analyzer.form.type.invalidSelection": "该分析仪类型修订版本不可用或已停用",
  "analyzer.form.type.loadError": "无法加载分析仪类型管理",
  "analyzer.form.type.other": "其他",
  "analyzer.form.type.placeholder": "选择类型",
  "analyzer.form.type.revision": "{name}，修订版 {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "IP地址格式无效",
  "analyzer.form.validation.name.required": "名称为必填项",
  "analyzer.form.validation.type.required": "类型为必填项",
  "analyzer.hl7.insertError": "HL7消息插入错误",
  "analyzer.hl7.parseError": "HL7消息解析错误",
  "analyzer.hl7.unknownAnalyzer": "未知分析仪",
  "analyzer.list.subtitle": "管理已配置的分析仪",
  "analyzer.list.title": "分析仪列表",
  "analyzer.lifecycle.deactivate.cancel": "取消停用",
  "analyzer.lifecycle.deactivate.confirm": "停用分析仪",
  "analyzer.lifecycle.deactivate.error": "无法停用分析仪。",
  "analyzer.lifecycle.deactivate.errorTitle": "停用失败",
  "analyzer.lifecycle.deactivate.message": "停用{name}？新运行将停止。其配置和历史记录将被保留，日后可重新激活。",
  "analyzer.lifecycle.deactivate.title": "停用分析仪",
  "analyzer.lifecycle.reactivate.blockedMessage": "在重新激活之前，请先完成以下设置要求。",
  "analyzer.lifecycle.reactivate.blockedTitle": "分析仪尚未就绪",
  "analyzer.lifecycle.reactivate.cancel": "取消重新激活",
  "analyzer.lifecycle.reactivate.confirm": "重新激活分析仪",
  "analyzer.lifecycle.reactivate.error": "无法重新激活分析仪。",
  "analyzer.lifecycle.reactivate.errorTitle": "重新激活失败",
  "analyzer.lifecycle.reactivate.message": "重新激活{name}？在使用前，系统将再次检查其设置中内容。",
  "analyzer.lifecycle.reactivate.title": "重新激活分析仪",
  "analyzer.connection.choice.select": "选择一个值",
  "analyzer.connection.field.apiToken": "API 令牌",
  "analyzer.connection.field.connectionRole": "连接角色",
  "analyzer.connection.field.directory": "目录",
  "analyzer.connection.field.directory.help": "分析仪桥主机上的目录",
  "analyzer.connection.field.enabled": "已启用",
  "analyzer.connection.field.filePattern": "文件名模式",
  "analyzer.connection.field.filePattern.help": "Analyzer Bridge 监视的文件名模式",
  "analyzer.connection.field.host": "主持人",
  "analyzer.connection.field.host.help": "The analyzer's IP address. Optional when the analyzer connects to the Analyzer Bridge. Leave it blank if the analyzer reaches the bridge through NAT or a proxy, and use the instrument system name instead.",
  "analyzer.connection.field.port": "端口",
  "analyzer.connection.field.senderId": "Instrument system name",
  "analyzer.connection.field.senderId.help": "The name this instrument sends in its messages (ASTM H.5 or HL7 MSH-3), such as the GeneXpert System Name. Needed only when several analyzers share this port and address.",
  "analyzer.connection.field.serialPort": "串行设备",
  "analyzer.connection.field.transport": "运输",
  "analyzer.connection.field.unavailable": "连接设置",
  "analyzer.connection.role.client": "客户",
  "analyzer.connection.role.server": "服务器",
  "analyzer.connection.reference.configured": "已配置桥接连接",
  "analyzer.connection.reference.missing": "需要建立连接",
  "analyzer.connection.transport.RS-232": "串行（RS-232）",
  "analyzer.connection.transport.TCP/IP": "网络（TCP/IP）",
  "analyzer.connection.validation.invalid": "请检查此值。",
  "analyzer.connection.validation.required": "此字段为必填项.",
  "analyzer.setup.close": "关闭分析仪设置",
  "analyzer.setup.connect.address.required": "输入分析仪地址",
  "analyzer.activation.blocker.bridgeAcknowledgement": "Analyzer Bridge 尚未确认此具体设置。",
  "analyzer.activation.blocker.connection": "连接设置不完整或无效。",
  "analyzer.activation.blocker.dataFlow": "此分析仪类型不支持所选的数据流。",
  "analyzer.activation.blocker.labUnit": "请分配至少一个有效的实验室单元。",
  "analyzer.activation.blocker.mappings": "必须再次验证分析仪的映射关系。",
  "analyzer.activation.blocker.name": "请输入分析仪的名称。",
  "analyzer.activation.blocker.profile": "已选择分析仪类型的修订版不可用，或不再与该分析仪匹配。",
  "analyzer.activation.blocker.recognition": "必须再次验证控制识别。",
  "analyzer.activation.blocker.transport": "此分析仪类型不支持所选的连接类型。",
  "analyzer.setup.connect.activation.active": "分析仪已启用",
  "analyzer.setup.connect.activation.activating": "激活分析仪",
  "analyzer.setup.connect.activation.blockerUnknown": "分析仪的设置尚未准备就绪，无法激活。",
  "analyzer.setup.connect.activation.cancel": "取消",
  "analyzer.setup.connect.activation.error": "无法检查分析仪的就绪状态。",
  "analyzer.setup.connect.activation.finish": "完成并激活",
  "analyzer.setup.connect.activation.loading": "检查分析仪是否就绪",
  "analyzer.setup.connect.activation.readiness": "激活就绪状态",
  "analyzer.setup.connect.activation.ready": "分析仪已准备就绪，可以激活了",
  "analyzer.setup.connect.activation.saveChanges": "保存更改",
  "analyzer.setup.connect.activation.saveLater": "保存并稍后完成",
  "analyzer.setup.connect.activation.saving": "保存分析仪",
  "analyzer.setup.connect.activation.verifyMappings": "Verify mappings",
  "analyzer.setup.connect.analyzerAddress": "分析仪地址",
  "analyzer.setup.connect.check.analyzer.address.missing": "No analyzer address is saved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.host.unknown": "The analyzer address {host} could not be resolved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.reachable": "The Bridge reached the analyzer at {host}.",
  "analyzer.setup.connect.check.analyzer.unreachable": "The Bridge could not reach the analyzer at {host}. Analyzers that connect to the Bridge often cannot be reached from it (a firewall, NAT, or a hosted server). Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.connection.mode.unsupported": "该桥接器不支持此连接模式。",
  "analyzer.setup.connect.check.directory.configuration.missing": "检测前请进入分析仪文件目录。",
  "analyzer.setup.connect.check.directory.not.directory": "配置的路径不是一个目录。",
  "analyzer.setup.connect.check.directory.not.found": "未找到配置的目录。",
  "analyzer.setup.connect.check.directory.not.readable": "The Bridge 无法读取配置的目录。",
  "analyzer.setup.connect.check.directory.path.invalid": "配置的目录路径无效。",
  "analyzer.setup.connect.check.directory.ready": "目录已准备就绪。",
  "analyzer.setup.connect.check.http.configuration.missing": "测试前请输入分析仪的地址。",
  "analyzer.setup.connect.check.http.connection.error": "Bridge 无法连接到分析仪的地址。",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "This analyzer sends files to the Bridge, so the Bridge cannot test the connection from here. A delivered file is the proof.",
  "analyzer.setup.connect.check.http.interrupted": "网络连接检测被中断了。",
  "analyzer.setup.connect.check.http.ready": "可以访问该分析仪的地址。",
  "analyzer.setup.connect.check.http.server.error": "分析仪的网址返回了服务器错误。",
  "analyzer.setup.connect.check.http.timeout": "在超时之前，分析仪的地址未作出响应。",
  "analyzer.setup.connect.check.http.url.invalid": "分析仪的地址无效。",
  "analyzer.setup.connect.check.listener.configuration.missing": "Enter the Bridge listener port before testing.",
  "analyzer.setup.connect.check.listener.endpoint.missing": "未配置 Bridge 的监听地址。",
  "analyzer.setup.connect.check.listener.not.listening": "Bridge 监听器不接受连接。",
  "analyzer.setup.connect.check.listener.port.in.use": "已配置的 Bridge 监听端口正在使用中。",
  "analyzer.setup.connect.check.listener.profile.unsupported": "该置顶个人资料未定义兼容的 Bridge 监听器。",
  "analyzer.setup.connect.check.listener.ready": "Bridge 监听器已就绪。",
  "analyzer.setup.connect.check.listener.timeout": "在超时之前，Bridge 监听器未作出响应。",
  "analyzer.setup.connect.check.remote.astm.ready": "分析仪已完成 ASTM 握手过程。",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "分析仪返回了一个无效的ASTM握手响应。",
  "analyzer.setup.connect.check.remote.configuration.missing": "测试前，请输入分析仪的地址和端口。",
  "analyzer.setup.connect.check.remote.connection.error": "Bridge 无法连接到分析仪。",
  "analyzer.setup.connect.check.remote.hl7.ready": "分析仪已完成 HL7 握手。",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "分析仪返回了一个无效的 HL7 握手响应。",
  "analyzer.setup.connect.check.remote.host.unknown": "无法解析分析仪的地址。",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "该分析仪协议不支持远程连接测试。",
  "analyzer.setup.connect.check.remote.refused": "分析仪拒绝了连接。",
  "analyzer.setup.connect.check.remote.timeout": "分析仪在超时前未作出响应。",
  "analyzer.setup.connect.check.serial.configuration.missing": "检测前，请输入分析仪的序列号。",
  "analyzer.setup.connect.check.serial.not.found": "未找到已配置的串行设备。",
  "analyzer.setup.connect.check.serial.not.readable": "Bridge 无法读取已配置的串行设备。",
  "analyzer.setup.connect.check.serial.path.invalid": "配置的串行设备路径无效。",
  "analyzer.setup.connect.check.serial.ready": "分析仪的串行设备已就绪。",
  "analyzer.setup.connect.checkKind.analyzer": "Analyzer (for information)",
  "analyzer.setup.connect.checkKind.directory": "目录",
  "analyzer.setup.connect.checkKind.http_endpoint": "网址",
  "analyzer.setup.connect.checkKind.http_input": "Analyzer file upload",
  "analyzer.setup.connect.checkKind.listener": "Bridge 监听器",
  "analyzer.setup.connect.checkKind.other": "连接检查",
  "analyzer.setup.connect.checkKind.remote_protocol": "分析仪协议",
  "analyzer.setup.connect.checkKind.serial_device": "串行设备",
  "analyzer.setup.connect.checkStatus.failed": "连接检查失败。",
  "analyzer.setup.connect.checkStatus.missing_configuration": "连接设置不完整。",
  "analyzer.setup.connect.checkStatus.passed": "连接检查通过。",
  "analyzer.setup.connect.checkStatus.skipped": "This check could not be run.",
  "analyzer.setup.connect.checkStatus.timed_out": "连接检查超时。",
  "analyzer.setup.connect.configureEndpoint": "将分析仪配置为使用",
  "analyzer.setup.connect.dataFlow": "数据流",
  "analyzer.setup.connect.dataFlow.resultsOnly": "仅显示结果",
  "analyzer.setup.connect.dataFlow.twoWay": "双向",
  "analyzer.setup.connect.directory": "分析仪文件目录",
  "analyzer.setup.connect.directory.required": "进入分析仪文件目录",
  "analyzer.setup.connect.error": "无法保存或检测连接设置。",
  "analyzer.setup.connect.evidence": "关联证据",
  "analyzer.setup.connect.loadError": "无法加载已保存的分析仪连接。",
  "analyzer.setup.connect.loading": "正在加载分析仪连接",
  "analyzer.setup.connect.outcome.failure": "连接测试失败",
  "analyzer.setup.connect.outcome.missing_configuration": "连接设置不完整",
  "analyzer.setup.connect.outcome.success": "已准备好连接",
  "analyzer.setup.connect.outcome.timeout": "连接超时",
  "analyzer.setup.connect.port": "分析仪端口",
  "analyzer.setup.connect.port.invalid": "请输入 1 到 65535 之间的端口号",
  "analyzer.setup.connect.sourceAddress": "分析仪源地址",
  "analyzer.setup.connect.test": "测试连接",
  "analyzer.setup.connect.testing": "检测连接",
  "analyzer.setup.connect.title": "连接",
  "analyzer.setup.connect.useResultsOnly": "仅使用结果",
  "analyzer.setup.instrument.continue": "继续验证",
  "analyzer.setup.instrument.labUnits": "实验室单元",
  "analyzer.setup.instrument.labUnits.placeholder": "选择实验室单元",
  "analyzer.setup.instrument.labUnits.required": "请至少选择一个实验室单元",
  "analyzer.setup.instrument.name": "分析仪名称",
  "analyzer.setup.instrument.name.required": "输入分析仪名称",
  "analyzer.setup.instrument.notListed": "未列出的仪器？",
  "analyzer.setup.instrument.saveError": "无法保存分析仪。请重试。",
  "analyzer.setup.instrument.saving": "保存分析仪",
  "analyzer.setup.instrument.summary": "已保存的仪器详细信息",
  "analyzer.setup.step.edit": "编辑 {step}",
  "analyzer.setup.instrument.type": "类型",
  "analyzer.setup.instrument.type.helper": "Choose the listed type for your instrument, even if it will only send results. Whether it sends results only or also receives orders is set later, in Connect.",
  "analyzer.setup.instrument.type.placeholder": "搜索分析仪类型",
  "analyzer.setup.instrument.type.required": "选择分析仪类型",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · 修订版 {revision}",
  "analyzer.setup.instrument.title": "乐器",
  "analyzer.setup.steps": "分析仪设置步骤",
  "analyzer.setup.title": "设置一个新的分析仪",
  "analyzer.setup.verify.attention": "验证需要重视",
  "analyzer.setup.verify.continue": "继续保持连接",
  "analyzer.setup.verify.selecting": "正在应用映射...",
  "analyzer.setup.verify.selectionError": "无法应用已审核的映射。请重新加载页面“验证”并重试。",
  "analyzer.setup.verify.counts": "绘图准备情况",
  "analyzer.setup.verify.heading": "审查分析仪类型映射",
  "analyzer.setup.verify.loadError": "无法加载映射验证。",
  "analyzer.setup.verify.loading": "正在加载映射验证",
  "analyzer.setup.verify.profile": "{name} · {protocol} · 修订版 {revision}",
  "analyzer.setup.verify.resultsReady": "{ready} {total}的结果值已准备就绪",
  "analyzer.setup.verify.summary": "设置中已审核的映射关系",
  "analyzer.setup.verify.summary.stale": "Mappings need to be verified again",
  "analyzer.setup.verify.review": "在“分析仪类型管理”中查看映射",
  "analyzer.setup.verify.testsReady": "{ready} {total} 测试已准备就绪",
  "analyzer.setup.verify.title": "验证",
  "analyzer.navigation.analyzerTypes": "分析仪类型",
  "analyzer.navigation.analyzers": "分析仪",
  "analyzer.navigation.analyzersList": "分析仪列表",
  "analyzer.navigation.fieldMappings": "字段映射",
  "analyzer.navigation.qc": "质控",
  "analyzer.navigation.qcDashboard": "QC仪表板",
  "analyzer.navigation.qcAlerts": "质控警报",
  "analyzer.navigation.qcCorrectiveActions": "质控纠正措施",
  "analyzerType.action.deactivate": "停用",
  "analyzerType.action.editMappings": "编辑映射关系",
  "analyzerType.action.history": "查看历史记录",
  "analyzerType.action.reactivate": "重新激活",
  "analyzerType.action.updateShared": "已分享更新",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, one {Analyzer using this type} other {Analyzers using this type}}",
  "analyzerType.affectedAnalyzers.updateAvailable": "有更新可用",
  "analyzerType.actions.ariaLabel": "{name} 的操作",
  "analyzerType.button.create": "创建",
  "analyzerType.button.cancel": "取消",
  "analyzerType.button.duplicate": "重复的个人资料",
  "analyzerType.button.publish": "发布个人资料",
  "analyzerType.button.startUpdate": "开始更新",
  "analyzerType.column.actions": "操作",
  "analyzerType.column.protocol": "协议",
  "analyzerType.column.resultsMapped": "结果映射",
  "analyzerType.column.status": "状态",
  "analyzerType.column.testsMapped": "已映射的检测项目",
  "analyzerType.column.type": "类型",
  "analyzerType.column.usedBy": "由……使用",
  "analyzerType.dataFlow.resultsOnly": "仅显示结果",
  "analyzerType.dataFlow.twoWay": "双向",
  "analyzerType.duplicate.lineage.subtitle": "新配置文件的来源是 {name} 的修订版本 {revision}。此后的更改不会影响源配置文件及其分析仪。",
  "analyzerType.duplicate.lineage.title": "保留谱系的新档案",
  "analyzerType.draft.created.subtitle": "该草稿已保存在Analyzer Bridge中。必须先完成并验证该草稿，才能将其发布以用于分析仪的设置。",
  "analyzerType.draft.created.title": "个人资料草稿已创建",
  "analyzerType.draft.loading": "正在加载个人资料草稿",
  "analyzerType.draft.publish.ready.subtitle": "{name} 具有Bridge独有的身份标识，并保留了其源头血统。",
  "analyzerType.draft.publish.ready.title": "已准备好发布",
  "analyzerType.draft.publish.review.subtitle": "发布前，请检查并保存{name}的控件识别行为。",
  "analyzerType.draft.publish.review.title": "完整个人资料审核",
  "analyzerType.draft.update.loading": "正在加载个人资料更新草稿",
  "analyzerType.draft.update.subtitle": "在该草稿完成并发布之前，共享分析仪类型保持不变。现有分析仪仍将固定在其当前版本上。",
  "analyzerType.draft.update.title": "已创建个人资料更新草稿",
  "analyzerType.empty.subtitle": "调整搜索条件或筛选条件，以查看其他分析仪类型。",
  "analyzerType.empty.title": "没有匹配的分析仪类型",
  "analyzerType.explainer.subtitle": "相同的分析仪可以共享同一种类型。当某个分析仪需要不同的行为时，请复制该类型；应停用类型，而非删除其历史记录。",
  "analyzerType.explainer.title": "可重复使用分析仪的设置中",
  "analyzerType.error.nameUnique": "个人资料名称必须是唯一的",
  "analyzerType.field.connectionTest": "支持连接测试",
  "analyzerType.field.dataFlow": "数据流",
  "analyzerType.field.fileFormat": "文件格式",
  "analyzerType.field.filePattern": "文件名模式",
  "analyzerType.field.manufacturer": "制造商",
  "analyzerType.field.model": "型号",
  "analyzerType.field.newProfileName": "新个人资料名称",
  "analyzerType.field.profileName": "个人资料名称",
  "analyzerType.field.protocol": "协议",
  "analyzerType.field.resultColumn": "“结果”列",
  "analyzerType.field.sampleColumn": "样本编号列",
  "analyzerType.field.sourceProfile.placeholder": "选择分析仪类型",
  "analyzerType.field.sourceProfile": "源分析仪类型",
  "analyzerType.field.testColumn": "测试代码列",
  "analyzerType.filter.all": "所有分析仪",
  "analyzerType.filter.mapping": "地图绘制状态",
  "analyzerType.filter.protocol": "协议",
  "analyzerType.filter.showDeactivated": "显示已停用",
  "analyzerType.filter.source": "创建时间",
  "analyzerType.history.action.created": "创建时间",
  "analyzerType.history.action.deactivated": "已停用",
  "analyzerType.history.action.duplicated": "重复项",
  "analyzerType.history.action.reactivated": "已重新激活",
  "analyzerType.history.action.shipped": "已发货",
  "analyzerType.history.action.updated": "更新",
  "analyzerType.history.actor": "由……修改",
  "analyzerType.history.change": "更改",
  "analyzerType.history.loading": "正在加载个人资料历史记录",
  "analyzerType.history.revisionValue": "修订版 {revision}",
  "analyzerType.history.revision": "修订",
  "analyzerType.history.status": "状态",
  "analyzerType.history.time": "修改于",
  "analyzerType.lineage": "来源 {profileId}，修订版本 {revision}简体中文（大陆）",
  "analyzerType.loading": "正在加载分析仪类型管理",
  "analyzerType.mapping.complete": "已完全映射",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.countWithExcluded": "{mapped} / {total} · {percent}% · {excluded} 已标记为“不再接收”",
  "analyzerType.mapping.incomplete": "需求分析",
  "analyzerType.mapping.notApplicable": "不适用",
  "analyzerType.mapping.notStarted": "已映射",
  "analyzerType.mappingEditor.alias": "别名：{alias}",
  "analyzerType.mappingEditor.confirm": "确认映射关系并控制识别",
  "analyzerType.mappingEditor.confirmation.by": "由 {actor} 在 {date} 上确认",
  "analyzerType.mappingEditor.confirmation.current": "当前确认",
  "analyzerType.mappingEditor.confirmation.stale": "确认信息已过期",
  "analyzerType.mappingEditor.confirmation.summary.current": "当前",
  "analyzerType.mappingEditor.confirmation.summary.stale": "过期",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "未确认",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "未确认",
  "analyzerType.mappingEditor.confirmation": "确认",
  "analyzerType.mappingEditor.confirmed": "映射和控制识别已确认",
  "analyzerType.mappingEditor.error.confirm": "确认失败",
  "analyzerType.mappingEditor.error.load": "无法加载分析仪类型映射",
  "analyzerType.mappingEditor.error.route": "需要有效的分析仪类型修订版本",
  "analyzerType.mappingEditor.error.save": "无法保存映射",
  "analyzerType.mappingEditor.excludeResult.short": "请勿接收",
  "analyzerType.mappingEditor.excludeResult": "请勿接收 {value}",
  "analyzerType.mappingEditor.excludeTest": "请勿接收 {code}",
  "analyzerType.mappingEditor.incomplete": "在确认之前，请解决或明确排除每一行数据源。",
  "analyzerType.mappingEditor.loading": "正在加载分析仪类型映射",
  "analyzerType.mappingEditor.normalized": "规范化恒等式",
  "analyzerType.mappingEditor.observed": "在保留结果中观察到",
  "analyzerType.mappingEditor.recognition.heading": "控制结果识别",
  "analyzerType.mappingEditor.recognition.none": "该分析仪类型明确声明，该接口不传输任何控制结果。",
  "analyzerType.mappingEditor.resultPicker.placeholder": "选择一个 OpenELIS 结果",
  "analyzerType.mappingEditor.resultPicker": "{value} 的 OpenELIS 结果",
  "analyzerType.mappingEditor.results.empty": "此测试没有可选的活跃结果",
  "analyzerType.mappingEditor.results.heading": "结果 - {name}",
  "analyzerType.mappingEditor.results.loading": "正在加载结果选项",
  "analyzerType.mappingEditor.results.openCatalog": "在“检测目录”中添加结果选项",
  "analyzerType.mappingEditor.results.testFirst": "在将 OpenELIS 测试结果映射之前，请先选择一项 OpenELIS 测试",
  "analyzerType.mappingEditor.results": "结果映射",
  "analyzerType.mappingEditor.return": "分析仪类型管理",
  "analyzerType.mappingEditor.save": "更新共享映射",
  "analyzerType.mappingEditor.saved": "映射已保存",
  "analyzerType.mappingEditor.shared.subtitle": "Changes create a new mapping candidate for {count, plural, =0 {this Analyzer Type} one {# analyzer using this type} other {# analyzers using this type}}. Existing active configurations do not move until the candidate is confirmed and adopted.",
  "analyzerType.mappingEditor.shared.title": "共享分析仪类型的映射",
  "analyzerType.mappingEditor.sourceCode": "分析仪代码",
  "analyzerType.mappingEditor.state.bound": "已映射",
  "analyzerType.mappingEditor.state.excluded": "请勿接收",
  "analyzerType.mappingEditor.state.unresolved": "需求分析",
  "analyzerType.mappingEditor.subtitle": "{protocol} · 修订版 {revision}",
  "analyzerType.mappingEditor.suggestion": "推荐链接：{name}",
  "analyzerType.mappingEditor.summary": "地图概览",
  "analyzerType.mappingEditor.testPicker.placeholder": "按名称、位置代码或 LOINC 搜索",
  "analyzerType.mappingEditor.testPicker": "{code} 的 OpenELIS 测试",
  "analyzerType.mappingEditor.tests.heading": "测试与结果映射",
  "analyzerType.mappingEditor.tests.help": "请单独审查每个分析仪代码。将其映射到一个活跃的 OpenELIS 测试中，或明确将其排除在外。",
  "analyzerType.mappingEditor.tests": "已映射的检测项目",
  "analyzerType.mappingEditor.title": "{name} 映射",
  "analyzerType.mappingEditor.unsaved": "未保存的映射更改",
  "analyzerType.mappingEditor.useSuggestion": "使用建议的检测项目",
  "analyzerType.modal.deactivate.subtitle": "现有分析仪与修订历史记录仍保持关联。此配置文件将不再可用用于新分析仪的设置中。",
  "analyzerType.modal.deactivate.title": "停用 {name}",
  "analyzerType.modal.history.title": "{name} 历史",
  "analyzerType.modal.reactivate.subtitle": "该配置文件将再次可用于新分析仪的设置中。现有分析仪仍将保持其已选择版本。",
  "analyzerType.modal.reactivate.title": "重新激活 {name}",
  "analyzerType.modal.update.subtitle": "This starts a new immutable revision from revision {revision}. {count, plural, one {# analyzer remains pinned to its current revision.} other {# analyzers remain pinned to their current revisions.}}",
  "analyzerType.modal.update.title": "更新 {name}",
  "analyzerType.notification.action.error.subtitle": "请再次尝试执行该个人资料操作。",
  "analyzerType.notification.action.error": "个人资料操作失败",
  "analyzerType.notification.create.success": "个人资料已创建",
  "analyzerType.notification.deactivate.success": "个人资料已停用",
  "analyzerType.notification.duplicate.success": "个人资料重复",
  "analyzerType.notification.update.success": "个人资料已更新",
  "analyzerType.notification.loadError.subtitle": "请检查分析仪桥接器的连接，然后重试。",
  "analyzerType.notification.loadError": "无法加载分析仪类型管理",
  "analyzerType.notification.reactivate.success": "个人资料已重新激活",
  "analyzerType.page.subtitle": "分析仪背后的可重复使用组件。",
  "analyzerType.page.title": "分析仪类型管理",
  "analyzerType.protocol.file": "平面文件",
  "analyzerType.recognition.none.affirmation": "我确认该接口不会传输控制结果",
  "analyzerType.recognition.none.subtitle": "仅当分析仪接口未发送控制结果时，才发布此配置文件。传输控制指令的配置文件需要明确的识别规则。",
  "analyzerType.recognition.none.title": "无法自动识别控制结果",
  "analyzerType.recognition.condition.add": "添加条件",
  "analyzerType.recognition.condition.fieldValue": "{source} 值",
  "analyzerType.recognition.condition.new": "新的识别条件",
  "analyzerType.recognition.condition.prefixValue": "标本ID前缀",
  "analyzerType.recognition.condition.remove": "移除条件",
  "analyzerType.recognition.condition.select.placeholder": "选择一种情况",
  "analyzerType.recognition.condition.select": "全新状态",
  "analyzerType.recognition.condition.sourceContains": "{source} 包含",
  "analyzerType.recognition.condition.sourceEquals": "{source} 等于",
  "analyzerType.recognition.condition.specimenPrefix": "标本编号以",
  "analyzerType.recognition.condition.summary.configuredPattern": "标本 ID 与配置的模式匹配",
  "analyzerType.recognition.condition.summary.contains": "{source} 包含 {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} 等于{value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} 以 {value} 开头",
  "analyzerType.recognition.condition.summary.unknown": "控制-结果识别",
  "analyzerType.recognition.error.load": "无法加载控件识别。",
  "analyzerType.recognition.error.save": "无法保存控制识别。",
  "analyzerType.recognition.error.title": "控制识别问题需要引起重视",
  "analyzerType.recognition.heading": "控制结果识别",
  "analyzerType.recognition.loading": "载荷控制识别",
  "analyzerType.recognition.mode.none": "该接口不传输控制结果",
  "analyzerType.recognition.mode.none.short": "未识别控制结果",
  "analyzerType.recognition.mode.rules": "使用以下条件识别控件",
  "analyzerType.recognition.mode.rules.short": "基于规则的控制识别",
  "analyzerType.recognition.mode": "该界面是如何识别控制结果的？",
  "analyzerType.recognition.rules.help": "当满足任何一个条件时，该结果即被视为对照组结果。",
  "analyzerType.recognition.save": "保存控制识别",
  "analyzerType.recognition.saved": "已保存控制识别",
  "analyzerType.recognition.source.specimenId": "标本编号",
  "analyzerType.recognition.validation.title": "个人简介草稿仍需完善",
  "analyzerType.revision": "修订版 {revision}",
  "analyzerType.search.label": "搜索分析仪类型",
  "analyzerType.search.placeholder": "搜索分析仪类型...",
  "analyzerType.source.shipped": "已发货",
  "analyzerType.source.site": "网站自建",
  "analyzerType.status.active": "活跃",
  "analyzerType.status.inactive": "已停用",
  "analyzerType.summary.ariaLabel": "分析仪类型汇总",
  "analyzerType.summary.deactivated": "已停用",
  "analyzerType.summary.inUse": "使用中",
  "analyzerType.summary.needsAttention": "需注意",
  "analyzerType.summary.total": "分析仪类型管理",
  "analyzerType.usedBy": "{count, plural, =0 {Not in use} one {# analyzer} other {# analyzers}}",
  "analyzer.navigation.qcControlLots": "对照组",
  "analyzer.navigation.qcRuleConfig": "规则配置",
  "analyzer.page.addButton": "添加分析仪",
  "analyzer.page.hierarchy.list": "列表",
  "analyzer.page.hierarchy.mappings": "映射",
  "analyzer.page.hierarchy.root": "分析仪",
  "analyzer.page.title": "分析仪管理",
  "analyzer.plugin.missing": "插件缺失",
  "analyzer.qc.alerts.message": "当质控结果超出可接受范围时将显示警报",
  "analyzer.qc.alerts.title": "质控警报",
  "analyzer.qc.corrective.message": "记录和跟踪质控失败的纠正措施",
  "analyzer.qc.corrective.title": "纠正措施",
  "analyzer.qc.placeholder.message": "此功能即将推出",
  "analyzer.qc.placeholder.title": "质控",
  "analyzer.action.viewResults": "查看结果",
  "analyzer.results.held.code": "分析仪代码：{code}",
  "analyzer.results.held.reviewMapping": "审查分析仪类型映射",
  "analyzer.results.held.subtitle": "无法接受已暂存的结果。请解决分析仪类型映射问题，以便下一个匹配结果能够进入正常的审核工作流。",
  "analyzer.results.held.tag": "举行",
  "analyzer.results.held.title": "{count, plural, one {# analyzer result needs attention} other {# analyzer results need attention}}",
  "analyzer.qualitativeMapping.isDefault": "默认值",
  "analyzer.qualitativeMapping.mappings": "映射",
  "analyzer.qualitativeMapping.noValues": "无可用值",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "选择OpenELIS代码",
  "analyzer.qualitativeMapping.subtitle": "配置定性结果映射",
  "analyzer.qualitativeMapping.title": "定性映射",
  "analyzer.qualitativeMapping.validation.error": "验证错误",
  "analyzer.qualitativeMapping.validation.error.subtitle": "请修正以下错误后再保存",
  "analyzer.qualitativeMapping.validation.noDefault": "未设置默认值",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "必须选择一个默认映射",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "OpenELIS代码为必填项",
  "analyzer.query.button": "查询分析仪",
  "analyzer.query.cancel": "取消",
  "analyzer.query.modal.logs": "日志",
  "analyzer.query.modal.noLogs": "暂无日志",
  "analyzer.query.modal.progress": "进度",
  "analyzer.query.modal.state": "状态",
  "analyzer.query.modal.subtitle": "查询分析仪获取结果",
  "analyzer.query.modal.title": "查询分析仪",
  "analyzer.query.progress": "查询进行中...",
  "analyzer.search.label": "搜索",
  "analyzer.search.placeholder": "搜索分析仪...",
  "analyzer.attention.review": "查看已保存的结果",
  "analyzer.attention.subtitle": "在将这些结果用于临床之前，请先对未知检测项目或值进行映射。",
  "analyzer.attention.tag": "需要关注",
  "analyzer.attention.title.many": "{count} 分析仪已保存结果",
  "analyzer.attention.title.one": "{name} 已公布结果",
  "analyzer.stat.active": "活跃",
  "analyzer.stat.inactive": "非活跃",
  "analyzer.stat.needsAttention": "需要关注",
  "analyzer.stat.setup": "在“设置中”",
  "analyzer.stat.total": "总计",
  "analyzer.stats.active": "活跃",
  "analyzer.stats.inactive": "非活跃",
  "analyzer.stats.total": "总计",
  "analyzer.status.active": "活跃",
  "analyzer.status.deleted": "已删除",
  "analyzer.status.error_pending": "错误待处理",
  "analyzer.status.inactive": "非活跃",
  "analyzer.status.offline": "离线",
  "analyzer.status.setup": "设置中",
  "analyzer.status.validation": "验证中",
  "analyzer.success.save": "保存成功",
  "analyzer.table.actions": "操作",
  "analyzer.table.connection": "连接",
  "analyzer.table.header.connection": "连接",
  "analyzer.table.header.lastModified": "最后修改",
  "analyzer.table.header.name": "名称",
  "analyzer.table.header.status": "状态",
  "analyzer.table.header.testUnits": "检测科室",
  "analyzer.table.header.type": "类型",
  "analyzer.table.lastModified": "最后修改",
  "analyzer.table.name": "名称",
  "analyzer.table.status": "状态",
  "analyzer.table.testUnits": "检测科室",
  "analyzer.table.type": "类型",
  "analyzer.table.type.loading": "加载分析仪类型",
  "analyzer.table.type.unavailable": "分析仪类型不可用",
  "analyzer.testUnits.count": "{count, plural, one {# unit} other {# units}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "网络桥健康检查失败",
  "analyzer.testConnection.bridge.httpStatus": "网络桥HTTP状态错误",
  "analyzer.testConnection.bridge.notConfigured": "网络桥未配置",
  "analyzer.testConnection.bridge.unparseableResponse": "网络桥响应无法解析",
  "analyzer.testConnection.bridge.unreachable": "网络桥无法访问",
  "analyzer.testConnection.close": "关闭",
  "analyzer.testConnection.logs": "连接日志",
  "analyzer.testConnection.requestBuildFailed": "请求构建失败",
  "analyzer.testConnection.success": "连接成功",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "TCP网络桥未配置",
  "analyzer.testConnection.testAgain": "重新测试",
  "analyzer.testConnection.testing": "正在测试连接...",
  "analyzer.testConnection.title": "测试连接",
  "analyzer.testMapping.activeMappings": "活跃映射",
  "analyzer.testMapping.analyzerInfo": "分析仪信息",
  "analyzer.testMapping.analyzerName": "分析仪名称",
  "analyzer.testMapping.analyzerType": "分析仪类型",
  "analyzer.testMapping.appliedMappings": "已应用的映射",
  "analyzer.testMapping.entityPreview": "实体预览",
  "analyzer.testMapping.errors": "错误",
  "analyzer.testMapping.loading": "加载中...",
  "analyzer.testMapping.messageInput": "消息输入",
  "analyzer.testMapping.messageInput.counter": "字符数",
  "analyzer.testMapping.messageInput.helper": "粘贴分析仪消息以测试映射配置",
  "analyzer.testMapping.messageInput.placeholder": "在此粘贴分析仪消息...",
  "analyzer.testMapping.messageInput.required": "消息为必填项",
  "analyzer.testMapping.noResults": "无结果",
  "analyzer.testMapping.parsedFields": "解析字段",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM引用",
  "analyzer.testMapping.parsedFields.fieldName": "字段名称",
  "analyzer.testMapping.parsedFields.interpretation": "解释",
  "analyzer.testMapping.parsedFields.mappedTo": "映射到",
  "analyzer.testMapping.parsedFields.rawValue": "原始值",
  "analyzer.testMapping.pluginConfigSnapshot": "插件配置快照",
  "analyzer.testMapping.previewOptions": "预览选项",
  "analyzer.testMapping.previewOptions.detailedParsing": "详细解析",
  "analyzer.testMapping.previewOptions.validateAll": "验证全部",
  "analyzer.testMapping.results": "结果",
  "analyzer.testMapping.saveTestCase": "保存测试用例",
  "analyzer.testMapping.submit": "提交",
  "analyzer.testMapping.subtitle": "测试分析仪消息映射配置",
  "analyzer.testMapping.testAnother": "测试其他消息",
  "analyzer.testMapping.title": "测试映射",
  "analyzer.testMapping.validation.invalidFormat": "消息格式无效",
  "analyzer.testMapping.validation.messageRequired": "消息为必填项",
  "analyzer.testMapping.validation.messageTooLarge": "消息过大",
  "analyzer.testMapping.warnings": "警告",
  "analyzer.unitMapping.analyzerUnit": "分析仪单位",
  "analyzer.unitMapping.analyzerUnit.helper": "分析仪报告的计量单位",
  "analyzer.unitMapping.conversionFactor": "转换因子",
  "analyzer.unitMapping.conversionFactor.helper": "用于将分析仪单位转换为OpenELIS单位的乘数",
  "analyzer.unitMapping.openelisUnit": "OpenELIS单位",
  "analyzer.unitMapping.openelisUnit.helper": "OpenELIS系统中使用的计量单位",
  "analyzer.unitMapping.openelisUnit.placeholder": "选择OpenELIS单位",
  "analyzer.unitMapping.rejectIfMismatch": "不匹配时拒绝",
  "analyzer.unitMapping.rejectIfMismatch.helper": "当单位不匹配时自动拒绝结果",
  "analyzer.unitMapping.subtitle": "配置分析仪与OpenELIS之间的单位映射",
  "analyzer.unitMapping.title": "单位映射",
  "analyzer.unitMapping.validation.analyzerUnit.required": "分析仪单位为必填项",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "转换因子无效",
  "analyzer.unitMapping.validation.conversionFactor.required": "转换因子为必填项",
  "analyzer.unitMapping.validation.error": "验证错误",
  "analyzer.unitMapping.validation.error.subtitle": "请修正以下错误后再保存",
  "analyzer.unitMapping.validation.openelisUnit.required": "OpenELIS单位为必填项",
  "analyzerTestName.header.analyzerName": "分析仪 - 分析仪检测名称",
  "analyzerTestName.modal.add.heading": "添加分析仪检测名称",
  "analyzerTestName.modal.update.heading": "更新分析仪检测名称",
  "assigned.cytopathologist.label": "已分配细胞病理学家",
  "assigned.pathologist.label": "已分配病理学家",
  "assigned.technician.label": "已分配技术员",
  "audittrail.table.heading.action": "操作",
  "audittrail.table.heading.identifier": "标识符",
  "audittrail.table.heading.item": "项目",
  "audittrail.table.heading.newvalue": "新值",
  "audittrail.table.heading.oldvalue": "旧值",
  "audittrail.table.heading.time": "时间",
  "audittrail.table.heading.user": "用户",
  "audittrail.table.title.patientResults": "患者结果",
  "availabletests.title": "可用检测",
  "back.action.button": "返回",
  "banner.menu.administration": "管理",
  "banner.menu.alerts": "警报",
  "banner.menu.alerts.tooltip": "查看系统警报",
  "banner.menu.aliquot": "分装样本",
  "banner.menu.aliquot.tooltip": "样本分装",
  "banner.menu.billing": "计费",
  "banner.menu.billing.tooltip": "计费",
  "banner.menu.createDouble": "双重录入",
  "banner.menu.createInitial": "初始录入",
  "banner.menu.eorders": "传入订单",
  "banner.menu.eqa": "外部质量评估",
  "banner.menu.eqa.distribution": "分发",
  "banner.menu.eqa.distribution.tooltip": "EQA样本分发",
  "banner.menu.eqa.management": "管理",
  "banner.menu.eqa.management.tooltip": "EQA管理",
  "banner.menu.eqa.mgmt": "EQA管理",
  "banner.menu.eqa.mgmt.distributions": "分发管理",
  "banner.menu.eqa.mgmt.distributions.tooltip": "管理EQA样本分发",
  "banner.menu.eqa.mgmt.participants": "参与者",
  "banner.menu.eqa.mgmt.participants.tooltip": "管理EQA参与者",
  "banner.menu.eqa.mgmt.programs": "计划",
  "banner.menu.eqa.mgmt.programs.tooltip": "管理EQA计划",
  "banner.menu.eqa.mgmt.results": "结果",
  "banner.menu.eqa.mgmt.results.tooltip": "管理EQA结果",
  "banner.menu.eqa.mgmt.tooltip": "外部质量评估管理",
  "banner.menu.eqa.tests": "检测",
  "banner.menu.eqa.tests.myPrograms": "我的计划",
  "banner.menu.eqa.tests.myPrograms.tooltip": "查看我参与的EQA计划",
  "banner.menu.eqa.tests.orders": "订单",
  "banner.menu.eqa.tests.orders.tooltip": "查看EQA检测订单",
  "banner.menu.eqa.tests.tooltip": "EQA检测",
  "banner.menu.eqa.tooltip": "外部质量评估",
  "banner.menu.generic.sample": "通用样本",
  "banner.menu.generic.sample.edit": "编辑样本",
  "banner.menu.generic.sample.import": "导入样本",
  "banner.menu.generic.sample.order": "接收样本",
  "banner.menu.generic.sample.results": "输入结果",
  "banner.menu.help": "帮助",
  "banner.menu.help.about": "视频教程",
  "banner.menu.help.contact": "版本说明",
  "banner.menu.help.documents": "流程文档",
  "banner.menu.help.formDBS": "DBS表单",
  "banner.menu.help.formVL": "VL表单",
  "banner.menu.help.usermanual": "用户手册",
  "banner.menu.home": "首页",
  "banner.menu.inventory": "库存",
  "banner.menu.inventory.catalog": "管理目录",
  "banner.menu.inventory.dashboard": "仪表板",
  "banner.menu.inventory.list": "库存物品",
  "banner.menu.inventory.reports": "报告",
  "banner.menu.nonconformity": "不符合项",
  "banner.menu.nonconformity.correctiveActions": "纠正措施",
  "banner.menu.nonconformity.dashboard": "所有NCE",
  "banner.menu.nonconformity.report": "报告不符合事件",
  "banner.menu.nonconformity.view": "查看新的不符合事件",
  "banner.menu.patient": "患者",
  "banner.menu.patient.Create": "研究",
  "banner.menu.patient.addOrEdit": "添加/编辑患者",
  "banner.menu.patient.merge": "合并患者",
  "banner.menu.patient.merge.tooltip": "合并重复患者记录",
  "banner.menu.patientConsult": "查看",
  "banner.menu.patientEdit": "编辑",
  "banner.menu.patienthistory": "患者历史",
  "banner.menu.printBarcode": "条码",
  "banner.menu.referredOut": "转诊",
  "banner.menu.report.validation.backlog": "延迟验证",
  "banner.menu.reports": "报告",
  "banner.menu.reports.routine": "常规",
  "banner.menu.reports.study": "研究",
  "banner.menu.results": "结果",
  "banner.menu.results.CobasIntegra400": "生物化学: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "免疫学: FacsCalibur",
  "banner.menu.results.FacsCantoII": "免疫学: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "免疫学: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "生物化学: 全自动分析仪导入器",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpert分析仪",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpert文件分析仪",
  "banner.menu.results.PocH100iAnalyzer": "PocH100i分析仪",
  "banner.menu.results.SysmeXT": "血液学: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNL分析仪",
  "banner.menu.results.SysmexXNLanalyzer": "SysmexXNL分析仪",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXP分析仪",
  "banner.menu.results.SysmexXPanalyzer": "SysmexXP分析仪",
  "banner.menu.results.accession": "按订单",
  "banner.menu.results.analyzer": "分析仪",
  "banner.menu.results.cobasc111analyzer": "生物化学: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert分析仪",
  "banner.menu.results.logbook": "按单元",
  "banner.menu.results.mindrayanalyzer": "迈瑞分析仪",
  "banner.menu.results.order.programmes": "订单程序",
  "banner.menu.results.patient": "按患者",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "按检测、日期或状态",
  "banner.menu.results.sysmexanalyzer": "血液学: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "血液学: Sysmex XT分析仪导入器",
  "banner.menu.results.taqman48dbsanalyzer": "病毒学: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "按检测日期",
  "banner.menu.results.unified": "结果录入",
  "banner.menu.results.unified.tooltip": "统一结果录入工作列表",
  "banner.menu.results.weber": "韦伯 4000",
  "banner.menu.resultvalidation": "验证",
  "banner.menu.resultvalidation.bacteria": "细菌",
  "banner.menu.resultvalidation.bench": "按工作台",
  "banner.menu.resultvalidation.biochemistry": "生物化学",
  "banner.menu.resultvalidation.cytobacteriology": "细胞细菌学",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "内分泌学",
  "banner.menu.resultvalidation.genotyping": "基因分型",
  "banner.menu.resultvalidation.hemato-immunology": "血液免疫学",
  "banner.menu.resultvalidation.hematology": "血液学",
  "banner.menu.resultvalidation.immunology": "免疫学",
  "banner.menu.resultvalidation.immunology.Haiti": "免疫学-病毒学",
  "banner.menu.resultvalidation.immunologyHematology": "免疫学 - 血液学",
  "banner.menu.resultvalidation.liquidBio": "液体生物学",
  "banner.menu.resultvalidation.malaria": "疟疾",
  "banner.menu.resultvalidation.molecularBio": "分子生物学",
  "banner.menu.resultvalidation.mycobacteriology": "分枝杆菌学",
  "banner.menu.resultvalidation.mycology": "真菌学",
  "banner.menu.resultvalidation.parasitology": "寄生虫学",
  "banner.menu.resultvalidation.serology": "血清学",
  "banner.menu.resultvalidation.serology-immunology": "血清学-免疫学",
  "banner.menu.resultvalidation.viralload": "病毒载量",
  "banner.menu.resultvalidation.virology": "病毒学",
  "banner.menu.resultvalidation_routine": "常规",
  "banner.menu.resultvalidation_study": "研究",
  "banner.menu.sample": "订单",
  "banner.menu.sample.shipment": "样本转运",
  "banner.menu.sampleAdd": "添加订单",
  "banner.menu.sampleBatchEntry": "批量订单录入",
  "banner.menu.sampleConsult": "查看",
  "banner.menu.sampleCreate": "研究",
  "banner.menu.sampleEdit": "编辑订单",
  "banner.menu.sampleManagement": "样本管理",
  "banner.menu.sampleManagement.tooltip": "样本管理菜单",
  "banner.menu.storage": "存储",
  "banner.menu.storage.tooltip": "样本存储管理",
  "banner.menu.study.eorders": "电子订单",
  "banner.menu.workplan": "工作计划",
  "banner.menu.workplan.batch": "Batch Workplan",
  "banner.menu.workplan.batch.tooltip": "Batch Workplan",
  "banner.menu.workplan.bench": "按单元",
  "banner.menu.workplan.panel": "按面板",
  "banner.menu.workplan.priority": "按优先级",
  "banner.menu.workplan.test": "按检测类型",
  "banner.menu.workplan.unit": "按检测科室",
  "barcode.additionalInvalidLevels.message": "条码包含超出有效部分的其他级别。仅预填有效级别。",
  "barcode.additionalInvalidLevels.warning": "检测到其他无效级别",
  "barcode.autoOpenForm": "使用有效层次结构打开位置表单",
  "barcode.debounce.warning": "请在扫描另一个条码前等待",
  "barcode.error": "无效条码",
  "barcode.firstMissingLevel": "第一个缺失级别：{level}",
  "barcode.format": "条码格式",
  "barcode.header": "条码",
  "barcode.invalidFormat": "无效的条码格式。预期：ROOM-DEVICE 或 ROOM-DEVICE-SHELF-RACK-POSITION",
  "barcode.label.block": "块标签",
  "barcode.label.freezer": "冰箱标签",
  "barcode.label.helper.text": "以毫米为单位输入值",
  "barcode.label.order": "订单标签行",
  "barcode.label.slide": "幻灯片标签",
  "barcode.label.specimen": "标本标签",
  "barcode.label.info.blockCaseNumber": "蜡块病例号",
  "barcode.label.info.blockId": "蜡块ID",
  "barcode.label.info.blockNumber": "蜡块编号",
  "barcode.label.info.boxid": "箱子编号",
  "barcode.label.info.caseNumber": "病例号",
  "barcode.label.info.collectedBy": "采集人",
  "barcode.label.info.collectionDate": "采集日期",
  "barcode.label.info.collectionDateTime": "采集日期时间",
  "barcode.label.info.created": "创建时间",
  "barcode.label.info.destination": "目标机构",
  "barcode.label.info.expiryDate": "过期日期",
  "barcode.label.info.labNumber": "实验室编号",
  "barcode.label.info.patientDobFull": "出生日期",
  "barcode.label.info.patientId": "患者ID",
  "barcode.label.info.patientName": "患者姓名",
  "barcode.label.info.patientSexFull": "性别",
  "barcode.label.info.samplecount": "样本数量",
  "barcode.label.info.siteId": "站点ID",
  "barcode.label.info.slideId": "切片ID",
  "barcode.label.info.slideNumber": "切片编号",
  "barcode.label.info.specimenType": "标本类型",
  "barcode.label.info.stainType": "染色类型",
  "barcode.label.info.storageLocation": "存储位置",
  "barcode.label.info.temperature": "储存温度",
  "barcode.label.info.tests": "检测",
  "barcode.labels.order.row": "订单标签行",
  "barcode.labels.running.total": "标签累计总数",
  "barcode.labels.sample.row": "样本标签行",
  "barcode.labels.section.title": "条码标签",
  "barcode.locationNotFound": "未找到位置",
  "barcode.notification.save": "条码配置已保存。",
  "barcode.partialMatch": "部分匹配 - 某些组件有效",
  "barcode.print.button": "打印",
  "barcode.print.dialog.quantityFor": "{label} 的打印数量",
  "barcode.print.dialog.title": "打印条码",
  "barcode.print.done": "打印完成",
  "barcode.print.individual.button": "打印标签",
  "barcode.print.later": "跳过 — 稍后打印",
  "barcode.print.preprint": "预印条码",
  "barcode.print.preprint.button": "预印标签",
  "barcode.print.preprint.note": "注意：如果添加了设施和/或样本和检测，它们将打印在每个标签上",
  "barcode.print.reprint.dialog": "重新打印条码",
  "barcode.print.section.set": "打印组",
  "barcode.print.set.button": "打印组",
  "barcode.print.set.instruction": "打印标签组(2个订单标签 + 每个标本1个标签)",
  "barcode.print.skip": "跳过",
  "barcode.print.title": "打印条码标签",
  "barcode.ready": "准备扫描",
  "barcode.scan": "扫描条码",
  "barcode.scan.error": "未找到订单",
  "barcode.scan.placeholder": "扫描条码或输入实验室编号...",
  "barcode.scan.success": "订单已成功加载",
  "barcode.scanning": "扫描中...",
  "barcode.scanOrType": "扫描条码或输入位置",
  "barcode.success": "找到位置",
  "barcode.validHierarchyPrefilled": "有效层次结构级别已预填",
  "barcode.validation.altPrefix": "备用前缀",
  "barcode.validationFailed": "条码验证失败",
  "barcodeconfiguration.browse.title": "条码配置",
  "breadcrumb.home": "首页",
  "breadcrumb.caseView": "案例查看",
  "breadcrums.admin.managment": "管理",
  "calendar.management.title": "日历管理",
  "calendar.management.description": "管理公共假期和周末配置,用于工作时间TAT(周转时间)计算",
  "calendar.management.addHoliday": "添加假期",
  "calendar.management.editHoliday": "编辑假期",
  "calendar.management.deleteConfirm": "确定要删除此假期吗?",
  "calendar.management.holidayName": "假期名称",
  "calendar.management.date": "日期",
  "calendar.management.recurring": "重复",
  "calendar.management.annual": "每年",
  "calendar.management.oneTime": "一次性",
  "calendar.management.active": "活跃",
  "calendar.management.inactive": "非活跃",
  "calendar.management.weekend": "周末",
  "calendar.management.weekendDays": "周末日期(不计入工作时间)",
  "calendar.management.weekendSaved": "周末配置已保存",
  "calendar.management.importCsv": "导入CSV",
  "calendar.management.exportCsv": "导出翻译",
  "calendar.management.importPreview": "导入预览",
  "calendar.management.year": "年份",
  "calendar.management.noHolidays": "未为{year}年配置假期。点击\"添加假期\"开始配置。",
  "calendar.management.duplicateDate": "此日期已存在假期",
  "calendar.management.imported": "已导入{count}个假期",
  "calendar.management.skipped": "已跳过{count}个假期",
  "calendar.management.holidayCount": "已为{year}年配置{count}个假期",
  "calendar.management.saveError": "保存假期时出错",
  "calendar.management.loadError": "加载假期时出错",
  "calendar.management.save": "保存",
  "calendar.management.cancel": "取消",
  "calendar.management.actions": "操作",
  "calendar.management.status": "状态",
  "calendar.management.column.date": "日期",
  "calendar.management.column.holidayName": "假期名称",
  "calendar.management.column.recurring": "重复",
  "calendar.management.column.status": "状态",
  "calendar.management.column.actions": "操作",
  "calendar.management.day.sun": "周日",
  "calendar.management.day.mon": "周一",
  "calendar.management.day.tue": "周二",
  "calendar.management.day.wed": "周三",
  "calendar.management.day.thu": "周四",
  "calendar.management.day.fri": "周五",
  "calendar.management.day.sat": "周六",
  "calendar.management.chooseFile": "选择CSV文件",
  "calendar.management.csvColumns": "列: date(日期), name(名称), recurring(是否重复, true/false)",
  "calendar.management.rowsFound": "找到{count}行",
  "calendar.management.column.csvDate": "日期",
  "calendar.management.column.csvName": "名称",
  "calendar.management.column.csvRecurring": "重复",
  "calendar.management.importing": "正在导入...",
  "caseView.action.discard": "Discard changes",
  "caseView.action.saveDraft": "Save draft",
  "caseView.banner.unsavedChanges": "This case has unsaved changes. Leave the page and lose them?",
  "caseView.badge.notApplicable": "不适用",
  "caseView.badge.readOnly": "Read only",
  "caseView.label.assignedStaff": "{role}: {name}",
  "caseView.label.caseProgress": "案件进度",
  "caseView.label.caseSummary": "Case summary",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "— not recorded",
  "caseView.label.unsavedChanges": "未保存的更改",
  "caseView.locked.awaitingStage": "Available once the case reaches {stage}",
  "caseView.locked.prerequisite": "Available once this case's earlier steps are complete",
  "column.qc.accession": "QC 样本",
  "column.qc.detail": "详情",
  "column.qc.result": "结果",
  "column.qc.test": "检测",
  "column.qc.type": "设备类型",
  "compliance.dashboard.chart.comparison.title": "站点对比 — 本期合规率（%）",
  "compliance.dashboard.chart.drilldown.title": "站点详细分析 — 按参数趋势",
  "compliance.dashboard.chart.trend.title": "合规率趋势 — 所有站点",
  "compliance.dashboard.descriptive.excluded": "趋势图中未包含的描述性参数",
  "compliance.dashboard.drilldown.placeholder": "选择一个站点……",
  "compliance.dashboard.empty": "没有数据符合已选择的过滤器条件",
  "compliance.dashboard.export.pdf": "导出PDF",
  "compliance.dashboard.filter.allStandards": "所有标准",
  "compliance.dashboard.filter.dateRange": "日期范围",
  "compliance.dashboard.filter.dateRangeEnd": "结束日期",
  "compliance.dashboard.filter.drilldownSite": "由站点进行深入分析",
  "compliance.dashboard.filter.sites": "样本点",
  "compliance.dashboard.filter.standard": "合规标准",
  "compliance.dashboard.kpi.complianceRate": "合规率",
  "compliance.dashboard.kpi.exceedances": "超标总次数",
  "compliance.dashboard.kpi.sitesMonitored": "受监测站点",
  "compliance.dashboard.kpi.totalOrders": "订单总数",
  "compliance.dashboard.loading.comparison": "正在加载比较结果……",
  "compliance.dashboard.loading.drilldown": "正在加载详细信息……",
  "compliance.dashboard.loading.exceedances": "正在加载超标数据……",
  "compliance.dashboard.loading.generating": "正在生成……",
  "compliance.dashboard.loading.trend": "正在加载趋势……",
  "compliance.dashboard.lowData": "数据较少（少于3个订单）",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "日期",
  "compliance.dashboard.table.col.labNumber": "实验编号 #",
  "compliance.dashboard.table.col.parameter": "参数",
  "compliance.dashboard.table.col.result": "结果",
  "compliance.dashboard.table.col.site": "网站",
  "compliance.dashboard.table.col.status": "状态",
  "compliance.dashboard.table.col.threshold": "阈值",
  "compliance.dashboard.table.exceedances.title": "超标情况摘要",
  "compliance.dashboard.title": "环境合规仪表板",
  "error.referOut.emailFormat": "请输入一个有效的电子邮件地址（例如：lab@example.org）。",
  "error.referOut.handoffRequiredForDispatch": "交接日期时间是派工的必填项。",
  "error.referOut.maxLength": "最多{max}个字符。",
  "error.referOut.phoneFormat": "请输入包含国家代码前缀的有效电话号码（例如：+62 812 3456 7890）。",
  "error.referOut.referringLabRequired": "选择一家参考实验室。",
  "error.validation.qc.ackFailed": "未能记录QC确认。请重试。",
  "holding.time.exceeded.message": "以下请求的 SOP 最大持有时间已超出：{tests}",
  "holding.time.exceeded.note": "警告：在超过SOP最大保持时间后输入了结果。",
  "holding.time.exceeded.title": "超时",
  "instructions.results.entry.unified.route": "启用后，统一的“结果录入”工作列表将取代旧版的结果录入页面：“结果”菜单中将仅显示一个“结果录入”项目，而旧版的结果录入链接将重定向至该项目。若要恢复旧版页面，请禁用此功能。",
  "label.button.edit.details": "编辑详情",
  "label.expand.poolDetails": "展开泳池详情",
  "label.pool.collapse": "隐藏单个标本",
  "label.pool.expand": "显示单个标本",
  "label.pool.expansion.next": "下一个",
  "label.pool.expansion.page": "第 {page} 页，共 {total} 页",
  "label.pool.expansion.prev": "上一个",
  "label.pool.expansion.title": "{animal} 标本（{count}）",
  "label.qc.fail": "失败",
  "label.qc.pass": "通过",
  "label.referOut.action.dispatch": "快讯",
  "label.referOut.action.edit": "编辑",
  "label.referOut.action.referOut": "转诊",
  "label.referOut.action.save": "保存转诊",
  "label.referOut.action.view": "查看",
  "label.referOut.column.actions": "操作",
  "label.referOut.column.referringLab": "转诊实验室",
  "label.referOut.column.sampleId": "样本编号",
  "label.referOut.column.sampleType": "样本类型",
  "label.referOut.column.status": "分包状态",
  "label.referOut.column.tests": "检测项目",
  "label.referOut.dispatch.error": "无法分派转介。",
  "label.referOut.dispatch.notSaved": "在发送前请先保存转诊单。",
  "label.referOut.dispatch.success": "转诊已发送。",
  "label.referOut.empty.subtitle": "样本保存后会显示在此处。请先保存订单，然后才能将标本转送。",
  "label.referOut.empty.title": "无可用样本",
  "label.referOut.field.agreementReference": "协议编号",
  "label.referOut.field.cocContactEmail": "产销监管链联系人电子邮件",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "产销监管链联系人名称",
  "label.referOut.field.cocContactPhone": "产销监管链联系人电话",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "预计归还日期",
  "label.referOut.field.handoffDate": "移交日期",
  "label.referOut.field.handoffDatetime": "移交日期时间",
  "label.referOut.field.handoffTime": "交接时间",
  "label.referOut.field.handoffTime.placeholder": "时:分:秒",
  "label.referOut.field.notes": "备注",
  "label.referOut.field.referringLab": "转诊实验室",
  "label.referOut.field.referringLab.placeholder": "选择参考实验室",
  "label.referOut.save.error": "保存失败。",
  "label.referOut.save.success": "转诊已保存。",
  "label.referOut.section.description": "将标本送往外部实验室。每个标本都附有完整的证据链元数据。",
  "label.referOut.section.title": "转诊 / 分包",
  "label.referOut.status.cancelled": "已取消",
  "label.referOut.status.closed": "已关闭",
  "label.referOut.status.completed": "已完成",
  "label.referOut.status.dispatched": "已发送",
  "label.referOut.status.draft": "草稿",
  "label.referOut.status.inProgress": "进行中",
  "label.referOut.status.notReferred": "内部",
  "label.referOut.status.received": "已接收",
  "label.referOut.status.rejected": "已拒收",
  "label.referOut.status.requested": "已请求",
  "label.referOut.status.resultsReturned": "返回的结果",
  "label.sampleKind.blank": "BLANK",
  "label.sampleKind.client": "客户样本",
  "label.sampleKind.control": "CONTROL",
  "label.sampleKind.duplicate": "DUPLICATE",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "我已审查了QC中的缺陷，并评估了这些缺陷对结果发布的影响",
  "label.validation.qc.ack.heading": "必填确认",
  "label.validation.qc.banner.subtitle": "在发布结果之前，请在下方进行审核并确认。",
  "label.validation.qc.banner.title": "检测到QC不合格——{count}的质量控制样本未通过验收标准",
  "label.validation.qc.failedSamples": "QC QC 失败样本",
  "label.validation.qc.justification": "理由",
  "label.validation.checkBeforeRelease": "发布前请检查",
  "label.validation.triage.filterLabel": "按信号过滤",
  "label.validation.filter.all": "所有分析仪",
  "label.validation.filter.needsReview": "需要审核",
  "label.validation.filter.nce": "NCE",
  "label.validation.filter.qcFail": "QC不合格",
  "label.validation.filter.modified": "已修改",
  "label.validation.filter.ackPending": "确认待处理",
  "label.validation.filter.critical": "紧急",
  "label.validation.filter.abnormal": "异常",
  "label.validation.lane.clear": "清除位置",
  "label.validation.lane.needsReview": "需要审核",
  "label.validation.signal.nce": "NCE 开放",
  "label.validation.signal.qcFail": "QC不合格",
  "label.validation.signal.modified": "已修改",
  "label.validation.signal.ackPending": "确认待处理",
  "label.validation.signal.nonconforming": "不符合要求",
  "label.validation.signal.critical": "紧急",
  "label.validation.review.result": "结果",
  "label.validation.review.units": "单位",
  "label.validation.review.normalRange": "参考范围",
  "label.validation.review.criticalRange": "危急范围",
  "label.validation.review.method": "方法",
  "label.validation.review.analyzer": "分析仪",
  "label.validation.review.performedAt": "Performed at",
  "label.validation.review.enteredBy": "录入人：",
  "label.validation.review.enteredDate": "录入于",
  "label.validation.review.collected": "已采样",
  "label.validation.review.qc": "QC",
  "label.validation.review.qc.PASS": "QC通过",
  "label.validation.review.qc.FAIL": "QC未通过",
  "label.validation.review.notRecorded": "未记录",
  "label.validation.review.beforeRelease": "发布前，请检查：",
  "label.validation.review.components": "组件",
  "label.validation.review.component": "组件",
  "label.validation.review.flag": "旗帜",
  "label.validation.review.primary": "主要",
  "label.validation.review.reference": "参考文献",
  "label.validation.review.notes": "备注",
  "label.validation.review.notes.summary": "{count} 备注",
  "label.validation.review.notes.empty": "尚无备注",
  "label.validation.review.notes.add": "验证说明",
  "label.validation.review.notes.placeholder": "添加一条验证备注……",
  "label.validation.review.notes.visibility": "可见性",
  "label.validation.review.notes.internal": "内部",
  "label.validation.review.notes.external": "发送并附上结果",
  "label.validation.review.notes.externalWarning": "该备注将显示在患者报告中。",
  "label.validation.review.notes.contextHint": "上下文：验证（自动记录）。",
  "label.validation.review.notes.context.result": "结果备注",
  "label.validation.review.modify.reason": "修改原因",
  "label.validation.review.modify.reasonRequired": "修改结果时需要提供理由。",
  "label.validation.review.modify.newValue": "新结果",
  "label.validation.review.modify.notEditable": "该结果类型可在“结果录入”页面进行编辑。",
  "label.validation.review.qcSection": "QC",
  "label.validation.review.reagents.followUp": "该分析所用的试剂和对照批次将在“结果录入”页面中进行审核。",
  "label.validation.review.action.release": "验证与发布",
  "label.validation.review.action.modify": "修改结果",
  "label.validation.review.action.saveModification": "保存修改",
  "label.validation.review.action.cancel": "取消",
  "label.validation.review.action.refer": "推荐此检测项目",
  "label.validation.review.release.qcAckFirst": "发布前请确认以下QC未通过的情况。",
  "label.validation.review.error.notAwaitingValidation": "自页面加载以来，该结果已发生变化。请重新加载页面并重新查看。",
  "label.validation.review.error.qcAcknowledgmentRequired": "该批次中失败数量的QC产品必须在放行前予以确认。",
  "label.validation.review.error.modificationReasonRequired": "修改结果时需要提供理由。",
  "label.validation.review.error.modifyRoleRequired": "您的角色权限不允许修改结果。",
  "label.validation.review.error.resultRequired": "保存前请输入结果值。",
  "label.validation.review.error.invalidResult": "结果不完整；请检查符合条件的值。",
  "label.validation.review.error.generic": "无法完成此操作。",
  "label.validation.review.success.released": "结果已审核并发布。",
  "label.validation.review.success.modified": "结果已修改。该结果仍保留在验证队列中。",
  "esig.context.validateSingle": "对登录号为 {accession} 的{test} 进行验证并发布",
  "label.validation.bulk.releaseAllClear": "发布“一切正常”通知（{count}）",
  "label.validation.bulk.heading": "发布所有合格结果",
  "label.validation.bulk.body": "这些 {count} 测试结果处于“清晰”状态：在范围内、通过 QC、无不符合项、未修改、非关键。发布时，整个数据集仅需一个电子签名；若该结果在发布前不再处于“清晰”状态，则该发布将被跳过。",
  "label.validation.bulk.disabled": "该关联机构已关闭批量发布功能。",
  "label.validation.emptyState.signals": "{count} results in this queue carry something to check before release.",
  "label.validation.emptyState.signalsDetail": "Most common: {signals}.",
  "label.validation.emptyState.noReference": "{count} results are for tests with no reference value recorded in the test catalogue, so they cannot be judged as normal.",
  "label.validation.emptyState.noReferenceHint": "Record an expected normal value for these tests in the Test Catalogue to let their results clear.",
  "label.validation.emptyState.queueEmpty": "Nothing is waiting for validation.",
  "label.validation.release.scope": "Clearance checks the reference range, result flags, non-conformities, edits after save and critical acknowledgment, and stops any result with a recorded quality-control failure. It does not confirm that quality control was performed.",
  "label.validation.bulk.none": "没有明确的结果可以公布。",
  "label.validation.bulk.column.accession": "实验室编号.",
  "label.validation.bulk.success": "{count} 公布了明确的结果。",
  "label.validation.bulk.partial": "{released} 已发布；{skipped} 因内容不再清晰而被跳过。",
  "label.validation.bulk.error.bulkReleaseDisabled": "该关联机构已关闭批量发布功能。",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "该批次中失败数量的QC产品必须在放行前予以确认。",
  "label.validation.bulk.error.nothingReleased": "所选结果中无一项目前已明确；尚未发布任何信息。",
  "label.validation.bulk.error.generic": "无法完成批量发布。",
  "label.validation.review.action.review": "评论 →",
  "esig.context.releaseAllClear": "发布 {count} 清除 {accession} 的结果",
  "instructions.validation.bulk.release": "启用后，“验证”页面将显示“批量放行”选项，该选项仅将“清除”通道（在范围内、通过QC、无信号）中的结果通过单一电子签名进行放行。若要要求在审核后逐个放行每个结果，请禁用此选项。",
  "instructions.validation.retest.note": "已启用此功能后，将结果发送给进行重新检测的验证人员，该人员必须为测试台撰写备注。",
  "label.validation.review.action.retest": "发送重新检测",
  "label.validation.review.action.reject": "拒绝（文件编号 NCE）",
  "label.validation.review.retest.note": "给法官的备注",
  "label.validation.review.retest.noteRequired": "发送重新检测结果时，必须附上一份备注。",
  "label.validation.review.retest.hint": "该结果将返回“结果录入”界面，管道将从第1级重新开始。",
  "label.validation.review.reject.hint": "拒绝文件属于不符合项；请完成此表进行记录。",
  "label.validation.review.reject.disabled": "该实验室已关闭结果拒收功能。",
  "label.validation.review.error.stale": "该结果由 {who} 在 {when} 处进行了修改。正在重新加载队列……",
  "label.validation.review.error.retestNoteRequired": "发送重新检测结果时，必须附上一份备注。",
  "label.validation.review.error.rejectionDisabled": "该实验室已关闭结果拒收功能。",
  "label.validation.review.success.retest": "结果已返回，需重新检测。",
  "label.validation.review.success.rejected": "结果被拒绝；该不符合项已记录在案。",
  "label.validation.bulk.error.stale": "您查看期间，队列发生了变化。正在重新加载页面……",
  "label.validation.autoValidated.toggle": "包含自动验证",
  "label.validation.autoValidated.heading": "自动验证的结果（{count}）",
  "label.validation.autoValidated.tag": "自动验证",
  "label.validation.autoValidated.empty": "该接种号没有经过自动验证的结果。",
  "label.validation.autoValidated.hint": "在结果录入时未经过验证器审核；仅供审核参考。",
  "label.validation.autoValidated.releasedOn": "发布于",
  "laporanHasil.action.generatePdf": "生成 PDF",
  "laporanHasil.action.regeneratePdf": "重新生成 PDF",
  "laporanHasil.col.actions": "操作",
  "laporanHasil.col.collectionDate": "采集日期",
  "laporanHasil.col.compliance": "合规",
  "laporanHasil.col.labNumber": "实验室编号",
  "laporanHasil.col.lastGenerated": "最后生成时间",
  "laporanHasil.col.site": "网站",
  "laporanHasil.col.standard": "标准",
  "laporanHasil.col.tests": "检测项目",
  "laporanHasil.detail.ambientTemp": "环境温度",
  "laporanHasil.detail.collectionDateTime": "采集日期时间",
  "laporanHasil.detail.collectionMethod": "收款方式",
  "laporanHasil.detail.complianceSummary": "合规摘要",
  "laporanHasil.detail.conditions": "收款条件",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "实验室分析师",
  "laporanHasil.detail.labManager": "实验室经理",
  "laporanHasil.detail.parameter": "参数",
  "laporanHasil.detail.ppNo": "PP 编号：否",
  "laporanHasil.detail.preservation": "保护",
  "laporanHasil.detail.result": "结果",
  "laporanHasil.detail.signatures": "签名",
  "laporanHasil.detail.site": "网站",
  "laporanHasil.detail.siteInfo": "站点信息",
  "laporanHasil.detail.standard": "标准",
  "laporanHasil.detail.status": "状态",
  "laporanHasil.detail.threshold": "阈值",
  "laporanHasil.detail.waterTemp": "水温",
  "laporanHasil.detail.weather": "天气",
  "laporanHasil.empty": "根据已选择的筛选条件，未找到任何订单。简体中文（大陆）",
  "laporanHasil.error": "无法加载报告。请重试。",
  "laporanHasil.filter.all": "所有分析仪",
  "laporanHasil.filter.allSites": "所有站点",
  "laporanHasil.filter.allStandards": "所有标准",
  "laporanHasil.filter.complianceStatus": "合规状态",
  "laporanHasil.filter.dateFrom": "开始日期",
  "laporanHasil.filter.dateTo": "结束日期",
  "laporanHasil.filter.generated": "已生成",
  "laporanHasil.filter.generationStatus": "生成状态",
  "laporanHasil.filter.notGenerated": "尚未生成",
  "laporanHasil.filter.samplingSite": "样本采样点",
  "laporanHasil.filter.standard": "合规标准",
  "laporanHasil.loading": "正在加载合规报告...",
  "laporanHasil.status.borderline": "边缘型",
  "laporanHasil.status.compliant": "符合要求的",
  "laporanHasil.status.ineligible": "否，未关联任何标准",
  "laporanHasil.status.nonCompliant": "不符合要求",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "为已审核的环境订单生成合规证书",
  "laporanHasil.tile.generated": "已生成",
  "laporanHasil.tile.ineligible": "不符合条件",
  "laporanHasil.tile.ineligible.desc": "未验证或未关联标准",
  "laporanHasil.tile.notGenerated": "尚未生成",
  "laporanHasil.title": "合规报告",
  "lhu.amendment.error.generic": "无法重新生成报告。请重试。",
  "lhu.amendment.modal.description": "您正在为实验室编号{labNumber}重新签发LHU。重新签发的报告将被视为对先前发布的证书的修订。",
  "lhu.amendment.modal.heading": "重新发布附有修订的LHU",
  "lhu.amendment.modal.submit": "重新发布与下载 PDF",
  "lhu.amendment.reason.helper": "说明对原始报告进行修订的原因（符合 ISO 17025 第 7.8.8 条的要求）。",
  "lhu.amendment.reason.label": "修改原因",
  "lhu.amendment.reason.placeholder": "例如：pH值测得结果不正确——仪器未经过校准",
  "lhu.amendment.reason.required": "必须填写修改原因",
  "lhu.amendment.reissue": "修订后重新发布",
  "lhu.amendment.submitting": "重新发布……",
  "nce.close.error": "无法关闭 NCE",
  "nce.close.success": "NCE已成功关闭",
  "nce.correctiveAction.error": "未能提升NCE身份",
  "nce.correctiveAction.success": "NCE 已采取纠正措施",
  "notificationtrigger.activetriggers.heading": "活跃触发器",
  "notificationtrigger.activetriggers.subtitle": "每行控制一种通知事件类型。切换至“开启”状态即可激活。通道和收件人设置仅在触发器启用时应用。",
  "notificationtrigger.channel.email": "电子邮件",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.column.channels": "频道",
  "notificationtrigger.column.enabled": "已启用",
  "notificationtrigger.column.eventcode": "活动位置代码",
  "notificationtrigger.column.override": "按实验室单元设置的覆盖规则",
  "notificationtrigger.column.recipients": "收件人",
  "notificationtrigger.column.trigger": "触发器",
  "notificationtrigger.config.subtitle": "按事件启用或禁用通知触发条件，选择发送渠道，并配置收件人类型。",
  "notificationtrigger.config.title": "通知触发器配置",
  "notificationtrigger.disabled.hint": "已启用此触发器以配置其通道和收件人。",
  "notificationtrigger.override.comingsoon": "目前尚不可用，无法按实验室单元进行覆盖设置。",
  "notificationtrigger.override.configure": "配置",
  "notificationtrigger.recipient.coccontact": "CoC 联系人",
  "notificationtrigger.recipient.orderingprovider": "订购供应商",
  "notificationtrigger.recipient.submittinguser": "提交用户",
  "notificationtrigger.referralout.defaultoff": "默认值“关闭”——必须显式启用。",
  "notificationtrigger.referralout.description": "在将样本送往外部实验室时发送。",
  "notificationtrigger.referralout.firesoncenote": "每次保存的转诊单触发一次通知。如果一笔订单包含转诊至两个不同实验室的转诊单，则会发送两条通知。",
  "notificationtrigger.referralout.name": "转出",
  "notificationtrigger.sentmessages.action.resend": "重新发送",
  "notificationtrigger.sentmessages.action.viewlog": "查看日志",
  "notificationtrigger.sentmessages.channel.failed": "失败",
  "notificationtrigger.sentmessages.channel.sent": "已发送",
  "notificationtrigger.sentmessages.column.actions": "操作",
  "notificationtrigger.sentmessages.column.channels": "频道",
  "notificationtrigger.sentmessages.column.datetime": "日期时间",
  "notificationtrigger.sentmessages.column.recipient": "收件人",
  "notificationtrigger.sentmessages.column.reference": "参考文献",
  "notificationtrigger.sentmessages.column.status": "状态",
  "notificationtrigger.sentmessages.column.type": "设备类型",
  "notificationtrigger.sentmessages.count": "{count} {total} 消息",
  "notificationtrigger.sentmessages.empty.heading": "尚未发送任何通知。",
  "notificationtrigger.sentmessages.filter.status.all": "所有状态",
  "notificationtrigger.sentmessages.filter.status.failed": "失败数量",
  "notificationtrigger.sentmessages.filter.status.label": "状态",
  "notificationtrigger.sentmessages.filter.status.sent": "已发送",
  "notificationtrigger.sentmessages.filter.type.all": "所有类型",
  "notificationtrigger.sentmessages.filter.type.label": "设备类型",
  "notificationtrigger.sentmessages.heading": "已发送的消息",
  "notificationtrigger.sentmessages.resend.disclaimer": "重新发送将重复发送原始消息的字节内容和收件人地址。若要发送至其他地址，请编辑患者记录并触发一个新事件。",
  "notificationtrigger.sentmessages.resend.failure": "重新发送失败。详情请参阅服务器日志。",
  "notificationtrigger.sentmessages.resend.success": "通知已重新发送。",
  "notificationtrigger.sentmessages.status.failed": "失败数量",
  "notificationtrigger.sentmessages.status.sent": "已发送",
  "notificationtrigger.sentmessages.subtitle": "OpenELIS 发送的所有外发通知，涵盖所有触发类型和渠道。",
  "notificationtrigger.sentmessages.viewlog.channels": "频道成果",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "尝试",
  "notificationtrigger.sentmessages.viewlog.column.channel": "频道",
  "notificationtrigger.sentmessages.viewlog.column.error": "错误",
  "notificationtrigger.sentmessages.viewlog.column.status": "状态",
  "notificationtrigger.sentmessages.viewlog.heading": "通知日志",
  "notificationtrigger.sentmessages.viewlog.message": "消息正文",
  "notificationtrigger.sentmessages.viewlog.subject": "主题",
  "notificationtrigger.status.new": "NEW",
  "notificationtrigger.subcontractdispatched.description": "当样本已实际寄送至接收实验室时发送。",
  "notificationtrigger.subcontractdispatched.name": "分包合同已发出",
  "notificationtrigger.tabs.sentmessages": "已发送的消息",
  "notificationtrigger.tabs.sentmessages.placeholder": "已发送的消息——将在未来的里程碑版本中推出。",
  "notificationtrigger.tabs.templates": "模板",
  "notificationtrigger.tabs.templates.placeholder": "模板编辑器——将在未来的里程碑版本中推出。",
  "notificationtrigger.tabs.triggers": "触发器",
  "notificationtrigger.templates.body.help": "包含合并字段的自由文本。此模板不由 i18n 管理——可直接编辑。",
  "notificationtrigger.templates.body.label": "消息正文",
  "notificationtrigger.templates.button.reset": "重置到默认值",
  "notificationtrigger.templates.button.save": "保存模板",
  "notificationtrigger.templates.channel.help": "每个频道都有自己的模板字段。请切换频道以分别进行编辑。",
  "notificationtrigger.templates.channel.label": "频道",
  "notificationtrigger.templates.heading": "通知模板配置",
  "notificationtrigger.templates.mergefields.heading": "可用的合并字段",
  "notificationtrigger.templates.mergefields.help": "以下字段专用于{eventCode}活动。点击某个字段，即可将其插入到光标所在位置。",
  "notificationtrigger.templates.mergefields.optionalnote": "如果推荐链接中未设置 [expectedReturn]，则该字段将显示为空白——不会报错。",
  "notificationtrigger.templates.preview.label": "渲染预览",
  "notificationtrigger.templates.referralout.description": "在保存推荐信息时，该邮件已发送给客户联系人（供应商）和/或内部员工（提交用户）。",
  "notificationtrigger.templates.subcontractdispatched.description": "当样本实际寄送至接收实验室时，已发送此邮件给接收实验室的CoC联系人及客户。",
  "notificationtrigger.templates.subject.label": "主题",
  "notificationtrigger.templates.subtitle": "为每种通知事件类型编写消息模板。模板为包含合并字段的自由文本。",
  "order.clinicalInfo.helper": "用于指导检测选择和报告的可选背景信息——未记录为确诊记录。",
  "order.complete.processing.description": "{labNumber} 该条目目前处于{status}状态，并将显示在V-03向量识别工作列表中。",
  "order.complete.processing.description.plain": "{labNumber} 当前状态为“处理中”，并将显示在 V-03 向量识别工作列表中。",
  "order.complete.processing.title": "订单已完成 — 正在处理中",
  "order.context.poolOf": "{count} 的图片集 {animal}",
  "order.paymentStatus.helper": "此订单的付款方式如下。",
  "order.priority.helper": "常规：按标准流程处理。紧急：立即处理。",
  "order.referral.sampleType.ambiguous": "此转诊单要求进行{items}检测，但无法自动确定样本类型。请在下方选择样本类型，并选择所需的检测项目。",
  "order.requester.section.helper": "请选择下达检测订单的医疗机构及负责的医护人员。",
  "panel.domain.clinical": "临床",
  "panel.domain.environmental": "环境",
  "panel.domain.eqa": "EQA样本",
  "panel.domain.vector": "Vector",
  "panel.filter.domain": "域名",
  "panel.organism.flea": "跳蚤",
  "panel.organism.fly": "飞",
  "panel.organism.mosquito": "蚊子",
  "panel.organism.rodent": "啮齿动物",
  "panel.organism.selectPlaceholder": "选择生物类群",
  "panel.organism.tick": "对",
  "patient.search.section.helper": "可通过任意字段组合进行搜索——支持部分匹配。“外部搜索”功能会查询客户登记册，至少需要提供姓名和出生日期。",
  "placeholder.validation.qc.justification": "必填（最大 500 个字符）",
  "provider.add.new": "+ 添加新供应商“{name}”",
  "providerTitle.abbreviation": "Abbreviation",
  "providerTitle.add": "Add Title",
  "providerTitle.confirm.activate": "Activate \"{title}\"?",
  "providerTitle.confirm.activate.body": "It will be offered again when choosing a provider's title.",
  "providerTitle.confirm.deactivate": "Deactivate \"{title}\"?",
  "providerTitle.confirm.deactivate.body": "It will no longer be offered for new selections. The {count} provider(s) already carrying it keep it.",
  "providerTitle.duplicate": "\"{value}\" is already in the list",
  "providerTitle.edit": "Edit Title",
  "providerTitle.edit.warning": "Changing a title changes how it displays on every provider using it.",
  "providerTitle.empty": "No provider titles are configured yet.",
  "providerTitle.filter.status": "状态",
  "providerTitle.filter.status.active": "活跃",
  "providerTitle.filter.status.all": "所有分析仪",
  "providerTitle.filter.status.inactive": "非活跃",
  "providerTitle.inUse": "使用中",
  "providerTitle.search": "Search titles",
  "providerTitle.sortOrder": "排序顺序",
  "providerTitle.summary": "{total} title(s): {active} active, {inactive} inactive.",
  "providerTitle.title": "标题",
  "providerTitle.titles": "Provider Titles",
  "provider.email.field": "提供者电子邮件",
  "provider.fax.field": "供应商传真",
  "provider.title.field": "标题",
  "provider.title.inName": "That looks like a title. Consider moving it to the Title field so lists sort by surname.",
  "provider.title.filter": "Filter by title",
  "provider.title.filter.all": "All titles",
  "provider.title.placeholder": "Select a title...",
  "provider.firstName.field": "名",
  "provider.lastName.field": "姓",
  "provider.new.helper": "保存此订单时，将创建一个新的供应商。",
  "provider.new.tag": "新",
  "provider.no.match": "未找到匹配的供应商。",
  "provider.phone.field": "电话",
  "qc.add.blank": "+ 空白 QC",
  "qc.add.control": "+ QC",
  "qc.add.duplicate": "+ 重复QC",
  "qc.collect.inheritsFromParent": "从父样本继承的集合详细信息",
  "qc.expectedValue.placeholder": "例如 50.0",
  "qc.samples.label": "QC样本：",
  "qc.samples.numericOnly": "目前，质量控制（QC）仅支持数值型检测项目。已选检测项目已标记——请选择一个数值型检测项目以启用质量控制（QC）。",
  "qc.samples.thresholdsMissing": "在添加质量控制样本之前，请先在“管理”→“测试配置”中为{tests}配置质量控制阈值。",
  "qc.status.current": "Current QC Status",
  "qc.status.failed.warning.message": "Lots that fail QC are excluded from testing and from stock available for use.",
  "qc.status.failed.warning.title": "This lot will not be usable",
  "qc.status.new": "New QC Status",
  "qc.status.notes": "QC备注",
  "qc.status.notes.placeholder": "Reason for the QC result, test performed, or reference",
  "qc.type.blank": "QC：空白",
  "qc.type.control": "QC：控制",
  "qc.type.duplicate": "QC：重复项",
  "referral.accept.error": "无法接受该结果。请重试。",
  "referral.action.accept": "接受",
  "referral.action.acceptToAnalysis": "接受分析",
  "referral.action.clearFilters": "清除筛选条件",
  "referral.action.enterResult": "输入结果",
  "referral.action.markLost": "马克·洛斯特",
  "referral.action.notifyReferenceLab": "通知参考实验室",
  "referral.action.openResultEntry": "在“结果录入”中打开",
  "referral.action.reject": "拒绝",
  "referral.banner.filterToStuck": "仅过滤卡住的情况",
  "referral.banner.stuckReferralsSubtitle": "{count} 转诊样本已在参考实验室停留超过{threshold}天。",
  "referral.banner.stuckReferralsTitle": "检测到卡住的转诊",
  "referral.box.cannotReconcileMessage": "无法核对样本箱——{count}的样本仍在等待结果核对。请参阅“参考实验室结果”。",
  "referral.box.viewBlockedReferrals": "在“参考实验室结果”中查看",
  "referral.breadcrumb.referenceLabResults": "参考实验室检测结果",
  "referral.chip.ariaLabel": "参考实验室结果查看",
  "referral.chip.history": "历史",
  "referral.chip.outstanding": "杰出",
  "referral.chip.returned": "已退回 — 需操作",
  "referral.column.actions": "操作",
  "referral.column.boxId": "箱子编号",
  "referral.column.closedDate": "截止日期",
  "referral.column.daysOutstanding": "应收账款天数",
  "referral.column.daysTotal": "天数总计",
  "referral.column.labNumber": "实验室编号",
  "referral.column.outcome": "结果",
  "referral.column.patient": "患者",
  "referral.column.priority": "优先级",
  "referral.column.referenceLab": "参考实验室",
  "referral.column.requestor": "原始请求者",
  "referral.column.resultSummary": "结果摘要",
  "referral.column.returnedDate": "退回日期",
  "referral.column.sentDate": "发送日期",
  "referral.column.status": "状态",
  "referral.column.tests": "检测",
  "referral.expand.criticalBadge": "CRITICAL",
  "referral.expand.detail.ageYears": "{years, plural, one {# year} other {# years}}",
  "referral.expand.detail.boxId": "箱子编号",
  "referral.expand.detail.boxReceivedDate": "已接收并送达参考实验室",
  "referral.expand.detail.collected": "已采样",
  "referral.expand.detail.currentStatus": "当前状态",
  "referral.expand.detail.daysOutstanding": "应收账款天数",
  "referral.expand.detail.dispatched": "已发送",
  "referral.expand.detail.fhirTask": "FHIR 任务",
  "referral.expand.detail.labNumber": "实验室编号",
  "referral.expand.detail.patient": "患者",
  "referral.expand.detail.priority": "优先级",
  "referral.expand.detail.referenceLab": "参考实验室",
  "referral.expand.detail.requestor": "原始请求者",
  "referral.expand.detail.sampleType": "样本类型",
  "referral.expand.detail.tests": "检测项目",
  "referral.expand.noResultPayload": "参考实验室未返回任何结构化结果。",
  "referral.expand.originalOrderContext": "原始订单上下文",
  "referral.expand.outcomeDetail": "结果详情",
  "referral.expand.receptionAction": "接待操作",
  "referral.expand.receptionHint": "请查看下方的检测结果，如果结果可用，请点击“接受”将其录入患者病历；如果结果不可用，请点击“拒绝”。",
  "referral.expand.referenceLabTransit": "参考实验室转运",
  "referral.expand.result": "结果",
  "referral.expand.statusDetail": "状态详情",
  "referral.filter.allPriorities": "所有优先级",
  "referral.filter.allRefLabs": "所有参考实验室",
  "referral.filter.dateRange": "日期范围",
  "referral.filter.daysOutstandingBucket": "应收账款天数",
  "referral.filter.daysOutstandingBucket.stuck": "卡住（> {threshold} 天）",
  "referral.filter.priority": "优先级",
  "referral.filter.referenceLab": "参考实验室",
  "referral.markLost.cancelButton": "取消",
  "referral.markLost.confirmButton": "标记为丢失",
  "referral.markLost.description": "这表示该转诊样本在运输中丢失，并将该样本从“待处理”列表中移除。临床团队需要重新采集样本并重新进行转诊。",
  "referral.markLost.modalTitle": "将转诊标记为“丢失”",
  "referral.markLost.reasonLabel": "理由",
  "referral.markLost.reasonPlaceholder": "例如：快递公司确认丢失。样品盒从未送达参考实验室。",
  "referral.markLost.reasonRequired": "必须提供理由。",
  "referral.metric.outstanding": "杰出",
  "referral.metric.reconciledToday": "今天已核对",
  "referral.metric.rejectedThisWeek": "本周已拒收",
  "referral.metric.returned": "已退回 — 需操作",
  "referral.notification.accepted": "该结果已录入患者病历。",
  "referral.notification.rejected": "结果被拒。已通知临床医生重新采集样本。",
  "referral.notify.errorRetry": "未能通知参考实验室。请重试。",
  "referral.notify.toast": "已通知参考实验室。",
  "referral.page.title": "参考实验室检测结果",
  "referral.reject.cancelButton": "取消",
  "referral.reject.confirmButton": "拒绝并通知临床医生",
  "referral.reject.description": "“拒绝”将永久终止原始检测，并通知临床医生重新采集样本并重新转诊。",
  "referral.reject.error": "无法拒绝该结果。请重试。",
  "referral.reject.modalTitle": "拒绝返回的结果",
  "referral.reject.reason.clotted": "凝结的",
  "referral.reject.reason.damagedContainer": "损坏集装箱",
  "referral.reject.reason.hemolyzed": "溶血的",
  "referral.reject.reason.insufficientVolume": "量不足",
  "referral.reject.reason.mislabeled": "标签错误",
  "referral.reject.reason.other": "其他原因",
  "referral.reject.reason.temperatureDeviation": "储存温度偏差",
  "referral.reject.reason.wrongSampleType": "样本类型错误",
  "referral.reject.reasonLabel": "理由",
  "referral.reject.reasonTextLabel": "详情",
  "referral.reject.reasonTextPlaceholder": "请说明为什么不能使用这个返回的结果。",
  "referral.reject.reasonTextRequired": "需要提供详细信息。",
  "referral.reject.warningTitle": "此操作无法撤销",
  "referral.result.interp.Abnormal": "异常",
  "referral.result.interp.Critical": "紧急",
  "referral.result.interp.Normal": "正常",
  "referral.status.cancelled": "已取消",
  "referral.status.completed": "返回的结果",
  "referral.status.draft": "草稿",
  "referral.status.inProgress": "参考实验室正在进行中",
  "referral.status.received": "在参考实验室",
  "referral.status.reconciled": "已核对",
  "referral.status.rejected": "被参考实验室拒绝",
  "referral.status.requested": "已发送——等待接受",
  "referral.table.count": "{count, plural, =0 {No referrals} one {# referral} other {# referrals}}",
  "referral.table.history.title": "历史",
  "referral.table.outstanding.title": "未结的转诊",
  "referral.table.returned.title": "已退回 — 需操作",
  "referral.tag.manuallyEntered": "手动输入",
  "reports.tat.title": "周转时间(TAT)报告",
  "reports.tat.description": "分析实验室在各个工作流程里程碑的周转时间",
  "reports.tat.generateReport": "生成报告",
  "reports.tat.clearFilters": "清除筛选",
  "reports.tat.segment.orderToCollection": "开单到采样",
  "reports.tat.segment.collectionToReceipt": "采样到接收",
  "reports.tat.segment.receiptToTesting": "接收到开始检测",
  "reports.tat.segment.receiptToResult": "接收到结果录入",
  "reports.tat.segment.receiptToValidation": "接收到审核",
  "reports.tat.segment.resultToValidation": "结果录入到审核",
  "reports.tat.segment.overall": "总体TAT",
  "reports.tat.calendarTime": "日历时间",
  "reports.tat.workingTime": "工作时间",
  "reports.tat.workingTimeInfo": "工作时间模式: 排除选定日期范围内的{weekendDays}和{holidayCount}个公共假期",
  "reports.tat.configuredWeekends": "已配置的周末",
  "reports.tat.noHolidaysWarning": "未配置公共假期。请在 管理 > 日历管理 中配置假期。",
  "reports.tat.manageCalendar": "管理日历",
  "reports.tat.totalResults": "总结果数",
  "reports.tat.meanTat": "平均TAT",
  "reports.tat.medianTat": "中位TAT",
  "reports.tat.percentile90": "第90百分位",
  "reports.tat.minTat": "最小TAT",
  "reports.tat.maxTat": "最大TAT",
  "reports.tat.stdDeviation": "标准差",
  "reports.tat.distribution": "TAT分布",
  "reports.tat.breakdownBy": "细分依据",
  "reports.tat.clickRowHint": "点击行查看 individual 结果",
  "reports.tat.summary": "转运箱摘要",
  "reports.tat.detailList": "详细列表",
  "reports.tat.trends": "趋势",
  "reports.tat.noResults": "未找到符合所选筛选条件的结果。请尝试调整日期范围或筛选条件。",
  "reports.tat.insufficientData": "数据不足",
  "reports.tat.loadError": "加载报告数据时出错",
  "reports.tat.dateRange": "日期范围",
  "reports.tat.labUnit": "实验室单元",
  "reports.tat.testPanel": "检测项目/组合",
  "reports.tat.priority.all": "所有分析仪",
  "reports.tat.priority.routine": "常规",
  "reports.tat.priority.stat": "紧急",
  "reports.tat.priority.asap": "尽快",
  "reports.tat.sampleType": "样本类型",
  "reports.tat.orderingSite": "开单机构",
  "reports.tat.priority": "优先级",
  "reports.tat.includeCancelled": "包含已取消/已拒绝",
  "reports.tat.export": "导出",
  "reports.tat.exportCsv": "导出翻译",
  "reports.tat.exportPdf": "导出PDF",
  "reports.tat.labNumber": "实验室编号",
  "reports.tat.patient": "患者",
  "reports.tat.test": "检测",
  "reports.tat.orderCreated": "已创建医嘱",
  "reports.tat.collected": "已采样",
  "reports.tat.received": "已接收",
  "reports.tat.testingStarted": "已开始检测",
  "reports.tat.resultEntered": "已录入结果",
  "reports.tat.validated": "已审核",
  "reports.tat.selectedTat": "选定TAT",
  "reports.tat.overallTat": "总体TAT",
  "reports.tat.columns": "列",
  "reports.tat.rowsPerPage": "每页行数",
  "reports.tat.showing": "显示第 {from}-{to} 条,共 {total} 条结果",
  "reports.tat.trend": "趋势",
  "reports.tat.aggregation": "聚合",
  "reports.tat.daily": "每日",
  "reports.tat.weekly": "每周",
  "reports.tat.monthly": "每月",
  "reports.tat.compareBy": "对比依据",
  "reports.tat.showVolume": "显示医嘱量",
  "reports.tat.mean": "均值",
  "reports.tat.median": "中位数",
  "reports.tat.notApplicable": "不适用",
  "reports.tat.dateRangeFrom": "日期范围(起)",
  "reports.tat.dateRangeTo": "日期范围(止)",
  "reports.tat.tatSegment": "TAT阶段",
  "reports.tat.metrics": "指标",
  "reports.tat.compareNone": "无",
  "reports.tat.comparePriority": "优先级",
  "reports.tat.column.labNumber": "实验室编号",
  "reports.tat.column.test": "检测",
  "reports.tat.column.labUnit": "实验室单元",
  "reports.tat.column.priority": "优先级",
  "reports.tat.column.ordered": "已订购",
  "reports.tat.column.collected": "已采样",
  "reports.tat.column.received": "已接收",
  "reports.tat.column.started": "已开始",
  "reports.tat.column.resulted": "已出结果",
  "reports.tat.column.validated": "已审核",
  "reports.tat.column.selectedTat": "选定TAT",
  "reports.tat.column.overallTat": "总体TAT",
  "reports.tat.column.name": "名称",
  "reports.tat.column.count": "数量",
  "reports.tat.column.mean": "均值",
  "reports.tat.column.median": "中位数",
  "reports.tat.column.p90": "第90百分位",
  "reports.tat.column.max": "最大值",
  "reports.tat.home": "首页",
  "reports.tat.all": "所有分析仪",
  "reports.tat.preset.today": "今天",
  "reports.tat.preset.7days": "最近7天",
  "reports.tat.preset.30days": "最近30天",
  "reports.tat.preset.90days": "最近90天",
  "reports.tat.preset.thisMonth": "本月",
  "reports.tat.preset.lastMonth": "上月",
  "reports.tat.preset.thisQuarter": "本季度",
  "button.cancel": "取消",
  "button.activate": "激活",
  "button.adjust": "调整",
  "button.deactivate": "停用",
  "button.dispose": "处置",
  "button.edit": "编辑",
  "button.generate": "生成",
  "button.label.genarateReport": "生成报告",
  "button.label.loadnext": "加载下一个包",
  "button.label.loadprevious": "加载上一个包",
  "button.label.showHidePram": "显示/隐藏报告参数",
  "button.record": "记录",
  "button.save": "保存",
  "button.save.draft": "保存草稿",
  "button.save.next": "“保存并下一个”",
  "button.save.stay": "保存",
  "button.send": "发送",
  "button.update": "更新",
  "calculatedTests": "计算检测",
  "catalog.item.activate.success": "目录项激活成功",
  "catalog.item.category": "类别",
  "catalog.item.code": "位置代码",
  "catalog.item.code.hint": "Stable identifier used by integrations. Leave blank and we'll generate one from the name, like PAR-500MG-001.",
  "catalog.item.code.locked": "Code is locked once saved so integrations and existing references keep working.",
  "catalog.item.code.placeholder": "Leave blank to auto-generate from name",
  "catalog.item.code.preview": "Will be saved as {code}",
  "catalog.item.compatibleAnalyzers": "兼容的分析仪",
  "catalog.item.deactivate.confirm.button": "停用",
  "catalog.item.deactivate.confirm.message": "您确定要停用 {itemName} 吗？",
  "catalog.item.deactivate.confirm.title": "确认停用",
  "catalog.item.deactivate.implications.1": "此物品将不再出现在活跃物品列表中",
  "catalog.item.deactivate.implications.2": "此物品的现有批次仍可访问",
  "catalog.item.deactivate.implications.3": "如果需要，您可以稍后重新激活此物品",
  "catalog.item.deactivate.implications.title": "影响：",
  "catalog.item.deactivate.label": "停用物品",
  "catalog.item.deactivate.success": "物品停用成功",
  "catalog.item.error.saveGeneric": "保存目录项时出错",
  "catalog.item.error.stabilityRequired": "Stability after opening is required for reagents",
  "catalog.item.form.title.add": "添加新目录项",
  "catalog.item.form.title.edit": "编辑目录项",
  "catalog.item.lowStockThreshold": "低库存阈值",
  "catalog.item.manufacturer": "制造商",
  "catalog.item.minimumStock": "最小库存水平",
  "catalog.item.name": "物品名称",
  "catalog.item.reorderLevel": "再订购水平",
  "catalog.item.reorderQuantity": "再订购数量",
  "catalog.item.save.error": "保存目录项时出错",
  "catalog.item.save.success": "目录项保存成功",
  "catalog.item.stabilityAfterOpening": "开封后稳定性（天）",
  "catalog.item.status": "状态",
  "catalog.item.storageRequirements": "存储要求",
  "catalog.item.testTypes": "检测类型",
  "catalog.item.testsPerCartridge": "每个试剂盒的检测次数",
  "catalog.item.testsPerKit": "每个试剂盒的检测次数",
  "catalog.item.type": "物品类型",
  "catalog.item.units": "单位",
  "catalog.search.placeholder": "按物品名称搜索",
  "choose.availablepanel": "选择可用面板",
  "coldStorage.action.createSuccess": "操作创建成功",
  "coldStorage.action.retractSuccess": "操作撤回成功",
  "coldStorage.action.updateSuccess": "操作更新成功",
  "coldStorage.actions": "操作",
  "coldStorage.activated": "已激活",
  "coldStorage.addDevicesMessage": "请添加设备以开始监控",
  "coldStorage.addNewDevice": "添加新设备",
  "coldStorage.alert.acknowledged": "警报已成功确认",
  "coldStorage.alert.actionFailed": "无法将 {action} 转发至 {alertId}",
  "coldStorage.alert.equipment": "设备警报",
  "coldStorage.alert.equipment.description": "设备故障或异常时发送警报",
  "coldStorage.alert.inventory": "库存警报",
  "coldStorage.alert.inventory.description": "库存水平异常时发送警报",
  "coldStorage.alert.resolved": "警报已成功解决",
  "coldStorage.alert.saveFailed": "警报保存失败",
  "coldStorage.alert.saveSuccess": "警报保存成功",
  "coldStorage.alert.temperature": "温度警报",
  "coldStorage.alert.temperature.description": "温度超出阈值时发送警报",
  "coldStorage.alert.type": "警报类型",
  "coldStorage.alertConfiguration": "警报配置",
  "coldStorage.autoEscalate": "自动升级",
  "coldStorage.button.delete": "删除",
  "coldStorage.configuredDevices": "已配置的设备",
  "coldStorage.correctiveAction.column.actionId": "操作 ID",
  "coldStorage.correctiveAction.column.created": "创建时间",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "最后由……更新",
  "coldStorage.correctiveAction.column.performedBy": "由表演者表演：",
  "coldStorage.correctiveAction.edited": "已编辑",
  "coldStorage.correctiveAction.status.cancelled": "已取消",
  "coldStorage.correctiveAction.status.completed": "已完成",
  "coldStorage.correctiveAction.status.inProgress": "进行中",
  "coldStorage.correctiveAction.status.pending": "待处理",
  "coldStorage.correctiveAction.status.retracted": "已撤回",
  "coldStorage.correctiveAction.type.calibration": "校准",
  "coldStorage.correctiveAction.type.calibration.description": "校准设备或传感器",
  "coldStorage.correctiveAction.type.equipmentRepair": "设备维修",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "维修或更换设备",
  "coldStorage.correctiveAction.type.itemReorder": "项目重新订购",
  "coldStorage.correctiveAction.type.itemReorder.description": "重新订购库存物品",
  "coldStorage.correctiveAction.type.maintenance": "维护",
  "coldStorage.correctiveAction.type.maintenance.description": "执行维护任务",
  "coldStorage.correctiveAction.type.other": "其他原因",
  "coldStorage.correctiveAction.type.other.description": "其他或自定义纠正措施",
  "coldStorage.correctiveAction.type.sampleRelocation": "搬迁样本",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "将样本转移到另一个位置",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "温度调整",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "调整温度设置",
  "coldStorage.criticalThreshold": "临界阈值",
  "coldStorage.dashboard.acknowledge": "确认",
  "coldStorage.dashboard.activeAlerts": "活跃警报 ({count})",
  "coldStorage.dashboard.column.currentTemp": "当前温度",
  "coldStorage.dashboard.column.currentTemp2": "探头 2 温度",
  "coldStorage.dashboard.column.device": "设备",
  "coldStorage.dashboard.column.duration": "时长",
  "coldStorage.dashboard.column.humidity": "湿度",
  "coldStorage.dashboard.column.lastReading": "上次阅读",
  "coldStorage.dashboard.column.location": "位置",
  "coldStorage.dashboard.column.severity": "严重程度",
  "coldStorage.dashboard.column.started": "已开始",
  "coldStorage.dashboard.column.targetTemp": "目标温度",
  "coldStorage.dashboard.column.temperature": "储存温度",
  "coldStorage.dashboard.column.unitId": "单位ID",
  "coldStorage.dashboard.column.unitName": "单位名称",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} 出现严重温度波动的存储单元",
  "coldStorage.dashboard.criticalAlertTitle": "紧急警报",
  "coldStorage.dashboard.deviceTypeFilter": "设备类型",
  "coldStorage.dashboard.kpi.critical": "紧急",
  "coldStorage.dashboard.kpi.normal": "正常状态",
  "coldStorage.dashboard.kpi.totalUnits": "存储单元总数",
  "coldStorage.dashboard.kpi.warnings": "警告",
  "coldStorage.dashboard.lastUpdate": "最后更新时间：{time}",
  "coldStorage.dashboard.loadingUnits": "正在加载存储单元……",
  "coldStorage.dashboard.noActiveAlerts": "没有活跃的警报",
  "coldStorage.dashboard.noUnitsFound": "未找到任何存储单元。",
  "coldStorage.dashboard.online": "在线",
  "coldStorage.dashboard.refresh": "刷新",
  "coldStorage.dashboard.refreshing": "令人神清气爽",
  "coldStorage.dashboard.refreshingEllipsis": "令人神清气爽……",
  "coldStorage.dashboard.searchLabel": "按单元编号或名称搜索",
  "coldStorage.dashboard.statusFilter": "状态",
  "coldStorage.dashboard.storageUnitsTitle": "仓储单元",
  "coldStorage.dashboard.subtitle": "实时温度监测与合规性",
  "coldStorage.dashboard.systemStatus": "系统状态：{status}",
  "coldStorage.dashboard.tab.correctiveActions": "纠正措施",
  "coldStorage.dashboard.tab.dashboard": "仪表板",
  "coldStorage.dashboard.tab.historicalTrends": "趋势",
  "coldStorage.dashboard.tab.reports": "报告",
  "coldStorage.dashboard.tab.settings": "设置",
  "coldStorage.dashboard.viewAlertDetails": "查看警报详情",
  "coldStorage.deactivated": "已停用",
  "coldStorage.description": "描述",
  "coldStorage.device.activate": "激活设备",
  "coldStorage.device.activateMessage": "确定要激活此设备吗？",
  "coldStorage.device.changeStatus": "更改状态",
  "coldStorage.device.changeStatusOf": "更改设备状态",
  "coldStorage.device.created": "设备已创建",
  "coldStorage.device.createdSuccess": "设备创建成功",
  "coldStorage.device.deactivate": "停用设备",
  "coldStorage.device.deactivateMessage": "确定要停用此设备吗？",
  "coldStorage.device.delete": "删除设备",
  "coldStorage.device.deleteConfirm": "确定要删除此设备吗？",
  "coldStorage.device.deleteWarning": "此操作无法撤销",
  "coldStorage.device.deleted": "设备已删除",
  "coldStorage.device.deviceStatus": "设备状态",
  "coldStorage.device.edit": "编辑设备",
  "coldStorage.device.id": "设备ID",
  "coldStorage.device.ipAddress": "IP地址",
  "coldStorage.device.port": "端口",
  "coldStorage.device.protocol": "协议",
  "coldStorage.device.registerCount": "按值划分的寄存器",
  "coldStorage.device.registerCount.help": "1 表示 16 位值，2 表示跨越两个寄存器的 32 位值",
  "coldStorage.device.roomFacility": "房间/设施",
  "coldStorage.device.rs485": "RS-485 半双工（可选）",
  "coldStorage.device.rs485.delayAfter": "发送后延迟（毫秒）",
  "coldStorage.device.rs485.delayBefore": "发送前延迟（毫秒）",
  "coldStorage.device.rs485.mode": "启用 RS-485 驱动器使能定时",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS 在发送期间为高电平",
  "coldStorage.device.rs485.rxDuringTx": "传输期间保持接收方启用状态",
  "coldStorage.device.rs485.termination": "已启用总线终结功能",
  "coldStorage.device.secondProbe": "第二个温度探头（可选）",
  "coldStorage.device.secondProbe.offset": "基准储存温度 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "第二个探针的基线偏移量",
  "coldStorage.device.secondProbe.register": "温度寄存器 2",
  "coldStorage.device.secondProbe.registerHelp": "第二个独立温度传感器的 Modbus 寄存器地址。其测量值会被记录并绘制成图表；阈值警报由第一个传感器触发。",
  "coldStorage.device.secondProbe.scale": "温度标度 2",
  "coldStorage.device.secondProbe.scaleHelp": "缩放因子（例如，0.1 表示除以 10）",
  "coldStorage.device.statusChanged": "设备状态已更改",
  "coldStorage.device.type": "设备类型",
  "coldStorage.device.updated": "设备已更新",
  "coldStorage.device.wordOrder": "词序",
  "coldStorage.device.wordOrder.bigEndian": "大端（最高有效字先）",
  "coldStorage.device.wordOrder.help": "32位值中两个寄存器的顺序；读取单个寄存器时忽略此顺序",
  "coldStorage.device.wordOrder.littleEndian": "小端序（最低有效字字首）",
  "coldStorage.deviceHistory.averageMetric": "平均值 {metric}",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "已确认 / 由表演者表现",
  "coldStorage.deviceHistory.column.date": "日期",
  "coldStorage.deviceHistory.column.eventId": "事件 ID",
  "coldStorage.deviceHistory.column.eventType": "活动类型",
  "coldStorage.deviceHistory.column.summaryTitle": "摘要 / 标题",
  "coldStorage.deviceHistory.column.time": "时间",
  "coldStorage.deviceHistory.correctiveActions": "纠正措施",
  "coldStorage.deviceHistory.dataPoints": "数据点",
  "coldStorage.deviceHistory.exportCsv": "导出翻译",
  "coldStorage.deviceHistory.loadingEvents": "正在加载事件历史记录...",
  "coldStorage.deviceHistory.loadingTemperature": "正在加载储存温度数据...",
  "coldStorage.deviceHistory.maxMetric": "Max {metric}",
  "coldStorage.deviceHistory.metric": "指标：",
  "coldStorage.deviceHistory.minMetric": "Min {metric}",
  "coldStorage.deviceHistory.noEventsFound": "未找到任何活动。",
  "coldStorage.deviceHistory.noTemperatureData": "已选择时间范围内的温度数据不可用。",
  "coldStorage.deviceHistory.searchEvents": "搜索活动",
  "coldStorage.deviceHistory.searchPlaceholder": "按事件 ID、摘要或用户搜索……",
  "coldStorage.deviceHistory.tab.eventHistory": "活动历史",
  "coldStorage.deviceHistory.tab.temperatureTrends": "气温趋势",
  "coldStorage.deviceHistory.timeRange": "时间范围：",
  "coldStorage.deviceHistory.title": "设备历史记录 - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "警报总数",
  "coldStorage.deviceHistory.totalEvents": "活动总数",
  "coldStorage.email": "电子邮件",
  "coldStorage.emailSmsNotifications": "邮件/短信通知",
  "coldStorage.error.createAction": "创建操作失败",
  "coldStorage.error.createDevice": "创建设备失败",
  "coldStorage.error.createRoom": "创建房间失败",
  "coldStorage.error.deleteDevice": "删除设备失败",
  "coldStorage.error.loadActions": "加载操作失败",
  "coldStorage.error.loadAuditTrail": "无法加载审计跟踪",
  "coldStorage.error.loadAuditTrailDetail": "加载审计记录时发生意外错误。",
  "coldStorage.error.loadDevices": "加载设备失败",
  "coldStorage.error.loadExcursions": "无法加载游览记录",
  "coldStorage.error.loadExcursionsDetail": "加载游览路线时发生意外错误。",
  "coldStorage.error.loadFailed": "无法加载冷藏存储监控数据。",
  "coldStorage.error.loadLocations": "加载位置失败",
  "coldStorage.error.loadUsers": "加载用户失败",
  "coldStorage.error.noCurrentUser": "无法识别当前用户。请重新登录。",
  "coldStorage.error.retractAction": "撤回操作失败",
  "coldStorage.error.saveThreshold": "保存阈值失败",
  "coldStorage.error.toggleStatus": "切换状态失败",
  "coldStorage.error.updateAction": "更新操作失败",
  "coldStorage.error.updateDevice": "更新设备失败",
  "coldStorage.error.updateFailed": "无法更新冷存储数据",
  "coldStorage.escalationDelay": "升级延迟",
  "coldStorage.escalationDelayHelper": "在升级到下一级之前等待的时间",
  "coldStorage.escalationRules": "升级规则",
  "coldStorage.filter.activeOnly": "仅活跃",
  "coldStorage.filter.all": "全部",
  "coldStorage.filter.inactiveOnly": "仅停用",
  "coldStorage.footer": "冷藏存储监控 v2.1.0 | 符合 CAP、CLIA、FDA 和 WHO 指南 | 符合 HIPAA 标准的数据处理",
  "coldStorage.granularNotificationControl": "精细通知控制",
  "coldStorage.granularNotificationControlDesc": "按设备和警报类型配置通知",
  "coldStorage.howNotificationsWork": "通知工作方式",
  "coldStorage.howNotificationsWorkDesc": "当温度超出阈值时，系统将通过邮件和短信发送通知",
  "coldStorage.loadingDevices": "正在加载设备...",
  "coldStorage.loadingPrefs": "正在加载偏好设置...",
  "coldStorage.name": "名称",
  "coldStorage.noConfigFound": "未找到配置",
  "coldStorage.noDevicesConfigured": "尚未配置设备",
  "coldStorage.notification.createRecord": "创建记录",
  "coldStorage.notification.logAttempt": "记录尝试",
  "coldStorage.notification.sendEmail": "发送邮件",
  "coldStorage.notification.sendSms": "发送短信",
  "coldStorage.pollInterval": "轮询间隔",
  "coldStorage.reports.column.action": "操作",
  "coldStorage.reports.column.details": "详情",
  "coldStorage.reports.column.excursionId": "游览编号",
  "coldStorage.reports.column.freezer": "冰箱",
  "coldStorage.reports.column.freezerId": "冰箱编号",
  "coldStorage.reports.column.startTime": "开始时间",
  "coldStorage.reports.column.temperatureRange": "温度范围",
  "coldStorage.reports.column.timestamp": "时间戳",
  "coldStorage.reports.column.user": "用户",
  "coldStorage.reports.downloadReport": "下载《{format}》报告",
  "coldStorage.reports.endDate": "结束日期",
  "coldStorage.reports.excursionHistory": "储存温度波动历史",
  "coldStorage.reports.exportFormat": "导出格式",
  "coldStorage.reports.footer": "冷藏存储监控 v2.1.0 | 符合 CAP、CLIA、FDA 和 WHO 标准 | 符合 HIPAA 要求的数据处理",
  "coldStorage.reports.freezer": "冰箱",
  "coldStorage.reports.generateReport": "生成报告",
  "coldStorage.reports.loadingAudit": "正在加载审计条目……",
  "coldStorage.reports.loadingExcursions": "正在加载游览项目……",
  "coldStorage.reports.noAuditActivity": "根据已选择的筛选条件，没有审计活动。",
  "coldStorage.reports.noAuditMatch": "没有符合您搜索条件的审计条目。",
  "coldStorage.reports.noExcursions": "根据已选择的筛选条件，没有可用游览项目。",
  "coldStorage.reports.regulatoryCompliance": "合规",
  "coldStorage.reports.regulatoryComplianceDesc": "报告遵循美国病理学家学会（CAP）、《临床实验室改进修正案》（CLIA）、美国食品药品监督管理局（FDA）以及世界卫生组织（WHO）关于温控存储的指导方针。",
  "coldStorage.reports.reportType": "报告类型",
  "coldStorage.reports.searchAuditTrail": "搜索审计跟踪...",
  "coldStorage.reports.startDate": "开始日期",
  "coldStorage.reports.tab.auditTrail": "审计跟踪",
  "coldStorage.reports.tab.excursions": "温度波动",
  "coldStorage.reports.title": "监管报告",
  "coldStorage.room.addNew": "添加新房间",
  "coldStorage.room.create": "创建房间",
  "coldStorage.room.created": "房间已创建",
  "coldStorage.room.description": "房间描述",
  "coldStorage.room.descriptionPlaceholder": "输入房间描述",
  "coldStorage.room.name": "房间名称",
  "coldStorage.room.namePlaceholder": "输入房间名称",
  "coldStorage.saveNotificationPrefs": "保存通知偏好",
  "coldStorage.saveThresholdConfig": "保存阈值配置",
  "coldStorage.saving": "正在保存...",
  "coldStorage.search.placeholder": "搜索设备...",
  "coldStorage.selectType": "选择设备类型",
  "coldStorage.sms": "短信",
  "coldStorage.status": "状态",
  "coldStorage.status.active": "活跃",
  "coldStorage.status.inactive": "停用",
  "coldStorage.status.noData": "无数据",
  "coldStorage.status.offline": "离线",
  "coldStorage.status.unknown": "未知",
  "coldStorage.supervisorEmail": "主管邮箱",
  "coldStorage.supervisorEmailHelper": "温度警报将发送到此邮箱",
  "coldStorage.supervisorEmailPlaceholder": "输入主管邮箱地址",
  "coldStorage.targetTemperature": "目标温度",
  "coldStorage.threshold.saveSuccess": "阈值保存成功",
  "coldStorage.thresholdConfiguration": "阈值配置",
  "coldStorage.trends.averageMetric": "平均值 {metric}",
  "coldStorage.trends.axis.humidity": "湿度（%）",
  "coldStorage.trends.axis.temperature": "储存温度（°C）",
  "coldStorage.trends.axis.temperature2": "储存温度 - 探头 2 (°C)",
  "coldStorage.trends.maxMetric": "Max {metric}",
  "coldStorage.trends.metric": "公制指标",
  "coldStorage.trends.metric.humidity": "湿度",
  "coldStorage.trends.metric.temperature": "储存温度",
  "coldStorage.trends.metric.temperature2": "储存温度（探头 2）",
  "coldStorage.trends.minMetric": "Min {metric}",
  "coldStorage.usingDefaults": "使用默认值",
  "coldStorage.validation.error": "验证错误",
  "coldStorage.validation.retractionReason": "请输入撤回原因",
  "coldStorage.validation.selectActionType": "请选择操作类型",
  "coldStorage.validation.selectDevice": "请选择设备",
  "coldStorage.validation.selectRoom": "请选择房间",
  "coldStorage.warningThreshold": "警告阈值",
  "collect.addSample.button": "添加样本",
  "collect.assign.addToSample": "添加到现有样本中",
  "collect.assign.button": "分配检测",
  "collect.assign.description": "将所需检测项目分配到样本管中",
  "collect.assign.newSample": "创建新样本",
  "collect.assign.newSampleHelp": "为新试管选择样本类型",
  "collect.assign.noExisting": "无可用样本",
  "collect.assign.title": "检测分配",
  "collect.multiSampleExample.description": "当需要多种样本类型时",
  "collect.multiSampleExample.result": "为每种设备类型创建单独的管子",
  "collect.multiSampleExample.title": "多样本采集示例",
  "collect.noSampleYet": "尚未采集任何样本",
  "collect.noTestsOrdered": "尚未安排任何检测项目",
  "collect.noTestsWarning.subtitle": "在继续操作之前，请在步骤 1 中添加附带检测结果的样本",
  "collect.noTestsWarning.title": "无需进行检测项目",
  "collect.printMoreLabels.button": "打印更多条码",
  "collect.printMoreLabels.helper": "为该样本打印更多标签",
  "collect.requestedTests.info": "此订单所需的检测项目",
  "collect.requestedTests.title": "要求进行的检测项目",
  "collect.sample.assignedTests": "检测",
  "collect.sample.collectionConditions": "收款条件",
  "collect.sample.collectionConditions.placeholder": "备注任何特殊情况……",
  "collect.sample.collectionDate": "采集日期",
  "collect.sample.collectionMethod": "收款方式",
  "collect.addTests.title": "Add Tests or Panels",
  "collect.addTests.helper": "Add a test the clinician asked for after the order was entered, or one that only becomes appropriate with the specimen in hand.",
  "collect.consentRequired.title": "Informed consent is required",
  "collect.consentRequired.subtitle": "This laboratory requires consent to be recorded before a collection can proceed.",
  "sample.holdingLimit": "Holding time: {limit}",
  "sample.holdingLimit.testBy": "test by {deadline}",
  "env.sample.receivedAtLab": "实验室已接收",
  "collect.sample.specimenOrigin": "Specimen Origin",
  "collect.sample.temperature": "样本储存温度",
  "collect.sample.temperature.placeholder": "e.g. 4 C",
  "collect.sample.collectionDate.helper": "样本采集日期",
  "collect.sample.collectionDateBeforeAdmission": "采集日期不能早于入院日期。",
  "collect.sample.collectionTime": "采集时间",
  "collect.sample.collector": "采集人",
  "collect.sample.header": "样本 {number}",
  "collect.sample.labPerformedSampling": "实验室进行的采样",
  "collect.sample.nce.link": "报告不符合事件",
  "collect.sample.noTests": "此样本未分配任何检测项目",
  "collect.sample.printLabels": "打印条码",
  "collect.sample.quantity": "数量",
  "collect.sample.receivedAtLab": "实验室已接收",
  "collect.sample.receivedAtLab.helper": "确认实验室是否已接收样本",
  "collect.sample.receivedDate": "接收日期",
  "collect.sample.receivedTime": "已接收时间",
  "collect.sample.remove": "移除样本",
  "collect.samples.title": "样本",
  "collect.table.compatibleTypes": "兼容的样本类型",
  "collect.table.sampleAssignments": "作业样本",
  "collect.table.testPanel": "检测项目/组合",
  "heading.informedConsent.sectionTitle": "知情同意书",
  "heading.informedConsent.auditRecord": "知情同意审核记录",
  "label.informedConsent.consentGiven": "患者已签署知情同意书",
  "label.informedConsent.formReference": "知情同意书参考编号：",
  "label.informedConsent.recordedBy": "录制者：",
  "label.informedConsent.recordedAt": "录制于",
  "label.informedConsent.statusTag": "已记录同意",
  "label.informedConsent.notRecorded": "未记录",
  "placeholder.informedConsent.formReference": "例如：CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "例如：史密斯博士",
  "error.informedConsent.formReferenceMaxLength": "知情同意书的参考编号必须在100个字符以内",
  "error.informedConsent.formReferenceInvalidChars": "仅允许使用字母、数字、连字符和空格",
  "coldstorage.label.dashboard": "冷藏存储仪表板",
  "collection.date": "采集日期",
  "collector": "采集人",
  "collector.label": "采集人",
  "column.actions": "操作",
  "column.name.accept": "接受",
  "column.name.analyzerResult": "分析仪结果",
  "column.name.currentResult": "当前结果",
  "column.name.ignore": "忽略",
  "column.name.normalRange": "正常范围",
  "column.name.notes": "备注",
  "column.name.pastNotes": "历史备注",
  "column.name.qcDetail": "详情",
  "column.name.qcStatus": "QC状态",
  "column.name.reject": "拒绝",
  "column.name.result": "结果",
  "column.name.retest": "重新检测",
  "column.name.sampleInfo": "样本信息",
  "column.name.sampleKind": "样本类型",
  "column.name.save": "保存",
  "column.name.statusPerRegulation": "状态 — 根据规定",
  "column.name.testDate": "检测日期",
  "column.name.testId": "检测ID",
  "column.name.testName": "检测名称",
  "column.name.uncertainty": "U (k=2)",
  "common.codeGenerator.error.invalidCode": "Code must contain at least one letter, digit, or underscore.",
  "common.properties.title": "常见属性",
  "configuration.batch.test.reassignment": "批量检测重新分配和取消",
  "configuration.method": "管理方法",
  "configuration.method.create": "创建新方法",
  "configuration.method.explain": "用于创建新方法、激活或停用方法",
  "configuration.method.rename": "重命名现有方法名称",
  "configuration.method.rename.explain": "用于更正现有方法的名称",
  "configuration.panel.assign": "检测分配",
  "configuration.panel.assign.explain": "通过点击检测名称选择要重新分配到不同面板的检测；它们显示在当前分配的面板下。",
  "configuration.panel.confirmation.explain": "在至少分配一个检测之前，此面板不会激活。",
  "configuration.panel.create": "创建新面板",
  "configuration.panel.create.duplicate": "已找到具有相同名称的现有面板类型。请取消或使用不同的名称。",
  "configuration.panel.manage": "管理面板",
  "configuration.panel.manage.explain": "用于创建、设置显示顺序或为面板分配检测",
  "configuration.panel.order": "设置面板顺序",
  "configuration.panel.order.explain": "通过点击类型并将其拖动到适当顺序来对面板进行排序。",
  "configuration.panel.order.explain.limits": "只有分配了检测的面板才能排序。对于新面板，请在排序前分配检测。",
  "configuration.panel.rename": "重命名现有面板",
  "configuration.panel.rename.explain": "用于更正现有面板的名称。",
  "configuration.sampleType.assign.explain": "通过点击检测名称选择要重新分配到不同样本类型的检测；它们显示在当前分配的样本类型下。",
  "configuration.sampleType.assign.new.type": "分配到样本类型",
  "configuration.sampleType.confirmation.explain": "在至少分配一个检测之前，此样本类型不会激活。",
  "configuration.sampleType.create": "创建新样本类型",
  "configuration.sampleType.create.duplicate": "已找到具有相同名称的现有检测样本类型。请取消或使用不同的名称。",
  "configuration.sampleType.manage": "管理样本类型",
  "configuration.sampleType.manage.explain": "用于创建、设置显示顺序或为样本类型分配检测",
  "configuration.sampleType.order": "设置样本类型顺序",
  "configuration.sampleType.order.explain": "通过点击类型并将其拖动到适当顺序来对样本类型进行排序。",
  "configuration.sampleType.order.explain.limits": "只有分配了检测的样本类型才能排序。对于新类型，请在排序前分配检测。",
  "configuration.selectList.add": "添加结果选择列表",
  "configuration.selectList.add.alert": "要更改当前结果列表条目的拼写，请使用重命名现有结果列表选项",
  "configuration.selectList.add.explain": "用于为检测结果创建结果选择列表",
  "configuration.selectList.assign.description": "新条目可以分配给检测，也可以不分配保存。选择一个或多个检测进行分配，然后调整显示顺序。如果新条目应该是所选检测的正常范围值，请选中标记为`正常`的框。如果希望技术人员在结果选择中输入文本以进一步限定结果，请选中标记为`可限定`的框，例如；如果选项是生物体列表，最后一个选项是`其他`，那么用户可以输入列表中没有的生物体。",
  "configuration.selectList.assign.header": "将新结果选择分配给检测",
  "configuration.selectList.assign.new": "新选择列表选项",
  "configuration.selectList.confirmChange": "正常值将从 %oldvalue% 更改为 %newvalue%，您确定要继续吗？",
  "configuration.selectList.description": "输入新选择选项的英文和法文。如果您不知道翻译，则输入的术语将用于两种语言。",
  "configuration.selectList.header": "创建新结果选择选项",
  "configuration.selectList.rename": "重命名现有结果列表选项",
  "configuration.selectList.rename.explain": "重命名现有结果列表选项",
  "configuration.test.activate": "激活/停用检测",
  "configuration.test.activate.explain": "用于激活或停用现有检测。",
  "configuration.test.add": "添加新检测",
  "configuration.test.add.explain": "用于向系统添加新检测。现有检测的修改应通过其他检测管理链接完成",
  "configuration.test.catalog": "查看检测目录",
  "configuration.test.catalog.explain": "查看当前检测目录",
  "configuration.test.management.ocl": "OCL概念导入",
  "configuration.test.management.organization": "检测组织",
  "configuration.test.management.spelling": "拼写更正",
  "configuration.test.modify": "修改检测",
  "configuration.test.modify.explain": "用于修改系统中的现有检测。",
  "configuration.test.modify.tab.configuration": "配置",
  "configuration.test.modify.tab.compliance": "合规阈值",
  "configuration.test.modify.filter.instruction": "选择样本类型或检测科室以显示检测。",
  "configuration.test.modify.filter.noTestsFound": "没有找到匹配所选标准的检测。",
  "configuration.test.modify.filter.selectToBegin": "请选择样本类型或检测科室开始查看检测。",
  "configuration.test.orderable": "启用/禁用检测可订购性",
  "configuration.test.orderable.explain": "可订购的检测可以在收样时订购。如果不可订购，则只能作为反射结果订购",
  "configuration.test.rename": "重命名现有检测名称",
  "configuration.test.rename.explain": "用于重命名现有检测。不会改变检测，只会改变用户在OpenELIS和报告中看到它们的方式",
  "configuration.testSection.rename": "重命名现有检测科室",
  "configuration.testSection.rename.explain": "用于更正现有检测科室的名称。",
  "configuration.testUnit.assign.new.unit": "分配到检测科室",
  "configuration.testUnit.confirmation.explain": "在至少分配一个检测之前，此检测单元不会激活。",
  "configuration.testUnit.create": "创建新检测单元",
  "configuration.testUnit.create.duplicate": "已找到具有相同名称的现有检测单元。请取消或使用不同的名称。",
  "configuration.testUnit.manage": "管理检测单元",
  "configuration.testUnit.manage.explain": "用于创建、设置显示顺序或为检测单元分配检测",
  "configuration.testUnit.order": "设置检测单元顺序",
  "configuration.testUnit.order.explain": "通过点击单元并将其拖动到适当顺序来对实验室单元进行排序。",
  "configuration.testUnit.order.explain.limits": "只有分配了检测的检测科室才能排序。对于新科室，请在排序前分配检测。",
  "configuration.type.rename": "重命名现有样本类型",
  "configuration.type.rename.explain": "用于更正现有面板的名称。",
  "heading.sampleType.management": "样本类型编辑器",
  "heading.sampleType.subtitle": "配置样本类型、显示顺序、检测关联以及领域分类。",
  "heading.sampleType.editing": "编辑中",
  "label.sampleType.domain": "样本域名",
  "label.domain.CLINICAL": "临床",
  "label.domain.ENVIRONMENTAL": "环境",
  "label.domain.VECTOR": "Vector",
  "label.sampleType.domain.clinical": "临床",
  "label.sampleType.domain.environmental": "环境",
  "label.sampleType.domain.helper": "确定该样本类型出现在哪种工作流模式（临床或环境）中。",
  "label.sampleType.filterDomain": "按域名筛选",
  "label.sampleType.testCount": "检测项目",
  "label.sampleType.actions": "操作",
  "label.sampleType.status": "状态",
  "placeholder.sampleType.search": "搜索样本类型...",
  "placeholder.sampleType.filter.domain": "所有域名",
  "button.sampleType.add": "添加样本类型",
  "configuration.uom.create": "创建新的测量单位",
  "configuration.uom.manage": "管理测量单位",
  "configuration.uom.manage.explain": "用于创建测量单位",
  "configuration.uom.rename": "重命名现有测量单位条目",
  "configuration.uom.rename.explain": "用于更正现有测量单位条目的名称。",
  "configure.labNumber.title": "实验室编号管理",
  "confirmation.rename": "确认您上面所做的更改。",
  "currentests.title": "当前检测",
  "cytology.label.cellabnomality": "上皮细胞异常",
  "cytology.label.confirmSelect": "如果您选择此选项，所有当前诊断信息将被移除",
  "cytology.label.dashboard": "细胞学仪表板",
  "cytology.label.glandular": "腺上皮",
  "cytology.label.negative": "无上皮内病变或恶性肿瘤",
  "cytology.label.neoplastic": "非肿瘤性细胞变异",
  "cytology.label.organisms": "生物体",
  "cytology.label.other": "其他恶性肿瘤",
  "cytology.label.otherResult": "其他诊断结果",
  "cytology.label.reactive": "反应性细胞变化",
  "cytology.label.review": "等待细胞病理学家审查",
  "cytology.label.specimen": "标本充分性",
  "cytology.label.squamous": "鳞状",
  "cytology.label.title": "细胞学",
  "dashboard.avg.turn.around.label": "平均周转时间",
  "dashboard.avg.turn.around.reception.to.result.label": "从接收至结果的平均时间",
  "dashboard.avg.turn.around.reception.to.validation.label": "从接收至验证的平均时间",
  "dashboard.avg.turn.around.result.to.validation.label": "结果 至 验证 平均时间",
  "dashboard.avg.turn.around.subtitle.label": "接收至验证",
  "dashboard.complete.orders.label": "今日完成订单",
  "dashboard.in.progress.label": "进行中",
  "dashboard.in.progress.subtitle.label": "等待结果录入",
  "dashboard.metrics.loadFailed": "Dashboard counts could not be loaded.",
  "dashboard.partially.completed.label": "今日部分完成",
  "dashboard.partially.completed.subtitle.label": "等待剩余检测项目",
  "dashboard.rejected.orders": "已拒绝订单",
  "dashboard.turn.around.label": "延迟周转",
  "dashboard.turn.around.subtitle.label": "超过96小时",
  "dashboard.unprints.results.label": "未打印结果",
  "dashboard.user.orders.label": "用户录入的订单",
  "dashboard.user.orders.today.label": "今日用户录入的订单",
  "dashboard.validation.ready.label": "准备验证",
  "dashboard.validation.ready.subtitle.label": "等待审查",
  "dataexport.status.actions": "操作",
  "dataexport.status.attempt.duration": "时长",
  "dataexport.status.attempt.endTime": "终结时间",
  "dataexport.status.attempt.startTime": "开始时间",
  "dataexport.status.attempt.status": "状态",
  "dataexport.status.duration.ms": "{value} ms简体中文（大陆）",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "尚未配置任何 FHIR 订阅者。请在 common.properties 文件中设置 org.openelisglobal.fhir.subscriber，并重启服务器以注册一个订阅者。",
  "dataexport.status.endpoint": "端点",
  "dataexport.status.failed24h": "失败数量 / 总计（24小时）",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "重试间隔",
  "dataexport.status.intervalValue": "{value} min简体中文（大陆）",
  "dataexport.status.lastAttempt": "最后一次尝试",
  "dataexport.status.lastRefreshed": "最后更新时间",
  "dataexport.status.lastStatus": "最新状态",
  "dataexport.status.lastSuccess": "最近的成功",
  "dataexport.status.loadingAttempts": "正在加载尝试记录……",
  "dataexport.status.never": "绝不",
  "dataexport.status.noAttempts": "尚未尝试",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "刷新",
  "dataexport.status.retry": "现在重试",
  "dataexport.status.retryInFlight": "正在触发……",
  "dataexport.status.title": "FHIR 数据导出状态",
  "datasubmission.siteid": "站点ID",
  "database.clean": "数据库清理",
  "database.clean.button": "清理数据库",
  "database.clean.confirm.message": "确定要清理数据库吗？此操作将删除所有非必要的演示数据。",
  "database.clean.confirm.title": "确认数据库清理",
  "database.clean.confirm.warning": "警告：此操作不可逆！",
  "database.clean.error": "数据库清理失败",
  "database.clean.not.training": "此功能仅在培训/演示模式下可用",
  "database.clean.success": "数据库清理成功",
  "database.clean.warning": "此操作将永久删除数据，请谨慎操作",
  "date.created": "创建日期",
  "datepicker.placeholder.dmy": "(日/月/年)简体中文（大陆）",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "删除时出错",
  "delete.success.msg": "删除成功",
  "description.active": "如果检测处于活跃状态，它可以在订单表单上订购或作为检测算法的一部分。如果不活跃，则不能订购或作为检测算法的一部分",
  "description.ageRange": "如果年龄范围(以月为单位)对给定值很重要，将在此处指定。",
  "description.name": "检测在openELIS中显示的名称。显示英文和法文",
  "description.normalRange": "此范围内的任何数值结果都是健康人的预期结果。",
  "description.note": "n/a表示不可用。未指定值。",
  "description.orderable": "如果检测处于活跃状态且可订购，则可以在订单表单上订购。如果它处于活跃状态但不可订购，则只有当它从另一个检测反射时才会执行",
  "description.panel": "如果此检测是检测面板的一部分，则面板将在此处命名。",
  "description.referenceValue": "健康人的选择值。仅针对选择列表结果提供。",
  "description.reportName": "检测在报告中显示的名称。显示英文和法文",
  "description.resultLimits": "数值检测的正常和有效结果的限制。这些值可以取决于患者的年龄和性别。",
  "description.resultType": "此检测的结果类型：",
  "description.resultType.alphanumeric": "A - 字母数字：",
  "description.resultType.alphanumericDesc": "在文本框中接受数字或文本。不会评估是否为正常或有效。",
  "description.resultType.cascadingMultiSelectList": "C - 级联多选列表：",
  "description.resultType.cascadingMultiSelectListDesc": "类似于多选，但用户将能够从下拉列表中选择多个组。",
  "description.resultType.kind": "此检测的结果类型：",
  "description.resultType.multiSelectList": "M - 多选列表：",
  "description.resultType.multiSelectListDesc": "用户将能够从下拉列表中选择一个或多个值。不会指定参考值。",
  "description.resultType.numeric": "N - 数值：",
  "description.resultType.numericDesc": "在文本框中只接受数值结果。可以评估结果是否在正常或有效范围内。",
  "description.resultType.selectList": "D - 选择列表：",
  "description.resultType.selectListDesc": "用户将能够从下拉列表中选择。正常值将指定为参考值。",
  "description.resultType.textArea": "R-自由文本：",
  "description.resultType.textAreaDesc": "在文本区域中最多接受200个字符。不会评估是否为正常或有效。",
  "description.sampleType": "可以进行检测的样本类型。如果录入技术人员能够在订购检测后选择样本类型，它将被标记为用户，表明用户将选择类型",
  "description.selectValues": "仅针对选择、多选或级联多选结果指定。这些是向用户显示的可用选择。如果选择标记为'可限定'，则当用户选择该值时，他们将能够在文本框中输入附加信息。",
  "description.sex": "如果患者的性别对给定值很重要，将在此处指定。",
  "description.significantDigits": "数值结果的有效位数。输入的结果将四舍五入或填充到正确的位数。正常范围也将以正确的有效位数显示。",
  "description.testUnit": "实验室的哪个部门执行检测。这也称为检测科室。",
  "description.uom": "检测的测量单位。这通常仅适用于数值或字母数字结果类型。",
  "description.validRange": "任何不在此范围内的数值结果都表明检测可能没有正确完成。",
  "dictionary.category.isActive": "是否活跃",
  "dictionary.category.label": "词典类别",
  "dictionary.category.localAbbreviation": "本地缩写",
  "dictionary.category.name": "类别",
  "dictionary.dictEntry": "字典条目",
  "dictionary.label.modify": "字典菜单",
  "dictionary.loincCode": "LOINC代码",
  "dictionary.loincCode.help": "输入标准LOINC标识符",
  "dictionary.loincCode.helpText": "标准实验室观察标识符",
  "dictionary.loincCode.invalid": "无效的LOINC格式(预期: 12345-6 或 LP12345-6)",
  "dictionary.loincCode.placeholder": "例如: 12345-6",
  "dictionary.menu.deactivate.fail": "字典菜单停用失败",
  "dictionary.menu.deactivate.success": "字典菜单停用成功",
  "dictionary.modal.add.heading": "添加词典",
  "dictionary.modal.edit.heading": "编辑词典",
  "dictionary.number.label": "词典编号",
  "disposal.button": "处置批次",
  "disposal.notes": "处置备注",
  "disposal.notes.placeholder": "提供处置详细信息（处置方法、见证人等）",
  "disposal.reason": "处置原因",
  "disposal.reason.select": "选择原因",
  "disposal.success": "批次处置成功",
  "disposal.title": "处置批次",
  "disposal.warning.message": "此操作无法撤销。批次将被标记为已处置并从活跃库存中移除。",
  "disposal.warning.title": "警告",
  "emergencyContactInfo.title": "紧急联系信息",
  "english.current": "英文当前",
  "english.label": "英文",
  "enterText.label": "输入文本",
  "eorder.allInfo": "全部信息",
  "eorder.button.editOrder": "编辑订单",
  "eorder.button.enterOrder": "录入订单",
  "eorder.buttons": " ",
  "eorder.date.end": "结束日期",
  "eorder.date.start": "开始日期",
  "eorder.facility.requesting": "请求设施",
  "eorder.header": "搜索传入检测请求",
  "eorder.id.national": "国家ID",
  "eorder.id.subjectNumber": "受试者编号",
  "eorder.instructions.enter1": "匹配搜索的检测请求 - 在",
  "eorder.instructions.enter2": "菜单中，添加实验室编号并选择",
  "eorder.instructions.enter3": "以接受订单原样，或选择",
  "eorder.instructions.enter4": "进行更改",
  "eorder.labNumber": "实验室编号",
  "eorder.labnumber.referring": "转诊实验室编号",
  "eorder.name.first": "名",
  "eorder.name.last": "姓",
  "eorder.passport.number": "护照号码",
  "eorder.priority": "优先级",
  "eorder.requestDate": "请求日期",
  "eorder.search.noresults": "没有电子订单",
  "eorder.search1.text": "按姓氏、国家ID号、转诊实验室的实验室编号或护照号码搜索",
  "eorder.search2.text": "按日期和状态搜索 输入检测请求的日期范围。这将按转诊日期或电子请求的订单日期搜索",
  "eorder.searchValue": "搜索值",
  "eorder.status": "状态",
  "eorder.test.name": "检测名称",
  "eqa.action.deactivate": "停用",
  "eqa.action.edit": "编辑",
  "eqa.action.enterResults": "录入结果",
  "eqa.action.enterViewResults": "输入/查看结果",
  "eqa.action.reactivate": "重新激活",
  "eqa.action.viewOrder": "查看订单",
  "eqa.action.viewResults": "查看结果",
  "eqa.admin.addProgram": "添加计划",
  "eqa.admin.col.actions": "操作",
  "eqa.admin.col.category": "类别",
  "eqa.admin.col.frequency": "频率",
  "eqa.admin.col.participants": "参与者",
  "eqa.admin.col.programName": "计划名称",
  "eqa.admin.col.provider": "提供者",
  "eqa.admin.delete": "删除",
  "eqa.admin.form.addHeading": "添加EQA计划",
  "eqa.admin.form.category.placeholder": "选择类别",
  "eqa.admin.form.description.placeholder": "输入计划描述",
  "eqa.admin.form.editHeading": "编辑EQA计划",
  "eqa.admin.form.frequency.placeholder": "选择频率",
  "eqa.admin.form.name.placeholder": "输入计划名称",
  "eqa.admin.form.provider.placeholder": "选择提供者",
  "eqa.admin.form.subtitle": "填写以下信息以创建EQA计划",
  "eqa.admin.programs.subtitle": "管理外部质量评估计划",
  "eqa.admin.programs.title": "EQA计划",
  "eqa.admin.provider.placeholder": "选择提供者",
  "eqa.admin.subtitle": "外部质量评估管理",
  "eqa.admin.systemSettings.placeholder": "搜索系统设置...",
  "eqa.admin.tab.participants": "参与者",
  "eqa.admin.tab.programs": "计划",
  "eqa.admin.tab.systemSettings": "系统设置",
  "eqa.admin.tab.userManagement": "用户管理",
  "eqa.admin.tile.acrossAllPrograms": "所有计划",
  "eqa.admin.tile.activePrograms": "活跃计划",
  "eqa.admin.tile.canManageEqa": "可管理EQA",
  "eqa.admin.tile.enrolledParticipants": "已注册参与者",
  "eqa.admin.tile.systemUsers": "系统用户",
  "eqa.admin.tile.totalParticipants": "参与者总数",
  "eqa.admin.tile.totalPrograms": "计划总数",
  "eqa.admin.title": "EQA管理",
  "eqa.admin.userManagement.placeholder": "搜索用户...",
  "eqa.column.actions": "操作",
  "eqa.deadline.label": "截止日期",
  "eqa.distribution.action.continue": "继续",
  "eqa.distribution.action.ship": "发运",
  "eqa.distribution.action.track": "跟踪",
  "eqa.distribution.action.viewReport": "查看报告",
  "eqa.distribution.advance": "推进分发",
  "eqa.distribution.backToDashboard": "返回概览",
  "eqa.distribution.barcodes": "条码",
  "eqa.distribution.col.actions": "操作",
  "eqa.distribution.col.deadline": "截止日期",
  "eqa.distribution.col.participants": "参与者",
  "eqa.distribution.col.program": "计划",
  "eqa.distribution.col.responses": "回复数",
  "eqa.distribution.col.round": "轮次",
  "eqa.distribution.col.samples": "样本",
  "eqa.distribution.col.shipmentId": "发货编号",
  "eqa.distribution.col.status": "状态",
  "eqa.distribution.create": "创建分发",
  "eqa.distribution.createError": "创建分发失败",
  "eqa.distribution.createShipment": "创建发货",
  "eqa.distribution.createSuccess": "分发创建成功",
  "eqa.distribution.dashboard.subtitle": "管理和跟踪EQA分发",
  "eqa.distribution.dashboard.title": "分发仪表板",
  "eqa.distribution.deadline": "截止日期",
  "eqa.distribution.detail.title": "分发详情",
  "eqa.distribution.empty": "暂无分发记录",
  "eqa.distribution.filter.allShipments": "所有发货",
  "eqa.distribution.filter.program": "项目",
  "eqa.distribution.filter.status": "状态",
  "eqa.distribution.list.title": "分发列表",
  "eqa.distribution.manageParticipants": "管理参与者",
  "eqa.distribution.name": "分发名称",
  "eqa.distribution.name.placeholder": "输入分发名称",
  "eqa.distribution.network.active": "活跃",
  "eqa.distribution.network.active.sub": "当前活跃的参与者",
  "eqa.distribution.network.responseRate": "响应率",
  "eqa.distribution.network.responseRate.sub": "参与者响应率",
  "eqa.distribution.network.subtitle": "网络概览",
  "eqa.distribution.network.title": "参与者网络",
  "eqa.distribution.network.total": "总计",
  "eqa.distribution.network.total.sub": "参与者总数",
  "eqa.distribution.participants": "参与者",
  "eqa.distribution.participants.min": "最少参与者",
  "eqa.distribution.participants.none": "目前尚无任何组织注册参加所选项目。请先注册参与者，然后再创建分发。",
  "eqa.distribution.participants.select": "选择参与者",
  "eqa.distribution.program": "项目",
  "eqa.distribution.program.select": "选择项目",
  "eqa.distribution.responseRate": "响应率",
  "eqa.distribution.shipments.subtitle": "查看和管理发货",
  "eqa.distribution.shipments.title": "发货",
  "eqa.distribution.shipped": "已发货",
  "eqa.distribution.status.completed": "已完成",
  "eqa.distribution.status.draft": "草稿",
  "eqa.distribution.status.prepared": "已准备",
  "eqa.distribution.status.shipped": "已发货",
  "eqa.distribution.step.confirmation": "确认",
  "eqa.distribution.step.details": "详情",
  "eqa.distribution.step.participants": "参与者",
  "eqa.distribution.summary.completed": "已完成",
  "eqa.distribution.summary.completed.sub": "已完成的分发",
  "eqa.distribution.summary.draft": "草稿",
  "eqa.distribution.summary.draft.sub": "草稿中的分发",
  "eqa.distribution.summary.participants": "参与者",
  "eqa.distribution.summary.participants.sub": "参与者总数",
  "eqa.distribution.summary.shipped": "已发货",
  "eqa.distribution.summary.shipped.sub": "已发货的分发",
  "eqa.enrollment.allStatuses": "所有状态",
  "eqa.enrollment.alreadyEnrolled": "已注册",
  "eqa.enrollment.alreadyEnrolledCount": "已注册数量",
  "eqa.enrollment.confirmWithdraw": "确认退出",
  "eqa.enrollment.created.success": "注册创建成功",
  "eqa.enrollment.deactivated": "已停用",
  "eqa.enrollment.description": "描述",
  "eqa.enrollment.district": "地区",
  "eqa.enrollment.editing": "编辑中",
  "eqa.enrollment.empty": "暂无注册记录",
  "eqa.enrollment.enroll": "注册",
  "eqa.enrollment.enrollParticipant": "注册参与者",
  "eqa.enrollment.enrollSelected": "注册所选",
  "eqa.enrollment.enrollmentDate": "注册日期",
  "eqa.enrollment.error": "The enrollment was not saved. Try again.",
  "eqa.enrollment.labUnits": "实验室科室",
  "eqa.enrollment.new": "新建注册",
  "eqa.enrollment.organizationCode": "机构代码",
  "eqa.enrollment.organizationName": "机构名称",
  "eqa.enrollment.panels": "检测面板",
  "eqa.enrollment.programName": "项目名称",
  "eqa.enrollment.programName.placeholder": "输入项目名称",
  "eqa.enrollment.provider": "供应商",
  "eqa.enrollment.provider.placeholder": "输入供应商名称",
  "eqa.enrollment.reactivate": "重新激活",
  "eqa.enrollment.reactivated": "已重新激活",
  "eqa.enrollment.save": "保存",
  "eqa.enrollment.saveChanges": "保存更改",
  "eqa.enrollment.searchOrgs": "搜索机构",
  "eqa.enrollment.searchPlaceholder": "搜索...",
  "eqa.enrollment.selectLabUnits": "选择实验室科室",
  "eqa.enrollment.selectOrg": "选择机构",
  "eqa.enrollment.selectOrgsPrompt": "请选择要注册的机构",
  "eqa.enrollment.selectPanels": "选择检测面板",
  "eqa.enrollment.selectProgram": "选择项目",
  "eqa.enrollment.selectProgramPrompt": "请先选择一个项目",
  "eqa.enrollment.selectTests": "选择检测",
  "eqa.enrollment.selected": "已选择",
  "eqa.enrollment.status": "状态",
  "eqa.enrollment.status.active": "活跃",
  "eqa.enrollment.status.suspended": "已暂停",
  "eqa.enrollment.status.withdrawn": "已退出",
  "eqa.enrollment.success": "注册成功",
  "eqa.enrollment.suspend": "暂停",
  "eqa.enrollment.tests": "检测",
  "eqa.enrollment.thisLab": "本实验室",
  "eqa.enrollment.updated.success": "注册更新成功",
  "eqa.enrollment.withdraw": "退出",
  "eqa.enrollment.withdrawReason": "退出原因",
  "eqa.enrollment.withdrawReasonPlaceholder": "请输入退出原因",
  "eqa.filter.allPriorities": "所有优先级",
  "eqa.filter.allPrograms": "所有项目",
  "eqa.filter.allStatuses": "所有状态",
  "eqa.filter.eqaOnly": "仅EQA",
  "eqa.filter.priority": "优先级",
  "eqa.filter.program": "项目",
  "eqa.filter.status": "状态",
  "eqa.management.action.enterResults": "录入结果",
  "eqa.management.action.submit": "提交",
  "eqa.management.bulkUpload": "批量上传",
  "eqa.management.col.accession": "登记号",
  "eqa.management.col.actions": "操作",
  "eqa.management.col.deadline": "截止日期",
  "eqa.management.col.progress": "进度",
  "eqa.management.col.provider": "供应商",
  "eqa.management.col.sampleId": "样本编号",
  "eqa.management.col.status": "状态",
  "eqa.management.daysLeft": "剩余天数",
  "eqa.management.distributions.title": "分发管理",
  "eqa.management.filter.allSamples": "所有样本",
  "eqa.management.overdue": "已逾期",
  "eqa.management.participants.subtitle": "查看和管理参与者",
  "eqa.management.participants.title": "参与者管理",
  "eqa.management.performance.onTime": "按时完成",
  "eqa.management.performance.participation": "参与率",
  "eqa.management.performance.participation.sub": "项目参与率",
  "eqa.management.performance.subtitle": "查看绩效指标",
  "eqa.management.performance.title": "绩效",
  "eqa.management.performance.zScore": "Z评分",
  "eqa.management.performance.zScore.sub": "平均Z评分",
  "eqa.management.programs.subtitle": "查看和管理EQA项目",
  "eqa.management.programs.title": "项目管理",
  "eqa.management.results.title": "结果管理",
  "eqa.management.samples.empty": "暂无样本",
  "eqa.management.samples.subtitle": "查看和管理样本",
  "eqa.management.samples.title": "样本管理",
  "eqa.management.status.completed": "已完成",
  "eqa.management.status.completed.sub": "已完成的订单",
  "eqa.management.status.inProgress": "进行中",
  "eqa.management.status.inProgress.sub": "进行中的订单",
  "eqa.management.status.in_progress": "进行中",
  "eqa.management.status.overdue": "已逾期",
  "eqa.management.status.pending": "待处理",
  "eqa.management.status.pending.sub": "待处理的订单",
  "eqa.management.status.submitted": "已提交",
  "eqa.management.status.submitted.sub": "已提交的订单",
  "eqa.management.subtitle": "管理外部质量评估",
  "eqa.management.title": "EQA管理",
  "eqa.management.viewPerformance": "查看绩效",
  "eqa.myProgram.helperText": "选择您要参与的EQA项目",
  "eqa.myProgram.label": "我的项目",
  "eqa.myProgram.prePopulated.subtitle": "预填充的项目信息",
  "eqa.myProgram.prePopulated.title": "预填充项目",
  "eqa.myProgram.select": "选择项目",
  "eqa.myPrograms.action.deactivate": "停用",
  "eqa.myPrograms.action.edit": "编辑",
  "eqa.myPrograms.action.reactivate": "重新激活",
  "eqa.myPrograms.description": "描述",
  "eqa.myPrograms.enrollButton": "注册",
  "eqa.myPrograms.enrollInProgram": "注册项目",
  "eqa.myPrograms.labUnits": "实验室科室",
  "eqa.myPrograms.panels": "检测面板",
  "eqa.myPrograms.programName": "项目名称",
  "eqa.myPrograms.provider": "供应商",
  "eqa.myPrograms.search.placeholder": "搜索项目...",
  "eqa.myPrograms.status": "状态",
  "eqa.myPrograms.status.active": "活跃",
  "eqa.myPrograms.status.inactive": "未激活",
  "eqa.myPrograms.subtitle": "您注册的EQA项目",
  "eqa.myPrograms.testMapping": "检测映射",
  "eqa.myPrograms.testMappingHint": "将EQA检测映射到本地检测",
  "eqa.myPrograms.tests": "检测",
  "eqa.myPrograms.title": "我的EQA项目",
  "eqa.order.deadline": "截止日期",
  "eqa.order.form.title": "EQA订单",
  "eqa.order.participantId": "参与者编号",
  "eqa.order.priority": "优先级",
  "eqa.order.programme": "项目",
  "eqa.order.provider": "供应商",
  "eqa.order.providerSampleId": "供应商样本编号",
  "eqa.orders.completedThisMonth": "本月已完成",
  "eqa.orders.enterNewTest": "录入新检测",
  "eqa.orders.inProgress": "进行中",
  "eqa.orders.overdue": "已逾期",
  "eqa.orders.pending": "待处理",
  "eqa.orders.search.placeholder": "搜索订单...",
  "eqa.participant.id": "参与者编号",
  "eqa.priority.critical": "紧急",
  "eqa.priority.label": "优先级",
  "eqa.priority.standard": "标准",
  "eqa.priority.urgent": "加急",
  "eqa.program.activate": "激活",
  "eqa.program.active": "活跃",
  "eqa.program.addProgram": "添加项目",
  "eqa.program.cancel": "取消",
  "eqa.program.create": "创建项目",
  "eqa.program.createTitle": "创建EQA项目",
  "eqa.program.deactivate": "停用",
  "eqa.program.description": "描述",
  "eqa.program.description.placeholder": "输入项目描述",
  "eqa.program.edit": "编辑",
  "eqa.program.editTitle": "编辑EQA项目",
  "eqa.program.empty": "暂无项目",
  "eqa.program.inactive": "未激活",
  "eqa.program.label": "项目",
  "eqa.program.management.title": "项目管理",
  "eqa.program.name": "项目名称",
  "eqa.program.name.placeholder": "输入项目名称",
  "eqa.program.name.required": "项目名称为必填项",
  "eqa.program.provider.required": "必须提供供应商",
  "eqa.program.participantCount": "参与者数量",
  "eqa.program.provider": "供应商",
  "eqa.program.required": "此字段为必填项",
  "eqa.program.save": "保存",
  "eqa.program.select": "选择项目",
  "eqa.program.status": "状态",
  "eqa.program.tests": "检测",
  "eqa.program.tests.assign": "分配检测",
  "eqa.program.tests.select": "选择检测",
  "eqa.provider.label": "供应商",
  "eqa.provider.sampleId": "供应商样本编号",
  "eqa.provider.select": "选择供应商",
  "eqa.results.acceptable": "可接受",
  "eqa.results.batch.import": "批量导入",
  "eqa.results.col.deadline": "截止日期",
  "eqa.results.col.labNumber": "实验室编号",
  "eqa.results.col.priority": "优先级",
  "eqa.results.col.programme": "项目",
  "eqa.results.col.provider": "供应商",
  "eqa.results.col.status": "状态",
  "eqa.results.import.confirm": "确认导入",
  "eqa.results.import.errors": "导入错误",
  "eqa.results.import.success": "导入成功",
  "eqa.results.import.upload": "上传导入文件",
  "eqa.results.manual.entry": "手动录入",
  "eqa.results.mean": "均值",
  "eqa.results.minimum.participants": "最少参与者数",
  "eqa.results.noResults": "无结果",
  "eqa.results.organization": "机构",
  "eqa.results.organization.select": "选择机构",
  "eqa.results.participant.count": "参与者数量",
  "eqa.results.performance": "表现",
  "eqa.results.questionable": "可疑",
  "eqa.results.report.downloading": "正在下载报告...",
  "eqa.results.report.generate": "生成报告",
  "eqa.results.search.placeholder": "搜索结果...",
  "eqa.results.standardDeviation": "标准差",
  "eqa.results.statistics": "统计",
  "eqa.results.submit": "提交",
  "eqa.results.test": "检测",
  "eqa.results.test.select": "选择检测",
  "eqa.results.title": "EQA结果",
  "eqa.results.unacceptable": "不可接受",
  "eqa.results.value": "值",
  "eqa.results.zscore": "Z分数",
  "eqa.sample.badge": "EQA样本",
  "eqa.sample.checkbox": "EQA样本",
  "eqa.sample.checkbox.helper": "勾选此项以将该样本标记为外部质量评估样本",
  "eqa.sample.demographics.disabled": "EQA样本的人口统计信息已禁用",
  "eqa.sample.patient.readonly.body": "EQA样本的患者信息为只读",
  "eqa.sample.patient.readonly.title": "患者信息只读",
  "eqa.section.title": "外部质量评估",
  "eqa.settings.integration.apiKey": "API密钥",
  "eqa.settings.integration.apiUrl": "API地址",
  "eqa.settings.integration.fhir": "FHIR集成",
  "eqa.settings.integration.fhir.desc": "启用通过FHIR进行EQA数据集成",
  "eqa.settings.integration.subtitle": "配置外部系统集成",
  "eqa.settings.integration.title": "集成设置",
  "eqa.settings.loading": "正在加载设置...",
  "eqa.settings.notifications.email": "电子邮件通知",
  "eqa.settings.notifications.email.desc": "启用EQA事件的电子邮件通知",
  "eqa.settings.notifications.eqaDeadline": "截止日期提醒",
  "eqa.settings.notifications.eqaDeadline.desc": "在EQA截止日期前发送提醒通知",
  "eqa.settings.notifications.stat": "加急通知",
  "eqa.settings.notifications.stat.desc": "启用加急EQA样本的通知",
  "eqa.settings.notifications.subtitle": "配置通知偏好设置",
  "eqa.settings.notifications.threshold": "通知阈值",
  "eqa.settings.notifications.title": "通知设置",
  "eqa.settings.performance.autoZScore": "自动Z分数计算",
  "eqa.settings.performance.autoZScore.desc": "自动计算EQA结果的Z分数",
  "eqa.settings.performance.generateReports": "自动生成报告",
  "eqa.settings.performance.generateReports.desc": "自动生成EQA表现报告",
  "eqa.settings.performance.subtitle": "配置表现评估参数",
  "eqa.settings.performance.title": "表现设置",
  "eqa.settings.performance.zScoreMax": "Z分数最大值",
  "eqa.settings.performance.zScoreMin": "Z分数最小值",
  "eqa.settings.saveError": "保存设置时出错",
  "eqa.settings.saveSuccess": "设置保存成功",
  "eqa.settings.saving": "正在保存...",
  "eqa.status.active": "活跃",
  "eqa.status.completed": "已完成",
  "eqa.status.inProgress": "进行中",
  "eqa.status.inactive": "非活跃",
  "eqa.status.inprogress": "进行中",
  "eqa.status.overdue": "已逾期",
  "eqa.status.pending": "待处理",
  "eqa.submission.audit": "提交审计",
  "eqa.submission.date": "提交日期",
  "eqa.submission.error": "提交时出错",
  "eqa.submission.fhir": "FHIR提交",
  "eqa.submission.fhir.description": "通过FHIR提交EQA结果",
  "eqa.submission.late.approve": "批准延迟提交",
  "eqa.submission.late.justification": "延迟提交理由",
  "eqa.submission.late.justification.placeholder": "请输入延迟提交的理由...",
  "eqa.submission.late.supervisor": "主管审批",
  "eqa.submission.late.warning": "此提交已超过截止日期",
  "eqa.submission.method": "提交方式",
  "eqa.submission.success": "提交成功",
  "eqa.submission.title": "提交",
  "eqa.tests.action.enterResults": "录入结果",
  "eqa.tests.action.viewOrder": "查看订单",
  "eqa.tests.action.viewResults": "查看结果",
  "eqa.tests.dateEntered": "录入日期",
  "eqa.tests.deadline": "截止日期",
  "eqa.tests.enterNew": "录入新检测",
  "eqa.tests.labNumber": "实验室编号",
  "eqa.tests.orders.subtitle": "管理EQA检测订单",
  "eqa.tests.orders.title": "EQA检测订单",
  "eqa.tests.priority": "优先级",
  "eqa.tests.program": "方案",
  "eqa.tests.provider": "供应商",
  "eqa.tests.searchPlaceholder": "搜索检测...",
  "eqa.tests.status": "状态",
  "eqa.tests.status.completed": "已完成",
  "eqa.tests.status.inProgress": "进行中",
  "eqa.tests.status.overdue": "已逾期",
  "eqa.tests.status.pending": "待处理",
  "eqa.tests.summary.completedThisMonth": "本月已完成",
  "eqa.tests.summary.inProgress": "进行中",
  "eqa.tests.summary.overdue": "已逾期",
  "eqa.tests.summary.pending": "待处理",
  "eqa.validation.deadline.required": "截止日期为必填项",
  "eqa.validation.program.required": "方案为必填项",
  "eqa.validation.provider.required": "供应商为必填项",
  "error.add.edited.msg": "编辑/添加时出错",
  "error.barcode.dimension.positive": "条码尺寸必须为正数",
  "error.barcode.labelcount.default.lte.max": "默认标签数量不能超过最大值",
  "error.delete.msg": "删除时出错",
  "error.duplicate.calculationname": "重复的计算名称或保存时出错",
  "error.fetch.boxDetails": "获取箱子详情失败",
  "error.fetch.boxes": "获取转运箱信息失败",
  "error.fetch.facilities": "获取机构信息失败",
  "error.fetch.unassignedSamples": "获取未分配样本失败",
  "error.field.required": "此字段为必填项",
  "error.import.patient": "将患者导入OpenELIS时出错",
  "error.invalid.email": "无效的电子邮件",
  "error.invalidcredentials": "用户名或密码不正确",
  "error.locale.format": "区域设置格式无效",
  "error.no.patient.data": "没有要导入的患者数据",
  "error.nonconform.report": "请输入值",
  "error.report.csv.date": "请选择日期类型。",
  "error.report.csv.study": "请选择研究类型。",
  "error.report.status": "生成报告时出错",
  "error.report.linkIncomplete": "The link does not say which {0} to open, so the report cannot be shown. Choose it from the report lists instead.",
  "error.report.linkIncomplete.title": "This report link is incomplete",
  "error.required.destination": "目标机构为必填项",
  "error.results.loadFailed": "无法加载结果工作列表",
  "error.results.loadFailed.detail": "这不是一个空的工作列表——请求失败了，因此此处不会显示任何待处理的工作。请重试，如果仍无法成功，请告知管理员。",
  "error.results.precision": "此检测的报告结果精确到 {0} 位小数。请按该精度输入数值，否则记录值与报告值将不一致。",
  "error.results.staleSave": "该结果由 {0} 在 {1} 进行了更新——请刷新页面以查看最新值",
  "error.load.failed": "Could not load this list. Reload to try again.",
  "error.save.failed": "保存失败",
  "error.save.msg": "保存时出错",
  "error.save.order": "保存订单时出错",
  "error.save.patient": "保存患者时出错",
  "error.title": "错误",
  "errorBoundary.reload": "重新加载页面",
  "errorBoundary.route.patientResultsViewer.message": "加载患者结果时出错，请重试",
  "errorBoundary.route.patientResultsViewer.title": "患者结果查看器出错",
  "errorBoundary.route.resultsSearch.message": "搜索结果时出错，请重试",
  "errorBoundary.route.resultsSearch.title": "结果搜索出错",
  "errorBoundary.route.orderEntry.message": "Something went wrong on the order entry page. Reload to try again.",
  "errorBoundary.route.orderEntry.title": "Order entry could not be loaded",
  "errorBoundary.route.samplePatientEntry.message": "加载样本患者录入时出错，请重试",
  "errorBoundary.route.samplePatientEntry.title": "样本患者录入出错",
  "errorBoundary.route.storage.message": "加载存储模块时出错，请重试",
  "errorBoundary.route.storage.title": "存储模块出错",
  "errorBoundary.route.analyzers.message": "加载分析仪模块时出错，请重试",
  "errorBoundary.route.analyzers.title": "分析仪模块出错",
  "errorBoundary.route.analyzerResults.message": "加载分析仪结果时出错，请重试",
  "errorBoundary.route.analyzerResults.title": "分析仪结果出错",
  "errors.no.sample": "Select the appropriate sample for each test.",
  "errors.requester.org.or.requestor.required": "Enter at least one of Requesting Organization or Requester contact.",
  "esig.button.certify": "认证与继续教育",
  "esig.button.reject": "拒绝",
  "esig.button.saveAndSign": "保存",
  "esig.button.sign": "签名",
  "esig.button.validate": "验证",
  "esig.certification.acknowledge": "我已阅读并理解上述声明",
  "esig.certification.intro": "在使用QC签名之前，您必须证明您的QC签名在法律上与您的亲笔签名具有同等效力。",
  "esig.error.disabled": "未启用QC签名",
  "esig.error.generic": "发生错误",
  "esig.error.invalidCredentials": "凭证无效",
  "esig.error.keycloakNotSupported": "目前尚不支持 Keycloak 身份验证用于 QC签名",
  "esig.error.loadingStatus": "无法加载签名状态",
  "esig.error.mustAcknowledge": "您必须确认该认证声明",
  "esig.error.passwordRequired": "需要密码",
  "esig.error.rejectionReasonRequired": "必须填写拒绝原因",
  "esig.error.title": "错误",
  "esig.error.usernameRequired": "需要用户名",
  "esig.info.fullAuth": "这是您在本会话中的首次登录。请输入用户名和密码进行身份验证。",
  "esig.info.legalBinding": "输入您的凭据即表示您根据《联邦法规汇编》第21篇第11部分的规定，创建了一份具有法律约束力的电子签名。",
  "esig.info.passwordOnly": "您当前处于登录状态。请输入密码以继续。",
  "esig.label.context": "操作:",
  "esig.label.meaning": "签名含义：",
  "esig.label.password": "密码",
  "esig.label.rejectionReason": "拒绝原因",
  "esig.label.signingAs": "署名：{userName}",
  "esig.label.username": "用户名",
  "esig.meaning.authored": "作者",
  "esig.meaning.modified": "已修改",
  "esig.meaning.rejected": "已拒收",
  "esig.meaning.validatedAndReleased": "已审核并发布",
  "esig.placeholder.password": "请输入密码以确认",
  "esig.placeholder.rejectionReason": "请输入拒绝原因",
  "esig.placeholder.username": "请输入您的用户名",
  "esig.title.certification": "QC签名认证",
  "esig.title.signature": "QC签名",
  "example": "示例",
  "external.id": "外部ID",
  "external.referrals.report": "外部转诊报告",
  "externalReferredOutTests.title": "外部转诊报告",
  "externalconnections.active": "活跃",
  "externalconnections.add.title": "添加外部连接",
  "externalconnections.authtype": "认证类型",
  "externalconnections.authtype.basic.password": "密码",
  "externalconnections.authtype.basic.username": "用户名",
  "externalconnections.browse.title": "外部连接",
  "externalconnections.deactivate.success": "外部连接停用成功",
  "externalconnections.description": "描述",
  "externalconnections.edit.title": "编辑外部连接",
  "externalconnections.name": "名称",
  "externalconnections.name.placeholder": "输入连接名称",
  "externalconnections.programmedconnection": "程序化连接",
  "externalconnections.save.success": "外部连接保存成功",
  "externalconnections.search": "搜索",
  "externalconnections.search.placeholder": "搜索连接...",
  "externalconnections.select": "选择",
  "externalconnections.uri": "URI地址",
  "externalconnections.uri.placeholder": "输入连接URI",
  "false.label": "假",
  "field.active": "活跃/不活跃",
  "field.ageRange": "年龄范围",
  "field.dictionaryValues": "字典值",
  "field.loinc": "LOINC",
  "field.name": "名称",
  "field.normalRange": "正常范围",
  "field.note": "备注",
  "field.orderable": "可订购/不可订购",
  "field.panel": "面板",
  "field.referenceValue": "参考值",
  "field.reportName": "报告名称",
  "field.resultLimits": "结果限制",
  "field.resultType": "结果类型",
  "field.sampleType": "样本类型",
  "field.select.testSection": "选择检测科室",
  "field.selectValues": "选择值",
  "field.sex": "性别",
  "field.significantDigits": "有效位数",
  "field.testSection": "检测科室",
  "field.testUnit": "检测单元",
  "field.uom": "测量单位",
  "field.validRange": "有效范围",
  "file.import.configuration.active": "活跃",
  "file.import.configuration.analyzer": "分析仪",
  "file.import.configuration.analyzer.emptyState": "无可用分析仪",
  "file.import.configuration.analyzer.placeholder": "选择分析仪",
  "file.import.configuration.cancel": "取消",
  "file.import.configuration.columnMappings": "列映射",
  "file.import.configuration.columnMappings.helperText": "配置文件列与系统字段之间的映射关系",
  "file.import.configuration.delimiter": "分隔符",
  "file.import.configuration.delimiter.helperText": "用于分隔文件中各列的字符",
  "file.import.configuration.error.save": "保存配置时出错",
  "file.import.configuration.error.unknown": "发生未知错误",
  "file.import.configuration.fileFormat": "文件格式",
  "file.import.configuration.fileFormat.placeholder": "选择文件格式",
  "file.import.configuration.filePattern": "文件名模式",
  "file.import.configuration.filePattern.helperText": "用于匹配导入文件的文件名模式",
  "file.import.configuration.hasHeader": "包含表头行",
  "file.import.configuration.importDirectory": "导入目录",
  "file.import.configuration.importDirectory.helperText": "监控待导入文件的目录",
  "file.import.configuration.importDirectory.placeholder": "输入导入目录路径",
  "file.import.configuration.save": "保存",
  "file.import.configuration.success.created": "导入配置创建成功",
  "file.import.configuration.success.updated": "导入配置更新成功",
  "file.import.configuration.title.add": "添加导入配置",
  "file.import.configuration.title.edit": "编辑导入配置",
  "file.import.configuration.validation.analyzerId.required": "分析仪为必填项",
  "file.import.configuration.validation.columnMappings.invalid": "列映射配置无效",
  "file.import.configuration.validation.importDirectory.required": "导入目录为必填项",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "过滤器",
  "freezer.alert.detail.acknowledge": "确认",
  "freezer.alert.detail.acknowledgedAt": "已确认",
  "freezer.alert.detail.acknowledgedBy": "已确认",
  "freezer.alert.detail.acknowledgmentNotes": "致谢备注",
  "freezer.alert.detail.actions": "已采取的操作",
  "freezer.alert.detail.close": "关闭",
  "freezer.alert.detail.correctiveAction": "纠正措施",
  "freezer.alert.detail.correctiveActionDescription": "描述",
  "freezer.alert.detail.correctiveActionFailed": "未能记录纠正措施",
  "freezer.alert.detail.correctiveActionType": "措施类型",
  "freezer.alert.detail.delete": "删除警报",
  "freezer.alert.detail.deleteConfirm": "要永久删除此警报吗？",
  "freezer.alert.detail.deleteFailed": "删除警报失败",
  "freezer.alert.detail.deletePermanently": "永久删除",
  "freezer.alert.detail.deleteWarning": "开始时间、严重程度、确认信息和备注已被移除，且没有审计跟踪，无法恢复。",
  "freezer.alert.detail.freezer": "冰箱",
  "freezer.alert.detail.id": "警报编号",
  "freezer.alert.detail.logCorrectiveAction": "记录纠正措施",
  "freezer.alert.detail.message": "消息",
  "freezer.alert.detail.method": "方法",
  "freezer.alert.detail.notes": "备注",
  "freezer.alert.detail.notesPlaceholder": "添加关于此警报的备注...",
  "freezer.alert.detail.notifications": "已发送通知",
  "freezer.alert.detail.overview": "警报概述",
  "freezer.alert.detail.recipient": "收件人",
  "freezer.alert.detail.resolutionNotes": "决议备注",
  "freezer.alert.detail.resolve": "已解决",
  "freezer.alert.detail.resolvedAt": "已解决",
  "freezer.alert.detail.resolvedBy": "由……决议",
  "freezer.alert.detail.sentAt": "已发送时间：",
  "freezer.alert.detail.severity": "严重程度",
  "freezer.alert.detail.startTime": "开始时间",
  "freezer.alert.detail.status": "状态",
  "freezer.alert.detail.summary": "转运箱摘要",
  "freezer.alert.detail.takenAt": "拍摄于",
  "freezer.alert.detail.takenBy": "拍摄者：",
  "freezer.alert.detail.title": "警报详情",
  "freezer.alert.severity.critical": "紧急",
  "freezer.alert.severity.warning": "警告",
  "freezer.alert.status.acknowledged": "已确认",
  "freezer.alert.status.closed": "已关闭",
  "freezer.alert.status.escalated": "升级",
  "freezer.alert.status.open": "待处理",
  "freezer.alert.status.resolved": "已解决",
  "freezer.nav.corrective": "纠正措施",
  "freezer.nav.corrective.tooltip": "查看和管理纠正措施",
  "freezer.nav.dashboard": "仪表板",
  "freezer.nav.dashboard.tooltip": "查看冰箱仪表板",
  "freezer.nav.reports": "报告",
  "freezer.nav.reports.tooltip": "查看冰箱报告",
  "freezer.nav.settings": "设置",
  "freezer.nav.settings.tooltip": "管理冰箱设置",
  "freezer.nav.trends": "趋势",
  "freezer.nav.trends.tooltip": "查看温度趋势",
  "french.current": "法文当前",
  "french.label": "法文",
  "from.title": "从",
  "genericSample.edit.success": "样本编辑成功",
  "genericSample.edit.title": "编辑样本",
  "genericSample.field.by": "由",
  "genericSample.field.count": "#",
  "genericSample.field.date": "日期",
  "genericSample.field.from": "从",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "实验室接收人",
  "genericSample.field.project": "项目",
  "genericSample.field.storageLocation": "存储冰箱编号和位置",
  "genericSample.field.type": "类型",
  "genericSample.notebook.selection.title": "项目选择（可选）",
  "genericSample.order.error.labNoRequired": "请在保存前生成实验室编号。",
  "genericSample.order.generateLabNo": "生成实验室编号",
  "genericSample.order.labNo.placeholder": "点击'生成实验室编号'创建",
  "genericSample.order.success.details": "样本详情",
  "genericSample.order.success.message": "样本订单创建成功",
  "genericSample.order.title": "接收样本",
  "gps.accuracy.display": "精度：{accuracy}米",
  "gps.accuracy.warning.message": "GPS精度较低，位置信息可能不准确",
  "gps.accuracy.warning.title": "精度警告",
  "gps.button.clear": "清除位置",
  "gps.button.getting.location": "正在获取位置...",
  "gps.button.location.captured": "位置已获取",
  "gps.button.use.my.location": "使用我的位置",
  "gps.collapse": "收起",
  "gps.config.accuracy.helper": "可接受的最大精度值（米）",
  "gps.config.accuracy.label": "精度阈值",
  "gps.config.enabled.description": "启用样本采集的GPS坐标捕获功能",
  "gps.config.enabled.label": "启用GPS",
  "gps.config.error.load": "加载GPS配置时出错",
  "gps.config.save.error": "保存GPS配置时出错",
  "gps.config.save.success": "GPS配置保存成功",
  "gps.config.saving": "正在保存...",
  "gps.config.section.general": "常规设置",
  "gps.config.timeout.helper": "等待GPS信号的最长时间（秒）",
  "gps.config.timeout.label": "超时时间",
  "gps.config.title": "GPS配置",
  "gps.config.unsaved.changes": "您有未保存的更改。是否确定要离开？",
  "gps.config.unsaved.subtitle": "如果离开，未保存的更改将丢失",
  "gps.config.unsaved.title": "未保存的更改",
  "gps.config.validation.accuracy.negative": "精度值不能为负数",
  "gps.config.validation.accuracy.too.high": "精度值过高",
  "gps.config.validation.timeout.too.high": "超时时间过长",
  "gps.config.validation.timeout.too.low": "超时时间过短",
  "gps.coordinates.captured.via": "坐标获取方式：{method}",
  "gps.coordinates.current": "当前坐标",
  "gps.error.not.supported": "您的浏览器不支持地理定位",
  "gps.error.permission.denied": "位置访问权限被拒绝",
  "gps.error.position.unavailable": "位置信息不可用",
  "gps.error.timeout": "获取位置请求超时",
  "gps.error.title": "GPS错误",
  "gps.error.unknown": "发生未知错误",
  "gps.info.description": "GPS坐标用于记录样本采集地点",
  "gps.info.title": "GPS信息",
  "gps.latitude.helper": "输入纬度值（-90到90之间）",
  "gps.latitude.invalid": "纬度值无效",
  "gps.latitude.label": "纬度",
  "gps.latitude.placeholder": "例如：39.9042",
  "gps.longitude.helper": "输入经度值（-180到180之间）",
  "gps.longitude.invalid": "经度值无效",
  "gps.longitude.label": "经度",
  "gps.longitude.placeholder": "例如：116.4074",
  "gps.manual.entry.off": "手动输入已关闭",
  "gps.manual.entry.on": "手动输入已开启",
  "gps.manual.entry.title": "手动输入坐标",
  "gps.manual.entry.toggle": "切换手动输入",
  "gps.not.captured": "未获取位置",
  "gps.section.description": "采集地点的GPS坐标",
  "gps.section.title": "GPS坐标",
  "gps.status.captured": "已获取",
  "gps.status.optional": "可选",
  "gps.tile.collapse": "收起GPS",
  "gps.tile.expand": "展开GPS",
  "gps.warning.partial.coordinates": "请同时提供纬度和经度",
  "header.ID": "ID",
  "header.assign": "分配",
  "header.cancel.test": "取消检测",
  "header.formname": "表单名称",
  "header.icon.help": "帮助",
  "header.icon.lang": "语言",
  "header.icon.menu.close": "关闭菜单",
  "header.icon.menu.open": "打开菜单",
  "header.icon.menu.pin": "固定菜单",
  "header.icon.menu.unpin": "取消固定菜单",
  "header.icon.notifications": "通知",
  "header.icon.search": "搜索",
  "header.icon.user": "用户",
  "header.label.ARV": "ARV-初始",
  "header.label.EID": "DBS-PCR儿童诊断",
  "header.label.changeLab": "选择实验室",
  "header.label.followup": "ARV-随访",
  "header.label.intialFollowup": "ARV -->初始-随访-VL",
  "header.label.logout": "退出登录",
  "header.label.nonconformityByDate": "按日期的不符合报告",
  "header.label.selectLab": "选择实验室",
  "header.label.selectlocale": "选择区域设置",
  "header.label.specialRequest": "特殊请求",
  "header.label.study.ciexport": "按日期导出CSV文件",
  "header.label.study.vlloadtrends": "病毒载量数据导出报告",
  "header.label.version": "版本：",
  "header.reject": "拒绝",
  "header.rejection.reason": "拒绝原因",
  "header.results.recorded": "记录的结果",
  "hide.aliquoting": "隐藏分装样本",
  "holder.choose.availabletest": "选择可用检测",
  "home.label": "首页",
  "immunohistochemistry.label.addreport": "添加报告",
  "immunohistochemistry.label.averageChrom": "每个细胞核平均17号染色体信号",
  "immunohistochemistry.label.averageHer2": "每个细胞核平均HER2",
  "immunohistochemistry.label.cellIntensity": "强度 . Allred评分",
  "immunohistochemistry.label.cellPercent": "%的细胞显示核染色",
  "immunohistochemistry.label.dashboard": "免疫组织化学仪表板",
  "immunohistochemistry.label.her2Assesment": "HER 2蛋白评估是",
  "immunohistochemistry.label.her2Pattern": "CerbB2/HER 2染色模式",
  "immunohistochemistry.label.her2ScoreOf": "评分为",
  "immunohistochemistry.label.historicalDiagnosis": "组织学诊断",
  "immunohistochemistry.label.ihcRatio": "Her2/neu信号与17号染色体的比率",
  "immunohistochemistry.label.ihcScore": "IHC (Cerb2评分)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (增殖指数): ",
  "immunohistochemistry.label.molecularType": "分子亚型",
  "immunohistochemistry.label.numberOfCancer": "癌细胞核数量",
  "immunohistochemistry.label.outOf8": "共8个",
  "immunohistochemistry.label.report": "报告",
  "immunohistochemistry.label.reports": "报告",
  "immunohistochemistry.label.review": "等待免疫组织化学审查",
  "immunohistochemistry.label.title": "免疫组织化学",
  "immunohistochemistry.label.tumorCells": "肿瘤细胞阳性(截止值20%)",
  "import.autoGenerated": "自动生成",
  "import.created": "已创建",
  "import.error.failed": "导入失败",
  "import.error.importFile": "导入文件时出错",
  "import.error.selectFile": "请选择要导入的文件",
  "import.error.validateFile": "请先验证文件",
  "import.error.validateFirst": "请先进行验证再导入",
  "import.error.validationFailed": "验证失败",
  "import.failed": "失败",
  "import.failedCount": "失败数量",
  "import.header.collectionDate": "采集日期",
  "import.header.errorMessage": "错误信息",
  "import.header.field": "字段",
  "import.header.from": "来源",
  "import.header.labNo": "实验室编号",
  "import.header.quantity": "数量",
  "import.header.row": "行",
  "import.header.sampleType": "样本类型",
  "import.header.samplesToCreate": "待创建样本数",
  "import.importing": "正在导入...",
  "import.invalidRows": "无效行数",
  "import.selectFile": "选择文件",
  "import.status.invalid": "无效",
  "import.status.valid": "有效",
  "import.success": "导入成功",
  "import.totalRows": "总行数",
  "import.totalSamplesToCreate": "待创建样本总数",
  "import.uploadFile": "上传文件",
  "import.uploadFileDesc": "选择要导入的文件",
  "import.validRows": "有效行数",
  "import.validating": "正在验证...",
  "import.validationStatus": "验证状态",
  "input.error.same.panel.type": "已找到具有相同名称的现有面板类型。请取消或使用不同的名称。",
  "input.placeholder.labNo": "输入实验室编号",
  "input.placeholder.patientFirstName": "输入患者名",
  "input.placeholder.patientId": "输入患者ID",
  "input.placeholder.patientLastName": "输入患者姓",
  "input.placeholder.prevLabNumber": "输入之前的实验室编号",
  "input.placeholder.providerEmail": "输入请求者的电子邮件",
  "input.placeholder.providerFax": "输入请求者的传真号码",
  "input.placeholder.providerWorkPhone": "输入请求者的电话号码",
  "input.placeholder.provisionalClinicalDiagnosis": "输入临时临床诊断",
  "input.placeholder.requesterFirstName": "输入请求者的名",
  "input.placeholder.requesterLastName": "输入请求者的姓",
  "input.placeholder.searchTestName": "在此搜索检测名称",
  "input.placeholder.selectPanel": "选择面板类型",
  "input.placeholder.selectPriority": "选择优先级",
  "input.placeholder.selectTest": "选择检测类型",
  "input.placeholder.selectTestSection": "选择单元类型",
  "instructions.copy.labnum": "复制实验室编号",
  "instructions.order.entry.eqa.enabled": "已启用EQA程序订单录入",
  "instructions.order.entry.requester": "启用此功能后，“搜索请求者”、“请求者名”和“请求者姓”将在“添加订单”页面上成为必填字段。禁用此功能（默认值）时，这三个字段均为可选字段。",
  "instructions.test.activation": "活跃检测：选中的框表示已经活跃的检测。要激活检测，请选中框；要停用，请取消选中框。任何没有现有活跃检测的样本类型都将被停用，并显示在底部的'非活跃样本类型'下。如果其中一个检测被激活，样本类型将被激活。",
  "instructions.test.activation.confirm": "验证这些是您想要进行的更改。如果正确，则保存。如果不正确，请使用后退按钮进行正确的更改",
  "instructions.test.activation.sort": "显示顺序：具有新激活检测的样本类型列表。对检测进行排序，以指示它们将如何在订单录入屏幕中显示。可以通过将项目拖动到所需位置来进行排序。",
  "instructions.test.order": "带有检查的检测是可订购的，没有检查的检测是不可订购的。更改检查以更改状态。要能够在录入时订购检测，它必须既活跃又可订购。活跃但不可订购的检测可以作为检测反射的一部分请求。",
  "invalid.json": "JSON无效",
  "inventory.add.button": "添加新批次",
  "inventory.addItem.button": "添加目录项",
  "inventory.consume.error.noLots": "No stock available for {name} ({code})",
  "inventory.consume.error.noLotsAwaitingQc": "No QC-passed stock for {name} ({code}): {count} lot(s) with stock are awaiting QC. Mark QC as passed to use them.",
  "inventory.consume.error.noLotsQcFailed": "No usable stock for {name} ({code}): {count} lot(s) with stock failed QC",
  "inventory.consume.error.noLotsQuarantined": "No usable stock for {name} ({code}): {count} lot(s) with stock are quarantined",
  "inventory.dashboard.title": "库存仪表板",
  "inventory.export.button": "导出",
  "inventory.filter.all": "全部",
  "inventory.filter.status": "按状态过滤",
  "inventory.filter.type": "按类型过滤",
  "inventory.itemType.CARTRIDGE": "Analyzer Cartridge",
  "inventory.itemType.HIV_KIT": "HIV Test Kit",
  "inventory.itemType.RDT": "RDT (Rapid Diagnostic Test)",
  "inventory.itemType.REAGENT": "Reagent",
  "inventory.itemType.SYPHILIS_KIT": "Syphilis Test Kit",
  "inventory.item.error.duplicateCode": "An inventory item with code \"{code}\" already exists.",
  "inventory.item.error.codeGenerationExhausted": "Could not find a free code for prefix \"{prefix}\". Enter a code manually.",
  "inventory.list.title": "库存物品",
  "inventory.lot.error.duplicateBarcode": "Barcode \"{barcode}\" is already assigned to lot {lotNumber}",
  "inventory.lot.search.placeholder": "Search by item name, lot number or barcode",
  "inventory.metrics.expired": "已过期",
  "inventory.metrics.expiringSoon": "即将过期",
  "inventory.metrics.lowStock": "低库存",
  "inventory.metrics.totalLots": "总批次",
  "inventory.tab.catalog": "目录",
  "inventory.tab.dashboard": "仪表板",
  "inventory.tab.reports": "报告",
  "inventory.title": "库存管理",
  "label.action": "操作",
  "labNumber.format.current": "当前格式",
  "labNumber.format.new": "新格式",
  "labNumber.prefix": "前缀",
  "labNumber.type": "实验室编号类型",
  "labNumber.usePrefix": "使用前缀",
  "label.actions": "操作",
  "label.active": "活跃",
  "label.actualTestName": "实际检测名称",
  "label.add": "添加",
  "label.add.notification": "向用户添加弹出通知",
  "label.all": "全部",
  "label.analysisNotStarted": "分析未开始",
  "label.any": "任何",
  "label.audittrail": "实验室编号",
  "label.audittrail.Reports": "审计跟踪报告",
  "label.audittrail.labNo.invalidaccessionnumber": "无效的订单号",
  "label.audittrail.labNo.missing": "实验室编号是必需的！",
  "label.audittrailreport.nextvisitdate": "下次就诊日期",
  "label.audittrailreport.priority": "优先级",
  "label.audittrailreport.program": "程序",
  "label.audittrailreport.receiveddate": "接收日期",
  "label.audittrailreport.requestdate": "请求日期",
  "label.audittrailreport.requester": "请求者",
  "label.audittrailreport.requester.firstname": "请求者的名",
  "label.audittrailreport.requester.lastname": "请求者的姓",
  "label.audittrailreport.sitename": "站点名称",
  "label.autoFilledFromServer": "由服务器自动填充",
  "label.barcode": "条码",
  "label.barcode.labelsets": "标签组数量",
  "label.barcode.orderlabel": "每组订单标签数量",
  "label.barcode.specimenlabel": "每组标本标签数量",
  "label.barcode.totallabel": "要打印的总标签数",
  "label.button.action": "操作",
  "label.button.add": "添加",
  "label.button.add.question": "添加新问题",
  "label.button.cancel": "取消",
  "label.button.close": "关闭",
  "label.button.changepassword": "更改密码",
  "label.button.clear": "清除",
  "label.button.confirm": "确认",
  "label.button.confirmAction": "确认操作",
  "label.button.confirmDelete": "确认删除",
  "label.button.confirmTitle": "您确定吗？",
  "label.button.delete": "删除",
  "label.button.descritpion": "描述",
  "label.button.edit": "编辑",
  "label.button.activate": "激活",
  "label.button.deactivate": "停用",
  "label.button.exit": "退出",
  "label.button.externalsearch": "外部搜索",
  "label.button.field": "字段",
  "label.button.finish": "完成",
  "label.button.finished": "完成",
  "label.button.generatePrintableVersion": "生成可打印版本",
  "label.button.import": "导入",
  "label.button.login": "登录",
  "label.button.login.sso": "单点登录",
  "label.button.newEntry": "新条目",
  "label.button.ok": "确定",
  "label.button.previous": "上一个",
  "label.button.range": "范围",
  "label.button.remove": "移除",
  "label.button.remove.block": "移除块",
  "label.button.remove.report": "移除报告",
  "label.button.remove.slide": "移除幻灯片",
  "label.button.reset": "重置",
  "label.button.sample": "样本",
  "label.button.save": "保存",
  "label.button.saveconfig": "保存QC频率",
  "label.button.search": "搜索",
  "label.button.select": "选择",
  "label.button.select.pathologist": "选择病理学家",
  "label.button.select.status": "选择状态",
  "label.button.select.technician": "选择技术员",
  "label.button.select.test": "选择检测",
  "label.button.start": "开始",
  "label.button.submit": "提交",
  "label.button.update": "更新",
  "label.button.uploadfile": "上传文件",
  "label.button.validate": "验证",
  "label.button.viewReport": "查看报告",
  "label.cancel": "取消",
  "label.cancel.test.no.replace": "取消所选实验室编号的检测，不分配新检测",
  "label.checkedWillBeModified": "选中的实验室编号将被修改",
  "label.clear": "清除过滤器",
  "label.content": "标签内容",
  "label.confirm": "确认",
  "label.created.samples": "创建的样本",
  "label.critical.range": "危急范围",
  "label.currentTest": "当前检测",
  "label.days": "天",
  "label.default.result": "默认结果",
  "label.delete": "删除",
  "label.description": "描述",
  "label.edit": "编辑",
  "label.electronic.orders": "电子订单",
  "label.equals": "等于",
  "label.error": "错误",
  "label.existing.methods": "现有方法",
  "label.existing.test.sets": "现有检测集",
  "label.filters.mycases": "我的案例",
  "label.filters.status": "状态",
  "label.field.required": "此字段为必填项",
  "label.status": "状态",
  "label.form.searchby": "按...搜索",
  "label.id": "ID",
  "label.import.errors": "导入错误",
  "label.inactive": "非活跃",
  "label.inactive.methods": "非活跃方法。分配检测以激活。",
  "label.includeInactiveTests": "包括非活跃检测",
  "label.inside.normalrange": "在正常范围内",
  "label.lastPrinted": "最后打印：{date} {time} 由 {user} 打印",
  "label.loading": "加载中...",
  "label.loinc": "LOINC",
  "label.management.title": "标签管理",
  "label.no": "否",
  "label.no.options.available": "没有可用选项",
  "label.none": "无",
  "label.notValidated": "未验证",
  "label.notequals": "不等于",
  "label.order.labNrPrefix": "实验室编号",
  "label.order.patientPrefix": "患者",
  "label.order.scan.text": "扫描或手动输入或",
  "label.orderable": "可订购",
  "label.outside.normalrange": "超出正常范围",
  "label.page.patientHistory": "患者历史",
  "label.preview.data": "预览数据",
  "label.print": "打印标签",
  "label.print.error": "生成标签时出错。请重试。",
  "label.print.error.popupBlocked": "弹出窗口被阻止。请允许此站点的弹出窗口以打印标签。",
  "label.print.openDirectly": "Open the labels in a new tab",
  "label.print.generating": "生成中...",
  "label.print.success": "标签打印成功",
  "label.print.description": "打印订单和样本的标签",
  "label.print.helper": "选择要打印的标签类型和数量",
  "label.print.success.count": "{count} 标签打印成功",
  "label.print.title": "打印条码",
  "label.printAll": "打印所有标签",
  "label.printAll.success": "所有标签均已打印成功",
  "label.printConfirmation.message": "为 {name}{code} 打印标签？",
  "label.printConfirmation.title": "打印标签",
  "label.printHistory": "打印历史",
  "label.printHistory.byUser": "由 {user} 打印",
  "label.printHistory.count": "{count} 个标签",
  "label.printHistory.loading": "加载打印历史...",
  "label.printHistory.never": "从未打印",
  "label.printHistory.unknownUser": "未知",
  "label.printHistory.viewAll": "查看历史",
  "label.printLabel": "打印标签",
  "label.program": "程序",
  "label.qualifiers": "限定符",
  "label.quantity": "数量",
  "label.readonly": "只读",
  "label.reference.value": "参考值",
  "label.refertest.referencelab": "将检测转诊到参考实验室",
  "label.rejectedByBiologist": "被生物学家拒绝",
  "label.rejectedByTechnician": "被技术员拒绝",
  "label.remove": "移除",
  "label.replaceWith": "替换为",
  "label.report.byNationalId": "按国家ID / 唯一健康ID号",
  "label.reporting.range": "报告范围",
  "label.result.order": "结果顺序",
  "label.resultSelectList": "结果选择列表",
  "label.results.actions": "操作",
  "label.results.anotherUser": "另一位用户",
  "label.results.date": "检测日期",
  "label.results.domain": "临床",
  "label.results.domain.env": "水质",
  "label.results.domain.vector": "病媒监测",
  "label.results.edit": "编辑",
  "label.results.inReviewBy": "正在由 {0} 审核",
  "label.results.labUnit": "实验室单元",
  "label.results.load": "加载结果",
  "label.results.loading": "Loading results...",
  "label.results.range": "参考范围",
  "label.results.range.env": "监管限值",
  "label.results.range.vector": "解释",
  "label.results.reflexTriggered": "已为以下内容添加了反射检测/计算检测：",
  "label.results.refresh": "刷新",
  "label.results.result": "结果",
  "label.results.resultFor": "{0} 的结果",
  "label.results.retry": "请重试",
  "label.results.save": "保存",
  "label.results.search": "按实验室编号搜索",
  "label.results.searchByPatient": "按患者搜索",
  "label.results.selectAnotherPatient": "选择另一位患者",
  "label.results.selectedPatient": "已选择的患者",
  "label.results.selectedPatient.none": "无",
  "label.results.status": "状态",
  "label.results.status.all": "所有分析仪",
  "label.results.subject": "样本 / 患者",
  "label.results.subject.env": "样本 / 站点",
  "label.results.subject.vector": "样本 / 陷阱",
  "label.results.table.caption": "结果工作列表",
  "label.results.test": "检测",
  "label.results.titer.placeholder": "e.g. 1:10",
  "label.results.method": "方法",
  "label.results.analyzer": "分析仪",
  "label.results.analyzer.none": "并非来自乐器",
  "label.results.fromAnalyzer": "来源：分析仪",
  "label.results.methodAnalyzerHint": "“方法”是指分析仪的类型；“分析仪”是指具体的仪器。",
  "label.results.expandRow": "展开行",
  "label.results.collapseRow": "折叠行",
  "label.results.referredOut": "转诊",
  "label.results.notes": "备注",
  "label.results.note.context": "上下文",
  "label.results.note.context.entry": "条目",
  "label.results.note.context.modification": "修改",
  "label.results.note.context.auto": "根据您当前的操作自动设置。",
  "label.results.note.visibility": "可见性",
  "label.results.note.internal": "仅限实验室内部使用",
  "label.results.note.external": "发送并附上结果",
  "label.results.note.analysisLevel": "分析级别",
  "label.results.note.externalWarning": "该备注将显示在患者报告中。",
  "label.results.note.placeholder": "添加备注……",
  "label.results.dilution.measured": "测量值",
  "label.results.dilution.factor": "稀释系数",
  "label.results.dilution.reported": "报告值：{0}",
  "label.results.saveHint": "“保存”会记录您的电子签名。紧急确认信息绝不会阻止“保存”操作。",
  "label.results.flag.normal": "正常",
  "label.results.flag.abnormal": "异常",
  "label.results.flag.critical": "紧急",
  "label.results.flag.invalid": "无效",
  "label.results.sample": "样本",
  "label.results.flag": "旗帜",
  "label.results.order.clinician": "开单医师",
  "label.results.order.phone": "电话",
  "label.results.order.site": "请求网站",
  "label.results.order.priority": "优先级",
  "label.results.order.collection": "系列",
  "label.results.section.program": "计划信息",
  "label.results.program.name": "计划",
  "label.results.program.eqa": "EQA样本",
  "label.results.program.readonly": "此处的项目字段为只读——请在原始订单中进行编辑。",
  "label.results.section.storage": "存储与样本处置",
  "label.results.storage.location": "位置",
  "label.results.storage.position": "位置",
  "label.results.storage.notes": "备注",
  "label.results.storage.unassigned": "未分配存储空间",
  "label.results.storage.assignLocation": "分配位置",
  "label.results.storage.moveLocation": "移动到该位置",
  "label.results.program.capturedData": "项目数据",
  "label.results.sampleStatus.title": "样本状态",
  "label.results.sampleStatus.volume": "卷：{1} 剩余 {0} · 状态 {2}。",
  "label.results.sampleStatus.noVolume": "状态 {0}。",
  "label.results.sampleStatus.available": "可用",
  "label.results.sampleStatus.usedUp": "用尽了（耗尽了）",
  "label.results.sampleStatus.disposed": "已处置",
  "label.results.sampleStatus.recordUse": "记录资金使用额",
  "label.results.sampleStatus.markUsedUp": "马克用完了",
  "label.results.sampleStatus.startDisposal": "开始处置",
  "label.results.sampleStatus.amountUsed": "本次检测项目的用量",
  "label.results.sampleStatus.record": "记录",
  "label.results.sampleStatus.recordHint": "减少剩余体积——在样本耗尽或被明确标记为“已用完”之前，不会将其处置。",
  "label.results.sampleStatus.usedUpNote": "样本已处理完毕，并已排入处置工作流。处置记录了由谁、何时以及采用何种方法进行处置。",
  "label.results.sampleStatus.disposalReason": "处置原因",
  "label.results.sampleStatus.disposalMethod": "处置方法",
  "label.results.sampleStatus.disposalNotes": "备注",
  "label.results.sampleStatus.confirmDisposal": "确认处置",
  "label.results.sampleStatus.reason.expired": "已过期",
  "label.results.sampleStatus.reason.contaminated": "受污染的",
  "label.results.sampleStatus.reason.patient_request": "患者请求",
  "label.results.sampleStatus.reason.testing_complete": "测试已完成",
  "label.results.sampleStatus.reason.other": "其他原因",
  "label.results.sampleStatus.method.autoclave": "生物危害高压灭菌器",
  "label.results.sampleStatus.method.neutralization": "化学中和",
  "label.results.sampleStatus.method.incineration": "焚烧",
  "label.results.sampleStatus.method.other": "其他原因",
  "label.results.sampleStatus.footnote": "“部分使用”会记录已消耗的数量与样本项的剩余体积；“完全耗尽”（或标记为“已用完”）将触发处置流程。",
  "label.results.section.reagents": "试剂、QC与对照品",
  "label.results.reagents.summary.analyzer": "分析仪报告的批次",
  "label.results.reagents.summary.manual": "手动捕获",
  "label.results.reagents.mode.analyzer": "捕获模式：分析仪报告",
  "label.results.reagents.mode.manual": "拍摄模式：手动（可选）",
  "label.results.reagents.analyzerNote": "由{0}在其结果有效载荷中报告——只读。",
  "label.results.reagents.lotsUsed": "所用试剂的批号",
  "label.results.reagents.noneLinked": "此检测未关联任何试剂——相关链接已在“检测目录”中配置。",
  "label.results.reagents.noLots": "该试剂目前库存中无可用批次。",
  "label.results.reagents.perTest": "{0} {1} 每次检测",
  "label.results.reagents.fefo": "建议采用FEFO法",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} 剩余的",
  "label.results.reagents.quantityUsed": "使用数量",
  "label.results.reagents.recordUse": "使用量创下记录",
  "label.results.reagents.recorded": "记录于 {0} {1} —— 跨批次已消耗先进先出（FEFO）原则。",
  "label.results.reagents.recordFailed": "无法记录试剂使用情况。",
  "label.results.reagents.amountInvalid": "使用数量必须为正数。",
  "label.results.reagents.consumeNote": "记录使用量会减少库存（FEFO），并生成一条与该分析相关的消耗交易。",
  "label.results.control.title": "控制结果",
  "label.results.control.noneConfigured": "此测试和分析仪未配置对照组。",
  "label.results.control.viewResults": "查看控制结果",
  "label.results.control.capture.controlLine": "Control line",
  "label.results.control.capture.valid": "有效",
  "label.results.control.capture.invalid": "无效",
  "label.results.control.capture.kitLot": "Kit lot",
  "label.results.control.capture.outcome": "结果",
  "label.results.control.capture.lot": "Control lot",
  "label.results.control.capture.measured": "测量值",
  "label.results.control.capture.expected": "Expected value",
  "label.results.control.capture.uncertainty": "Uncertainty (±)",
  "label.results.control.capture.record": "Record control result",
  "label.results.control.capture.recorded": "Control result recorded.",
  "label.results.control.capture.recordedBlocked": "Control result recorded. Reporting is blocked for covered results until a passing repeat is recorded.",
  "label.results.control.capture.blockedHint": "A failing control blocks reporting for covered results — a repeat run is expected.",
  "label.results.control.capture.noBenchLots": "No bench control lot is configured for this test — add one under QC → Control Lots before recording a quantitative control.",
  "label.results.control.capture.incomplete": "Complete the control result fields before recording.",
  "label.results.control.capture.failed": "Recording the control result failed.",
  "label.results.dilution.title": "稀释",
  "label.results.section.attachments": "附件",
  "label.results.attachments.summary": "{0} 文件",
  "label.results.attachments.none": "无",
  "label.results.attachments.empty": "该订单目前尚无附件。",
  "label.results.attachments.add": "添加附件",
  "label.results.attachments.tooLarge": "文件大小超过了 10 MB 的限制。",
  "label.results.attachments.uploadFailed": "上传失败——支持 PDF、JPG、PNG 或 TIFF 格式，文件大小上限为 10 MB。",
  "label.results.attachments.resultsScope": "结果",
  "label.results.attachments.orderScope": "订单录入",
  "label.results.attachments.view": "查看",
  "label.results.attachments.download": "下载",
  "label.results.section.interpretation": "解释",
  "label.results.interpretation.summary": "通过规则或自由输入进行输入",
  "label.results.interpretation.ruleFired": "规则已触发（{0}）· 自动打开",
  "label.results.interpretation.autoOpen": "规则触发 · 自动打开",
  "label.results.interpretation.ruleBanner": "规则匹配（在测试中配置）：输入的值{0}属于{1}。选择一个类别以应用其解释文本，然后根据需要进行编辑。",
  "label.results.interpretation.match": "与值匹配",
  "label.results.interpretation.freeText": "解释（自由译文）",
  "label.results.interpretation.footnote": "解释可通过在检测中配置的规则（按类别划分的区间，会自动与值匹配）或自由文本来设定。规则文本在应用或编辑之前仅为非强制性的建议。保存后，该规则将随结果一同发送至报告中。",
  "label.results.nce.disposition": "结果处理",
  "label.results.nce.disposition.hint": "在提交NCE时应用。转诊是一项单独的行操作，而非处置结果。",
  "label.results.nce.disposition.none": "无",
  "label.results.nce.disposition.none.detail": "在不更改结果的情况下提交NCE。",
  "label.results.nce.disposition.cancel": "取消结果",
  "label.results.nce.disposition.cancel.detail": "无效。未报告值。这是分析前新化学实体（NCE）中常见的情况。",
  "label.results.nce.disposition.reject": "拒绝 + 理由",
  "label.results.nce.disposition.reject.detail": "清除该值并记录原因。由您的电子签名“保存”操作应用。",
  "label.results.nce.disposition.retest": "重新检测",
  "label.results.nce.disposition.retest.detail": "对该样本再次下达相同的检测订单；该重复检测将显示为“待处理”。",
  "label.results.nce.disposition.rejectArmed": "已启用该行上的拒绝选项——点击“保存”（电子签名）以应用该设置。",
  "label.results.nce.disposition.cancelled": "结果已取消。",
  "label.results.nce.disposition.retested": "已订购重新检测。",
  "label.results.critical.range": "紧急",
  "label.results.critical.banner.title": "紧急值——需通知医生",
  "label.results.critical.banner.body": "必须通知负责的临床医生。确认信息将记录在“警报”仪表板上，且绝不会阻止“保存”操作。",
  "label.results.critical.acknowledge": "我确认",
  "label.results.critical.acknowledged": "已确认",
  "label.results.critical.comment": "致谢说明",
  "label.results.critical.comment.placeholder": "例如：由电话通知医生",
  "label.results.section.history": "历史（本分析）",
  "label.results.history.summary": "{0} 活动",
  "label.results.history.summary.unloaded": "修订 · 状态 · 重新检测",
  "label.results.history.when": "当",
  "label.results.history.event": "活动",
  "label.results.history.detail": "详情",
  "label.results.history.by": "由",
  "label.results.history.event.CREATED": "创建时间",
  "label.results.history.event.STATUS": "状态",
  "label.results.history.event.RESULT": "结果",
  "label.results.history.event.NOTE": "备注",
  "label.results.history.event.RETEST": "重新检测",
  "label.results.history.event.REFLEX": "Reflex",
  "label.results.history.event.OTHER": "活动",
  "label.results.history.empty": "此项分析目前尚无记录的事件。",
  "label.results.history.footnote": "本分析仅包含——修订、状态变更、重新检测、更正、备注和审核条目。患者趋势数据存储在患者病历中；Westgard规则显示在QC仪表板上。",
  "label.results.nce.report": "报告不符合项",
  "label.results.reject.result": "拒绝结果",
  "label.results.reject.reason": "拒绝原因",
  "label.results.reject.hint": "保存时若出现拒绝，系统将清除该值，记录拒绝原因，并将该分析标记为“技术性拒绝”。",
  "label.results.referral.refer": "推荐此检测项目",
  "label.results.referral.editing": "待转诊 — 编辑",
  "label.results.referral.organization": "参考实验室",
  "label.results.referral.reason": "转诊原因",
  "label.results.referral.date": "转介日期",
  "label.results.referral.reportDate": "Reference lab report date",
  "label.results.referral.reportDate.placeholder": "(日/月/年)简体中文（大陆）",
  "label.results.referral.hint": "当您保存此行时，转诊信息将被记录，并转至“转诊”仪表板。",
  "label.results.referral.cancel": "丢弃",
  "label.results.section.aliquots": "分装样本",
  "label.results.aliquots.summary": "{0} 分装样本",
  "label.results.aliquots.summary.unloaded": "列表 · 创建",
  "label.results.aliquots.labNo": "实验室编号",
  "label.results.aliquots.quantity": "数量",
  "label.results.aliquots.createdDate": "创建时间",
  "label.results.aliquots.empty": "该样品目前尚无分装样本。",
  "label.results.aliquots.count": "分装样本数量",
  "label.results.aliquots.totalQuantity": "要转移的总数量",
  "label.results.aliquots.notes": "备注",
  "label.results.aliquots.create": "创建分装样本",
  "label.results.aliquots.created": "已创建分装样本。",
  "label.results.aliquots.failed": "无法创建分装样本。",
  "label.results.aliquots.remaining": "父样本剩余数量",
  "label.results.history.event.REFERRAL": "转介",
  "label.results.history.event.NCE": "不符合项",
  "label.results.referenceZone": "参考与背景",
  "label.results.layoutRemembered": "记住布局",
  "label.results.resetLayout": "重置布局",
  "label.results.section.orderInfo": "订单信息",
  "label.results.sampleType": "样本类型",
  "label.results.testDate": "检测日期",
  "label.results.receivedDate": "已接收",
  "label.results.technician": "技术员",
  "label.routine.Reports": "常规报告",
  "label.sample.types.activate": "以下样本类型将被激活：",
  "label.sample.types.deactivate": "以下样本类型将被停用，因为它们没有检测：",
  "label.save": "保存",
  "label.saving": "保存中...",
  "label.search.available.targetest": "搜索可用检测",
  "label.search.availablepanel": "搜索可用面板",
  "label.search.labno.family": "按实验室编号或姓氏搜索",
  "label.search.patient": "搜索患者",
  "label.select": "选择",
  "label.select.dateRange": "选择您想要报告的日期范围",
  "label.select.list.options": "选择列表选项",
  "label.selectTestSectionCatalog": "选择检测科室以查看该科室的目录",
  "label.sex.dependent": "性别相关",
  "label.shortCode": "短代码",
  "label.shortCode.error.invalidChars": "短代码只能包含字母、数字、连字符和下划线",
  "label.shortCode.error.maxLength": "短代码必须为10个字符或更少",
  "label.shortCode.error.network": "无法验证唯一性。请手动检查。",
  "label.shortCode.error.save": "保存短代码错误：{error}",
  "label.shortCode.error.startChar": "短代码必须以字母或数字开头",
  "label.shortCode.helper": "最多10个字符，字母数字，连字符，下划线",
  "label.shortCode.optional.helper": "可选（如果代码 ≤ 10 个字符，将使用代码）。最多10个字符，字母数字，可包含连字符/下划线",
  "label.shortCode.required.helper": "当代码 > 10 个字符时必填。最多10个字符，字母数字，可包含连字符/下划线",
  "label.shortCode.update.success": "短代码更新成功",
  "label.shortCodeRequired": "打印标签需要短代码。请先在编辑表单中设置短代码。",
  "label.shortCodeWarning": "更改短代码将使现有标签无效",
  "label.showChildren": "显示子元素",
  "label.study.Reports": "研究报告",
  "label.test.activate": "以下检测将被激活：",
  "label.test.add": "向订单添加检测",
  "label.test.batch.cancel.finish": "这是不可逆的。",
  "label.test.batch.cancel.start": "您已选择取消检测",
  "label.test.batch.no.change.finish": "检测不会被更改。",
  "label.test.batch.replace.start": "以下",
  "label.test.deactivate": "以下检测将被停用：",
  "label.test.display.order": "检测显示顺序",
  "label.test.order.confirm": "验证：启用/禁用检测可订购性",
  "label.test.orderable": "以下检测可从订单表单订购。",
  "label.test.results": "检测结果",
  "label.test.resultsData": "检测结果数据",
  "label.test.unorderable": "以下检测不可在订单表单上订购。它们只能作为反射检测订购。",
  "label.testActivate": "检测激活",
  "label.testName": "检测名称",
  "label.text.generate": "生成",
  "label.total.tests": "总检测数",
  "label.type": "标签类型",
  "label.type.order": "订单标签行",
  "label.type.pool": "{count} 的图片集 {animal}",
  "label.type.sample": "标签样本",
  "label.unit": "单位",
  "label.user.notestsection": "当前用户没有分配实验室单元。请联系管理员",
  "label.validation.errors": "验证错误",
  "label.validation.results": "验证结果",
  "label.view": "查看",
  "label.viewtestCatalog": "检测目录",
  "label.warning": "警告",
  "label.yes": "是",
  "labno.alt.prefix.instruction": "预印条码标签的前缀(4个字符)：",
  "labno.alt.prefix.note": "注意：如果此前缀已被使用，编号将从生成的最后一个数字继续。",
  "labno.alt.prefix.use": "使用与订单录入生成相同的编号格式和可用编号池。",
  "language.select.label": "英文",
  "legend.search.availabletests": "搜索可用检测",
  "loading": "加载中...",
  "loading.boxes": "正在加载转运箱...",
  "loading.description": "加载中...",
  "location.collection.title": "取件位置",
  "location.environmentalConditions": "环境条件",
  "location.environmentalConditions.placeholder": "例如：25°C，晴天",
  "location.gps.error": "无法获取位置",
  "location.gps.getCurrent": "获取当前位置",
  "location.gps.getting": "正在获取位置...",
  "location.gps.latitude": "GPS纬度",
  "location.gps.longitude": "GPS经度",
  "location.gps.notSupported": "您的浏览器不支持地理位置功能",
  "location.gps.permissionDenied": "位置权限被拒绝",
  "location.gps.timeout": "位置请求超时",
  "location.gps.unavailable": "无法获取位置信息",
  "location.helper": "位置层次结构（区域/地区/镇村）采用现有的位置结构体系。环境工作流配置文件允许某些行不显示标签，以便根据需要设置更简单或更简短的行集。",
  "location.requesterReference": "请求者参考",
  "location.requesterReference.placeholder": "例如：EPA 524.2 方法",
  "location.select.placeholder": "选择“{levelName}”...",
  "location.siteDescription": "采集点描述",
  "location.siteDescription.placeholder": "例如：市政供水取水口",
  "locale.active": "活跃",
  "locale.add": "添加语言环境",
  "locale.add.title": "添加语言环境",
  "locale.code": "语言代码",
  "locale.code.helper": "语言环境代码（例如 en, fr, zh）",
  "locale.create.success": "语言环境创建成功",
  "locale.delete.confirm.message": "您确定要删除此语言环境吗？此操作无法撤销。",
  "locale.delete.confirm.title": "确认删除语言环境",
  "locale.delete.error": "删除语言环境失败",
  "locale.delete.fallback.error": "无法删除备用语言环境",
  "locale.delete.success": "语言环境删除成功",
  "locale.displayName": "显示名称",
  "locale.displayName.helper": "语言环境的显示名称",
  "locale.edit.title": "编辑语言环境",
  "locale.fallback": "备用语言环境",
  "locale.fallback.error": "设置备用语言环境失败",
  "locale.fallback.success": "备用语言环境设置成功",
  "locale.management.description": "管理应用程序支持的语言环境",
  "locale.management.title": "语言环境管理",
  "locale.setFallback": "设置为备用",
  "locale.sortOrder": "排序顺序",
  "locale.status": "状态",
  "locale.update.success": "语言环境更新成功",
  "log.submitting.aliquot.data": "提交分装样本数据：",
  "log.submitting.aliquot.data2": "提交分装样本数据(JSON)：",
  "logging.management.apply": "应用",
  "logging.management.description": "管理系统日志级别配置",
  "logging.management.label": "日志管理",
  "logging.management.level": "日志级别",
  "logging.management.logger": "日志记录器",
  "logging.management.logger.helper": "输入要修改的日志记录器名称（例如：com.example.MyClass）",
  "logging.management.success": "日志配置更新成功",
  "login.account.disabled": "账户已禁用",
  "login.account.locked": "账户已锁定",
  "login.complexity.message": "密码必须：",
  "login.complexity.message.1": "必须至少7个字符",
  "login.complexity.message.2": "可能包含大写和小写字母或数字",
  "login.complexity.message.3": "必须包含至少一个以下字符：*, $, #, !",
  "login.complexity.message.4": "不得包含任何其他字符",
  "login.complexity.new.message": "新密码必须：",
  "login.complexity.new.message.1": "不得与当前密码相同",
  "login.error.account.disable": "您的账户已禁用。请联系系统管理员。",
  "login.error.password.current.incorrect": "您输入的当前密码不正确。请重试。",
  "login.error.password.expired": "您的密码已过期。请联系系统管理员。",
  "login.error.update.message": "更新密码失败。请重试。",
  "login.login.": "重复密码",
  "login.login.current.password": "当前密码",
  "login.login.first": "名",
  "login.login.last": "姓",
  "login.login.name": "登录名",
  "login.login.new.password": "新密码",
  "login.login.password": "密码",
  "login.login.repeat.password": "重复密码",
  "login.msg.password": "密码",
  "login.msg.password.missing": "需要密码",
  "login.msg.username": "用户名",
  "login.msg.username.missing": "需要用户名",
  "login.notice.message": "注意：此服务仅允许授权人员访问。如果您没有管理员的明确授权，您必须立即退出。本组织禁止未经授权访问、披露、复制、修改、转移、销毁、丢失、滥用或盗窃其信息。",
  "login.password.expired.date": "密码过期日期",
  "login.password.expired.date.placeholder": "(日/月/年)",
  "login.redirecting.sso": "正在重定向到单点登录...",
  "login.subtitle": "登录",
  "login.timeout": "用户超时(分钟)",
  "login.timeout.placeholder": "以毫秒为单位输入",
  "login.title": "登录",
  "lot.barcode": "条码",
  "lot.barcode.assign": "This lot has no barcode yet. Enter one now; it is locked once saved.",
  "lot.barcode.hint": "Leave blank to generate one from the item code and lot number.",
  "lot.barcode.locked": "Barcode is locked once saved so printed labels keep working.",
  "lot.barcode.placeholder": "Leave blank to auto-generate",
  "lot.barcode.placeholder.assign": "Enter a barcode",
  "lot.calculatedExpiry": "计算出的过期日期",
  "lot.currentQuantity": "当前数量",
  "lot.dateOpened": "开封日期",
  "lot.details.no.movements": "No movements recorded for this lot",
  "lot.details.no.transactions": "此批次无记录的交易",
  "lot.details.no.usage": "此批次无使用历史",
  "lot.details.section.basic": "基本信息",
  "lot.details.section.dates": "重要日期",
  "lot.details.section.movements": "Movement History",
  "lot.details.section.quantities": "数量",
  "lot.details.section.storage": "存储位置",
  "lot.details.section.transactions": "交易历史",
  "lot.details.section.usage": "使用历史",
  "lot.details.tab.info": "信息",
  "lot.details.tab.transactions": "交易",
  "lot.details.tab.usage": "使用历史",
  "lot.details.title": "批次详情",
  "lot.details.view": "查看详情",
  "lot.expirationDate": "过期日期",
  "lot.form.title.add": "接收新库存批次",
  "lot.form.title.edit": "编辑库存批次",
  "lot.initialQuantity": "初始数量",
  "lot.label.print": "Print label",
  "lot.label.print.failed": "Could not generate the label. Please try again.",
  "lot.number": "批号",
  "lot.number.hint": "Stable identifier for this lot. Leave blank and we'll generate one from the item code and today's date.",
  "lot.number.placeholder": "Leave blank to auto-generate",
  "lot.qcStatus.FAILED": "失败数量",
  "lot.qcStatus.PASSED": "通过",
  "lot.qcStatus.PENDING": "待处理",
  "lot.qcStatus.QUARANTINED": "Quarantined",
  "lot.qcStatus.hint": "Lots stay unusable for testing until QC is marked Passed.",
  "lot.qcStatus": "QC状态",
  "lot.receiptDate": "接收日期",
  "lot.save.error": "保存批次时出错",
  "lot.save.error.locationAfterCreate": "The lot was created, but assigning its storage location failed. Press Save again to retry the assignment only, so the lot is not received twice. {reason}",
  "lot.save.success": "批次保存成功",
  "lot.selectItem": "选择目录项",
  "lot.selectLocation": "选择存储位置",
  "lot.status": "状态",
  "lot.status.ACTIVE": "活跃",
  "lot.status.CONSUMED": "已消耗",
  "lot.status.DISPOSED": "已处置",
  "lot.status.EXPIRED": "已过期",
  "lot.status.IN_USE": "使用中",
  "lot.status.QUARANTINED": "Quarantined",
  "lot.storageLocation": "存储位置",
  "manage.testing.algorithms.add.reflex.tests": "管理检测算法和反射检测",
  "master.lists.page": "主列表页面",
  "master.lists.page.analyzer": "分析仪检测名称菜单",
  "master.lists.page.barcode": "条码配置",
  "master.lists.page.batchtest": "批量检测重新分配和取消",
  "master.lists.page.external.connections": "外部连接菜单",
  "master.lists.page.field": "字段验证配置 ",
  "master.lists.page.list": "列表插件",
  "master.lists.page.menu": "菜单配置",
  "master.lists.page.notification": "检测通知配置",
  "master.lists.page.order.entry": "订单录入配置",
  "master.lists.page.org": "组织菜单",
  "master.lists.page.patient": "患者录入配置",
  "master.lists.page.printed": "打印报告配置",
  "master.lists.page.provider": "提供者",
  "master.lists.page.report.result": "结果报告配置",
  "master.lists.page.result": "结果录入配置",
  "master.lists.page.site": "站点信息",
  "master.lists.page.test.management": "检测管理",
  "master.lists.page.user": "用户管理",
  "master.lists.page.work.plan": "工作计划配置 ",
  "menu.accession.validation": "按订单",
  "menu.accession.validation.range": "按订单编号范围",
  "menu.billing.active": "计费菜单活跃",
  "menu.billing.address": "计费URL",
  "menu.billing.title": "计费菜单管理",
  "menu.genericSample": "通用样本",
  "menu.genericSample.edit": "编辑样本",
  "menu.genericSample.import": "导入",
  "menu.genericSample.order": "接收样本",
  "menu.global.title": "全局菜单管理",
  "menu.label.filter": "过滤器：",
  "menu.label.filter.active": "仅活跃",
  "menu.label.filter.admin": "仅管理员",
  "menu.label.filter.role": "按实验室单元角色",
  "menu.nonconform.active": "不符合菜单活跃",
  "menu.nonconform.title": "不符合菜单管理",
  "menu.patient.active": "患者菜单活跃",
  "menu.patient.title": "患者菜单管理",
  "menu.results.range": "按订单编号范围",
  "menu.sidenav.active": "侧边导航活跃",
  "menu.study.active": "研究菜单活跃",
  "menu.study.title": "研究菜单配置",
  "menu.validation.date": "按日期",
  "message.method.activation": "在至少分配一个检测之前，此方法单元不会激活。",
  "message.propertiesupdate.success": "属性更新成功",
  "method.browse.title": "方法部门",
  "method.methodName": "方法名称",
  "method.modal.add.heading": "添加新方法",
  "modal.add.method": "添加新方法",
  "move.back": "向后移动",
  "move.to.aliquot": "移动到分装样本",
  "new.patient.label": "新患者",
  "next.action.button": "下一个",
  "nextLabel.action.button": "下一个标签",
  "no.aliquots": "没有可用的分装样本",
  "no.analysis.found": "没有找到分析",
  "no.data.found": "没有找到数据",
  "no.option": "否",
  "noTestsFound.matching": "没有找到匹配的检测",
  "nonconform.add.new.date": "添加新日期",
  "nonconform.corrective.action": "计划或建议的纠正措施：",
  "nonconform.corrective.actionType": "措施类型",
  "nonconform.corrective.comment": "评论",
  "nonconform.corrective.control": "计划或建议的纠正预防性措施或并发控制：",
  "nonconform.corrective.title": "不符合事件纠正措施",
  "nonconform.date.completed": "完成日期",
  "nonconform.date.discussion.nce": "与NCE staff讨论的日期",
  "nonconform.date.event": "事件日期",
  "nonconform.description.nce": "NCE描述",
  "nonconform.field.date": "NCE日期",
  "nonconform.field.reporting.data": "报告日期",
  "nonconform.goToNceForm": "转到NCE报告表单",
  "nonconform.lab.componenet.nce": "发生NCE的实验室组件",
  "nonconform.label.highseverity": "9 = 非常高严重程度-- 需要立即采取措施",
  "nonconform.label.lowseverity": "1 = 非常低严重程度-- 不需要立即采取措施",
  "nonconform.label.prescibernamesite": "处方者名称和站点",
  "nonconform.label.proposed.action": "建议措施",
  "nonconform.label.reportingunit": "报告单元",
  "nonconform.label.suspected.cause.nce": "NCE的疑似原因",
  "nonconform.nce.concurrent.control.action": "并发控制措施",
  "nonconform.nce.number": "NCE 数字",
  "nonconform.nce.preventive.action": "预防措施",
  "nonconform.nce.resolution": "NCE解决",
  "nonconform.nce.resolution.description": "纠正措施和预防/并发控制是否有效解决了不符合事件并防止其再次发生？",
  "nonconform.nce.turnaround.time": "周转时间",
  "nonconform.order.save.fail": "保存失败",
  "nonconform.order.save.success": "保存成功",
  "nonconform.person.reporting.different": "报告NCE的人员名称(如果不同)",
  "nonconform.person.responsible": "负责人",
  "nonconform.report": "报告不符合事件(NCE)",
  "nonconform.report.field.date": "报告日期",
  "nonconform.severity.score": "严重程度评分",
  "nonconform.view.comments": "评论",
  "nonconform.view.corrective.action.description": "要采取的纠正措施的描述",
  "nonconform.view.event.date": "事件日期",
  "nonconform.view.event.description": "事件描述",
  "nonconform.view.lab.component": "实验室组件",
  "nonconform.view.nce.category": "NCE类别",
  "nonconform.view.nce.likely.occur": "NCE再次发生的可能性有多大？",
  "nonconform.view.nce.severity": "严重程度",
  "nonconform.view.nce.type": "NCE类型",
  "nonconform.view.preventive.description": "如果适用，预防或并发控制措施的描述",
  "nonconform.view.report": "查看新的不符合事件",
  "nonconform.view.reporting.person": "报告人员",
  "nonconform.view.severe.consequences": "NCE的后果或影响有多严重？",
  "nonconform.view.specimen": "标本",
  "nce.attachment.dropzone": "将文件拖放到此处，或点击上传文件",
  "nce.attachment.error.maxFiles": "允许的{maxFiles}文件数量上限",
  "nce.attachment.error.size": "文件大小超过了{maxSize}的上限",
  "nce.attachment.error.type": "不允许的文件类型。可接受的类型：{types}",
  "nce.attachment.error.upload": "上传文件时出错",
  "nce.attachment.files": "文件",
  "nce.attachment.hint": "（可选——最大{maxFiles}个文件，每个文件不超过10MB）",
  "nce.attachment.uploading": "正在上传...",
  "nce.category.administrative": "管理",
  "nce.category.analytical": "分析性",
  "nce.category.postanalytical": "分析后",
  "nce.category.preanalytical": "分析前",
  "nce.field.attachments": "附件",
  "nce.field.notes": "备注",
  "nce.field.description.placeholder": "请描述发生了什么、何时发现的，以及任何相关背景……",
  "nce.field.immediateAction": "已采取的紧急措施",
  "nce.field.immediateAction.placeholder": "当时立即采取了哪些纠正措施……",
  "nce.field.linkedItems": "相关样本/结果",
  "nce.field.severity": "严重程度",
  "nce.field.title": "标题",
  "nce.field.title.placeholder": "活动简介……",
  "nce.severity.critical": "紧急",
  "nce.severity.critical.description": "患者安全风险、违规行为",
  "nce.severity.major": "专业",
  "nce.severity.major.description": "对质量或运营产生重大影响",
  "nce.severity.minor": "次要的",
  "nce.severity.minor.description": "影响有限，易于纠正",
  "nce.severity.low": "低",
  "nce.severity.low.description": "影响微乎其微，无需采取纠正措施",
  "nce.status.open": "待处理",
  "nce.status.underInvestigation": "正在调查中",
  "nce.tree.empty": "未找到任何订单。请输入实验室编号以开始搜索。",
  "nce.tree.loading": "正在加载订单...",
  "nce.tree.order": "接收样本",
  "nce.tree.search": "按测试或样本筛选...",
  "nce.tree.selected": "{sampleCount} 样本，已选择{resultCount}的结果",
  "nce.trigger.order_cancellation": "取消订单可能需要提供NCE文件",
  "nce.trigger.partial_sample_rejection": "部分样本被拒需提供NCE文件",
  "nce.trigger.pathology_rejection": "病理学病例被拒可能需要提供NCE文件",
  "nce.trigger.premature_disposal": "过早处置可能需要提供NCE文件",
  "nce.trigger.qc_invalidation": "QC无效需要提供NCE的文件",
  "nce.trigger.referral_rejection": "转诊被拒需提供NCE文件",
  "nce.trigger.result_rejection_no_retest": "若要拒绝检测结果且不进行重新检测，则需提供NCE文件",
  "nce.trigger.result_rejection_retest": "因检测结果被拒而需重新检测的情况，可能需要提供NCE文件",
  "nce.trigger.sample_rejection": "样本拒收需提供NCE文件",
  "nce.trigger.test_cancel_no_results": "考试取消可能需要提供NCE证明文件",
  "nce.trigger.test_cancel_with_results": "若需取消检测并获取结果，须提供NCE相关文件",
  "nce.type.calibration_failure": "校准失败",
  "nce.type.communication_failure": "通信故障",
  "nce.type.contamination": "污染",
  "nce.type.documentation_error": "文档错误",
  "nce.type.equipment_malfunction": "设备故障",
  "nce.type.labeling_error": "标签错误",
  "nce.type.patient_id_mismatch": "患者ID不匹配",
  "nce.type.policy_violation": "违反政策",
  "nce.type.procedure_deviation": "程序偏差",
  "nce.type.qc_failure": "QC失败",
  "nce.type.reagent_issue": "试剂问题",
  "nce.type.report_delay": "报告延迟",
  "nce.type.report_distribution_error": "报告分发错误",
  "nce.type.requisition_incomplete": "采购申请不完整",
  "nce.type.resource_shortage": "资源短缺",
  "nce.type.result_interpretation_error": "结果解释错误",
  "nce.type.sample_collection_error": "样本采集错误",
  "nce.type.staff_competency_issue": "员工能力问题",
  "nce.type.storage_error": "存储错误",
  "nce.type.system_error": "系统错误",
  "nce.type.training_gap": "培训缺口",
  "nce.type.transcription_error": "转录错误",
  "nce.type.transport_issue": "运输问题",
  "nce.type.request_form_error": "请求表单错误",
  "nce.type.equipment_failure": "设备警报",
  "nce.type.procedure_error": "操作错误",
  "nce.type.calibration_error": "校准错误",
  "nce.type.cross_contamination": "交叉污染",
  "nce.type.result_transcription_error": "结果转录错误",
  "nce.type.report_delivery_error": "报告交付错误",
  "nce.type.critical_value_not_reported": "未报告临界值",
  "nce.type.delayed_result": "延迟结果",
  "nce.type.result_amendment": "结果更正",
  "nce.type.training_issue": "培训问题",
  "nce.button.createNce": "创建 NCE",
  "nce.button.skip": "跳过",
  "nce.creating": "创建 NCE...",
  "nce.description.placeholder": "请描述该不符合项……",
  "nce.error.create.failed": "无法创建 NCE",
  "nce.error.severity.required": "必须填写严重程度",
  "nce.trigger.mandatory.message": "在执行此操作之前，您必须先创建一个 NCE。",
  "nce.trigger.mandatory.title": "必须具备NCE资格",
  "nce.trigger.order_cancellation.message": "取消订单可能需要提供不符合要求的事件的相关证明文件。",
  "nce.trigger.order_cancellation.title": "订单取消 - NCE",
  "nce.trigger.partial_sample_rejection.message": "部分样本被拒需记录不符合项。",
  "nce.trigger.partial_sample_rejection.title": "部分样本被拒——需提供NCE",
  "nce.trigger.pathology_rejection.message": "病理学病例被拒可能需要提供不符合项的记录。",
  "nce.trigger.pathology_rejection.title": "病理学拒收 - NCE",
  "nce.trigger.premature_disposal.message": "提前处置可能需要对不符合项进行记录。",
  "nce.trigger.premature_disposal.title": "过早处置——NCE",
  "nce.trigger.qc_invalidation.message": "质量控制（QC）无效需要对不符合项进行记录。",
  "nce.trigger.qc_invalidation.title": "QC无效——需要 NCE",
  "nce.trigger.referral_rejection.message": "拒绝转诊需要对不符合项进行记录。",
  "nce.trigger.referral_rejection.title": "转诊申请被拒绝——需提供NCE",
  "nce.trigger.result_rejection_no_retest.message": "若不进行重新检测即拒绝结果，则需记录该不符合项。",
  "nce.trigger.result_rejection_no_retest.title": "结果被拒 - 需提供NCE",
  "nce.trigger.result_rejection_retest.message": "若因结果被拒而需进行重新检测，可能需要记录不符合项。",
  "nce.trigger.result_rejection_retest.title": "结果被拒 - NCE",
  "nce.trigger.sample_rejection.message": "样本拒收需对不符合项进行记录。",
  "nce.trigger.sample_rejection.title": "样本拒收——需提供NCE",
  "nce.trigger.test_cancel_no_results.message": "取消检测可能需要提供不符合项的证明文件。",
  "nce.trigger.test_cancel_no_results.title": "考试取消 - NCE",
  "nce.trigger.test_cancel_with_results.message": "若要取消已产生结果的检测项目，需记录不符合项。",
  "nce.trigger.test_cancel_with_results.title": "考试取消——需参加NCE考试",
  "nce.admin.trigger.config.title": "NCE 触发器配置",
  "nce.admin.trigger.config.description": "配置在何时自动创建或提示生成不符合项。",
  "nce.admin.trigger.behaviors.title": "触发行为",
  "nce.admin.rejection.mappings.title": "拒绝原因映射",
  "nce.admin.rejection.mappings.description": "将拒绝原因映射到NCE类别，以便自动填充数据。",
  "nce.trigger.behavior.mandatory": "必填",
  "nce.trigger.behavior.prompted": "受提示",
  "nce.trigger.behavior.disabled": "已禁用",
  "nce.trigger.column.type": "扳机类型",
  "nce.trigger.column.description": "描述",
  "nce.trigger.column.behavior": "行为",
  "nce.trigger.column.active": "活跃",
  "nce.trigger.type.sampleRejection": "样本拒收",
  "nce.trigger.type.resultRejection": "结果被拒绝",
  "nce.trigger.type.qaEvent": "QA 活动",
  "nce.trigger.type.manual": "手册",
  "nce.trigger.update.success": "触发器配置已更新",
  "nce.trigger.update.error": "无法更新触发器配置",
  "nce.mapping.add": "添加映射",
  "nce.mapping.edit": "编辑映射",
  "nce.mapping.column.rejectionReason": "拒绝原因",
  "nce.mapping.column.category": "NCE类别",
  "nce.mapping.column.type": "NCE类型",
  "nce.mapping.column.severity": "默认值严重程度",
  "nce.mapping.column.active": "活跃",
  "nce.mapping.noData": "未配置任何拒绝映射",
  "nce.mapping.validation.error": "必须填写拒绝原因和类别",
  "nce.mapping.save.success": "映射已成功保存",
  "nce.mapping.active": "活跃",
  "nce.field.category": "类别",
  "nce.field.type": "设备类型",
  "nce.select.category": "选择一个类别",
  "nce.select.type": "选择类型",
  "nce.error.dateOfEvent.required": "必须填写事件日期",
  "nce.error.reportingUnit.required": "必须指定报告单元",
  "nce.error.description.required": "必须填写描述",
  "nce.error.suspectedCauses.required": "必须提供疑似原因",
  "nce.error.proposedAction.required": "需要采取建议措施",
  "nce.error.category.required": "“类别”为必填项",
  "nce.attachment.saveFirst": "保存 NCE 活动以启用文件附件功能",
  "nce.attachment.error.noEvent": "请先保存 NCE 活动，然后再上传附件",
  "nce.attachment.download": "下载",
  "nce.attachment.delete": "删除",
  "requester.add.new.restricted": "管理员已禁用添加新机构的权限。",
  "requester.add.new.restricted.organization.contact": "管理员已禁用为新机构添加联系人信息的功能。请在上方搜索现有机构。",
  "requester.add.new.restricted.provider": "管理员已禁用添加新供应商的功能。",
  "requester.add.new.restricted.provider.contact": "管理员已禁用为新供应商输入联系信息的功能。请在上方搜索现有供应商。",
  "requester.add.new.restricted.requestor": "管理员已禁用添加新申请人的功能。请在上方搜索现有申请人。",
  "requester.contact.search": "请求者搜索",
  "requester.contact.search.helper": "请搜索提出这些检测请求的联系人，或在下方输入新的联系人。必须至少填写“申请机构”或“请求者”其中一项。",
  "requester.organization.add.new": "+ 添加新组织“{name}”",
  "requester.organization.email": "机构电子邮件",
  "requester.organization.fax": "机构传真",
  "requester.organization.new.helper": "保存此订单后，将创建一个新的机构。",
  "requester.organization.new.tag": "新",
  "requester.organization.no.match": "未找到匹配的机构。",
  "requester.organization.phone": "机构电话",
  "requester.organization.search": "查询申请机构",
  "requestor.add.new": "+ 添加新请求者“{name}”",
  "requestor.add.new.restricted": "您的管理员已禁用添加新请求者的功能。",
  "requestor.department": "系",
  "requestor.email": "电子邮件",
  "requestor.fax": "传真",
  "requestor.firstName": "名",
  "requestor.lastName": "姓",
  "requestor.name": "申请者名称",
  "requestor.name.placeholder": "请输入申请人的名称",
  "requestor.new.helper": "保存此订单时，将创建一个新的请求者。",
  "requestor.new.tag": "新",
  "requestor.no.match": "未找到匹配的请求者。",
  "requestor.phone": "电话",
  "requestor.search.helper": "请输入至少 2 个字符以进行自动搜索。",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "所有拍品",
  "result.pool.filter.allPools": "所有泳池",
  "result.pool.filter.clear": "清除筛选条件",
  "result.pool.filter.count": "显示 {shown}，共 {total} 条结果",
  "result.pool.filter.lot": "按批次筛选",
  "result.pool.filter.pool": "按泳池筛选",
  "result.pool.intake": "进水池",
  "result.pool.subpool": "子池 {n}",
  "result.vectorPool.label": "{count} 的图片集 {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "不确定度必须是一个非负数。",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "样本",
  "sample.priority.ASAP": "尽快",
  "sample.priority.FUTURE_STAT": "Future STAT",
  "sample.priority.ROUTINE": "常规",
  "sample.priority.STAT": "STAT (Urgent)",
  "sample.priority.TIMED": "Timed",
  "sample.referToReferenceLab.helper": "如果该样本需要在外部参考实验室进行检测，请标记此处。",
  "sampleAcceptance.action.moveDown": "向下移动",
  "sampleAcceptance.action.moveUp": "向上移动",
  "sampleAcceptance.banner.resampledFrom": "这是通过对样本编号{id}进行重采样而创建的替代版本。",
  "sampleAcceptance.banner.resampledFrom.title": "替换样本",
  "sampleAcceptance.banner.resampledTo": "该样本被拒绝，并进行了重新抽样。替换顺序：{accession}。",
  "sampleAcceptance.banner.resampledTo.title": "重新采样",
  "sampleAcceptance.button.addItem": "添加项目",
  "sampleAcceptance.col.active": "活跃",
  "sampleAcceptance.col.label": "标签",
  "sampleAcceptance.col.order": "接收样本",
  "sampleAcceptance.col.statusForDomain": "该域名的状态",
  "sampleAcceptance.domain.all": "所有域名",
  "sampleAcceptance.domain.clinical": "临床",
  "sampleAcceptance.domain.environmental": "环境",
  "sampleAcceptance.domain.vector": "Vector",
  "sampleAcceptance.enforcement.help": "执行规则是按域设置的，而不是按实验室单元设置的——一名接待员可能服务于多个实验室单元。",
  "sampleAcceptance.enforcement.label": "检查清单的执行 — {domain}",
  "sampleAcceptance.enforcement.mandatory": "必填 — 完成前禁止执行第3步",
  "sampleAcceptance.enforcement.off": "手动输入已关闭 — 隐藏检查清单",
  "sampleAcceptance.enforcement.optional": "可选 — 记录但不阻塞",
  "sampleAcceptance.gate.blocked": "此领域必须接受标本——在继续处理此订单之前，必须接受所有标本（或报告“未接受”（NCE）/重新采样）。",
  "sampleAcceptance.labWide.heading": "全实验室通用项目（除非特定领域有不同规定，否则均适用）simplified-chinese (Mainland)",
  "sampleAcceptance.labWide.inherited": "实验室范围内的项目 — 继承（主动回退）",
  "sampleAcceptance.labWide.superseded": "全实验室范围的项目——此处已废止（从“所有领域”处编辑而来）",
  "sampleAcceptance.notify.enforcementSaved": "执法动态更新",
  "sampleAcceptance.notify.itemAdded": "已添加检查清单项目",
  "sampleAcceptance.notify.itemSaved": "已保存待办事项项目",
  "sampleAcceptance.notify.recordFailed": "无法记录确认",
  "sampleAcceptance.notify.rejectFailed": "拒绝失败",
  "sampleAcceptance.notify.resampleFailed": "重采样失败",
  "sampleAcceptance.ownItems.empty": "尚无项目——该域名将返回下方的全实验室列表。",
  "sampleAcceptance.ownItems.heading": "{domain} 项",
  "sampleAcceptance.qa.accepted.success": "已记录确认",
  "sampleAcceptance.qa.answer.fail": "失败",
  "sampleAcceptance.qa.answer.na": "不适用",
  "sampleAcceptance.qa.answer.pass": "通过",
  "sampleAcceptance.qa.button.accept": "接受样本",
  "sampleAcceptance.qa.button.reject": "拒绝",
  "sampleAcceptance.qa.button.resample": "重新采样",
  "sampleAcceptance.qa.context.collected": "已采样",
  "sampleAcceptance.qa.context.longTransit": "长途转机——由你决定",
  "sampleAcceptance.qa.context.note": "Transit 仅供参考——它不会自动对任何内容进行评分。活跃列表：{domain}。",
  "sampleAcceptance.qa.context.received": "已接收",
  "sampleAcceptance.qa.context.transit": "运输时间",
  "sampleAcceptance.qa.empty": "此域名尚未配置任何验收检查表。",
  "sampleAcceptance.qa.failHint": "该样本失败了检查——应报告为NCE或重新采样，而不是直接接受。",
  "sampleAcceptance.qa.noSample": "将样本集保存，以便对该标本进行接收验收。",
  "sampleAcceptance.qa.note.label": "备注（可选）",
  "sampleAcceptance.qa.note.placeholder": "可选——记录任何观察到的状况",
  "sampleAcceptance.qa.status.accepted": "已接受",
  "sampleAcceptance.qa.status.pending": "待处理",
  "sampleAcceptance.qa.status.rejected": "已拒收",
  "sampleAcceptance.qa.status.review": "评论",
  "sampleAcceptance.qa.subtitle": "完成此样本的验收清单",
  "sampleAcceptance.qa.subtitle.rejected": "该标本已拒收并重新采样——仅供查阅。",
  "sampleAcceptance.qa.subtitle.rejectedVector": "此捕获已拒收——只读。",
  "sampleAcceptance.qa.title": "入学录取",
  "sampleAcceptance.reject.commit": "提交被拒绝",
  "sampleAcceptance.reject.info": "将此渔获作为无法使用的渔获予以拒绝。该渔获无法重新捕捞，因此不会生成替换订单。",
  "sampleAcceptance.reject.reason.label": "原因（根据失败的项目预填——可编辑）",
  "sampleAcceptance.reject.reason.required": "需要填写理由",
  "sampleAcceptance.reject.success": "样本已拒收。",
  "sampleAcceptance.reject.title": "拒绝 — {labNumber}",
  "sampleAcceptance.resample.commit": "提交重采样",
  "sampleAcceptance.resample.info": "拒绝此样本，并创建新的采样单以安排重新采样。将通知请求者。",
  "sampleAcceptance.resample.reason.label": "原因（根据失败的项目预填——可编辑）",
  "sampleAcceptance.resample.reason.required": "需要填写理由",
  "sampleAcceptance.resample.success": "已创建重采样——新订单编号为{accession}。已通知请求者。",
  "sampleAcceptance.resample.title": "重新采样 — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "资格要求",
  "sampleAcceptance.review.col.labNo": "实验编号 #",
  "sampleAcceptance.review.col.sampleType": "样本类型",
  "sampleAcceptance.review.col.transit": "中转",
  "sampleAcceptance.review.noSamples": "目前尚无采集的标本可供审查。",
  "sampleAcceptance.review.subtitle": "选择一个样本以完成其验收清单",
  "sampleAcceptance.review.title": "入学录取",
  "sampleAcceptance.status.active": "活跃",
  "sampleAcceptance.status.inactive": "非活跃",
  "sampleAcceptance.status.inheritedActive": "活跃（继承）",
  "sampleAcceptance.status.superseded": "已废止",
  "sampleAcceptance.title": "样本验收清单",
  "sidenav.label.admin.nceTriggerConfig": "触发器配置",
  "sidenav.label.admin.nceCategoryType": "类别与设备类型",
  "sidenav.label.admin.nceConfig": "NCE 配置",
  "nce.admin.categorytype.title": "NCE类别与类型配置",
  "nce.admin.categorytype.description": "管理“不符合项”可用的类别和设备类型。",
  "nce.admin.tab.categories": "类别",
  "nce.admin.tab.types": "设备类型",
  "nce.admin.category.add": "添加类别",
  "nce.admin.category.edit": "编辑类别",
  "nce.admin.category.name.required": "类别名称为必填项",
  "nce.admin.category.save.success": "类别已成功保存",
  "nce.admin.category.save.error": "保存失败",
  "nce.admin.type.add": "添加设备类型",
  "nce.admin.type.edit": "编辑类型",
  "nce.admin.type.validation.error": "设备类型和类别必须填写",
  "nce.admin.type.save.success": "设备类型已成功保存",
  "nce.admin.type.save.error": "保存失败",
  "nce.admin.column.name": "名称",
  "nce.admin.column.displayKey": "显示键",
  "nce.admin.column.typesCount": "设备类型数量",
  "nce.admin.column.category": "类别",
  "nce.admin.column.actions": "操作",
  "nce.admin.field.name": "名称",
  "nce.admin.field.displayKey": "显示键（用于国际化）",
  "nce.admin.field.displayKey.helper": "可选。用于翻译。",
  "nce.admin.field.category": "类别",
  "nce.admin.delete.confirm.title": "确认删除",
  "nce.admin.delete.confirm.message": "您确定要删除“{name}”吗？此操作无法撤销。",
  "nce.admin.delete.success": "已成功删除",
  "nce.inline.title": "报告不符合事件",
  "nce.inline.context": "上下文（自动填充）",
  "nce.dashboard.title": "所有NCE",
  "nce.dashboard.subtitle": "该实验室所有待处理的NCEs",
  "nce.button.reportNce": "NCE报告",
  "nce.search.placeholder": "搜索 NCE...",
  "nce.filter.allStatus": "所有状态",
  "nce.filter.allCategories": "所有类别",
  "nce.filter.allSeverities": "所有严重程度",
  "nce.filter.clearAll": "清除所有",
  "nce.summary.critical": "紧急",
  "nce.summary.major": "专业",
  "nce.summary.minor": "次要的",
  "nce.summary.overdue": "已逾期",
  "nce.tag.overdue": "已逾期",
  "nce.tab.eventDetails": "活动详情",
  "nce.tab.investigation": "调查",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "历史",
  "nce.field.suspectedCauses": "疑似原因",
  "nce.field.proposedAction": "建议措施",
  "nce.field.trigger": "触发器",
  "nce.capReason.time_24h": "{count} samples linked — capped at 24h window",
  "nce.capReason.count_50": "{count} samples linked — capped at 50 most recent",
  "nce.capa.noItems": "目前尚未记录任何纠正/预防措施。",
  "nce.capa.dueDate": "Due Date",
  "nce.history.noItems": "无历史记录。",
  "nce.history.system": "系统",
  "nce.action.acknowledge": "确认",
  "nce.action.assignTo": "分配给",
  "nce.action.addNote": "添加备注",
  "nce.action.close": "关闭 NCE",
  "nce.action.startCorrectiveAction": "开始纠正措施",
  "nce.link.duplicate.warning": "这些标本已与该NCE相关联",
  "nce.list.empty": "否，未找到符合您条件的NCE。",
  "nce.modal.addNote": "添加备注",
  "nce.modal.addNoteDescription": "在 NCE {nceNumber} 上添加一条备注",
  "nce.modal.notePlaceholder": "请输入您的备注...",
  "nce.modal.assign": "分配 NCE",
  "nce.modal.assignDescription": "将 NCE {nceNumber} 分配给某位用户",
  "nce.modal.selectUser": "选择用户",
  "nce.modal.searchUser": "搜索用户...",
  "nce.assign.selectUser": "请选择要分配的用户",
  "nce.assign.success": "NCE 已成功分配",
  "nce.assign.error": "无法分配 NCE",
  "nce.acknowledge.success": "NCE 已成功确认",
  "nce.acknowledge.error": "未能确认 NCE",
  "nce.note.empty": "请输入备注",
  "nce.note.success": "备注已成功添加",
  "nce.note.error": "添加备注失败",
  "nce.attachment.downloadError": "下载附件失败",
  "nce.attachment.viewError": "无法查看附件",
  "not.available": "不可用",
  "not.specified": "未指定",
  "notAuthenticated": "未认证",
  "notebook.attachments.title": "附件",
  "notebook.attachments.uploadPrompt": "点击上传文件",
  "notebook.auditTrail.action.archived": "归档",
  "notebook.auditTrail.action.created": "创建",
  "notebook.auditTrail.action.finalized": "最终确定",
  "notebook.auditTrail.action.locked": "锁定",
  "notebook.auditTrail.action.submitted": "已提交",
  "notebook.auditTrail.action.updated": "更新",
  "notebook.auditTrail.comingSoon": "审计跟踪功能即将可用。",
  "notebook.auditTrail.none.subtitle": "未找到此笔记本的审计跟踪条目。",
  "notebook.auditTrail.none.title": "无可用审计跟踪",
  "notebook.auditTrail.title": "审计跟踪",
  "notebook.button.edit": "编辑",
  "notebook.button.editResults": "编辑结果",
  "notebook.button.enterResults": "输入结果",
  "notebook.button.newLabNotebook": "项目",
  "notebook.button.view": "查看",
  "notebook.comments.add.button": "添加评论",
  "notebook.comments.add.label": "添加评论",
  "notebook.comments.none.subtitle": "尚未添加任何评论。",
  "notebook.comments.none.title": "无评论",
  "notebook.comments.title": "评论",
  "notebook.error.notAssigned": "您未分配到此项目",
  "notebook.heading.allEntries": "所有条目",
  "notebook.heading.notebooks": "项目",
  "notebook.icon.edit": "编辑",
  "notebook.instruments.title": "仪器",
  "notebook.label.addpage": "添加页面",
  "notebook.label.author": "作者",
  "notebook.label.basicinfo": "基本信息",
  "notebook.label.content": "主要内容",
  "notebook.label.dashboard": "笔记本仪表板",
  "notebook.label.drafts": "草稿",
  "notebook.label.entry": "笔记本条目",
  "notebook.label.entryFiles": "条目文件",
  "notebook.label.instanceEntry": "笔记本实例条目",
  "notebook.label.entryTags": "条目标签",
  "notebook.label.experimentDoc": "实验文档",
  "notebook.label.experimentType": "实验类型",
  "notebook.label.filter.types": "实验类型",
  "notebook.label.finalized": "本周已完成",
  "notebook.label.formEntry": "笔记本表单录入",
  "notebook.label.objective": "目标",
  "notebook.label.pages": "工作流页面",
  "notebook.label.pending": "等待审查",
  "notebook.label.project": "项目",
  "notebook.label.project.title": "项目标题",
  "notebook.label.projectFiles": "项目文件",
  "notebook.label.projectTags": "项目标签",
  "notebook.label.protocol": "协议ID",
  "notebook.label.questionnaire": "问卷",
  "notebook.label.sampleManagement": "样本管理",
  "notebook.label.status": "状态",
  "notebook.label.technician": "技术员",
  "notebook.label.title": "条目标题",
  "notebook.label.total": "总条目数",
  "notebook.page.completed": "已完成",
  "notebook.page.content": "内容：",
  "notebook.page.instructions": "说明：",
  "notebook.page.markComplete": "标记为完成",
  "notebook.page.modal.add.errorRequired": "标题和内容是必需的。",
  "notebook.page.modal.add.title": "添加新页面",
  "notebook.page.modal.content.label": "内容",
  "notebook.page.modal.edit.title": "编辑页面",
  "notebook.page.modal.instructions.label": "说明",
  "notebook.page.modal.title.label": "标题",
  "notebook.page.title": "笔记本",
  "notebook.pages.none.subtitle": "点击添加页面",
  "notebook.pages.none.title": "未添加页面",
  "notebook.project.definition.form.title": "项目定义表单",
  "notebook.project.entry.form.title": "项目录入表单",
  "notebook.results.modal.title": "{accession}的结果",
  "notebook.results.noAccession": "此样本无订单号可用",
  "notebook.results.none.subtitle": "未找到提供的订单号的结果。",
  "notebook.results.none.title": "未找到结果",
  "notebook.results.title": "结果",
  "notebook.sample.result.dateCreated": "创建日期",
  "notebook.samples.available": "可用样本",
  "notebook.samples.none.subtitle": "按患者或订单号搜索样本",
  "notebook.samples.none.subtitle.selected": "点击添加样本",
  "notebook.samples.none.title": "无可用样本",
  "notebook.samples.none.title.selected": "未选择样本",
  "notebook.samples.resultsRecorded": "结果记录：",
  "notebook.samples.selected": "已选样本",
  "notebook.search.byAccession": "按订单号搜索",
  "notebook.search.byPatient": "按患者搜索",
  "notebook.select.label": "选择笔记本",
  "notebook.status.archived": "归档条目",
  "notebook.status.assignment.title": "状态和分配",
  "notebook.status.draft": "保存草稿",
  "notebook.status.finalized": "最终确定条目",
  "notebook.status.locked": "锁定条目",
  "notebook.status.metadata.title": "状态和元数据",
  "notebook.status.submitted": "提交审查",
  "notebook.tab.attachments": "附件",
  "notebook.tab.auditTrail": "审计跟踪",
  "notebook.tab.comments": "评论",
  "notebook.tab.content": "内容",
  "notebook.tab.entryDetails": "条目详情",
  "notebook.tab.metadata": "元数据",
  "notebook.tab.results": "结果",
  "notebook.tab.samples": "样本",
  "notebook.tab.workflow": "工作流",
  "notebook.table.header.entries": "条目",
  "notebook.tag.placeholder": "输入标签",
  "notebook.tags.add": "添加标签",
  "notebook.tags.modal.add.errorRequired": "标签是必需的。",
  "notebook.tags.modal.add.label": "标签",
  "notebook.tags.modal.add.title": "添加新标签",
  "notebook.tags.title": "标签",
  "notebook.validation.content.required": "主要内容是必需的。",
  "notebook.validation.objective.required": "目标是必需的。",
  "notebook.validation.project.required": "项目是必需的。",
  "notebook.validation.protocol.required": "协议ID是必需的。",
  "notebook.validation.title.required": "标题是必需的。",
  "notebook.validation.type.required": "实验类型是必需的。",
  "notification.error": "错误",
  "notification.info": "信息",
  "notification.invalid.confirm.password": "您输入的密码与上述密码不同。",
  "notification.invalid.loginName": "请输入仅包含字母数字且无空格的数值。",
  "notification.invalid.name": "请输入仅包含字母数字的值。",
  "notification.invalid.password": "请按照说明输入密码。",
  "notification.login.generic.error": "尝试登录时出错",
  "notification.login.syntax.error": "尝试登录时出错 - 无法将响应解析为JSON",
  "notification.organization.post.delete.success": "组织停用成功。",
  "notification.organization.post.internetAddress": "输入有效的组织URL。",
  "notification.organization.post.save.success": "组织信息添加成功。",
  "notification.organization.post.success": "组织信息更新成功。",
  "notification.password.change.fail": "密码更改失败",
  "notification.password.change.success": "密码更改成功",
  "notification.response.syntax.error": "错误 - 无法将响应解析为JSON",
  "notification.resultSelectList.post.save.success": "Result select list saved successfully.",
  "notification.resultSelectList.post.update.success": "Result select list updated successfully.",
  "notification.slideover.button.hideread": "隐藏已读",
  "notification.slideover.button.markallasread": "全部标记为已读",
  "notification.slideover.button.markasread": "标记为已读",
  "notification.slideover.button.reload": "重新加载",
  "notification.slideover.button.showread": "显示已读",
  "notification.slideover.button.subscribe": "在此设备上订阅",
  "notification.slideover.button.subscribe.fail": "订阅失败",
  "notification.slideover.button.subscribe.success": "订阅成功",
  "notification.slideover.button.unsubscribe": "取消订阅",
  "notification.slideover.button.unsubscribe.fail": "取消订阅失败",
  "notification.slideover.button.unsubscribe.success": "取消订阅成功",
  "notification.slideover.empty.header": "您已全部完成",
  "notification.sliderover.empty.message": "您目前没有任何通知。",
  "notification.success": "成功",
  "notification.title": "通知消息",
  "notification.user.add.success": "User information added successfully.",
  "notification.user.post.delete.success": "用户停用成功。",
  "notification.user.post.save.success": "用户信息添加成功。",
  "notification.user.update.success": "User information updated successfully.",
  "notify.error": "用户和消息是必需的",
  "notify.main.title": "通知用户",
  "notify.message": "消息",
  "notify.user.by": "要通知的用户",
  "notify.user.success.notification": "通知发送成功",
  "of": "的",
  "openreports.activity.title": "活动报告",
  "openreports.aggregate.title": "汇总报告",
  "openreports.all.test.summary.title": "检测报告摘要",
  "openreports.all.tests.aggregate": "所有检测摘要",
  "openreports.hiv.aggregate": "HIV检测摘要",
  "openreports.management.title": "管理报告",
  "openreports.mgt.nonconformity.date": "按日期的不符合报告",
  "openreports.mgt.nonconformity.section": "按单元和原因的不符合报告",
  "openreports.mgt.rejection": "拒绝报告",
  "openreports.patient.EID.version1": "EID版本1",
  "openreports.patient.EID.version2": "EID版本2",
  "openreports.patient.VL.version1": "VL国家版本",
  "openreports.patientTestStatus": "患者状态报告",
  "openreports.patientreports.title": "患者状态报告",
  "openreports.stat.aggregate": "统计报告",
  "order.accept": "接受",
  "order.accept.error": "无法接受订单",
  "order.additionalInfo": "附加信息",
  "order.additionalInfo.helper": "关于此订单的可选备注",
  "order.clinicalInfo": "临床信息",
  "order.continue": "继续",
  "order.current.time": "当前时间 (hh:mm)",
  "order.dashboard.empty": "未找到任何订单",
  "order.dashboard.title": "订单仪表板",
  "order.department.label": "病房/科室/单元：",
  "order.diagnosis.helper": "初步诊断——用于指导检查的选择。未记录为确诊。",
  "order.diagnosis.placeholder": "输入诊断结果或临床备注",
  "order.entry.setup": "批量订单录入设置",
  "order.external": "外部",
  "order.facility": "设施",
  "order.filter.priority": "按优先级筛选",
  "order.filter.status": "状态",
  "order.fixIssue": "修复问题",
  "order.form.label": "表单：",
  "order.form.select": "选择表单",
  "order.generate.barcode": "生成条码并保存",
  "order.generate.barcode.history": "之前使用的订单号",
  "order.if.other.label": "如果是其他请指定：",
  "order.invalid.requester.name.label": "无效的请求者姓名",
  "order.invalid.site.name": "无效站点名称",
  "order.labNumber": "实验室编号",
  "order.labNumber.generate": "生成实验室编号",
  "order.labNumber.helper": "此订单的唯一标识符",
  "order.attachment.action.delete": "删除附件",
  "order.attachment.action.download": "下载附件",
  "order.attachment.action.view": "查看附件",
  "order.attachment.column.actions": "操作",
  "order.attachment.column.fileName": "文件名称",
  "order.attachment.column.fileSize": "尺寸",
  "order.attachment.column.fileType": "设备类型",
  "order.attachment.column.uploadedAt": "上传于",
  "order.attachment.delete.confirm.body": "您确定要删除“{fileName}”吗？此操作无法撤销。",
  "order.attachment.delete.confirm.title": "删除附件",
  "order.attachment.delete.failed": "无法删除该附件。请重试。",
  "order.attachment.dropzone": "将文件拖放到此处，或点击浏览文件",
  "order.attachment.empty": "目前尚无附件。",
  "order.attachment.error.maxFiles": "您最多可以附加{maxFiles}个文件。",
  "order.attachment.error.size": "每个文件的大小必须不超过{maxSize}。",
  "order.attachment.error.type": "允许的文件类型：{types}",
  "order.attachment.heading": "附件",
  "order.attachment.hint": "可选。最多{maxFiles}个文件，每个文件大小不超过10MB。支持格式：PDF、JPG、PNG、TIFF。",
  "order.attachment.upload.failed": "无法上传一个或多个附件。",
  "order.labNumber.placeholder": "输入或生成实验室编号",
  "order.label.add": "添加订单",
  "order.label.modify": "修改订单",
  "order.legend.EDTATube": "EDTA管",
  "order.legend.commonFields": "公共字段",
  "order.legend.configureBarcode": "配置条码录入",
  "order.legend.dryBloodSpot": "干血斑",
  "order.legend.dryTube": "干燥管",
  "order.legend.facility": "设施",
  "order.legend.onDemand": "按需",
  "order.legend.optionalFields": "可选字段",
  "order.legend.patient": "患者信息",
  "order.legend.preDemand": "预印",
  "order.legend.sample": "样本",
  "order.legend.selectMethod": "选择方法",
  "order.legend.siteName": "站点名称",
  "order.legend.specimen.collected": "已采集标本",
  "order.legend.tests": "检测",
  "order.legend.viralLoadTest": "病毒载量检测",
  "order.lastUpdated": "最后更新时间",
  "order.load.error": "加载订单失败",
  "order.location": "位置",
  "order.new": "新秩序",
  "order.payment.status.label": "患者支付状态：",
  "order.paymentStatus": "付款状态",
  "order.previousLabNumber": "之前的实验室编号",
  "order.previousLabNumber.placeholder": "如有，请输入之前的实验室编号",
  "order.printLabels": "打印条码",
  "order.printLabels.info": "打印此订单的条码",
  "order.priority": "优先级",
  "order.progress": "进度",
  "order.provisionalDiagnosis": "初步诊断",
  "order.received.time": "接收时间 (hh:mm)",
  "order.reception.time": "接收时间 (hh:mm)：",
  "order.remember.site.and.requester.label": "记住站点和请求者",
  "order.readonly.message": "此订单处于只读模式",
  "order.requester": "请求者",
  "order.requester.email.label": "请求者电子邮件：",
  "order.requester.fax.label": "请求者传真号码：",
  "order.requester.firstName.label": "请求者名：",
  "order.requester.lastName.label": "请求者姓：",
  "order.requester.phone.label": "请求者电话：",
  "order.requester.provisionalDiagnosis.label": "临时临床诊断：",
  "order.result.reporting.heading": "结果报告",
  "order.sampleCategory": "样本类别",
  "order.sampleCategory.helper": "选择要采集的样本类别",
  "order.sampling.performed.label": "已执行采样用于分析：",
  "order.search.requester.label": "搜索请求者",
  "order.saveStatus.error": "保存失败",
  "order.saveStatus.saved": "已保存",
  "order.saveStatus.saving": "保存中...",
  "order.saveStatus.unsaved": "未保存的更改",
  "order.save.blocked": "订单未保存",
  "order.save.notPersisted": "The server accepted the order but stored no samples for it. Check the order before continuing.",
  "order.save.incomplete": "请在保存前添加一名患者（或采样点）和至少一种样本类型。",
  "order.save.incomplete.fields": "Add {fields} before saving.",
  "order.save.incomplete.and": "and",
  "order.save.requirement.labNumber": "a lab number",
  "order.save.requirement.patient": "a patient",
  "order.save.requirement.samplingSite": "a sampling site",
  "order.save.requirement.collectionSite": "a collection site",
  "order.save.requirement.sampleType": "at least one sample type",
  "order.save.requirement.site": "a requesting site",
  "order.requestDate": "订单日期",
  "order.nextVisitDate": "下次就诊日期",
  "order.sampleHandling": "Sample Handling",
  "sampleAcceptance.qa.button.continueWithTesting": "Continue with testing",
  "sampleAcceptance.qa.continueWithTesting.reason": "Why is this sample being tested despite the failed check?",
  "sampleAcceptance.qa.continueWithTesting.record": "Record and continue",
  "order.eqaSample": "External quality assessment (EQA) sample",
  "order.noPatient": "This order has no patient",
  "order.noPatient.reason": "Reason for ordering without a patient",
  "order.noPatient.reason.eqa": "External quality assessment sample",
  "order.noPatient.warning.title": "Results will not be evaluated against a reference range",
  "order.noPatient.warning.subtitle": "Without a patient there is no age or sex to select a reference range from, so results on this order will not be flagged normal or abnormal.",
  "order.noPatient.butPatientChosen": "A patient is attached to this order, so the no-patient decision will not be recorded.",
  "order.eqa.program": "EQA Programme",
  "order.eqa.providerSampleId": "供应商样本编号",
  "order.eqa.deadline": "截止日期",
  "order.eqa.priority": "优先级",
  "order.rememberSiteAndRequester": "Remember this site and requester for my next order",
  "order.testLocationCode": "Sampling Performed At",
  "order.testLocationCode.other": "其他原因",
  "order.testLocationCode.otherLabel": "If other, specify",
  "provider.fax.invalid": "Enter a valid fax number, digits and + ( ) - only.",
  "provider.email.invalid": "Enter a valid email address, for example lab@example.org.",
  "order.save.requirement.provider": "a requesting provider",
  "order.save.requirement.testsPerSample": "at least one test or panel on every sample",
  "order.saved.draft": "草稿已保存",
  "order.saved.title": "已保存订单 {labNumber}",
  "order.saved.next": "下一个：{step}",
  "order.search.placeholder": "搜索订单……",
  "order.search.site.name": "搜索站点名称",
  "order.send.toAnalyzer": "发送至分析仪",
  "order.send.modal.title": "将订单发送至分析仪",
  "order.send.modal.confirm": "发送",
  "order.send.modal.cancel": "取消",
  "order.send.modal.analyzerLabel": "目标分析仪",
  "order.send.modal.accession": "物种编号：{accession}",
  "order.send.modal.noAnalyzers": "未为 LIS 发起的外送配置任何分析仪。",
  "order.send.success": "订单已发货",
  "order.send.error": "订单派送失败",
  "order.send.unknownError": "未知桥接错误",
  "order.send.missingAccession": "该订单没有可用于关联该结果的订单号。",
  "order.site.name": "站点名称：",
  "order.step.collect": "收集",
  "order.step.complete": "完成",
  "order.step.enter": "录入订单",
  "order.step.label": "贴标签与存放",
  "order.step.patient.info": "患者信息",
  "order.step.program.selection": "程序选择",
  "order.step.qa": "质量保证审核",
  "order.start.new": "开始新订单",
  "order.submit.labNumber": "提交时请注明实验室编号",
  "order.submit.success": "订单已成功提交简体中文（大陆）",
  "order.submitted.success.msg": "订单已成功提交",
  "order.summary.accessionNumber": "订单号",
  "order.summary.collectionDate": "采集日期",
  "order.summary.patientName": "患者姓名",
  "order.summary.sampleType": "样本类型",
  "order.summary.title": "订单摘要",
  "order.test.request.heading": "检测请求",
  "order.title": "订单",
  "ordertests.title": "订单检测",
  "organization.add.placeholder": "字母数字值",
  "organization.add.placeholder.active": "Y 或 N",
  "organization.add.placeholder.internetAddress": "https://组织名称.com",
  "organization.add.placeholder.parent": "上级组织",
  "organization.add.title": "添加组织",
  "organization.city": "城市",
  "organization.clia.number": "CLIA编号",
  "organization.edit.title": "编辑组织",
  "organization.internetaddress": "互联网地址",
  "organization.isActive": "是否活跃",
  "organization.main.title": "组织管理",
  "organization.next": "下一页",
  "organization.organizationName": "组织名称",
  "organization.parent": "上级组织",
  "organization.previous": "上一页",
  "organization.search.byorgname": "按组织名称搜索",
  "organization.search.parent.name": "上级组织名称",
  "organization.search.placeHolder": "按组织名称搜索...",
  "organization.select": "选择",
  "organization.short.CI": "组织前缀",
  "organization.streetAddress": "街道地址",
  "organization.type.CI": "活动类型",
  "organization.type.CI.description": "活动类型：描述",
  "organization.type.CI.name": "活动类型：名称",
  "organization.type.CI.select": "活动类型：选择",
  "otherMalignant.placeholder": "其他恶性",
  "page.breadcrumb.separator": "/",
  "page.title.back": "返回",
  "pagination.backward": "上一页",
  "pagination.forward": "下一页",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "第{min}-{max}项，共{total}项",
  "pagination.items-on-page": "{count} {count, plural, one {item} other {items}} on this page",
  "pagination.items-per-page": "每页项目数",
  "pagination.itemsPerPage": "每页项数",
  "pagination.nextPage": "下一页",
  "pagination.page": "第{page}页",
  "pagination.page-number": "页码",
  "pagination.page-range": "共{total} {total, plural, one {页} other {页}}",
  "pagination.previousPage": "上一页",
  "panel.existing": "现有面板",
  "panel.existing.inactive": "非活跃面板（分配检测以激活）",
  "panel.new": "新面板",
  "panel.panelName": "面板名称",
  "pathology.label.addblock": "添加块",
  "pathology.label.addslide": "添加幻灯片",
  "pathology.label.block": "块",
  "pathology.label.block.add.number": "要添加的块数",
  "pathology.label.block.number": "块号",
  "pathology.label.blocks": "块",
  "pathology.label.casesInProgress": "进行中的案例",
  "pathology.label.complete": "完成",
  "pathology.label.conclusion": "结论",
  "pathology.label.dashboard": "病理学仪表板",
  "pathology.label.grossexam": "大体检查",
  "pathology.label.location": "位置",
  "pathology.label.microexam": "显微镜检查",
  "pathology.label.printlabel": "打印标签",
  "pathology.label.refer": "转诊至免疫组织化学",
  "pathology.label.release": "准备发布",
  "pathology.label.report": "病理学报告",
  "pathology.label.request": "请求",
  "pathology.label.requests": "其他病理学请求",
  "pathology.label.review": "等待病理学审查",
  "pathology.label.slide": "幻灯片",
  "pathology.label.slide.add.number": "要添加的幻灯片数",
  "pathology.label.slide.number": "幻灯片号",
  "pathology.label.slides": "幻灯片",
  "pathology.label.stage": "阶段",
  "pathology.label.techniques": "使用的技术",
  "pathology.label.textconclusion": "文本结论",
  "pathology.label.title": "病理学",
  "pathology.label.view": "查看文件",
  "pathology.stage.accessioned": "Accessioned",
  "pathology.stage.completed": "已完成",
  "pathology.stage.coverslipping": "Coverslipping & QC",
  "pathology.stage.decalcification": "Decalcification",
  "pathology.stage.embedding": "Embedding",
  "pathology.stage.grossing": "Grossing",
  "pathology.stage.microtomy": "Microtomy",
  "pathology.stage.processing": "处理",
  "pathology.stage.readyPathologist": "Ready for Pathologist",
  "pathology.stage.staining": "Staining",
  "pathology.stage.underReview": "Under Pathologist Review",
  "patient.address.camp": "营地/公社",
  "patient.address.fokontany": "福孔塔尼",
  "patient.address.hamletOrLot": "哈姆雷特 / 洛特",
  "patient.address.healthdistrict": "地区",
  "patient.address.healthregion": "区域",
  "patient.address.province": "省",
  "patient.address.street": "街道",
  "patient.address.town": "城镇",
  "patient.age.days": "天",
  "patient.age.months": "月",
  "patient.age.years": "年龄/年",
  "patient.alias": "别名",
  "patient.dataSourceName": "数据源名称",
  "patient.dob": "出生日期",
  "patient.eduction": "教育",
  "patient.emergency.additional.camp": "输入营地/公社",
  "patient.emergency.additional.district": "输入地区",
  "patient.emergency.additional.education": "输入教育",
  "patient.emergency.additional.maritalstatus": "输入婚姻状况",
  "patient.emergency.additional.nationnality": "输入国籍",
  "patient.emergency.additional.othernationality": "输入其他国籍",
  "patient.emergency.additional.region": "输入区域",
  "patient.emergency.additional.street": "输入街道",
  "patient.emergency.additional.town": "输入城镇",
  "patient.emergency.email": "输入紧急联系人电子邮件",
  "patient.emergency.firstname": "输入紧急联系人名",
  "patient.emergency.lastname": "输入紧急联系人姓",
  "patient.emergency.phone": "输入紧急联系人电话",
  "patient.externalId": "外部ID",
  "patient.female": "女性",
  "patient.first.name": "名",
  "patient.gender": "性别",
  "patient.gps.latitude": "GPS纬度",
  "patient.gps.latitude.placeholder": "例如：-18.879190（范围为-90到90）",
  "patient.gps.longitude": "GPS经度",
  "patient.gps.longitude.placeholder": "例如，47.507905（范围为 -180 到 180）",
  "patient.id": "患者ID",
  "patient.information.age": "输入年龄",
  "patient.information.days": "输入天数",
  "patient.information.email": "输入患者电子邮件",
  "patient.information.firstname": "输入患者名",
  "patient.information.healthid": "输入唯一健康标识符",
  "patient.information.lastname": "输入患者姓",
  "patient.information.months": "输入月数",
  "patient.information.nationalid": "输入国籍标识符",
  "patient.information.primaryphone": "输入患者主要电话",
  "patient.label": "患者",
  "patient.label.additionalInfo": "附加信息",
  "patient.label.age": "年龄",
  "patient.label.customNotes": "自定义备注",
  "patient.label.diseaseProgramme": "目标疾病项目",
  "patient.label.occupation": "职业",
  "patient.label.contactphone": "联系电话：{PHONE_FORMAT}",
  "patient.label.email": "电子邮件",
  "patient.label.info": "患者信息",
  "patient.label.modify": "添加或修改患者",
  "patient.label.name": "姓名",
  "patient.label.nopatientid": "无患者信息可用",
  "patient.label.primaryphone": "主要电话：{PHONE_FORMAT}",
  "patient.label.sex": "性别",
  "patient.last.name": "姓",
  "phone.format.international.label": "国际",
  "phone.format.local.label": "本地",
  "patient.male": "男性",
  "patient.maritalstatus": "婚姻状况",
  "patient.merge.activeOrders": "活跃订单",
  "patient.merge.address": "地址",
  "patient.merge.addressesDiffer": "地址不同：{primary} 对比 {secondary}",
  "patient.merge.auditEntries": "审计条目（将保留原始患者）",
  "patient.merge.back": "返回",
  "patient.merge.cancelButton": "取消",
  "patient.merge.clinicalSummary": "临床摘要",
  "patient.merge.confirmButton": "确认合并",
  "patient.merge.confirmCheckbox": "我理解此操作无法撤销，并已验证正在合并正确的患者",
  "patient.merge.confirmMerge": "确认患者合并",
  "patient.merge.conflictNote": "（将使用主要患者的人口统计信息）",
  "patient.merge.conflictingInfo": "检测到冲突信息",
  "patient.merge.contactInfo": "联系信息",
  "patient.merge.county": "县/州",
  "patient.merge.dataToConsolidate": "要合并的数据",
  "patient.merge.demographics": "人口统计",
  "patient.merge.dob": "出生日期",
  "patient.merge.email": "电子邮件",
  "patient.merge.emailsDiffer": "电子邮件不同：{primary} 对比 {secondary}",
  "patient.merge.error.alreadyMerged": "患者已被合并",
  "patient.merge.error.executionFailed": "合并执行失败",
  "patient.merge.error.noPermission": "只有全局管理员可以合并患者",
  "patient.merge.error.patientNotFound": "未找到患者",
  "patient.merge.error.samePatient": "不能将患者与自身合并",
  "patient.merge.error.selectBoth": "请选择两个患者以继续",
  "patient.merge.error.selectPrimary": "请选择哪个患者应作为主要记录",
  "patient.merge.error.validationFailed": "合并验证失败",
  "patient.merge.externalIds": "外部ID",
  "patient.merge.gender": "性别",
  "patient.merge.identifiers": "标识符",
  "patient.merge.identifiersToPreserve": "要保留的标识符（两个患者）",
  "patient.merge.mergeSummary": "合并摘要",
  "patient.merge.mergingFrom": "合并自",
  "patient.merge.mergingLabel": "合并",
  "patient.merge.name": "姓名",
  "patient.merge.nationalId": "国家ID",
  "patient.merge.nationalIds": "国家ID",
  "patient.merge.nextStep": "下一步",
  "patient.merge.noIdentifiers": "未记录标识符",
  "patient.merge.noPatientSelected": "未选择患者",
  "patient.merge.notRecorded": "未记录",
  "patient.merge.orders": "订单",
  "patient.merge.ordersCount": "{count} ({active} 活跃)",
  "patient.merge.patientId": "患者ID",
  "patient.merge.patientIds": "患者ID",
  "patient.merge.patientResults": "患者结果",
  "patient.merge.phone": "电话",
  "patient.merge.phonesDiffer": "电话号码不同：{primary} 对比 {secondary}",
  "patient.merge.postalCode": "邮政编码",
  "patient.merge.primaryLabel": "主要",
  "patient.merge.primaryPatient": "主要患者",
  "patient.merge.reason": "合并原因（必需）",
  "patient.merge.reasonPlaceholder": "输入合并这些患者记录的原因...",
  "patient.merge.recordsReassigned": "{count} 条记录已重新分配",
  "patient.merge.samples": "样本",
  "patient.merge.searchDifferent": "搜索不同的患者",
  "patient.merge.selectFirstPatient": "选择第一个患者",
  "patient.merge.selectPrimaryDescription": "哪个患者应成为主要记录？",
  "patient.merge.selectPrimaryRecord": "选择主要患者记录",
  "patient.merge.selectSecondPatient": "选择第二个患者",
  "patient.merge.step.compare": "选择主要患者",
  "patient.merge.step.confirm": "确认合并",
  "patient.merge.step.select": "选择患者",
  "patient.merge.streetAddress": "街道地址",
  "patient.merge.success": "患者合并成功完成",
  "patient.merge.successMessage": "患者 {mergedId} 已合并到患者 {primaryId} 中。审计ID：{auditId}",
  "patient.merge.testResults": "检测结果",
  "patient.merge.title": "合并患者记录",
  "patient.merge.totalContacts": "联系人",
  "patient.merge.totalRelations": "关系",
  "patient.merge.totalResults": "总结果数",
  "patient.merge.totalSamples": "样本数",
  "patient.merge.town": "城镇/城市",
  "patient.merge.tryDifferentSearch": "请尝试调整搜索条件或使用不同的患者标识符。",
  "patient.merge.warning.dataLink": "所有未来的数据都将链接到主要患者。未选中的患者将被标记为合并且不活跃。",
  "patient.merge.warning.irreversible": "此操作无法撤销。所有数据将被永久合并。",
  "patient.merge.warning.samePatient": "选择了相同的患者",
  "patient.merge.warning.samePatientDescription": "您选择了相同的患者作为两个记录。请选择两个不同的患者进行合并。",
  "patient.natioanalid": "国家ID",
  "patient.nationalid": "国家ID",
  "patient.nationality": "国籍",
  "patient.nationality.other": "指定其他国籍",
  "patient.photo.active.camera": "点击激活相机",
  "patient.photo.add": "添加照片",
  "patient.photo.browse": "点击浏览文件",
  "patient.photo.camera.permission.denied": "相机权限被拒绝。请检查您的浏览器设置。",
  "patient.photo.cancel": "取消",
  "patient.photo.capture": "拍摄照片",
  "patient.photo.captured": "已拍摄照片：",
  "patient.photo.change": "更改图像",
  "patient.photo.confirm": "确认",
  "patient.photo.dragndrop": "将图像拖放到此处",
  "patient.photo.error.fileTooLarge": "图片太大。最大尺寸为 2MB。",
  "patient.photo.formats": "格式：JPG, PNG (最大1MB)",
  "patient.photo.import": "导入",
  "patient.photo.label": "患者照片",
  "patient.photo.modal.heading": "选择患者照片",
  "patient.photo.modal.options": "图像选择选项",
  "patient.photo.preview": "预览：",
  "patient.photo.preview.alt": "患者照片预览",
  "patient.photo.preview.captured.alt": "已拍摄的患者照片",
  "patient.photo.retake": "重新拍摄",
  "patient.photo.start.camera": "启动相机",
  "patient.photo.take": "拍摄照片",
  "patient.photo.view": "查看照片",
  "patient.idDoc.title": "身份证明文件",
  "patient.idDoc.addDocument": "添加文档",
  "patient.idDoc.selectImage": "选择图片",
  "patient.idDoc.documentType": "文档类型",
  "patient.idDoc.description": "描述",
  "patient.idDoc.description.placeholder": "输入文档描述",
  "patient.idDoc.category.nationalId": "外部ID",
  "patient.idDoc.category.insuranceCard": "保险卡",
  "patient.idDoc.category.other": "其他原因",
  "patient.idDoc.view": "查看",
  "patient.idDoc.edit": "编辑",
  "patient.idDoc.delete": "删除",
  "patient.idDoc.remove": "移除",
  "patient.idDoc.pending": "未保存",
  "patient.idDoc.empty": "未上传任何身份证明文件",
  "patient.idDoc.viewDocument": "查看文档",
  "patient.idDoc.editDocument": "编辑文档",
  "patient.idDoc.confirmDelete": "删除文档",
  "patient.idDoc.deleteWarning": "您确定要删除此文档吗？此操作无法撤销。",
  "patient.idDoc.upload": "上传",
  "patient.idDoc.dragndrop": "将文件拖放到此处",
  "patient.idDoc.browse": "或点击浏览文件",
  "patient.idDoc.formats": "文件格式：JPEG、PNG、PDF（最大10MB）",
  "patient.idDoc.useCamera": "使用相机",
  "patient.idDoc.pdfSelected": "已选择 PDF 文档",
  "patient.idDoc.error.invalidFormat": "文件格式无效。支持的格式：JPEG、PNG、PDF。",
  "patient.idDoc.error.fileTooLarge": "文件过大。最大大小为 10MB。",
  "patient.prev.lab.no": "之前的实验室编号",
  "patient.report.associated.name": "关联患者报告",
  "patient.report.collection.name": "已采集的ARV患者报告",
  "patient.search.nopatient": "未找到与搜索词匹配的患者",
  "patient.st.number": "ST编号",
  "patient.subject.number": "唯一健康ID号",
  "patient.yrs": "年",
  "patientcontact.person.email": "联系人电子邮件",
  "patientcontact.person.firstname": "联系人名",
  "patientcontact.person.lastname": "联系人姓",
  "placeholder.accession.number": "输入订单号",
  "print.barcode": "打印条码",
  "process.testAdd.pressNext.ageRangeSelectiong": "年龄范围选择步骤不是必需的，请按下一个按钮！",
  "process.testAdd.pressNext.selectGroupDictionary": "选择组字典列表步骤不是必需的，请按下一个按钮！",
  "program.name.label": "程序名称",
  "project.ARVFollowupStudy.name": "ARV随访",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "初始ARV",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "未确定",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "近期检测",
  "project.SequencingStudy.name": "测序",
  "project.SpecialRequestStudy.name": "特殊请求",
  "project.VLStudy.name": "病毒载量",
  "project.add.subtitle": "添加项目",
  "project.add.title": "添加项目",
  "project.browse.title": "项目",
  "project.completedDate": "完成日期",
  "project.desc.short": "项目描述",
  "project.description": "项目描述",
  "project.edit.subtitle": "编辑项目",
  "project.edit.title": "编辑项目",
  "project.external.reference": "外部参考",
  "provider.browse.title": "提供者管理",
  "provider.email": "电子邮件",
  "provider.fax": "传真",
  "provider.isActive": "是否活跃",
  "provider.modal.add.heading": "添加供应商",
  "provider.modal.update.heading": "更新供应商",
  "provider.providerFirstName": "提供者名",
  "provider.providerLastName": "提供者姓",
  "provider.search": "搜索提供者",
  "provider.search.placeholder": "搜索提供者姓名...",
  "provider.select": "选择提供者",
  "provider.telephone": "电话",
  "qa.checklist.incomplete": "质量保证检查清单不完整",
  "qa.checklist.instructions": "提交前请完成所有必要的检查",
  "qa.checklist.samplingSiteCorrect": "站点信息正确",
  "qa.checklist.title": "质量保证检查清单",
  "qa.summary.noSamples": "没有样本可供审查",
  "qa.summary.noTests": "未选择检测",
  "qa.summary.order": "订单详情",
  "qa.summary.panel": "面板",
  "qa.summary.patient": "患者信息",
  "qa.summary.poolOf": "{count} 的图片集 {animal}",
  "qa.summary.samples": "样本摘要",
  "qa.summary.samplingSite": "样本采样点",
  "qa.summary.siteCode": "站点位置代码",
  "qa.summary.siteName": "站点名称",
  "qc.comments.add": "添加评论",
  "qc.comments.empty": "暂无评论",
  "qc.comments.placeholder": "输入评论...",
  "qc.comments.title": "QC评论",
  "qc.expectedValue": "期望值",
  "qc.frequency.compliance": "合规性",
  "qc.frequency.config": "QC频率配置",
  "qc.frequency.daily": "每天",
  "qc.frequency.everyHours": "每隔数小时",
  "qc.frequency.everySamples": "每隔数个样本",
  "qc.frequency.manual": "手动",
  "qc.frequency.notConfigured": "未配置",
  "qc.frequency.perShift": "每班次",
  "qc.frequency.save": "保存QC频率",
  "qc.frequency.type": "频率类型",
  "qc.frequency.value": "频率值",
  "qc.leveyJennings.mean": "均值",
  "qc.leveyJennings.minus2SD": "-2SD",
  "qc.leveyJennings.minus3SD": "-3SD",
  "qc.leveyJennings.noData": "无可用数据",
  "qc.leveyJennings.plus2SD": "+2SD",
  "qc.leveyJennings.plus3SD": "+3SD",
  "qc.leveyJennings.title": "Levey-Jennings图",
  "qc.notes": "QC备注",
  "qc.notes.placeholder": "输入QC备注和观察结果",
  "qc.parentSample": "父样本",
  "qc.signature.comment": "签名评论",
  "qc.signature.comment.placeholder": "输入签名评论...",
  "qc.signature.ipAddress": "IP地址",
  "qc.signature.noSignatures": "暂无签名",
  "qc.signature.sign": "签名",
  "qc.signature.signedAt": "签名时间",
  "qc.signature.success": "签名成功",
  "qc.signature.title": "QC签名",
  "qc.signature.userId": "用户ID",
  "qc.status": "QC状态",
  "qc.status.failed": "失败",
  "qc.status.notRequired": "非必需",
  "qc.status.passed": "通过",
  "qc.status.pending": "待处理QC",
  "qc.status.select": "选择QC状态",
  "qc.status.update.button": "更新QC状态",
  "qc.status.update.success": "QC状态更新成功",
  "qc.status.update.title": "更新QC状态",
  "qc.status.warning.message": "将此批次标记为'失败'将阻止其使用，直到QC状态更新。",
  "qc.status.warning.title": "QC失败警告",
  "qc.westgard.noViolations": "无违规",
  "qc.westgard.rule.disabled": "已禁用",
  "qc.westgard.rule.enabled": "已启用",
  "qc.westgard.rules": "Westgard规则",
  "qc.westgard.rules.description": "配置用于QC数据评估的Westgard规则",
  "qc.westgard.violations": "违规记录",
  "quantity": "数量",
  "quantity.balanced": "数量平衡",
  "quantity.not.balanced": "数量不平衡",
  "quick.entry.accession.number": "订单号",
  "referTest.referralLabel": "将检测转诊到参考实验室",
  "referral.button.labSearch": "按实验室编号搜索转诊",
  "referral.button.patientSearch": "搜索患者",
  "referral.button.unitTestSearch": "按单元和检测搜索转诊",
  "referral.date.end": "结束日期 (dd/mm/yyyy)",
  "referral.date.start": "开始日期 (dd/mm/yyyy)",
  "referral.emptyState": "根据已选择的过滤器，未找到相关推荐。",
  "referral.error": "无匹配条件的转诊",
  "referral.input": "扫描或手动输入",
  "referral.label.institute": "机构",
  "referral.label.reason": "转诊原因",
  "referral.label.referredOutTests": "已转诊检测",
  "referral.label.sentdate": "发送日期",
  "referral.label.testmethod": "方法",
  "referral.label.testtoperform": "要执行的检测",
  "referral.main.button": "按患者搜索转诊",
  "referral.matching.search": "匹配搜索的转诊检测",
  "referral.out.head": "转诊",
  "referral.out.note": "注意：如果按结果日期搜索，只会显示有结果的检测。",
  "referral.out.request": "按日期/检测/单元的日期类型结果：",
  "referral.print.selected.patient.reports": "打印选定的患者报告",
  "referral.print.selected.patient.reports.selectall.button": "选择全部",
  "referral.print.selected.patient.reports.selectnone.button": "选择无",
  "referral.result.labNumber": "按实验室编号结果",
  "referral.result.referenceRange": "参考范围",
  "referral.search": "搜索",
  "referral.search.column.analysisId": "分析ID",
  "referral.search.column.referenceLab": "参考实验室",
  "referral.search.column.resultDate": "结果日期",
  "referral.search.column.sentDate": "发送日期",
  "referral.test": "检测",
  "referral.testresult.pastnote": "历史备注",
  "referral.units": "单元",
  "referrer.label": "转诊者",
  "reflexTests": "反射检测",
  "reject.action.button": "拒绝",
  "reject.order.sample.notification": "您正在拒绝一个样本。此样本将被拒绝，保存后不会出现在工作计划中，此订单不能输入结果。",
  "remaining.quantity": "剩余数量：",
  "remove.aliquot": "移除分装样本",
  "report.enter.labNumber.headline": "按订单号/实验室编号生成一个报告或一系列报告",
  "report.enter.patient.headline": "生成客户的所有报告",
  "report.enter.patient.headline.description": "通过之前的实验室编号、患者ID（可以是唯一健康ID号或国家ID）或其他字段搜索患者。",
  "report.enter.site.headline": "按站点生成报告",
  "report.labe.byLabNumber": "按实验室编号报告",
  "report.labe.byPatient": "按患者报告",
  "report.labe.date": "按日期报告",
  "report.labe.site": "按站点报告",
  "report.label.site.dateType": "日期类型",
  "report.label.site.onlyResults": "仅包含结果的报告",
  "report.patient.site.description": "按结果日期或订单日期生成报告。结果日期将仅显示有结果的报告。如果选择仅包含结果的报告，则所有检测都在进行中的报告将不会生成。",
  "report.select.site": "选择站点",
  "report.select.studttype": "选择研究类型",
  "reporting.label.testName": "报告检测名称",
  "reports.auditTrail": "审计跟踪",
  "reports.systemAuditTrail": "系统审计跟踪",
  "reports.button": "生成报告",
  "reports.dateRange": "日期范围",
  "reports.endDate": "结束日期",
  "reports.error.dateRangeRequired": "此报告类型需要日期范围",
  "reports.error.generationFailed": "生成报告失败。请重试。",
  "reports.error.invalidDate": "Invalid date",
  "reports.error.invalidDateRange": "结束日期必须在开始日期之后",
  "reports.error.unknownExportFormat": "Unknown export format",
  "reports.error.unknownReportType": "Unknown report type",
  "reports.export": "导出",
  "reports.export.byDate": "按日期导出",
  "reports.export.byDate_routine": "常规CSV报告",
  "reports.export.general": "通用导出",
  "reports.export.specific": "病毒载量数据导出",
  "reports.export.valid": "有效",
  "reports.export.whonet": "WHONET报告",
  "reports.followupRequired.byLocation": "需要随访",
  "reports.format": "导出格式",
  "reports.format.select": "选择格式",
  "reports.generate.title": "生成库存报告",
  "reports.generating": "生成中...",
  "reports.generation.success": "报告生成并下载成功",
  "reports.groupByLocation": "按存储位置分组",
  "reports.groupByType": "按物品类型分组",
  "reports.grouping": "分组选项",
  "reports.help.description": "使用这些报告分析您的库存数据：",
  "reports.help.tip1": "使用日期范围进行趋势分析",
  "reports.help.tip2": "按类型或位置分组以获得更好的洞察",
  "reports.help.tip3": "导出到Excel进行进一步分析",
  "reports.help.title": "报告提示",
  "reports.includeExpired": "包括已过期批次",
  "reports.includeInactive": "包括非活跃物品",
  "reports.info.message": "请选择下方的报告类型和选项。生成报告可能需要几分钟时间。",
  "reports.info.title": "报告生成",
  "reports.label.cistudyexport": "通用报告",
  "reports.label.indicator": "指标",
  "reports.label.indicator.performance": "部分性能",
  "reports.label.referred.out": "已转诊检测报告",
  "reports.label.trends": "趋势",
  "reports.menu.covid": "Covid报告",
  "reports.nonConformity.byDate.report": "按日期",
  "reports.nonConformity.byLabno.report": "按实验室编号",
  "reports.nonConformity.bySectionReason.report": "按单元和原因",
  "reports.nonConformity.bySectionReason.title": "按单元和原因的不符合报告",
  "reports.nonConformity.menu": "不符合报告",
  "reports.nonConformity.notification.report": "不符合通知",
  "reports.nonConformity.notification.report.instructions": "如果选择了服务，则将打印尚未打印的任何不符合通知。如果没有列出服务，则所有通知都已打印。输入实验室编号将打印通知，即使它已经打印过。不必选择服务。",
  "reports.options": "过滤选项",
  "reports.patient.ARV.version1": "ARV版本",
  "reports.patient.ARV.version1 ": "ARV版本1",
  "reports.patient.ARVFollowup.version1": "ARV随访版本1",
  "reports.patient.ARVFollowup.version2": "ARV随访版本2",
  "reports.patient.ARVInitial.version1": "ARV初始版本1",
  "reports.patient.ARVInitial.version2": "ARV初始版本2",
  "reports.patient.Indeterminate.location": "按服务的未确定",
  "reports.patient.Indeterminate.version1": "未确定版本1",
  "reports.patient.Indeterminate.version2": "未确定版本2",
  "reports.startDate": "开始日期",
  "reports.type": "报告类型",
  "reports.type.expirationForecast": "过期预测",
  "reports.type.expirationForecast.description": "在指定日期范围内过期的物品",
  "reports.type.lotTraceability": "批次可追溯性",
  "reports.type.lotTraceability.description": "完整的批次移动和使用可追溯性",
  "reports.type.lowStock": "低库存警报",
  "reports.type.lowStock.description": "当前低于最低库存水平的物品",
  "reports.type.select": "选择报告类型",
  "reports.type.stockLevels": "库存水平报告",
  "reports.type.stockLevels.description": "所有库存物品的当前库存水平",
  "reports.type.transactionHistory": "交易历史",
  "reports.type.transactionHistory.description": "日期范围内的所有交易",
  "reports.type.usageTrends": "使用趋势",
  "reports.type.usageTrends.description": "随时间的使用模式和消耗趋势",
  "request.samesite.order": "下相同站点订单",
  "requester.label": "请求者",
  "required.invalidtext": "此字段是必需的",
  "result.acceptasis.warning": "选中此框将表示您无条件接受结果。\n预期用途：\n1. 检测已重做且结果相同。\n2. 检测没有结果，但您不想取消它。\n3. 结果已更改，技术员希望给予生物学家在验证步骤中添加备注解释更改原因的选项。\n在任何情况下，请留下备注解释您采取此操作的原因。\n",
  "result.acceptasis.trigger": "接受",
  "result.acceptasis.reason.label": "无条件接受的理由",
  "result.acceptasis.reason.placeholder": "必填项——例如：经两次重新检测结果相同，或无结果可用",
  "result.acceptasis.confirm": "确认接受",
  "result.acceptasis.cancel": "取消",
  "result.acceptasis.committed": "已接受",
  "result.acceptasis.undo": "撤销",
  "result.entry.error.accessionRequired": "请输入订单号",
  "result.entry.error.title": "错误",
  "result.entry.info.title": "信息",
  "result.entry.label": "结果录入",
  "result.entry.noResults": "未找到订单号 {accessionNumber} 的样本",
  "result.entry.noTestsFound": "未找到订单号 {accessionNumber} 的待处理结果检测",
  "result.entry.results.accessionNumber": "订单号",
  "result.entry.results.sampleCount": "样本",
  "result.entry.results.testCount": "检测",
  "result.entry.results.title": "待处理结果的检测",
  "result.entry.saveSuccess": "{testName} 的结果已保存",
  "result.entry.search.accessionLabel": "订单号",
  "result.entry.search.accessionPlaceholder": "输入订单号...",
  "result.entry.search.button": "搜索",
  "result.entry.search.searching": "搜索中...",
  "result.entry.search.title": "按订单号搜索",
  "result.entry.success.title": "成功",
  "result.entry.table.action": "操作",
  "result.entry.table.header.sampleId": "样本ID",
  "result.entry.table.header.sampleType": "样本类型",
  "result.entry.table.header.testCount": "检测",
  "result.entry.table.noSamples": "未找到包含检测的样本",
  "result.entry.table.noTests": "此样本无检测",
  "result.entry.table.result": "结果",
  "result.entry.table.resultPlaceholder": "输入结果",
  "result.entry.table.save": "保存",
  "result.entry.table.saving": "保存中...",
  "result.entry.table.status": "状态",
  "result.entry.table.testName": "检测名称",
  "result.entry.table.testsTitle": "检测 ({count})",
  "result.entry.title": "结果录入",
  "result.noTestsFound": "未找到合适的检测。",
  "result.nonconforming.item": "样本或订单不符合或检测已被拒绝",
  "result.outOfValidRange.msg": "您输入的值（红色字段）超出了该记录允许的值范围。请检查该值",
  "result.notNumeric.msg": "{test}: \"{value}\" is not a number. Enter a plain decimal or scientific notation such as 1.5e5 or 1.5 x 10^5, then save again.",
  "result.reject.warning": "拒绝结果将永久删除检测结果 \n结果将不再可用。",
  "result.report.queue.size": "队列大小：",
  "result.search.noresult": "未找到结果",
  "resultreporting.browse.title": "结果报告配置",
  "resultreporting.config.url": "结果将发送到的站点的URL。例如 http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://组织名称.com/someSite",
  "results.label.refer": "将检测转诊到参考实验室",
  "routine.reports": "常规报告",
  "rulebuilder.error.invalidNumeric": "无效的数值",
  "rulebuilder.error.invalidTest": "无效的检测",
  "rulebuilder.label.add.externaltrigger": "添加外部`触发者`消息",
  "rulebuilder.label.add.internaltrigger": "添加内部`触发者`消息",
  "rulebuilder.label.addAction": "添加操作",
  "rulebuilder.label.addCondition": "添加条件",
  "rulebuilder.label.addExternalNote": "添加外部备注",
  "rulebuilder.label.addInternalNote": "添加内部备注",
  "rulebuilder.label.addPopup": "添加弹出窗口",
  "rulebuilder.label.addRule": "添加规则",
  "rulebuilder.label.addRuleConditions": "添加反射规则条件",
  "rulebuilder.label.confirmDelete": "您确定要停用此规则吗？",
  "rulebuilder.label.dictValue": "字典值",
  "rulebuilder.label.noSuggestions": "无可用建议",
  "rulebuilder.label.numericValue": "数值",
  "rulebuilder.label.numericValue2": "数值2",
  "rulebuilder.label.overallOptions": "整体选项",
  "rulebuilder.label.perfomActions": "执行以下操作",
  "rulebuilder.label.relation": "关系",
  "rulebuilder.label.removeAction": "移除操作",
  "rulebuilder.label.removeCondition": "移除条件",
  "rulebuilder.label.removeRule": "停用规则",
  "rulebuilder.label.rule": "规则",
  "rulebuilder.label.ruleDetails": "查看规则",
  "rulebuilder.label.ruleName": "规则名称",
  "rulebuilder.label.searchTest": "搜索检测",
  "rulebuilder.label.selectSample": "选择样本",
  "rulebuilder.label.textValue": "文本值",
  "rulebuilder.label.toggleRule": "切换规则",
  "sample.accession.number": "样本订单号",
  "sample.add.action": "添加样本",
  "sample.collection.date": "采集日期",
  "sample.collection.method": "收款方式",
  "sample.collection.method.placeholder": "例如：静脉采血、毛细血管采血、导管采血",
  "sample.collection.time": "采集时间",
  "sample.currentDate": "当前日期",
  "sample.requiredBy": "要求提供者",
  "sample.specimen.origin": "标本来源（参考实验室）",
  "sample.specimen.origin.placeholder": "转诊实验室名称",
  "sample.temperature": "样本储存温度",
  "sample.temperature.placeholder": "例如：室温、冰镇、冷藏",
  "sample.entry.available.tests": "可用检测",
  "sample.entry.nextVisit.date": "下次就诊日期",
  "sample.entry.panels": "面板",
  "sample.entry.project.patient.and.testName": "患者姓名/代码{br}检测名称",
  "sample.entry.project.testName": "检测名称",
  "sample.entry.search.barcode": "打印现有订单的条码",
  "sample.id": "样本ID",
  "sample.item.info": "样本信息",
  "sample.items.for.accession": "订单号的样本项：",
  "sample.label.accessionNumber": "订单号",
  "sample.label.collectionDate": "采集日期",
  "sample.label.dept": "病房/科室/单元",
  "sample.label.facility": "转诊设施",
  "sample.label.labnumber": "实验室编号",
  "sample.label.labnumber.generate": "生成",
  "sample.label.labnumber.new": "新实验室编号",
  "sample.labnumber.reassign.button": "重新分配实验室编号",
  "sample.labnumber.reassign.confirm": "重新分配",
  "sample.labnumber.reassign.current": "当前实验室编号",
  "sample.labnumber.reassign.heading": "重新分配实验室编号",
  "sample.labnumber.reassign.pending": "保存后，该标本将被重新分配至{number}。",
  "sample.labnumber.reassign.pending.title": "待处理的实验室编号重新分配",
  "sample.labnumber.reassign.undo": "撤销",
  "sample.labnumber.reassign.warning": "重新分配会永久更改该标本的实验室编号。现有标签、报告以及对当前编号的引用将不再与之匹配。请仅在需要更正标本标签错误时执行此操作。",
  "sample.label.noorder": "订单不存在",
  "sample.label.orderdate": "订单日期",
  "sample.label.orderpanel": "订单面板",
  "sample.label.requester": "请求者",
  "sample.label.search.Order": "搜索订单",
  "sample.label.search.labnumber": "按订单号搜索",
  "sample.label.search.patient": "按患者搜索",
  "sample.label.typeOfSample": "样本类型",
  "sample.label.types": "样本类型",
  "sample.management.action.clearSelection": "清除选择",
  "sample.management.action.createAliquot": "创建分装样本",
  "sample.management.action.selectAllAliquots": "选择所有分装样本",
  "sample.management.action.selectAllParents": "选择所有父样本",
  "sample.management.addTests.button": "添加检测",
  "sample.management.addTests.error.addFailed": "添加检测失败。请重试。",
  "sample.management.addTests.error.loadSampleTypes": "加载样本类型时出错",
  "sample.management.addTests.error.loadTests": "加载可用检测时出错",
  "sample.management.addTests.error.noEligibleSamples": "无法添加检测：所有选定的样本已全部分配",
  "sample.management.addTests.error.noTests": "请至少选择一个检测",
  "sample.management.addTests.modal.add": "添加检测",
  "sample.management.addTests.modal.addCount": "添加 {count} 个检测",
  "sample.management.addTests.modal.adding": "添加中...",
  "sample.management.addTests.modal.aliquotsIncluded": "包含分装样本",
  "sample.management.addTests.modal.bulkAliquotNote": "检测将添加到所有选定的样本，包括分装样本。",
  "sample.management.addTests.modal.cancel": "取消",
  "sample.management.addTests.modal.noEligibleSamples": "无符合条件的样本",
  "sample.management.addTests.modal.noTestsAvailable": "此样本类型无可用检测。",
  "sample.management.addTests.modal.noTestsSelected": "未选择检测",
  "sample.management.addTests.modal.panels": "面板",
  "sample.management.addTests.modal.searchTestsPlaceholder": "搜索检测...",
  "sample.management.addTests.modal.selectSampleType": "样本类型",
  "sample.management.addTests.modal.selectSampleTypeFirst": "请选择样本类型以查看可用面板和检测。",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "选择样本类型...",
  "sample.management.addTests.modal.selectTests": "选择检测",
  "sample.management.addTests.modal.selectTestsPlaceholder": "搜索并选择检测...",
  "sample.management.addTests.modal.selectedTests": "已选检测",
  "sample.management.addTests.modal.subtitle": "向 {count} 个选定的样本添加检测",
  "sample.management.addTests.modal.tests": "检测",
  "sample.management.addTests.modal.title": "向样本添加检测",
  "sample.management.addTests.resultItem": "{sampleId}：{added} 个已添加",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}：{added} 个已添加，{skipped} 个已跳过",
  "sample.management.addTests.success": "{count} 个检测成功添加",
  "sample.management.addTests.successDetailed": "{count} 个检测已添加到 {samples} 个样本：{details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} 个检测已添加到 {samples} 个样本，{skipped} 个已跳过：{details}",
  "sample.management.addTests.successWithSkipped": "{added} 个检测已添加，{skipped} 个已跳过（已订购）",
  "sample.management.addTests.title": "添加检测",
  "sample.management.addTests.warning.dispensedSamples": "{count} 个样本没有剩余体积，将被跳过。检测将添加到 {eligible} 个符合条件的样本。",
  "sample.management.addTests.warning.dispensedSamples.title": "已分配样本已排除",
  "sample.management.aliquot.error.createFailed": "创建分装样本失败。请重试。",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "分装样本数量必须在1到100之间",
  "sample.management.aliquot.error.quantityExceedsRemaining": "请求的数量 ({requested}) 超过剩余数量 ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "每个分装样本的数量 ({quantityPerAliquot}) 将小于最小值 (0.001)",
  "sample.management.aliquot.error.quantityPositive": "数量必须大于0",
  "sample.management.aliquot.error.quantityRequired": "数量是必需的",
  "sample.management.aliquot.error.title": "错误",
  "sample.management.aliquot.modal.cancel": "取消",
  "sample.management.aliquot.modal.create": "创建分装样本",
  "sample.management.aliquot.modal.createMultiple": "创建 {count} 个分装样本",
  "sample.management.aliquot.modal.creating": "创建中...",
  "sample.management.aliquot.modal.notesLabel": "备注（可选）",
  "sample.management.aliquot.modal.notesPlaceholder": "添加关于此分装样本的任何备注...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "输入要创建的等体积分装样本数量（1-100）",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "分装样本数量",
  "sample.management.aliquot.modal.parentInfo": "父样本信息",
  "sample.management.aliquot.modal.preview": "预览",
  "sample.management.aliquot.modal.previewText": "创建 {count} 个分装样本，每个 {quantityEach} {unit}",
  "sample.management.aliquot.modal.quantityHelper": "输入要转移的数量，单位为 {unit}",
  "sample.management.aliquot.modal.quantityLabel": "要转移的数量",
  "sample.management.aliquot.modal.quantityPlaceholder": "输入数量",
  "sample.management.aliquot.modal.subtitle": "从样本 {externalId} 创建分装样本",
  "sample.management.aliquot.modal.title": "创建分装样本",
  "sample.management.aliquot.modal.totalQuantityHelper": "输入要在所有分装样本中分配的总数量，单位为 {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "要转移的总数量",
  "sample.management.aliquot.success": "分装样本 {externalId} 创建成功。请再次搜索以查看更新后的结果。",
  "sample.management.aliquot.successMultiple": "{count} 个分装样本创建成功 ({externalIds})。请再次搜索以查看更新后的结果。",
  "sample.management.breadcrumb.title": "样本管理",
  "sample.management.cancelTest.error": "取消检测失败。请重试。",
  "sample.management.cancelTest.success": "检测 \"{testName}\" 成功取消",
  "sample.management.description": "搜索和管理样本项，创建分装样本，以及添加检测",
  "sample.management.error.title": "错误",
  "sample.management.hierarchy.aliquotOf": "{parent} 的分装样本",
  "sample.management.hierarchy.aliquots": "分装样本",
  "sample.management.noResults.subtitle": "未找到订单号为 {accessionNumber} 的样本项",
  "sample.management.noResults.title": "未找到结果",
  "sample.management.results.accessionNumber": "订单号",
  "sample.management.results.aliquots": "分装样本",
  "sample.management.results.aliquotsSelected": "分装样本",
  "sample.management.results.item": "项",
  "sample.management.results.items": "项",
  "sample.management.results.selected": "已选择",
  "sample.management.results.title": "样本项",
  "sample.management.results.totalCount": "总样本数",
  "sample.management.search.error.general": "加载样本结果时出错。请重试。",
  "sample.management.search.label": "搜索样本",
  "sample.management.search.loading": "搜索中...",
  "sample.management.search.placeholder": "输入订单号以搜索...",
  "sample.management.search.title": "搜索样本",
  "sample.management.status.allVolumeDispensed": "已分配所有体积",
  "sample.management.status.available": "可用",
  "sample.management.status.consumed": "已消耗",
  "sample.management.status.inUse": "使用中",
  "sample.management.status.unknown": "未知",
  "sample.management.success.title": "成功",
  "sample.management.table.cancelTest": "取消检测",
  "sample.management.table.cancelling": "取消中...",
  "sample.management.table.header.externalId": "样本ID",
  "sample.management.table.header.hierarchy": "层次结构",
  "sample.management.table.header.originalQuantity": "原始数量",
  "sample.management.table.header.quantity": "原始数量",
  "sample.management.table.header.remainingQuantity": "剩余数量",
  "sample.management.table.header.sampleType": "样本类型",
  "sample.management.table.header.status": "状态",
  "sample.management.table.header.tests": "检测",
  "sample.management.table.noResults": "无样本项可显示。使用上面的搜索查找样本。",
  "sample.management.table.noTests": "此样本未订购检测",
  "sample.management.table.orderedDate": "已订购",
  "sample.management.table.orderedTests": "已订购检测 ({count})",
  "sample.management.title": "样本管理",
  "sample.panel.label.text": "搜索可用面板",
  "sample.panel.placeholder": "选择可用面板",
  "sample.panel.search.error.msg": "未找到匹配的面板",
  "sample.quantity.label": "数量",
  "sample.receivedDate": "接收日期",
  "sample.reject.label": "拒绝样本",
  "sample.remove.action": "移除样本",
  "sample.requestDate": "请求日期",
  "sample.search.nosample": "未找到提供的订单号的样本。",
  "sample.search.panel.legend.text": "搜索可用面板",
  "sample.search.scanner.instructions": "扫描或手动输入。对于单个报告，请将右侧的框留空",
  "sample.search.scanner.instructions.highaccession": "对于单个报告，请将右侧的框留空",
  "sample.search.scanner.instructions2": "扫描或手动输入。",
  "sample.search.title": "搜索样本",
  "sample.select.type": "选择样本类型",
  "sample.type": "样本类型",
  "sample.type.and.test.sort.order": "样本类型和检测排序顺序",
  "sample.type.helper": "选择标本类型——选择后，可用检测项目和检测方法将自动更新。",
  "sample.uom.label": "样本测量单位",
  "sample.voided.title": "样本已作废",
  "sampleManagement.actions": "操作",
  "sampleManagement.addTests.button": "添加检测",
  "sampleManagement.addTests.cancel": "取消",
  "sampleManagement.addTests.duplicate": "检测已为 {sampleId} 订购",
  "sampleManagement.addTests.error": "添加检测时出错",
  "sampleManagement.addTests.incompatible": "检测与样本类型 ({sampleType}) 不兼容",
  "sampleManagement.addTests.selectSamples": "选择要添加检测的样本",
  "sampleManagement.addTests.selectTests": "选择要添加的检测",
  "sampleManagement.addTests.skipped": "跳过了 {count} 个重复项",
  "sampleManagement.addTests.submit": "添加检测",
  "sampleManagement.addTests.success": "{count} 个检测成功添加",
  "sampleManagement.addTests.title": "向样本添加检测",
  "sampleManagement.aliquot.button": "创建分装样本",
  "sampleManagement.aliquot.cancel": "取消",
  "sampleManagement.aliquot.error": "创建分装样本时出错",
  "sampleManagement.aliquot.error.concurrentModification": "其他用户修改了此样本。请刷新后重试。",
  "sampleManagement.aliquot.error.insufficientQuantity": "无法分装：请求的 {requested} 超过剩余的 {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "已分配所有体积：没有剩余数量可供分装",
  "sampleManagement.aliquot.notes": "备注（可选）",
  "sampleManagement.aliquot.notesPlaceholder": "添加关于此分装样本的备注...",
  "sampleManagement.aliquot.parentExternalId": "父样本外部ID",
  "sampleManagement.aliquot.parentLabel": "父样本",
  "sampleManagement.aliquot.quantityPlaceholder": "输入数量...",
  "sampleManagement.aliquot.quantityToTransfer": "要转移的数量",
  "sampleManagement.aliquot.remainingQuantity": "剩余数量",
  "sampleManagement.aliquot.submit": "创建分装样本",
  "sampleManagement.aliquot.success": "分装样本 {externalId} 创建成功",
  "sampleManagement.aliquot.title": "创建分装样本",
  "sampleManagement.aliquot.unit": "单位",
  "sampleManagement.aliquot.validation.exceeds": "数量超过剩余数量",
  "sampleManagement.aliquot.validation.min": "数量必须至少为 0.001",
  "sampleManagement.aliquot.validation.required": "要转移的数量是必需的",
  "sampleManagement.clearSelection": "清除选择",
  "sampleManagement.hierarchy.children": "分装样本：",
  "sampleManagement.hierarchy.collapse": "折叠层次结构",
  "sampleManagement.hierarchy.expand": "展开层次结构",
  "sampleManagement.hierarchy.level": "级别 {level}",
  "sampleManagement.hierarchy.parent": "父样本：",
  "sampleManagement.notification.refreshResults": "结果已刷新",
  "sampleManagement.results.children": "分装样本",
  "sampleManagement.results.collectionDate": "采集日期",
  "sampleManagement.results.count": "找到 {count} 个样本",
  "sampleManagement.results.externalId": "外部ID",
  "sampleManagement.results.originalQuantity": "原始数量",
  "sampleManagement.results.parent": "父样本",
  "sampleManagement.results.remainingQuantity": "剩余数量",
  "sampleManagement.results.sampleType": "样本类型",
  "sampleManagement.results.status": "状态",
  "sampleManagement.results.tests": "检测",
  "sampleManagement.results.title": "搜索结果",
  "sampleManagement.search.button": "搜索",
  "sampleManagement.search.error": "搜索样本时出错",
  "sampleManagement.search.label": "按订单号搜索",
  "sampleManagement.search.loading": "搜索中...",
  "sampleManagement.search.noResults": "未找到此订单号的样本",
  "sampleManagement.search.placeholder": "输入订单号...",
  "sampleManagement.selectSamples": "选择样本",
  "sampleManagement.selectedCount": "{count} 个已选择",
  "sampleManagement.test.name": "检测名称",
  "sampleManagement.test.orderedDate": "订购日期",
  "sampleManagement.test.status": "状态",
  "sampleManagement.test.status.CANCELLED": "已取消",
  "sampleManagement.test.status.COMPLETED": "已完成",
  "sampleManagement.test.status.IN_PROGRESS": "进行中",
  "sampleManagement.test.status.ORDERED": "已订购",
  "sampleManagement.title": "样本管理",
  "sampleManagement.validation.accessionNumberRequired": "订单号是必需的",
  "sampleManagement.validation.parentSampleRequired": "父样本项是必需的",
  "sampleManagement.validation.samplesRequired": "必须至少选择一个样本",
  "sampleManagement.validation.testsRequired": "必须至少选择一个检测",
  "sampleType.existing": "现有样本类型",
  "sampleType.existing.inactive": "非活跃样本类型。分配检测以激活。",
  "sampleType.new": "新样本类型",
  "sampleType.typeName": "样本类型名称",
  "save.aliquot.changes": "保存分装样本更改",
  "save.config.success.msg": "配置更新成功",
  "save.order.success.msg": "样本订单录入已成功保存",
  "save.success": "成功保存",
  "saving": "保存中...",
  "search.by.dictionary.entry": "按字典条目搜索",
  "search.label": "搜索",
  "search.label.accession": "输入订单号",
  "search.label.analysis": "选择分析状态",
  "search.label.collectiondate": "输入采集日期",
  "search.label.fromaccession": "从订单号",
  "search.label.loadnext": "从实验室编号加载下一个99条记录",
  "search.label.receiveddate": "输入接收日期",
  "search.label.sample": "选择样本状态",
  "search.label.test": "选择检测名称",
  "search.label.testdate": "输入检测日期",
  "search.label.testunit": "选择检测单元",
  "search.label.toaccession": "到订单号",
  "search.patient.label": "搜索患者",
  "search.placeholder": "请输入搜索内容...",
  "searchTests.label": "搜索可用检测",
  "searchTests.legend": "搜索可用检测",
  "searchindexmanagement.description": "添加或修改数据时，搜索索引会自动更新。如果您需要手动更新搜索索引，请单击开始重新索引按钮。这可能需要一些时间。",
  "searchindexmanagement.label": "搜索索引管理",
  "searchindexmanagement.reindex": "开始重新索引",
  "searchindexmanagement.reindex.error": "重新索引失败",
  "searchindexmanagement.reindex.success": "重新索引成功完成",
  "select.aliquot": "选择分装样本",
  "select.datarange.label": "日期范围用于转诊时间",
  "select.dateRange": "选择检测报告摘要的日期范围",
  "select.default.option.label": "选择一个选项",
  "select.end.date.referredTests": "结束日期 (dd/mm/yyyy)",
  "select.labUnits": "选择您要为其创建检测的实验室单元，您可以根据需要选择多个",
  "select.label.analyser": "选择分析仪",
  "select.priority.tests": "选择要显示的检测的优先级",
  "select.program": "程序",
  "select.referral.centre": "转诊中心或实验室",
  "select.referral.centre.is.required": "转诊中心或实验室是必需的",
  "select.start.date.referredTests": "开始日期 (dd/mm/yyyy)",
  "select.timeFrame": "选择您要生成报告的时间范围",
  "select.timeFrame.Note": "注意：所有日期和时间均基于接收时间。例如：1月31日晚上11:59接收并于2月1日上午9:30得出结果的检测将显示为1月非正常工作时间。",
  "select.year.report": "选择您要生成报告的年份",
  "selectListRenameEntry.selectList": "选择列表重命名条目",
  "selectListRenameEntry.selectListEdit": "选择列表重命名条目编辑",
  "selectReportValues.title": "选择报告值",
  "selectResult.title": "选择结果",
  "serial.config.active.label": "活跃",
  "serial.config.baudRate.label": "波特率",
  "serial.config.connect.button": "连接",
  "serial.config.connect.error": "连接失败",
  "serial.config.connect.success": "连接成功",
  "serial.config.create.title": "创建串口配置",
  "serial.config.dataBits.label": "数据位",
  "serial.config.disconnect.button": "断开连接",
  "serial.config.disconnect.error": "断开连接失败",
  "serial.config.disconnect.success": "断开连接成功",
  "serial.config.edit.title": "编辑串口配置",
  "serial.config.flowControl.label": "流控制",
  "serial.config.flowControl.none": "无",
  "serial.config.form.legend": "串口配置",
  "serial.config.parity.even": "偶校验",
  "serial.config.parity.label": "校验位",
  "serial.config.parity.mark": "标记",
  "serial.config.parity.none": "无",
  "serial.config.parity.odd": "奇校验",
  "serial.config.parity.space": "空格",
  "serial.config.portName.label": "端口名称",
  "serial.config.save.error": "保存串口配置失败",
  "serial.config.save.success": "串口配置保存成功",
  "serial.config.status.label": "状态",
  "serial.config.stopBits.label": "停止位",
  "serial.config.validation.analyzerId.required": "分析仪ID为必填项",
  "serial.config.validation.baudRate.invalid": "波特率无效",
  "serial.config.validation.dataBits.invalid": "数据位无效",
  "serial.config.validation.portName.required": "端口名称为必填项",
  "server.error.msg": "哎呀，服务器错误，请联系管理员",
  "common.retry": "重试",
  "show.aliquoting": "显示分装样本",
  "showing": "显示",
  "breadcrumb.label.addOrder": "添加订单",
  "sidenav.label.admin": "管理",
  "sidenav.label.admin.backToMainMenu": "返回主菜单",
  "sidenav.label.admin.barcodeconfiguration": "条码配置",
  "sidenav.label.admin.labelPresets": "标签预设",
  "sidenav.label.admin.commonproperties": "应用属性",
  "sidenav.label.admin.eqaProgram": "EQA程序",
  "sidenav.label.admin.formEntry.menustatementconfig": "菜单声明配置",
  "sidenav.label.admin.formEntry.nonconformityconfig": "不符合配置",
  "sidenav.label.admin.formEntry.patientconfig": "患者录入配置",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "打印报告配置",
  "sidenav.label.admin.formEntry.resultConfig": "结果录入配置",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "订单录入配置",
  "sidenav.label.admin.formEntry.siteBranding": "站点品牌",
  "sidenav.label.admin.formEntry.siteInfoconfig": "站点信息",
  "sidenav.label.admin.formEntry.validationconfig": "验证配置",
  "sidenav.label.admin.formEntry.Workplanconfig": "工作计划配置",
  "sidenav.label.admin.labNumber": "实验室编号管理",
  "sidenav.label.admin.localization": "本地化",
  "sidenav.label.admin.menu": "菜单配置",
  "sidenav.label.admin.menu.billing": "计费菜单配置",
  "sidenav.label.admin.menu.global": "全局菜单配置",
  "sidenav.label.admin.menu.nonconform": "不符合菜单配置",
  "sidenav.label.admin.menu.patient": "患者菜单配置",
  "sidenav.label.admin.menu.study": "研究菜单配置",
  "sidenav.label.admin.organizationmgt": "组织管理",
  "sidenav.label.admin.testmgt": "反射检测配置",
  "sidenav.label.admin.testmgt.calculated": "计算值检测管理",
  "sidenav.label.admin.testmgt.testCatalogEditor": "测试目录编辑器",
  "sidenav.label.admin.testCatalog": "测试目录管理",
  "sidenav.label.admin.testCatalog.backToList": "← 所有检测项目",
  "sidenav.label.admin.testCatalog.sectionsHelper": "点击某项测试以编辑其各部分",
  "sidenav.label.admin.testCatalog.editing": "编辑中",
  "sidenav.label.admin.testCatalog.editingGeneric": "编辑测试",
  "label.testCatalog.editor": "测试目录编辑器",
  "label.testCatalog.editor.empty": "点击某项测试以编辑其各部分",
  "label.testCatalog.editor.empty.helper": "从“测试目录”列表中打开一个测试，以便对其进行编辑。",
  "label.testCatalog.editor.loadError": "无法加载此检测。请重试。",
  "label.testCatalog.editor.saveAsNew": "保存为“新测试”……",
  "label.testCatalog.editor.save.pending": "该功能将在分区编辑器发货后可用。",
  "label.testCatalog.editor.clone.pending": "编辑器各部分发运后，即可使用“另存为新测试”功能。",
  "label.testCatalog.section.pending": "本节的编辑器将在后续的里程碑版本中发布。",
  "label.testCatalog.section.basic-info": "基本信息",
  "label.testCatalog.section.sample-results": "样本与结果",
  "label.testCatalog.section.methods": "方法",
  "label.testCatalog.section.ranges": "范围",
  "label.testCatalog.section.qc-targets": "QC Targets",
  "label.testCatalog.section.storage": "样本存储",
  "label.testCatalog.section.panels": "检测面板",
  "label.testCatalog.entity.panels": "检测面板",
  "note.panel.domainUpgrade": "检测面板现在有了“领域”属性；现有面板的“领域”属性此前均设置为“临床”。",
  "note.panel.domainLaterPhase": "“环境”和“病媒”领域将在后续阶段已启用。",
  "label.panel.list.description": "已订购的测试集合；样本类型源自其成员测试",
  "label.panel.list.empty": "没有面板符合当前的过滤器条件。",
  "label.panel.search": "按名称或 LOINC 搜索",
  "button.panel.add": "添加面板",
  "label.panel.col.name": "面板名称",
  "label.panel.col.tests": "检测项目",
  "label.panel.col.domain": "域名",
  "label.panel.list.mixedDomain": "Mixed domain",
  "label.panel.list.mixedDomain.detail": "Sample types outside this panel's domain: {sampleTypes}",
  "label.panel.col.sampleTypes": "样本类型（衍生）",
  "label.panel.col.status": "状态",
  "label.panel.backToList": "返回列表",
  "title.panel.new": "新面板",
  "label.panel.name": "面板名称",
  "placeholder.panel.name": "例如：贫血检查",
  "label.panel.domain": "域名",
  "helper.panel.domainGuard": "此面板中仅可添加 {domain}-domain 格式的检测项目。",
  "helper.panel.loincIsIdentifier": "该面板的 LOINC 即为其标识符。",
  "note.panel.sampleTypesDerived": "样本类型源自本检测面板中的检测项目。",
  "label.panel.description": "描述",
  "label.panel.active": "活跃",
  "helper.panel.needsTest": "必须添加至少一项检测项目，才能激活此面板。",
  "error.panel.save": "无法保存该面板。请检查各字段，然后重试。",
  "error.panel.nameRequired": "必须填写面板名称。",
  "error.panel.nameTooLong": "A panel name has at most 20 characters.",
  "error.panel.descriptionTooLong": "A description has at most 60 characters.",
  "error.panel.nameDuplicate": "Another panel already uses this name. Enter a different name.",
  "error.panel.domainConflict": "This panel cannot be filed under {domain}: {count, plural, one {# of its tests belongs} other {# of its tests belong}} to another domain ({tests}).",
  "helper.panel.domainConflict.remedy": "Change the domain of those tests in the Test Catalog, or remove them from this panel, then save again.",
  "error.panel.tests.domainConflict": "Not saved: {tests} {count, plural, one {is} other {are}} not in this panel's domain ({domain}). Only {domain}-domain tests can be added.",
  "error.testCatalog.panels.domainConflict": "This test cannot join {panelName}: the panel is filed under {panelDomain} and the test under {testDomain}.",
  "success.panel.created": "Panel created. It stays inactive until at least one test is assigned to it.",
  "error.panel.create.invalid": "The panel could not be created. Fill in every required field, including a LOINC code.",
  "label.panel.section.basic-info": "基本信息",
  "label.panel.section.tests": "检测项目",
  "label.panel.section.terminology": "术语",
  "label.panel.section.localization": "本地化",
  "label.panel.localization.intro": "编辑此面板名称的各语言翻译。未翻译的字段将默认显示为英文。请通过“翻译管理”管理页面管理所有翻译。",
  "label.panel.localization.empty": "此面板中没有可本地化的名称字段。",
  "label.panel.localization.loadError": "无法加载此面板的翻译。",
  "label.panel.localization.field.name": "面板名称",
  "sidenav.label.admin.panel.editing": "编辑组：{name}",
  "sidenav.label.admin.panel.sectionsHelper": "点击一个面板以编辑其中的各部分",
  "sidenav.label.admin.panel.addingNew": "添加新面板",
  "label.panel.testsCount": "检测项目",
  "label.panel.addTest": "添加检测",
  "label.panel.tests.filterBySampleType": "按样本类型筛选",
  "label.panel.tests.filterBySampleType.all": "所有样本类型",
  "placeholder.panel.addTest": "按名称或位置代码搜索……",
  "helper.panel.membershipSync": "会员写入操作会保持订单条目面板列表的同步。",
  "label.panel.col.order": "接收样本",
  "label.panel.col.testName": "检测名称",
  "label.panel.col.code": "位置代码",
  "label.panel.moveUp": "向上移动",
  "label.panel.moveDown": "向下移动",
  "empty.panel.tests": "尚无检测项目——请在上方搜索以添加第一个检测项目。",
  "helper.panel.loincRouting": "它同时也是一把实时路由密钥——FHIR电子医嘱在接收时会根据此位置代码匹配检测面板。主要LOINC代码仍保留在检测面板上，用于列表显示和医嘱录入。",
  "label.panel.terminology.primary": "主要",
  "label.panel.terminology.empty": "目前尚无术语映射。LOINC映射即为该检测面板的标识符。",
  "label.panel.terminology.saved": "术语映射已保存。",
  "label.panel.terminology.saveInvalid": "某些映射无效。请检查来源、位置代码和重复项。",
  "label.panel.terminology.saveError": "无法保存术语映射。",
  "note.panel.positionShared": "该字段写入 panel_item.sort_order —— 这与测试端“检测面板”部分所编辑的字段相同。",
  "label.testCatalog.section.labels": "标签",
  "label.testCatalog.section.terminology": "术语",
  "label.testCatalog.labels.col.preset": "预设",
  "label.testCatalog.labels.col.defaultQty": "默认值",
  "label.testCatalog.labels.col.maxQty": "最大数量",
  "label.testCatalog.labels.col.allowOverride": "允许覆盖",
  "label.testCatalog.labels.col.actions": "操作",
  "label.testCatalog.labels.addLabelType": "添加标签类型",
  "label.testCatalog.labels.addLabelType.placeholder": "选择一个标签预设……",
  "label.testCatalog.labels.empty": "未配置任何标签类型。请添加标签预设，以便在订购此检测时自动推荐标签。",
  "label.testCatalog.labels.loadError": "无法加载此检测项目的标签配置。",
  "label.testCatalog.labels.saved": "标签配置已保存",
  "label.testCatalog.labels.saveError": "无法保存标签配置。",
  "label.testCatalog.labels.unsaved": "您有未保存的标签更改。请点击“保存”以应用这些更改。",
  "label.testCatalog.labels.maxLtDefault": "“最大数量”必须大于或等于“默认值”。",
  "label.testCatalog.labels.allowOverride.label": "允许在订单录入时进行覆盖",
  "label.testCatalog.labels.generationSettings": "标签生成设置",
  "label.testCatalog.labels.remove.action": "移除",
  "label.testCatalog.labels.remove.title": "移除标签类型",
  "label.testCatalog.labels.remove.confirm": "移除",
  "label.testCatalog.labels.remove.body": "是否从该测试的标签配置中移除“{name}”？",
  "label.testCatalog.section.reagents": "试剂",
  "label.testCatalog.section.analyzers": "分析仪列表",
  "label.testCatalog.section.alerts": "警报",
  "label.testCatalog.section.accreditation": "Accreditation",
  "label.testCatalog.accreditation.add": "Add accreditation",
  "label.testCatalog.accreditation.added": "Accreditation added",
  "label.testCatalog.accreditation.removed": "Accreditation removed",
  "label.testCatalog.accreditation.empty": "This test is not accredited by any body.",
  "label.testCatalog.accreditation.selectBody": "Choose an accrediting body",
  "label.testCatalog.accreditation.remove": "Remove accreditation",
  "label.testCatalog.accreditation.remove.body": "Remove this test from {body}? Its logo will stop appearing on reports that contain only this test.",
  "label.testCatalog.accreditation.manageLink": "Manage accrediting bodies and expiry dates",
  "label.testCatalog.accreditation.loadError": "Accreditation could not be loaded.",
  "label.testCatalog.accreditation.saveError": "The accreditation could not be added.",
  "label.testCatalog.accreditation.deleteError": "The accreditation could not be removed.",
  "label.testCatalog.section.reflex-calc": "Reflex & Calc",
  "label.testCatalog.section.localization": "本地化",
  "label.testCatalog.section.display-order": "显示顺序",
  "label.sampleType.section.basic-info": "基本信息",
  "label.sampleType.section.associated-tests": "相关检测项目",
  "label.sampleType.section.terminology": "术语",
  "label.sampleType.section.localization": "本地化",
  "label.sampleType.localization.intro": "编辑此示例类型的名称的各语言翻译。未翻译的字段将默认显示为英文。请通过“翻译管理”管理页面管理所有翻译。",
  "label.sampleType.localization.empty": "该样本类型没有可本地化的名称字段。",
  "label.sampleType.localization.loadError": "无法加载此样本类型的翻译。",
  "label.sampleType.localization.field.name": "样本类型名称",
  "label.sampleType.terminology.intro": "为确保互操作性，请将此样本类型映射到标准术语代码。",
  "label.sampleType.terminology.empty": "目前尚无术语映射。",
  "label.sampleType.terminology.saved": "术语映射已保存。",
  "label.sampleType.terminology.saveError": "无法保存术语映射。",
  "label.sampleType.terminology.saveInvalid": "某些映射无效。请检查来源、位置代码和重复项。",
  "label.sampleType.terminology.addHint": "请先保存此样本类型，然后再添加术语映射。",
  "label.sampleType.localization.addHint": "请先保存此样本类型，然后编辑其翻译。",
  "label.sampleType.name": "名称",
  "label.sampleType.section.display-order": "显示顺序",
  "label.sampleType.section.disposal": "处置",
  "label.sampleType.displayOrder": "“样本类型”菜单中的选项",
  "label.sampleType.displayOrder.intro": "将此样本类型放置在订单录入的“样本类型”菜单中。输入位置或使用方向键，然后保存——所有样本类型都会重新编号。",
  "label.sampleType.displayOrder.current": "此样本类型",
  "label.sampleType.displayOrder.loading": "正在加载样本类型...",
  "label.sampleType.displayOrder.saved": "显示顺序已更新。",
  "label.sampleType.displayOrder.saveError": "无法更新显示顺序。",
  "label.sampleType.displayOrder.addHint": "请先保存此样本类型，然后设置其菜单位置。",
  "label.sampleType.disposalInstructions": "处置说明",
  "label.sampleType.disposal.intro": "关于处置此类标本类型的自由文本参考指南。权威且规范的操作流程详见各检测项目的“存储”部分及标本处置工作流。",
  "label.sampleType.disposal.placeholder": "例如：在作为生物危害废物处置前进行高压灭菌",
  "label.sampleType.disposal.loading": "正在加载处置说明...",
  "label.sampleType.disposal.saved": "已保存处置说明。",
  "label.sampleType.disposal.saveError": "无法保存处置说明。",
  "label.sampleType.disposal.addHint": "请先保存此样本类型，然后再添加处置说明。",
  "label.sampleType.tests.manageIntro": "与该样本类型相关的检测项目。搜索目录以添加更多项目，或删除现有链接。该链接也可在“检测目录”中通过检测项目的“基本信息”进行管理。",
  "label.sampleType.tests.search": "搜索检测",
  "label.sampleType.tests.searchPlaceholder": "按检测名称搜索...",
  "label.sampleType.tests.filterBySampleType": "按样本类型筛选",
  "label.sampleType.tests.filterBySampleType.all": "任何样本类型",
  "label.sampleType.tests.pick": "添加检测",
  "label.sampleType.tests.pickPlaceholder": "选择一项检测……",
  "label.sampleType.tests.add": "添加检测",
  "label.sampleType.tests.addError": "无法将该测试与该样本类型关联。",
  "label.sampleType.tests.remove": "移除测试",
  "label.sampleType.tests.removeError": "无法取消关联该检测项目。",
  "label.sampleType.tests.loading": "正在加载相关检测项目...",
  "label.sampleType.tests.none": "此样本类型未关联任何检测项目。",
  "message.sampleType.add.success": "Sample type saved successfully.",
  "message.sampleType.edit.success": "样本类型已成功更新。",
  "error.sampleType.create.invalidName": "This name contains characters that are not allowed, such as HTML tags. Remove them and try again.",
  "error.sampleType.create.invalid": "The sample type was not created. Check the fields and try again.",
  "error.sampleType.create.duplicateName": "A sample type with this name already exists.",
  "error.sampleType.update.description.409": "Another sample type in this domain already has this description.",
  "error.sampleType.update.abbreviation.409": "Another sample type in this domain already uses this abbreviation.",
  "error.sampleType.update.abbreviation.400": "The abbreviation has at most 10 characters.",
  "error.sampleType.update.whonetCode.400": "The WHONET code has at most 5 characters.",
  "label.sampleType.loading": "正在加载样本类型...",
  "stock.status.pendingQc": "待处理QC",
  "stock.status.qcFailed": "Failed QC",
  "stock.status.quarantined": "Quarantined",
  "label.sampleType.whonetCode": "WHONET 标本位置代码",
  "helper.sampleType.whonetCode": "写入 WHONET SPECIMEN_TYPE 字段的位置代码（最多 5 个字符）。",
  "label.sampleType.whonetReturn": "返回 WHONET 预览",
  "warning.sampleType.deactivateInUse": "{count} 主动测试使用此类型；当其处于非活跃状态时，无法对其进行订购。",
  "note.sampleType.associatedTests.viewOnly": "仅查看——检测标本是其身份识别的一部分。若要对该样本类型进行检测，请在“检测目录”中创建一个标本变体。",
  "sidenav.label.admin.sampleType.backToList": "← 所有样本类型",
  "sidenav.label.admin.sampleType.editing": "编辑中",
  "sidenav.label.admin.sampleType.editingGeneric": "编辑样本类型",
  "sidenav.label.admin.sampleType.sectionsHelper": "点击某样本类型以编辑其各部分",
  "sidenav.label.admin.sampleType.addingNew": "添加新样本类型",
  "label.testCatalog.localization.locale": "区域设置",
  "label.testCatalog.localization.intro": "编辑此测试名称和报告名称的各语言翻译。未翻译的字段将默认显示为英文。请通过“翻译管理”管理页面管理所有翻译。",
  "label.testCatalog.localization.unsaved": "您有未保存的更改。请点击“保存”以应用这些更改。",
  "label.testCatalog.localization.loadError": "无法加载此检测项目的翻译。",
  "label.testCatalog.localization.empty": "此测试中没有可本地化的名称字段。",
  "label.testCatalog.localization.saved": "翻译已保存",
  "label.testCatalog.localization.saveError": "无法保存翻译。",
  "label.testCatalog.localization.field.name": "检测名称",
  "label.testCatalog.localization.field.reportingName": "报告名称",
  "label.testCatalog.localization.fallback.en": "备用语言环境 (英文)",
  "label.testCatalog.localization.fallback.tooltip": "由于未为“{locale}”配置翻译值，因此显示英文值。",
  "label.testCatalog.reflexCalc.loadError": "无法为此检测加载反射和计算交叉链接。",
  "label.testCatalog.reflexCalc.reflex.heading": "反射检测",
  "label.testCatalog.reflexCalc.reflex.helper": "根据该检测结果自动安排后续检测的规则。请在“主列表”→“Reflex 规则”中进行管理。",
  "label.testCatalog.reflexCalc.reflex.col.rule": "规则名称",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "触发条件",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "已订购的反射检测",
  "label.testCatalog.reflexCalc.reflex.empty": "未配置任何反射规则。反射规则可在“主列表”→“反射规则”中进行管理。",
  "label.testCatalog.reflexCalc.reflex.manage": "管理反射规则",
  "label.testCatalog.reflexCalc.calc.heading": "计算结果",
  "label.testCatalog.reflexCalc.calc.helper": "使用此测试结果或将此测试作为输出结果的公式。请在“主列表”→“计算结果”中进行管理。",
  "label.testCatalog.reflexCalc.calc.feedsInto": "该检测项目的结果将纳入",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "该测试的计算方法如下：",
  "label.testCatalog.reflexCalc.calc.col.name": "公式名称",
  "label.testCatalog.reflexCalc.calc.col.formula": "公式",
  "label.testCatalog.reflexCalc.calc.col.output": "输出检测",
  "label.testCatalog.reflexCalc.calc.empty": "无",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "此测试不会影响任何计算结果。计算操作在“主列表”→“计算值”中进行管理。",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "此测试结果并非根据其他测试结果计算得出。计算操作在“主列表”→“计算值”中进行管理。",
  "label.testCatalog.reflexCalc.calc.manage": "管理计算结果",
  "label.testCatalog.alerts.addRule": "添加规则",
  "label.testCatalog.alerts.empty": "未配置任何警报规则。请添加一条规则，以便在结果符合某个条件时通知收件人。",
  "label.testCatalog.alerts.loadError": "无法加载此检测项目的警报规则。",
  "label.testCatalog.alerts.saved": "警报规则已保存",
  "label.testCatalog.alerts.saveError": "无法保存警报规则。",
  "label.testCatalog.alerts.deleted": "已删除警报规则",
  "label.testCatalog.alerts.deleteError": "无法删除该警报规则。",
  "label.testCatalog.alerts.nameRequired": "规则名称为必填项。",
  "label.testCatalog.alerts.valueRequired": "“特定值”触发器需要指定一个具体值。",
  "label.testCatalog.alerts.col.name": "名称",
  "label.testCatalog.alerts.col.trigger": "触发器",
  "label.testCatalog.alerts.col.channels": "频道",
  "label.testCatalog.alerts.col.ack": "需确认",
  "label.testCatalog.alerts.col.enabled": "已启用",
  "label.testCatalog.alerts.col.actions": "操作",
  "label.testCatalog.alerts.trigger.ALL": "所有结果",
  "label.testCatalog.alerts.trigger.ABNORMAL": "异常",
  "label.testCatalog.alerts.trigger.CRITICAL": "紧急",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "具体值",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "合规违规",
  "label.testCatalog.alerts.edit.action": "编辑",
  "label.testCatalog.alerts.delete.action": "删除",
  "label.testCatalog.alerts.delete.title": "删除警报规则",
  "label.testCatalog.alerts.delete.confirm": "删除",
  "label.testCatalog.alerts.delete.body": "删除警报规则{name}？",
  "label.testCatalog.alerts.modal.addTitle": "添加提醒规则",
  "label.testCatalog.alerts.modal.editTitle": "编辑警报规则",
  "label.testCatalog.alerts.field.name": "规则名称",
  "label.testCatalog.alerts.field.trigger": "当结果为以下情况时触发警报：",
  "label.testCatalog.alerts.field.specificValue": "具体值",
  "label.testCatalog.alerts.field.channels": "通知渠道",
  "label.testCatalog.alerts.field.recipients": "收件人",
  "label.testCatalog.alerts.field.ackRequired": "要求确认",
  "label.testCatalog.alerts.channel.sms": "短信",
  "label.testCatalog.alerts.channel.email": "电子邮件",
  "label.testCatalog.alerts.recipient.physician": "开具处方的医生",
  "label.testCatalog.alerts.recipient.patient": "患者",
  "label.testCatalog.alerts.recipient.facility": "转诊设施",
  "label.testCatalog.alerts.recipient.customPhone": "定制电话",
  "label.testCatalog.alerts.recipient.customEmail": "自定义电子邮件",
  "label.testCatalog.alerts.recipient.roleId": "通知具有该角色的用户",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "选择角色",
  "label.testCatalog.reagents.col.name": "试剂名称",
  "label.testCatalog.reagents.col.usage": "使用类型",
  "label.testCatalog.reagents.col.qty": "每次检测的数量",
  "label.testCatalog.reagents.col.stock": "库存水平",
  "label.testCatalog.reagents.col.actions": "操作",
  "label.testCatalog.reagents.empty": "未关联任何试剂。请从库存中关联试剂，以便跟踪每次检测项目的消耗量。",
  "label.testCatalog.reagents.loadError": "无法装载此检测所需的试剂。",
  "label.testCatalog.reagents.linkButton": "偶联试剂",
  "label.testCatalog.reagents.linkError": "无法链接一个或多个试剂。请重试。",
  "label.testCatalog.reagents.modal.title": "链接试剂",
  "label.testCatalog.reagents.modal.linkSelected": "已选择链接",
  "label.testCatalog.reagents.modal.select.label": "试剂",
  "label.testCatalog.reagents.modal.select.placeholder": "选择要链接的试剂",
  "label.testCatalog.reagents.modal.allLinked": "所有可用的试剂均已与该检测关联。",
  "label.testCatalog.reagents.unitPlaceholder": "单位",
  "label.testCatalog.reagents.updated": "试剂已更新",
  "label.testCatalog.reagents.saveError": "无法保存更改。",
  "label.testCatalog.reagents.unsaved": "您有未保存的试剂更改。请点击“保存”以应用这些更改。",
  "label.testCatalog.reagents.retry": "重试",
  "label.testCatalog.reagents.unlink.action": "取消关联",
  "label.testCatalog.reagents.unlink.title": "解除试剂链接",
  "label.testCatalog.reagents.unlink.confirm": "取消关联",
  "label.testCatalog.reagents.unlink.body": "是否要将{name}与本次测试解除关联？与该试剂关联的现有结果不受影响。",
  "label.testCatalog.reagents.unlinked": "试剂未关联",
  "label.testCatalog.reagents.unlinkError": "无法解除试剂的关联。请重试。",
  "label.testCatalog.basicInfo.name": "名称",
  "label.testCatalog.basicInfo.name.helper": "显示名称已被翻译——请在“本地化”部分进行编辑。",
  "label.testCatalog.basicInfo.reportingName": "报告名称",
  "label.testCatalog.basicInfo.labUnit": "实验室单元",
  "label.testCatalog.basicInfo.createInactiveHint": "该测试创建时处于“非活跃”状态。请配置其各部分，然后将其激活，以便用户可以订购。",
  "sidenav.label.environmental.compliance.tooltip": "环境合规仪表板",
  "site.search.helper": "请输入至少 2 个字符以进行自动搜索。此信息用于将路由结果返回给请求站点。",
  "storage.skipped.title": "跳过了{count}个样本的存储操作",
  "test.qc.blankThreshold": "空白阈值",
  "test.qc.recoveryWindowPct": "恢复窗口 (%)",
  "test.qc.rpdThreshold": "RPD阈值（%）",
  "test.qc.thresholds.description": "环境/媒介QC评估的可选阈值。如不适用，请留空。",
  "test.qc.thresholds.heading": "QC验收标准",
  "title.testCatalog.createTest": "创建新测试",
  "label.testCatalog.testName": "检测名称",
  "label.testCatalog.testCode": "测试代码",
  "label.testCatalog.domain": "域名",
  "label.testCatalog.specimenType": "样本类型",
  "label.testCatalog.basicInfo.sampleTypes": "样本类型",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "选择本检测所涉及的所有标本。配置在这些标本之间共享。",
  "error.testCatalog.basicInfo.sampleTypeRequired": "请至少选择一种样本类型。",
  "error.testCatalog.basicInfo.sampleTypeDomain": "此样本类型的域与测试的域不匹配。",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "标本",
  "label.testCatalog.override.shared": "所有标本（共享）",
  "notice.testCatalog.intake.awaitingSpecimen": "等待标本——该检测需使用多个标本；请在采样时解决。",
  "tag.testCatalog.finding.noSampleTypeLink": "没有样本类型的链接",
  "error.testCatalog.codeExists": "已经有一个使用此位置代码的测试了。",
  "error.testCatalog.description.inUse": "已有另一个检测项目使用了此描述。描述必须是唯一的——请修改后再次保存。",
  "notification.testCatalog.testCreated": "测试“{name}”已创建。请在左侧各部分中完成其配置。",
  "label.testCatalog.basicInfo.code": "位置代码",
  "label.testCatalog.basicInfo.description": "描述",
  "label.testCatalog.basicInfo.domain": "域名",
  "label.testCatalog.basicInfo.domain.CLINICAL": "临床",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "环境",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vector",
  "label.testCatalog.basicInfo.domainModal.title": "更改测试域名？",
  "label.testCatalog.basicInfo.domainModal.body": "将此测试的域名更改为 {domain} 吗？这会影响该测试在目录中的分类方式。",
  "label.testCatalog.basicInfo.amr": "AMR监测检测",
  "label.testCatalog.basicInfo.cultureWorkflowType": "培养工作流",
  "label.testCatalog.basicInfo.cultureWorkflowType.none": "不是培养工作流",
  "label.testCatalog.basicInfo.cultureWorkflowType.BACTERIOLOGY": "细菌学",
  "label.testCatalog.basicInfo.cultureWorkflowType.MYCOBACTERIOLOGY_TB": "分枝杆菌学/TB",
  "label.testCatalog.basicInfo.cultureWorkflowType.MYCOLOGY": "真菌学",
  "label.testCatalog.basicInfo.active": "活跃",
  "label.testCatalog.basicInfo.status": "状态",
  "label.testCatalog.basicInfo.orderable": "可订购",
  "label.testCatalog.basicInfo.saved": "基本信息已保存。",
  "label.testCatalog.sampleResults.saved": "样本和结果已保存。",
  "label.testCatalog.sampleResults.empty": "目前尚无结果组件。请添加一个，以定义如何捕获此测试的结果。",
  "label.testCatalog.sampleResults.newComponent": "(新组件)",
  "label.testCatalog.sampleResults.code": "组件代码",
  "label.testCatalog.sampleResults.isPrimary": "主要成分",
  "label.testCatalog.sampleResults.showOnReport": "显示在患者报告中",
  "label.testCatalog.sampleResults.label": "组件标签",
  "label.testCatalog.sampleResults.resultType": "结果类型",
  "label.testCatalog.sampleResults.resultType.N": "数值",
  "label.testCatalog.sampleResults.resultType.none": "未选择结果类型",
  "label.testCatalog.sampleResults.preview.noType": "请在上方选择一种结果类型，以查看技术人员将如何录入该结果。",
  "label.testCatalog.sampleResults.resultType.D": "单选列表（字典）",
  "label.testCatalog.sampleResults.resultType.R": "自由文本",
  "label.testCatalog.sampleResults.resultType.M": "多选列表",
  "label.testCatalog.sampleResults.resultType.C": "级联多选",
  "label.testCatalog.sampleResults.resultType.T": "滴度",
  "label.testCatalog.sampleResults.resultType.A": "Alpha（已审核文本）",
  "label.testCatalog.sampleResults.resultType.group.primary": "常见",
  "label.testCatalog.sampleResults.resultType.group.advanced": "高级/旧版设备类型",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "高级/旧版设备类型",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "隐藏高级/旧版设备类型",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "一个带有单位的测量数值（例如 12.3 g/dL）。",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "从固定集合中选择的一个值（例如“检测到”/“未检测到”）。",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "一段打字的评论或描述。",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "列表中的一个或多个值；没有单一的参考值。",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "分组选项；可选择多个组。",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "稀释比例如1:10或1:20（在血清学中很常见）。",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "已审核的字母数字文本（代码或短代码值）。",
  "label.testCatalog.sampleResults.preview": "结果录入预览",
  "label.testCatalog.sampleResults.previewHelper": "技术员输入该结果时，看到的画面如下。",
  "label.testCatalog.sampleResults.purpose": "明确技术员在该检测中应记录的内容以及如何解释结果。",
  "label.testCatalog.sampleResults.labelRequired": "每个结果组件在保存之前都需要添加标签。",
  "label.testCatalog.sampleResults.resultTypeRequired": "在保存之前，请为“{component}”选择一种结果类型。",
  "label.testCatalog.sampleResults.mostTestsOneResult": "大多数测试只记录一个结果。只有当该测试产生多个值（例如差值）时，才应添加一个组件。",
  "label.testCatalog.sampleResults.displayOrder": "显示顺序",
  "label.testCatalog.sampleResults.uom": "测量单位",
  "label.testCatalog.sampleResults.uom.none": "(无)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ 添加新单位…",
  "label.testCatalog.sampleResults.uom.newName": "显示名称",
  "label.testCatalog.sampleResults.uom.newCode": "位置代码",
  "label.testCatalog.sampleResults.uom.newUcum": "UCUM位置代码",
  "label.testCatalog.sampleResults.uom.newDescription": "描述",
  "label.testCatalog.sampleResults.uom.saveNew": "创建单位",
  "label.testCatalog.sampleResults.significantDigits": "有效位数",
  "label.testCatalog.sampleResults.significantDigits.helper": "输入数值结果时，小数点后保留的位数。如不进行四舍五入，请留空。",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "Limit of detection (optional)",
  "admin.testCatalog.sampleResults.loq.helper": "Limit of quantification (optional)",
  "error.testCatalog.sampleResults.lodGtLoq": "LOD cannot be greater than LOQ.",
  "error.testCatalog.sampleResults.detectionLimitNegative": "Detection limits must be zero or more.",
  "admin.testCatalog.qcTargets.section.label": "QC Targets",
  "admin.testCatalog.qcTargets.intro": "The control targets Results Entry judges each QC run against. Enter them once here so technicians only enter the measured value.",
  "admin.testCatalog.qcTargets.column.level": "Control level",
  "admin.testCatalog.qcTargets.column.expected": "Expected value",
  "admin.testCatalog.qcTargets.column.uncertainty": "Uncertainty (±)",
  "admin.testCatalog.qcTargets.column.unit": "单位",
  "admin.testCatalog.qcTargets.column.overrides": "Lot overrides",
  "admin.testCatalog.qcTargets.column.status": "状态",
  "admin.testCatalog.qcTargets.column.actions": "操作",
  "admin.testCatalog.qcTargets.level.low": "低",
  "admin.testCatalog.qcTargets.level.normal": "正常",
  "admin.testCatalog.qcTargets.level.high": "高",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "Expected outcome",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "Choose the expected outcome",
  "admin.testCatalog.qcTargets.addTarget": "Add target",
  "admin.testCatalog.qcTargets.addOverride": "Add lot override",
  "admin.testCatalog.qcTargets.lot.label": "Control lot",
  "admin.testCatalog.qcTargets.lot.placeholder": "Search control lots…",
  "admin.testCatalog.qcTargets.lot.emptyLink": "No lots found — manage lots in QC Lot Management",
  "admin.testCatalog.qcTargets.overrides.none": "No lot overrides",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, one {# lot override} other {# lot overrides}}",
  "admin.testCatalog.qcTargets.empty.level": "No target configured — techs enter values at capture",
  "admin.testCatalog.qcTargets.helper.precedence": "At results entry, the control form prefills from the lot override if one exists, otherwise the level default.",
  "admin.testCatalog.qcTargets.showDeactivated": "显示已停用",
  "admin.testCatalog.qcTargets.deactivate": "停用",
  "admin.testCatalog.qcTargets.reactivate": "重新激活",
  "admin.testCatalog.qcTargets.edit": "Edit target",
  "admin.testCatalog.qcTargets.done": "打印完成",
  "admin.testCatalog.qcTargets.saved": "QC targets saved.",
  "admin.testCatalog.qcTargets.loadError": "The QC targets could not be loaded.",
  "error.testCatalog.qcTargets.uncertaintyNegative": "不确定度必须是一个非负数。",
  "error.testCatalog.qcTargets.required": "Every active target needs an expected value and an uncertainty, or an expected outcome.",
  "label.testCatalog.sampleResults.defaultResult": "默认结果",
  "label.testCatalog.sampleResults.allowMultiple": "允许多次读取",
  "label.testCatalog.sampleResults.options": "选择列表选项",
  "label.testCatalog.sampleResults.options.empty": "尚未定义任何选项。请至少添加一个选项，以便输入此结果。",
  "label.testCatalog.sampleResults.option.value": "值",
  "label.testCatalog.sampleResults.option.sortOrder": "排序顺序",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "选项会按升序排序顺序显示给技术员——数字越小，显示位置越靠前。",
  "label.testCatalog.sampleResults.option.normal": "正常",
  "label.testCatalog.sampleResults.addOption": "添加选项",
  "label.testCatalog.sampleResults.addCustomOption": "添加自定义选项",
  "label.testCatalog.sampleResults.searchDictionary": "搜索字典值……",
  "label.testCatalog.sampleResults.removeOption": "移除选项",
  "label.testCatalog.sampleResults.interpretations": "解释",
  "label.testCatalog.sampleResults.interpretations.empty": "未定义任何解释。请添加一个解释，以便为结果附加指导信息或严重程度标记。",
  "label.testCatalog.sampleResults.interp.valueMatch": "价格匹配",
  "label.testCatalog.sampleResults.interp.selectValue": "请选择一个值……",
  "label.testCatalog.sampleResults.interp.numericHint": "例如：>140、90-140、=0",
  "label.testCatalog.sampleResults.interp.text": "解释",
  "label.testCatalog.sampleResults.interp.severity": "严重程度",
  "label.testCatalog.sampleResults.addInterpretation": "添加解释",
  "label.testCatalog.sampleResults.removeInterpretation": "移除解释",
  "label.testCatalog.sampleResults.severity.NORMAL": "正常",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "异常",
  "label.testCatalog.sampleResults.severity.CRITICAL": "紧急",
  "label.testCatalog.sampleResults.actions": "操作",
  "label.testCatalog.sampleResults.addComponent": "添加组件",
  "label.testCatalog.sampleResults.removeComponent": "移除组件",
  "label.testCatalog.sampleResults.moveUp": "将组件向上移动",
  "label.testCatalog.sampleResults.moveDown": "将组件向下移动",
  "label.testCatalog.sampleResults.copyFrom": "从测试环境复制配置",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "选择一项检测……",
  "label.testCatalog.sampleResults.copyFromButton": "从检测项目中复制",
  "label.testCatalog.sampleResults.copyConfirm.title": "Replace this test's result configuration?",
  "label.testCatalog.sampleResults.copyConfirm.body": "Every result component, select-list option and interpretation of this test will be replaced with those of {source}. Nothing changes until you click Save. Once saved, the replacement cannot be undone.",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "Replace configuration",
  "label.testCatalog.sampleResults.copyStaged": "Configuration copied from {source}, not saved yet",
  "label.testCatalog.sampleResults.copyStaged.helper": "Click Save to replace this test's configuration with it, or discard it to keep the current one.",
  "label.testCatalog.sampleResults.copyDiscard": "Discard copied configuration",
  "label.testCatalog.sampleResults.copyEmpty": "{source} has no result configuration to copy.",
  "label.testCatalog.sampleResults.copyLoadError": "The configuration of {source} could not be loaded.",
  "label.testCatalog.sampleResults.copied": "配置已复制。",
  "label.testCatalog.ranges.activated": "测试已激活。",
  "label.testCatalog.ranges.ackModal.title": "存在保障缺口时仍可激活吗？",
  "label.testCatalog.ranges.ackModal.confirm": "确认并激活",
  "label.testCatalog.ranges.ackModal.warning": "该检测项目的参考范围存在覆盖缺口。",
  "label.testCatalog.ranges.ackModal.body": "以下年龄段没有参考范围——该年龄段的结果无法根据参考范围进行标记。请点击“确认”以继续操作。",
  "label.testCatalog.ranges.male": "男性",
  "label.testCatalog.ranges.female": "女性",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "天",
  "label.testCatalog.ranges.months": "几个月",
  "label.testCatalog.ranges.years": "年份",
  "label.testCatalog.ranges.noUpperLimit": "无上限",
  "label.testCatalog.ranges.noLowerLimit": "无下限",
  "label.testCatalog.ranges.both": "两者",
  "label.testCatalog.ranges.add": "添加范围",
  "label.testCatalog.ranges.empty": "尚未定义参考范围。",
  "label.testCatalog.ranges.saved": "参考范围已保存。",
  "label.testCatalog.ranges.loadError": "无法加载参考范围。",
  "label.testCatalog.ranges.col.component": "组件",
  "label.testCatalog.ranges.allComponents": "所有组件",
  "label.testCatalog.ranges.col.sex": "性别",
  "label.testCatalog.ranges.col.age": "年龄范围",
  "label.testCatalog.ranges.col.normal": "正常",
  "label.testCatalog.ranges.col.critical": "紧急",
  "label.testCatalog.ranges.col.valid": "有效",
  "label.testCatalog.ranges.col.actions": "操作",
  "label.testCatalog.ranges.anyAge": "任何年龄",
  "label.testCatalog.ranges.coverage.title": "覆盖范围验证",
  "label.testCatalog.ranges.coverage.gapsHeading": "已发现的年龄区间：",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "完全覆盖",
  "label.testCatalog.ranges.coverage.status.GAP": "有空隙",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "存在重叠",
  "label.testCatalog.ranges.coverage.status.EMPTY": "否",
  "label.testCatalog.ranges.modal.titleAdd": "添加参考范围",
  "label.testCatalog.ranges.modal.titleEdit": "编辑参考范围",
  "label.testCatalog.ranges.modal.sex": "适用范围",
  "label.testCatalog.ranges.modal.component": "结果组件",
  "label.testCatalog.ranges.modal.component.all": "所有组件",
  "label.testCatalog.ranges.modal.ageUnit": "年龄单位",
  "label.testCatalog.ranges.modal.minAge": "从……岁起",
  "label.testCatalog.ranges.modal.maxAge": "年龄（留空表示无上限）",
  "label.testCatalog.ranges.modal.lowNormal": "正常低",
  "label.testCatalog.ranges.modal.highNormal": "正常偏高",
  "label.testCatalog.ranges.modal.lowCritical": "紧急低",
  "label.testCatalog.ranges.modal.highCritical": "紧急高",
  "label.testCatalog.ranges.modal.lowValid": "有效低点",
  "label.testCatalog.ranges.modal.highValid": "有效高",
  "label.testCatalog.ranges.modal.ageError": "“到年龄”必须大于“从年龄”。",
  "label.testCatalog.ranges.modal.boundsError": "边界值必须按由内向外嵌套：有效下限 ≤ 紧急下限 ≤ 正常下限 ≤ 正常上限 ≤ 紧急上限 ≤ 有效上限。",
  "label.testCatalog.storage.saved": "样本存储已保存。",
  "label.testCatalog.storage.loadError": "无法加载示例存储设置。",
  "label.testCatalog.storage.history.view": "查看更改历史",
  "label.testCatalog.storage.history.title": "样本存储 — 变更历史",
  "label.testCatalog.storage.history.loadError": "无法加载更改历史记录。",
  "label.testCatalog.storage.history.empty": "未记录任何变更。",
  "label.testCatalog.storage.history.filter": "按字段筛选",
  "label.testCatalog.storage.history.col.changedAt": "修改于",
  "label.testCatalog.storage.history.col.changedBy": "修改者：",
  "label.testCatalog.storage.history.col.field": "字段",
  "label.testCatalog.storage.history.col.old": "旧值",
  "label.testCatalog.storage.history.col.new": "新值",
  "label.testCatalog.storage.storageHeading": "存储",
  "label.testCatalog.storage.disposalHeading": "处置",
  "label.testCatalog.storage.handlingHeading": "特殊处理",
  "label.testCatalog.storage.condition": "存储条件",
  "label.testCatalog.storage.conditionCustom": "自定义条件",
  "label.testCatalog.storage.duration": "最长存储期限",
  "label.testCatalog.storage.durationUnit": "时间单位",
  "label.testCatalog.storage.stabilityNotes": "稳定性备注",
  "label.testCatalog.storage.protectFromLight": "避光保存",
  "label.testCatalog.storage.doNotFreeze": "请勿冷冻",
  "label.testCatalog.storage.doNotRefrigerate": "请勿冷藏",
  "label.testCatalog.storage.disposalMethod": "处置方法",
  "label.testCatalog.storage.disposalTimeframe": "处置时间框架",
  "label.testCatalog.storage.disposalUnit": "时间单位",
  "label.testCatalog.storage.specialInstructions": "特别说明",
  "label.testCatalog.storage.overrideRestricted": "限制存储时长的覆盖设置",
  "label.testCatalog.storage.none": "— 无 —",
  "label.testCatalog.storage.condition.AMBIENT": "环境温度/常温",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "受控室温（20–25°C）",
  "label.testCatalog.storage.condition.COOL_ROOM": "冷藏室（8–15°C）",
  "label.testCatalog.storage.condition.COLD_ROOM": "冷藏室（2–8°C）",
  "label.testCatalog.storage.condition.REFRIGERATED": "冷藏（2-8°C）",
  "label.testCatalog.storage.condition.FROZEN": "冷冻（-20°C）",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "深冷（−70°C）",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "超低温冰箱（−80°C）",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "恒温培养箱（35–37°C）",
  "label.testCatalog.storage.disposal.INCINERATION": "焚烧",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "高压灭菌器",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "化学消毒",
  "label.testCatalog.storage.disposal.BIOHAZARD": "生物危害废物",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "锐器容器",
  "label.testCatalog.storage.disposal.SEWER": "污水/排水处置",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "退回发送方",
  "label.testCatalog.storage.disposal.ARCHIVE": "长期存档",
  "label.testCatalog.storage.disposal.STANDARD": "标准垃圾",
  "label.testCatalog.storage.unit.hours": "小时",
  "label.testCatalog.storage.unit.days": "天",
  "label.testCatalog.storage.unit.weeks": "周",
  "label.testCatalog.storage.unit.months": "几个月",
  "label.testCatalog.analyzers.infoCard": "在分析仪配置屏幕上，分析仪与该检测项目相关联。此列表为只读。",
  "label.testCatalog.analyzers.empty": "目前尚未将任何分析仪映射到此检测。",
  "label.testCatalog.analyzers.loadError": "无法为该检测项目加载分析仪列表。",
  "label.testCatalog.analyzers.col.analyzer": "分析仪",
  "label.testCatalog.analyzers.col.testName": "分析仪检测名称",
  "label.testCatalog.displayOrder.pickSampleType": "样本类型",
  "label.testCatalog.displayOrder.intro": "重新排列某样本类型中测试的显示顺序。顺序会自动保存。",
  "label.testCatalog.displayOrder.empty": "此样本类型未分配任何检测。",
  "label.testCatalog.displayOrder.loadError": "无法加载显示顺序。",
  "label.testCatalog.displayOrder.saved": "显示顺序已保存。",
  "label.testCatalog.displayOrder.moveUp": "向上移动",
  "label.testCatalog.displayOrder.moveDown": "向下移动",
  "label.testCatalog.displayOrder.col.position": "位置",
  "label.testCatalog.displayOrder.col.test": "检测",
  "label.testCatalog.displayOrder.dragHandle": "拖动以重新排序",
  "label.testCatalog.terminology.intro": "为确保互操作性，请将此检测映射到标准术语代码。",
  "vector.collectedVolume.helper": "该水体中的生物体数量，例如蚊子的数量。",
  "vector.complete.animal": "动物",
  "vector.complete.cancel": "取消",
  "vector.complete.details.collectionDate": "采集日期",
  "vector.complete.details.collectionSite": "回收点",
  "vector.complete.details.collector": "采集人",
  "vector.complete.details.lifecycleStage": "生命周期阶段",
  "vector.complete.details.tests": "检测项目",
  "vector.complete.details.title": "订单详情",
  "vector.complete.details.trapType": "陷阱类型",
  "vector.complete.labNumber": "实验室编号",
  "vector.complete.newOrder": "新矢量订单",
  "vector.complete.quantity": "数量",
  "vector.complete.quantity.value": "{count} 生物体",
  "vector.complete.status": "状态",
  "vector.complete.status.processing": "处理",
  "vector.lifecycleStage.helper": "已采样生物体的发育阶段。",
  "vector.order.collectionContext.helper": "可选——记录采集时的生态条件（生物学）。",
  "vector.order.collectionDate.heading": "采集日期",
  "vector.order.collectionDate.helper": "从田间实际采集该批次样品的日期。适用于本订单中的每个样品。",
  "vector.order.site.add.new": "+ 添加新网站“{name}”",
  "vector.order.site.add.new.restricted": "管理员已禁用添加新采样点的功能。",
  "vector.order.site.new.helper": "保存此订单后，将创建一个新的采样点。",
  "vector.order.site.new.tag": "新",
  "vector.order.site.no.match": "未找到匹配的网站。",
  "vector.pool.noTests": "未记录任何检测项目",
  "vector.pool.summary": "{count} 的图片集 {animal}",
  "vector.trapCount.helper": "已部署的陷阱数量——与“夜”的数量结合，用于计算每陷阱夜的密度。",
  "vector.trapNights.helper": "陷阱已激活并处于工作状态的晚数。若未记录监测工作量，请留空。",
  "vector.trapType.helper": "使用的采集方法或设备——请先选择样本类型。",
  "vectorDec.actionBar.assigned": "{assigned}/{total} 已分配 · {pools} 资源池",
  "vectorDec.button.back": "返回",
  "vectorDec.button.discard": "丢弃",
  "vectorDec.button.previewGrouping": "预览分组",
  "vectorDec.button.savePools": "保存泳池",
  "vectorDec.button.splitIndividuals": "拆分至个人 →",
  "vectorDec.button.splitIndividuals.tooltip": "快速设置：每组标本一个",
  "vectorDec.button.view": "查看",
  "vectorDec.col.children": "儿童标本",
  "vectorDec.col.positiveTest": "检测结果呈阳性",
  "vectorDec.col.results": "结果",
  "vectorDec.col.status": "状态",
  "vectorDec.empty": "没有去卷积任务。",
  "vectorDec.error.initiateFailed": "无法启动反卷积。",
  "vectorDec.error.loadWorklist": "无法加载反卷积工作列表。",
  "vectorDec.error.minPoolCount": "池的数量必须至少为2个。",
  "vectorDec.error.noAssignedSpecimens": "保存前，请将至少一个标本拖放到池中。",
  "vectorDec.error.noParent": "没有可用以拆分的父样本 SampleItem。",
  "vectorDec.error.poolFloorByType": "Lot 提供了{types}样本类型（{names}）——进行随机分布时，至少需要{types}个采样池。",
  "vectorDec.error.unassignedSpecimens": "{count} 标本尚未分配。请在保存前将所有标本分配完毕。",
  "vectorDec.field.howManyPools": "有多少个游泳池？",
  "vectorDec.field.notes": "备注",
  "vectorDec.field.organismsPerPool": "每个样池中的生物体数量",
  "vectorDec.field.poolCount": "池的数量",
  "vectorDec.field.strategy": "分配方法",
  "vectorDec.filter.all": "所有分析仪",
  "vectorDec.filter.status": "按状态筛选",
  "vectorDec.heading.preview": "拟议的泳池分组",
  "vectorDec.heading.split": "划分为子池",
  "vectorDec.heading.worklist": "池式去卷积",
  "vectorDec.individualMode.badge": "个人模式",
  "vectorDec.locationOverride.help": "为单个子样本池覆盖继承的采样点。当单个批次样本来自多个采样点时，请使用此选项。",
  "vectorDec.locationOverride.inherit": "继承自 lot（默认值）",
  "vectorDec.locationOverride.notes": "分装样本备注",
  "vectorDec.locationOverride.site": "回收点",
  "vectorDec.locationOverride.title": "按子分拣区收集位置（可选）",
  "vectorDec.message.success": "{count} 已创建子池（{labRange}），{orders}个测试订单已排入队列。状态 → 去卷积进行中。",
  "vectorDec.message.successIndividual": "{count} 已创建分装样本（{labRange}），{orders}项检测订单已排入队列。状态 → 去卷积处理进行中。一旦确认阳性结果，将触发VR-07子孢子确认流程。",
  "vectorDec.parent.label": "父样本",
  "vectorDec.parent.quantity": "数量：{qty}",
  "vectorDec.preview.body": "{count} 使用{strategy}对标本池进行分组。在保存前，可通过在不同标本池之间拖拽标本来调整分组。",
  "vectorDec.preview.empty": "无标本",
  "vectorDec.preview.organisms": "生物体",
  "vectorDec.preview.poolN": "{n} 组",
  "vectorDec.preview.poolWithSpecies": "Pool {n} — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, one {# specimen} other {# specimens}}",
  "vectorDec.preview.title": "建议的分组方案",
  "vectorDec.preview.unassigned": "{count, plural, =0 {All specimens assigned} one {# unassigned} other {# unassigned}}",
  "vectorDec.preview.unassignedHint": "{count} 未分配 — 这些仍保留在原始池中。",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ 反射规则将在豁免检定时触发",
  "vectorDec.reflexPreview.parentTests": "父级测试指令（{test}）——在每个子节点上重新执行",
  "vectorDec.reflexPreview.screeningPanel": "筛选小组",
  "vectorDec.reflexPreview.tipSplitIndividuals": "提示：将标本拆分为单独的标本，以便同时触发{rules}——这些规则仅适用于仅含单一生物体的标本池。",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} specimens → ~{perPool} per pool{remainder, plural, =0 {} other {, remainder +1 to first {remainder}}}",
  "vectorDec.status.complete": "去污完成",
  "vectorDec.status.confirmed": "已确认",
  "vectorDec.status.inProgress": "进行中",
  "vectorDec.status.pending": "需要审核",
  "vectorDec.strategy.manual": "手动分配——将标本拖放至组中",
  "vectorDec.strategy.manual.hint": "请自行将标本拖拽到池中",
  "vectorDec.strategy.manual.title": "手动分配",
  "vectorDec.strategy.random": "随机分配——将标本均匀分配到各混合样本中",
  "vectorDec.strategy.random.hint": "将标本均匀分配到各混合标本中",
  "vectorDec.strategy.random.title": "随机分配",
  "vectorDec.strategy.species": "由物种自动划分子组——将匹配的标本分组",
  "vectorDec.strategy.species.hint": "按物种对标本进行分组——标本上需标注物种名称",
  "vectorDec.strategy.species.title": "由物种自动划分子池",
  "vectorDec.totalOrganisms": "生物体总数",
  "vectorDec.warning.exceedsParent.body": "{total} 子池中请求的生物体各不相同，但父池的{parent}。系统仍会创建{total}个子池。",
  "vectorDec.warning.exceedsParent.title": "总数量超过父项数量",
  "vectorId.batch.selectedCount": "{count, plural, one {# specimen selected} other {# specimens selected}}",
  "vectorId.bloodMeal.add": "将面板添加到订单中",
  "vectorId.bloodMeal.added": "标本检测订单中新增了“血粉鉴定项目”。",
  "vectorId.bloodMeal.addedSub": "来源：手动（实验室技术人员接受了该建议）。依据 BR-V03-014。",
  "vectorId.bloodMeal.alreadyAttached": "已附上血粉检测报告（{skipped}检测）。",
  "vectorId.bloodMeal.body": "订购“蚊子吸血样本鉴定套餐”，以鉴定该标本所吸食的宿主物种。",
  "vectorId.bloodMeal.bulkAdd": "将面板添加到所有分析仪（{count}）",
  "vectorId.bloodMeal.bulkAddedSub": "针对{count}标本处理的血粉检测项目。",
  "vectorId.bloodMeal.bulkBody": "请在每份已选择的标本中添加“蚊子血粉鉴定面板”，以便实验室能够鉴定出蚊子吸食过哪种脊椎动物宿主的血液。",
  "vectorId.bloodMeal.bulkSummary": "血粉面板：已添加 {added}，{skipped} 已存在，{rejected} 被拒绝。",
  "vectorId.bloodMeal.bulkTitle": "检测到吸过血的女性个体（{count}标本）",
  "vectorId.bloodMeal.dismiss": "关闭",
  "vectorId.bloodMeal.error.add": "无法添加“蚊子血粉鉴定面板”。",
  "vectorId.bloodMeal.error.dismiss": "无法记录解雇情况。",
  "vectorId.bloodMeal.title": "检测到已吸血的女性",
  "vectorId.bulk.applyToCount": "适用于{count}标本",
  "vectorId.bulk.heading": "批量应用物种标识",
  "vectorId.bulk.notice.body": "分子详细信息字段（目标基因、检测方法、登记号）不会批量复制——请针对每个标本分别记录这些信息。",
  "vectorId.bulk.notice.title": "未复制标本特有的字段",
  "vectorId.button.bulkApply": "🔖 批量应用（{count}）",
  "vectorId.button.cancel": "取消",
  "vectorId.button.close": "▲ 关闭",
  "vectorId.button.confirm": "确认",
  "vectorId.button.confirmAll": "✓ 确认所有向量",
  "vectorId.button.confirmResult": "✓ 确认：{test}",
  "vectorId.button.hideResults": "隐藏结果",
  "vectorId.button.identify": "▼ 识别",
  "vectorId.button.reviewResults": "评审结果（{n}）",
  "vectorId.button.save": "保存身份信息",
  "vectorId.button.splitPool": "↗ 分割",
  "vectorId.col.collectionDate": "采集日期",
  "vectorId.col.decon": "Decon",
  "vectorId.col.decon.help": "去卷积状态——是否已录入池结果，以及子池是否正在等待审查。",
  "vectorId.col.idStatus": "ID 状态",
  "vectorId.col.lotId": "拍品编号",
  "vectorId.col.organismGroup": "组",
  "vectorId.col.progress": "进度",
  "vectorId.col.site": "样本采样点",
  "vectorId.completion.body": "{positive} 已确认的{total}子池（{pct}%）",
  "vectorId.completion.body.confirmed": "{total} 向量已确认",
  "vectorId.completion.body.partial": "已确认该样本池中的所有载体均：",
  "vectorId.completion.heading": "去卷积完成",
  "vectorId.completion.heading.confirmed": "结果已确认",
  "vectorId.completion.heading.partial": "结果部分得到确认",
  "vectorId.completion.tag": "去污完成",
  "vectorId.completion.tag.confirmed": "已确认",
  "vectorId.completion.tag.partial": "部分确认",
  "vectorId.confidence.confirmed": "已确认",
  "vectorId.confidence.presumptive": "推定",
  "vectorId.distribution.confirmed": "{count} 已确认",
  "vectorId.distribution.heading": "物种分布",
  "vectorId.distribution.notIdentified": "{count} 未识别",
  "vectorId.distribution.notYet": "尚未确定",
  "vectorId.distribution.presumptive": "{count} 推定",
  "vectorId.empty": "此队列中没有拍品。",
  "vectorId.error.accessionFormat": "GenBank 登录号格式：1–2 个字母，后跟 5–8 个数字（例如 MW123456）。",
  "vectorId.error.confidenceRequired": "这需要自信。",
  "vectorId.error.loadSpecimens": "无法加载该批次的标本。",
  "vectorId.error.loadWorklist": "无法加载工作列表。",
  "vectorId.error.methodRequired": "需要指定识别方法。",
  "vectorId.error.notesTooLong": "备注内容不得超过500个字符。",
  "vectorId.error.requiredFields": "必须提供物种、方法和置信度。",
  "vectorId.error.saveFailed": "无法保存身份信息。",
  "vectorId.error.speciesRequired": "必须填写物种。",
  "vectorId.filter.complete": "完成",
  "vectorId.filter.complete.sub": "所有标本均已鉴定完毕。",
  "vectorId.filter.decon": "反卷积",
  "vectorId.filter.decon.sub": "已录入分组赛结果，正在等待技术员决定是拆分还是确认。",
  "vectorId.filter.label": "状态",
  "vectorId.filter.notstarted": "待处理的订单",
  "vectorId.filter.notstarted.sub": "已接收，0份标本已鉴定。",
  "vectorId.filter.partialid": "部分ID",
  "vectorId.filter.partialid.sub": "身份识别正在进行中。",
  "vectorId.filter.pending": "待处理",
  "vectorId.filter.pending.sub": "所有未完成的批次，包括结果尚待技术员审查的批次。",
  "vectorId.form.assayName": "检测名称",
  "vectorId.form.assayName.placeholder": "多重PCR",
  "vectorId.form.confidence": "自信",
  "vectorId.form.genbankAccession": "GenBank 登记号",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "生命周期阶段",
  "vectorId.form.linkedResult": "病原体检测结果链接",
  "vectorId.form.linkedResultPlaceholder": "请选择该地块上的一个结果……",
  "vectorId.form.method": "方法",
  "vectorId.form.molecularDetails": "🔬 分子细节",
  "vectorId.form.notes": "备注",
  "vectorId.form.physState": "生理状态",
  "vectorId.form.select": "选择…",
  "vectorId.form.species": "物种",
  "vectorId.form.speciesPlaceholder": "搜索属或种……",
  "vectorId.form.targetGene": "靶基因",
  "vectorId.form.targetGene.placeholder": "COI、ITS2、28S rDNA",
  "vectorId.heading.worklist": "向量识别工作列表",
  "vectorId.loading": "正在加载……",
  "vectorId.message.bulkSuccess": "对{count}标本进行的鉴定。",
  "vectorId.message.saveSuccess": "身份信息已保存。",
  "vectorId.method.both": "形态学 + 分子学",
  "vectorId.method.molecular": "分子",
  "vectorId.method.morphological": "形态学",
  "vectorId.notif.confirmAll.error": "无法确认结果。请重试。",
  "vectorId.notif.confirmAll.success": "该混合样本中所有载体的检测结果均已确认。",
  "vectorId.notif.deconNeeded.body": "该样本池已录入结果。请将其拆分为子样本池以进行进一步测试，或确认该结果适用于所有载体制剂。",
  "vectorId.notif.deconNeeded.bodyWithTest": "其中一项检测项目已得出结果。可将其分为若干子样本池进行进一步检测，或确认该结果是否适用于所有向量。",
  "vectorId.notif.deconNeeded.title": "小组赛结果等待审查",
  "vectorId.physState.blood_fed": "吸过血的",
  "vectorId.physState.gravid": "Gravid",
  "vectorId.physState.half_gravid": "半孕期",
  "vectorId.physState.unfed": "未喂食",
  "vectorId.physState.unknown": "未知 / 未评估",
  "vectorId.resplit.heading": "Split：{label}",
  "vectorId.search.placeholder": "搜索房源……",
  "vectorId.specimen.col.confidence": "自信",
  "vectorId.specimen.col.idStatus": "ID 状态",
  "vectorId.specimen.col.label": "标本",
  "vectorId.specimen.col.labNo": "实验室编号",
  "vectorId.specimen.col.poolOrSpecimen": "数据池 / 标本",
  "vectorId.specimen.col.species": "物种",
  "vectorId.specimen.confirmed": "已确认",
  "vectorId.specimen.count": "标本",
  "vectorId.specimen.empty": "本批次无标本。",
  "vectorId.specimen.label": "标本编号：{n}",
  "vectorId.specimen.notIdentified": "未识别",
  "vectorId.specimen.presumptive": "推定",
  "vectorId.status.complete": "完成",
  "vectorId.status.inProgress": "进行中",
  "vectorId.status.notStarted": "待处理的订单",
  "vectorId.tag.deconComplete": "完成",
  "vectorId.tag.deconInProgress": "正在进行去污作业",
  "vectorId.tag.deconNeeded": "⚠ 审核结果",
  "vectorId.tag.subPoolPending": "{count} 包含结果的子池",
  "vectorId.tree.organisms": "{count, plural, one {# organism} other {# organisms}}",
  "vectorReport.density.bySite": "由地点和时期划分的密度",
  "vectorReport.density.effortNotRecorded": "未记录的努力",
  "vectorReport.density.period": "时期",
  "vectorReport.density.perTrapNight": "密度（每陷阱夜）",
  "vectorReport.density.pools": "游泳池",
  "vectorReport.density.site": "网站",
  "vectorReport.density.specimens": "标本",
  "vectorReport.density.title": "各站点标本数量统计",
  "vectorReport.density.trapNights": "Trap之夜",
  "vectorReport.description": "根据记录的媒介采集数据、物种鉴定结果和病原体检测结果计算得出的监测指标",
  "vectorReport.empty": "已选择范围内无数据。",
  "vectorReport.exportPdf": "导出PDF",
  "vectorReport.fieldMap.description": "对“手动录入助手”中显示的指标进行重新排序、隐藏、重新标记或添加门户标签。",
  "vectorReport.fieldMap.hidden": "隐藏",
  "vectorReport.fieldMap.label": "标签",
  "vectorReport.fieldMap.metric": "公制指标",
  "vectorReport.fieldMap.order": "接收样本",
  "vectorReport.fieldMap.portalTag": "门户标签",
  "vectorReport.fieldMap.title": "手动输入字段映射",
  "vectorReport.fieldMap.visibility": "可见性",
  "vectorReport.fieldMap.visible": "可见",
  "vectorReport.fieldMap.visibleLabel": "在“手动输入助手”中可见",
  "vectorReport.filter.allSites": "所有站点",
  "vectorReport.filter.apply": "应用",
  "vectorReport.filter.dateRange": "日期范围",
  "vectorReport.filter.from": "来源",
  "vectorReport.filter.site": "采样点",
  "vectorReport.filter.to": "到",
  "vectorReport.freshness": "数据时效性",
  "vectorReport.freshness.as": "截至 {time} 的数据",
  "vectorReport.freshness.unknown": "未知",
  "vectorReport.generated": "生成时间",
  "vectorReport.home": "首页",
  "vectorReport.loadError": "无法加载监控指标。请重试。",
  "vectorReport.manualEntry.confirmBody": "是否要记录本周数据的审计快照（{periodStart} – {periodEnd}）？重新提交一周的数据将被记录为一条独立的条目。",
  "vectorReport.manualEntry.confirmSubmit": "确认",
  "vectorReport.manualEntry.copied": "已复制到剪贴板",
  "vectorReport.manualEntry.copy": "复制值",
  "vectorReport.manualEntry.empty": "此期间未配置任何指标",
  "vectorReport.manualEntry.loading": "正在加载每周的数据……",
  "vectorReport.manualEntry.lowConfidence": "置信度降低（池去卷积值低于95%）",
  "vectorReport.manualEntry.markSubmitted": "标记为“已提交”",
  "vectorReport.manualEntry.submitError": "无法记录提交",
  "vectorReport.manualEntry.submitted": "已标记为“已提交”的一周",
  "vectorReport.manualEntry.title": "手动录入助手",
  "vectorReport.manualEntry.week": "报告周",
  "vectorReport.mir.classic": "MIR（经典版）",
  "vectorReport.mir.observed": "感染率（观察值）",
  "vectorReport.mir.pathogen": "病原体",
  "vectorReport.mir.positivePools": "阳性混合样本",
  "vectorReport.mir.resolution": "积极解决",
  "vectorReport.mir.species": "物种",
  "vectorReport.mir.sporozoite": "子孢子率",
  "vectorReport.mir.sporozoiteNote": "当池去卷积分辨率低于95%时，置信度会降低。",
  "vectorReport.mir.title": "各物种的最低感染率",
  "vectorReport.mir.totalSpecimens": "标本总数",
  "vectorReport.mir.withheld": "暂不公布",
  "vectorReport.positivity.notConfigured": "此部署未配置阳性分类，因此无法提供感染率、阳性率和孢子虫数量数据。请在检测目录中配置结果显著性以启用这些功能。",
  "vectorReport.positivity.pathogen": "病原体",
  "vectorReport.positivity.pct": "积极态度",
  "vectorReport.positivity.poolsPositive": "泳池检测结果呈阳性",
  "vectorReport.positivity.poolsTested": "已检测的泳池",
  "vectorReport.positivity.title": "病原体阳性率",
  "vectorReport.positivity.unrecognized": "某些结果的显著性值不属于公认的分类（阳性、阴性或未确定），因此未计入阳性结果总数。请查阅检测目录，以便将这些结果计入统计。",
  "vectorReport.prompt": "选择日期范围和站点，然后点击“应用”以查看监测指数。",
  "vectorReport.qc.detail": "{passed} {total}分析通过了",
  "vectorReport.qc.passed": "分析通过",
  "vectorReport.qc.passRate": "通过率",
  "vectorReport.qc.title": "QC合格率",
  "vectorReport.qc.total": "分析总计",
  "vectorReport.species.genus": "属",
  "vectorReport.species.pct": "分享",
  "vectorReport.species.species": "物种",
  "vectorReport.species.specimens": "标本",
  "vectorReport.species.title": "物种分布",
  "vectorReport.sporozoite.title": "子孢子率（按蚊）",
  "vectorReport.title": "病媒监测",
  "vfs.abj": "ABJ（无幼虫率）",
  "vfs.abj.target.below": "✗ ABJ 低于卫生部设定的 95% 目标",
  "vfs.abj.target.met": "✓ ABJ 达到了卫生部设定的 95% 的目标",
  "vfs.bi": "布雷托指数（每100户）",
  "vfs.ci": "集装箱指数（CI）",
  "vfs.containersExamined": "已检查的集装箱",
  "vfs.containersPositive": "集装箱呈阳性",
  "vfs.err.containersExceeded": "不能超过已检查的集装箱数量。",
  "vfs.err.examinedMin": "输入幼虫数据时，该值必须≥1。",
  "vfs.err.housesExceeded": "不得超过已检查的房屋数量。",
  "vfs.err.negative": "不能为负数。",
  "vfs.err.populationMin": "输入蛹的数据时，该值必须≥1。",
  "vfs.hi": "房屋指数（HI）",
  "vfs.housesExamined": "已检查的房屋",
  "vfs.housesPositive": "房屋呈阳性",
  "vfs.indices.title": "计算指标（预览）",
  "vfs.larval.title": "幼虫调查——模式C",
  "vfs.populationAtRisk": "高危人群",
  "vfs.ppi": "每人蛹数（PPI）",
  "vfs.pupaeCount": "蛹的数量",
  "vfs.pupal.title": "蛹调查——D模式",
  "vfs.surveyMethod": "调查方法",
  "vfs.surveyMethod.placeholder": "选择一个选项",
  "warning.testCatalog.noLoinc": "该检测项目没有 LOINC 代码。无法将分析仪和电子订单的结果导入到该检测项目中。",
  "warning.testCatalog.duplicateLoinc": "{testName} 也使用了 LOINC 代码 {code}。针对该代码接收到的检测结果仅会被路由到一项检测（首次匹配）——这可能导致结果被发送至错误的检测项目。",
  "label.testCatalog.terminology.col.source": "来源",
  "label.testCatalog.terminology.col.code": "位置代码",
  "label.testCatalog.terminology.col.displayName": "显示名称",
  "label.testCatalog.terminology.displayName.placeholder": "例如：血清或血浆中的葡萄糖[质量/体积]",
  "label.testCatalog.terminology.col.relationship": "关系",
  "label.testCatalog.terminology.col.appliesTo": "适用范围",
  "label.testCatalog.terminology.appliesTo.test": "完整检测",
  "label.testCatalog.terminology.col.actions": "操作",
  "label.testCatalog.terminology.source": "术语来源",
  "label.testCatalog.terminology.code": "位置代码",
  "label.testCatalog.terminology.relationship": "关系",
  "label.testCatalog.terminology.addMapping": "添加映射",
  "label.testCatalog.terminology.remove": "移除映射",
  "label.testCatalog.terminology.empty": "目前尚无术语映射。",
  "label.testCatalog.terminology.loadError": "无法加载术语映射。",
  "label.testCatalog.terminology.saved": "术语映射已保存。",
  "error.testCatalog.terminology.duplicate": "{source} 代码 {code} 是重复项——该测试已存在此映射。",
  "error.testCatalog.terminology.invalid": "无法保存映射——请检查是否存在重复代码、未知来源或无效关系。",
  "label.testCatalog.terminology.rel.none": "— 无 —",
  "label.testCatalog.terminology.rel.SAME_AS": "与……相同",
  "label.testCatalog.terminology.rel.BROADER_THAN": "比……更广泛",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "比……窄",
  "label.testCatalog.panels.intro": "管理该测试所属的面板，以及它在每个面板中的位置。",
  "label.testCatalog.panels.addToPanel": "添加到面板",
  "label.testCatalog.panels.col.panel": "面板",
  "label.testCatalog.panels.col.position": "位置",
  "label.testCatalog.panels.col.actions": "操作",
  "label.testCatalog.panels.position": "位置",
  "label.testCatalog.panels.remove": "从面板中移除",
  "label.testCatalog.panels.remove.confirm.heading": "从面板上移除检测项目吗？",
  "label.testCatalog.panels.remove.confirm.body": "该测试将从“{panel}”中移除。它仍会保留在目录及其他面板中。您可以稍后重新添加它。",
  "label.testCatalog.panels.moveUp": "提前行动",
  "label.testCatalog.panels.moveDown": "稍后再移动",
  "label.testCatalog.panels.viewOrder": "查看该面板的测试顺序",
  "label.testCatalog.panels.orderContext": "本检查项目中的检测项目（按顺序）：",
  "label.testCatalog.panels.empty": "该检测项目目前尚未纳入任何检测项目组合。",
  "label.testCatalog.panels.loadError": "无法加载委员会成员信息。",
  "label.testCatalog.panels.saved": "已保存小组成员信息。",
  "label.testCatalog.panels.createPanel": "创建新面板",
  "label.testCatalog.panels.createPanelHint": "输入名称以创建一个面板，并将此测试添加到该面板中。其样本类型、排序模块及其他设置将在后续的“面板编辑器”中进行配置。",
  "notification.testCatalog.panels.created": "已创建“{name}”面板，并添加了此测试。请在“检测面板”中进一步配置该面板。",
  "label.search": "搜索",
  "label.testCatalog.list": "检测目录",
  "label.testCatalog.list.search": "按检测名称搜索",
  "label.testCatalog.list.col.status": "状态",
  "label.testCatalog.list.filter.allDomains": "所有域名",
  "label.testCatalog.list.filter.allStatus": "所有状态",
  "label.testCatalog.list.filter.inactive": "非活跃",
  "label.testCatalog.list.coverageIncomplete": "报道不完整",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "任何",
  "label.testCatalog.list.filter.amrOnly": "仅限AMR",
  "label.testCatalog.list.filter.nonAmr": "非AMR",
  "label.testCatalog.list.filter.sampleType": "样本类型",
  "label.testCatalog.list.filter.allSampleTypes": "所有样本类型",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "否 LOINC",
  "label.testCatalog.list.filter.issuesOnly": "仅显示存在问题的检测项目",
  "label.testCatalog.list.health.banner": "{count} 检测存在配置问题（{errors} 错误 · {warnings} 警告）",
  "label.testCatalog.list.health.show": "显示",
  "label.testCatalog.activation.incomplete.heading": "测试目前还无法激活",
  "label.testCatalog.activation.incomplete.body": "在激活此测试之前，请先解决以下问题：",
  "label.testCatalog.list.col.sampleType": "样本类型",
  "button.testCatalog.newTest": "新检测项目",
  "button.testCatalog.editRelated": "将相关的检测项目集中编辑",
  "button.testCatalog.editRelatedFromEditor": "编辑相关检测项目……",
  "label.testCatalog.editor.noRelated": "没有其他检测项目与该检测名称相同。",
  "label.testCatalog.editor.createSaveFirst.title": "请先保存检测项目",
  "label.testCatalog.editor.createSaveFirst": "填写基本信息并保存。创建测试后，该部分即可使用。",
  "label.testCatalog.editingNTests": "编辑{count}测试",
  "label.testCatalog.perTestIdentity": "身份信息与 LOINC（每项检测项目）",
  "state.testCatalog.differsAcrossTests": "各检测项目结果有所不同",
  "button.testCatalog.setAllTo": "将所有值都设置为这些值",
  "label.testCatalog.group.rangesSaved": "参考范围已保存至{count}检测项目中。",
  "label.testCatalog.group.storageIntro": "只需编辑一次“存储与处理”设置；保存后，该设置将应用到所有已选择的检测。",
  "button.testCatalog.removeFromSet": "从该集合中移除",
  "label.testCatalog.group.rangesIntro": "只需编辑一次参考范围；保存后，该参考范围将应用于所有已选择的检测项目。标识符和LOINC将保留在每个检测项目中。",
  "label.testCatalog.group.rangesDiffer": "已选检测项目的电流范围并不相同。保存后，所有检测项目的电流范围都将设置为以下值。",
  "label.testCatalog.ranges.table.sex": "适用范围",
  "label.testCatalog.ranges.table.age": "年龄范围",
  "label.testCatalog.ranges.table.normal": "正常（低/高）",
  "label.testCatalog.list.filters": "过滤器",
  "label.testCatalog.list.filters.count": "过滤器（{count}）",
  "label.testCatalog.list.error": "无法加载检测目录。请调整过滤器或重新加载页面后重试。",
  "label.testCatalog.list.empty": "没有检测项目符合当前的筛选条件。",
  "sidenav.label.admin.testmgt.ManageMethod": "管理方法",
  "sidenav.label.admin.testmgt.reflex": "反射检测管理",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "查看检测目录",
  "sidenav.label.admin.usermgt": "用户管理",
  "sideNav.label.arvfollowup1": "ARV随访版本1",
  "sideNav.label.arvfollowup2": "ARV随访版本2",
  "sideNav.label.arvreports1": "ARV初始版本1",
  "sideNav.label.arvreports2": "ARV初始版本2",
  "sideNav.label.arvversion1": "ARV版本1",
  "sideNav.label.associatedpatientreport": "关联患者报告",
  "sideNav.label.audittrail": "审计跟踪",
  "sidenav.label.barcode": "条码",
  "sidenav.label.batchorder": "批量订单录入",
  "sideNav.label.bypaneltype": "按面板类型",
  "sideNav.label.bytesttype": "按检测类型",
  "sideNav.label.byunit": "按单元",
  "sideNav.label.collectedarvpatientreports": "已采集的ARV患者报告",
  "sidenav.label.cytology": "细胞学",
  "sidenav.label.cytology.dashboard": "仪表板",
  "sideNav.label.delayedvalidation": "延迟验证",
  "sidenav.label.editorder": "编辑订单",
  "sideNav.label.eidreports1": "EID版本1",
  "sideNav.label.eidreports2": "EID版本2",
  "sideNav.label.exportcsvfile": "导出常规CSV文件",
  "sideNav.label.followuprequired": "需要随访",
  "sideNav.label.generalreport": "通用报告",
  "sideNav.label.hivtestsummary": "HIV检测摘要",
  "sidenav.label.immunochem": "免疫组织化学",
  "sidenav.label.immunochem.dashboard": "仪表板",
  "sidenav.label.incomingorder": "电子订单",
  "sideNav.label.intermediatebyservice": "按服务的中间报告",
  "sideNav.label.intermediatereport1": "中间报告版本1",
  "sideNav.label.intermediatereport2": "中间报告版本2",
  "sidenav.label.inventory": "库存",
  "sidenav.label.inventory.management": "库存管理",
  "sidenav.label.inventory.management.tooltip": "管理库存物品、批次和库存水平",
  "sidenav.label.inventory.tooltip": "试剂、试剂盒和用品的库存管理",
  "sideNav.label.laporanHasil": "合规报告",
  "sideNav.label.noncomformitynotification": "不符合通知",
  "sideNav.label.noncomformityreportsbydate": "按日期",
  "sideNav.label.noncomformityreportsbylabno": "按实验室编号",
  "sideNav.label.noncomformityreportsbyunit": "按单元和原因",
  "sidenav.label.notebook": "笔记本",
  "sidenav.label.add.order": "添加订单",
  "sidenav.label.clinical.order": "添加临床医嘱",
  "sidenav.label.environmental.compliance": "合规仪表板",
  "sidenav.label.environmental.order": "添加环境订单",
  "sidenav.label.vector.order": "添加向量顺序",
  "sidenav.label.order": "订单",
  "sidenav.label.order.collect": "采集样本",
  "sidenav.label.order.dashboard": "仪表板",
  "sidenav.label.order.enter": "录入订单",
  "sidenav.label.order.label": "贴标签与存放",
  "sidenav.label.order.qa": "质量保证审核",
  "sidenav.label.pathology": "病理学",
  "sidenav.label.pathology.dashboard": "仪表板",
  "sideNav.label.referredtestreport": "已转诊检测报告",
  "sideNav.label.rejectionreport": "拒绝报告",
  "sidenav.label.reports": "报告",
  "sidenav.label.reports.routine": "常规",
  "sidenav.label.reports.study": "研究",
  "sidenav.label.results": "结果",
  "sidenav.label.results.byrange": "按实验室编号范围",
  "sidenav.label.results.order": "按订单",
  "sidenav.label.results.patient": "按患者",
  "sidenav.label.results.testdate": "按检测日期",
  "sidenav.label.results.unit": "按单元",
  "sideNav.label.sectionperformance": "部分性能",
  "sideNav.label.specialrequest": "特殊请求 ",
  "sidenav.label.statisticsreport": "统计报告",
  "sidenav.label.statusreport": "患者状态报告",
  "sidenav.label.storage.coldstorage": "冷藏存储监控",
  "sidenav.label.storage.coldstorage.tooltip": "监控冰箱和冷藏库的温度和湿度",
  "sidenav.label.storage.management": "存储管理",
  "sidenav.label.storage.management.tooltip": "管理存储位置和设备",
  "sidenav.label.testsummary": "所有检测摘要",
  "sidenav.label.validation": "验证",
  "sidenav.label.validation.order": "按订单搜索",
  "sidenav.label.validation.routine": "常规",
  "sidenav.label.validation.study": "研究",
  "sidenav.label.validation.testdate": "按检测日期搜索",
  "sideNav.label.viralloaddataexport": "病毒载量数据导出",
  "sideNav.label.vlversionnational": "VL国家版本",
  "sidenav.label.workplan": "工作计划",
  "sidenav.label.workplan.panel": "按面板类型",
  "sidenav.label.workplan.priority": "按优先级",
  "sidenav.label.workplan.test": "按检测类型",
  "sidenav.label.workplan.unit": "按单元",
  "sideNav.title.activityreport": "活动报告",
  "sidenav.title.aggregatereport": "汇总报告",
  "sideNav.title.arvreports": "ARV报告",
  "sideNav.title.associatedpatientreport": "关联患者报告",
  "sideNav.title.audittrail": "审计 Trail",
  "sideNav.title.collectedarvpatientreports": "已采集的ARV患者报告",
  "sideNav.title.delayedvalidation": "延迟验证",
  "sideNav.title.eidreports": "EID报告",
  "sideNav.title.environmentalReports": "环境报告",
  "sideNav.title.exportbydate": "按日期导出",
  "sideNav.title.exportcsvfile": "导出常规CSV文件",
  "sideNav.title.indicator": "指标",
  "sideNav.title.intermediatereport": "中间报告",
  "sideNav.title.noncomformityreports": "不符合报告",
  "sideNav.title.referredtestreport": "已转诊检测报告",
  "sideNav.title.rejectionreport": "拒绝报告",
  "sideNav.title.specialrequest": "特殊请求 ",
  "sideNav.title.tatreport": "周转时间",
  "sideNav.title.vectorIdentification": "向量识别",
  "sideNav.title.vlreport": "病毒载量报告",
  "sideNav.label.audittrail.orderEvents": "事件排序",
  "sideNav.label.audittrail.systemEvents": "系统事件",
  "sidenav.label.addorder": "添加订单",
  "sidenav.label.admin.sampleTypeManagement": "样本类型编辑器",
  "sideNav.label.qa": "Quality Assurance",
  "sideNav.label.qa.overview": "QA Overview",
  "sideNav.label.qa.qc": "Statistical QC",
  "sideNav.label.qa.qc.dashboard": "QC仪表板",
  "sideNav.label.qa.qc.alerts": "QC警报",
  "sideNav.label.qa.qc.controlLots": "QC Lot Management",
  "sideNav.label.qa.qc.ruleConfig": "规则配置",
  "sideNav.label.qa.qc.reagentQc": "Reagent QC",
  "sideNav.label.qa.qc.manualQc": "Analyzer Manual QC",
  "sideNav.label.qa.qi": "Quality Indicators",
  "sideNav.label.qa.qi.dashboard": "QI Dashboard",
  "sideNav.label.qa.qi.config": "QI Configuration",
  "qa.qiConfig.subtitle": "Set per-indicator target and action thresholds, enable or disable indicators, and override thresholds for specific test sections.",
  "qa.qiConfig.column.overrides": "Overrides",
  "qa.qiConfig.field.enabled": "Track this indicator",
  "qa.qiConfig.field.target": "Target",
  "qa.qiConfig.field.action": "Action threshold",
  "qa.qiConfig.field.category": "Test section",
  "qa.qiConfig.editor.title": "Edit {indicator}",
  "qa.qiConfig.editor.defaults": "Default thresholds",
  "qa.qiConfig.editor.overrides": "Per-section overrides",
  "qa.qiConfig.editor.usesDefault": "Test sections without an override use the indicator default.",
  "qa.qiConfig.editor.noOverrides": "No overrides — every test section uses the default.",
  "qa.qiConfig.editor.addOverride": "Add section override",
  "qa.qiConfig.editor.autoNce": "When the month-to-date value breaches the action threshold, a non-conforming event is created automatically (one per indicator per month).",
  "qa.qiConfig.indicator.tat": "Average Turnaround Time",
  "qa.qiConfig.indicator.rejection": "Rejection Rate",
  "qa.qiConfig.indicator.amendment": "Amendment Rate",
  "qa.qiConfig.indicator.nce": "NCE Pulse",
  "qa.qiConfig.indicator.callback": "Critical Callback Compliance",
  "qa.qiConfig.validation.required": "Both target and action thresholds are required.",
  "qa.qiConfig.validation.range": "Thresholds must be between 0 and 100.",
  "qa.qiConfig.validation.direction": "Target and action threshold are in the wrong order for this indicator.",
  "qa.qiConfig.validation.category": "Choose a test section for each override.",
  "qa.qiConfig.validation.duplicateCategory": "A test section can only be overridden once.",
  "qa.qiConfig.confirmDisableTitle": "Disable this indicator?",
  "qa.qiConfig.confirmDisableBody": "This will hide the dashboard tile, suppress new alerts, and stop auto-generated NCEs for this indicator. Historical data is preserved. Continue?",
  "qa.qiConfig.saveFailed": "Could not save QI configuration.",
  "sideNav.label.qa.qms": "QMS & Improvement",
  "sideNav.label.qa.qms.esigLog": "Electronic Signature Log",
  "sideNav.label.qa.qms.capaRegister": "CAPA Register",
  "sideNav.label.qa.qms.accreditation": "Accreditation",
  "qa.qms.capaRegister.subtitle": "Every corrective and preventive action across all non-conforming events, with due dates and status.",
  "qa.qms.capaRegister.tile.dueThisWeek": "Due This Week",
  "qa.qms.capaRegister.tile.completed": "Completed (90d)",
  "qa.qms.capaRegister.filter.assignee": "Assignee",
  "qa.qms.capaRegister.filter.from": "Due Date (From)",
  "qa.qms.capaRegister.filter.to": "Due Date (To)",
  "qa.qms.capaRegister.column.correctiveAction": "Corrective / Preventive Action",
  "qa.qms.capaRegister.column.assignee": "Person Responsible",
  "qa.qms.capaRegister.status.open": "待处理",
  "qa.qms.capaRegister.status.overdue": "已逾期",
  "qa.qms.capaRegister.status.completed": "已完成",
  "qa.qms.capaRegister.error": "The CAPA register could not be loaded.",
  "qa.qms.accreditation.title": "Test Accreditation",
  "qa.qms.accreditation.subtitle": "Accrediting bodies and per-test enrollment. Drives the accreditation logos on patient reports and the inspector-readiness answer.",
  "qa.qms.accreditation.error": "Accreditation data could not be loaded.",
  "qa.qms.accreditation.actionError": "The change could not be saved.",
  "qa.qms.accreditation.tile.total": "Bodies",
  "qa.qms.accreditation.inForce": "In force: {names}",
  "qa.qms.accreditation.bodies.title": "Accrediting Bodies",
  "qa.qms.accreditation.bodies.add": "Add body",
  "qa.qms.accreditation.body.column.logo": "Logo",
  "qa.qms.accreditation.body.column.expiresOn": "Expires",
  "qa.qms.accreditation.status.ACTIVE": "活跃",
  "qa.qms.accreditation.status.EXPIRING": "Expiring soon",
  "qa.qms.accreditation.status.EXPIRED": "已过期",
  "qa.qms.accreditation.status.INACTIVE": "非活跃",
  "qa.qms.accreditation.body.modal.addTitle": "Add Accrediting Body",
  "qa.qms.accreditation.body.modal.editTitle": "Edit Accrediting Body",
  "qa.qms.accreditation.body.edit": "Edit body",
  "qa.qms.accreditation.body.delete": "Delete body",
  "qa.qms.accreditation.body.field.codeHelper": "2–16 characters: capitals, digits and hyphens. Cannot be changed later.",
  "qa.qms.accreditation.body.field.expiresOn": "Accreditation expires",
  "qa.qms.accreditation.body.field.visibilityMode": "Show the logo on a report when",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "Any accredited test is on the report",
  "qa.qms.accreditation.visibility.PERCENTAGE": "A percentage of the report's tests are accredited",
  "qa.qms.accreditation.body.field.thresholdPct": "Threshold (%)",
  "qa.qms.accreditation.body.field.logo": "Logo (PNG or JPEG, at least 64×64 pixels, up to 500 KB)",
  "qa.qms.accreditation.body.logo.remove": "Remove logo",
  "qa.qms.accreditation.body.required": "Code, name and expiry date are required.",
  "qa.qms.accreditation.body.saveError": "The accrediting body could not be saved.",
  "qa.qms.accreditation.body.logoError": "The logo could not be uploaded. Use a PNG or JPEG of at least 64×64 pixels and no more than 500 KB.",
  "qa.qms.accreditation.body.delete.title": "Delete Accrediting Body",
  "qa.qms.accreditation.body.delete.body": "Delete {name}? This cannot be undone.",
  "qa.qms.accreditation.body.delete.blocked": "Cannot delete — {count} test accreditations reference this body. Remove them first.",
  "qa.qms.accreditation.enrollments.title": "Enrolled Tests",
  "qa.qms.accreditation.enrollments.add": "Enroll tests",
  "qa.qms.accreditation.enrollment.column.body": "Accrediting Body",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "Effective From",
  "qa.qms.accreditation.enrollment.column.expires": "Body Expires",
  "qa.qms.accreditation.enrollment.remove": "Remove enrollment",
  "qa.qms.accreditation.eqa.title": "EQA Coverage of Accredited Scope",
  "qa.qms.accreditation.eqa.subtitle": "ISO 15189 §7.7 asks whether every test you claim as accredited takes part in external quality assessment. This compares accredited scope against active EQA enrollments.",
  "qa.qms.accreditation.eqa.column.scope": "Tests in Scope",
  "qa.qms.accreditation.eqa.column.covered": "Covered by EQA",
  "qa.qms.accreditation.eqa.column.gaps": "Gaps",
  "qa.qms.accreditation.eqa.noGaps": "Full coverage",
  "qa.qms.accreditation.eqa.gapsMore": "{names} and {count} more",
  "qa.qms.accreditation.eqa.error": "EQA coverage could not be loaded.",
  "qa.qms.accreditation.filter.body": "Accrediting body",
  "qa.qms.accreditation.filter.test": "Test: {name}",
  "qa.qms.accreditation.enroll.modal.title": "Enroll Tests",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "Effective from (optional)",
  "qa.qms.accreditation.enroll.required": "Select an accrediting body and at least one test.",
  "qa.qms.accreditation.enroll.failed": "The enrollment was rejected.",
  "qa.qms.accreditation.enrollment.delete.title": "Remove Enrollment",
  "qa.qms.accreditation.enrollment.delete.body": "Remove {test} from {body}?",
  "qa.qms.esigLog.subtitle": "Every electronic signature recorded in the system — who signed what, when, and why.",
  "qa.qms.esigLog.column.signer": "Signer",
  "qa.qms.esigLog.column.subject": "主题",
  "qa.qms.esigLog.filter.subjectType": "Subject Type",
  "qa.qms.esigLog.filter.apply": "Apply Filters",
  "qa.qms.esigLog.export.confirm.title": "Export without filters?",
  "qa.qms.esigLog.export.confirm.body": "No filters are applied, so this exports every signature in the selected date range (up to 10,000 rows).",
  "qa.qms.esigLog.meaning.AUTHORED": "作者",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "Validated & Released",
  "qa.qms.esigLog.meaning.REJECTED": "已拒收",
  "qa.qms.esigLog.error": "Unable to load the signature log. Please try again.",
  "qa.qi.dashboard.subtitle": "Five quality indicators including the optional Critical Callback Compliance opt-in.",
  "qa.qi.dashboard.window.label": "Reporting window",
  "qa.qi.dashboard.window.7d": "Rolling 7 days",
  "qa.qi.dashboard.window.30d": "Rolling 30 days",
  "qa.qi.dashboard.window.90d": "Rolling 90 days",
  "qa.qi.dashboard.window.ytd": "Year to date",
  "qa.qi.dashboard.lastRecomputed": "Last recomputed: {time}",
  "qa.qi.dashboard.viewDetail": "View detail",
  "qa.qi.dashboard.tileInfo": "What does this tile measure?",
  "qa.qi.disabled.toast.title": "Indicator disabled",
  "qa.qi.disabled.toast.message": "This quality indicator is disabled in QI Configuration; its detail page is unavailable.",
  "qa.qi.dashboard.tile.tat.label": "Average TAT",
  "qa.qi.dashboard.tile.tat.tooltip": "Average turnaround time from sample receipt to result validation, across all completed test orders in the reporting window.",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.tat.secondary": "Across {count, plural, one {# lab unit} other {# lab units}} · Slowest: {unit} ({tat})",
  "qa.qi.dashboard.tile.tat.empty": "No completed test orders in this window.",
  "qa.qi.dashboard.tile.tat.error": "Turnaround data is unavailable.",
  "qa.qi.dashboard.tile.rejection.label": "Rejection Rate",
  "qa.qi.dashboard.tile.amendment.label": "Amendment Rate",
  "qa.qi.dashboard.tile.ncePulse.label": "NCE Pulse",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "Critical non-conforming events not yet acknowledged, as of now. A current count, not a trend.",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "critical pending",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} in corrective action",
  "qa.qi.dashboard.tile.ncePulse.error": "NCE data is unavailable.",
  "qa.qi.dashboard.tile.amendment.tooltip": "Results corrected after their patient report went out, as a share of results released in the reporting window.",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.amendment.secondary": "{amended} amended of {released} released",
  "qa.qi.dashboard.tile.amendment.empty": "No results released in this window.",
  "qa.qi.dashboard.tile.amendment.error": "Amendment data is unavailable.",
  "qa.qi.dashboard.tile.rejection.tooltip": "Tests rejected at results entry or validation, as a share of tests started in the reporting window.",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.rejection.secondary": "{rejected} rejected of {total} started",
  "qa.qi.dashboard.tile.rejection.empty": "No tests started in this window.",
  "qa.qi.dashboard.tile.rejection.error": "Rejection data is unavailable.",
  "qa.qi.dashboard.tile.thresholds": "Target {target} · action {action}",
  "qa.qi.amendment.title": "Amendment Rate — Detail",
  "qa.qi.amendment.subtitle": "Results corrected after their patient report went out.",
  "qa.qi.amendment.column.amendedAt": "Amended at",
  "qa.qi.amendment.column.priorValue": "Prior value",
  "qa.qi.amendment.column.currentValue": "Current value",
  "qa.qi.amendment.column.amendedBy": "Amended by",
  "qa.qi.amendment.column.releasedAt": "Released at",
  "qa.qi.amendment.column.timeToAmend": "Time to amend",
  "qa.qi.amendment.rate.label": "Amendment rate",
  "qa.qi.amendment.trend.empty": "No trend data in this window.",
  "qa.qi.amendment.breakdown.title": "By test",
  "qa.qi.amendment.breakdown.column.rate": "Rate",
  "qa.qi.rejection.title": "Rejection Rate — Detail",
  "qa.qi.rejection.subtitle": "Tests rejected at results entry, with the recorded rejection reason.",
  "qa.qi.rejection.column.rejectedAt": "Rejected at",
  "qa.qi.rejection.column.rejectedBy": "Rejected by",
  "qa.qi.rejection.heatmap.title": "Heatmap: ordering location × test section",
  "qa.qi.rejection.heatmap.section": "Test section",
  "qa.qi.rejection.heatmap.unknown": "Unknown location",
  "qa.qi.rejection.heatmap.unknownSection": "Unknown section",
  "qa.qi.rejection.heatmap.legend": "Cells colored by rate against the lab's thresholds: green ≤ {target}%, amber in between, red ≥ {action}%. Hover a cell for rejected / started counts.",
  "qa.qi.rejection.rate.label": "Rejection rate",
  "qa.qi.rejection.reasons.title": "By reason (Pareto)",
  "qa.qi.rejection.reasons.column.percent": "% of rejections",
  "qa.qi.rejection.reasons.column.cumulative": "Cumulative %",
  "qa.qi.rejection.reasons.donut.label": "Rejections",
  "qa.qi.rejection.reasons.insight": "Top {count} of {total} reasons account for {percent}% of rejections — addressing {reason} first has the biggest impact.",
  "qa.qi.rejection.breakdown.other": "Other ({count} tests)",
  "qa.qi.rejection.list.title": "Individual rejections",
  "qa.qi.amendment.list.title": "Individual amendments",
  "qa.qi.callback.button": "Log callback",
  "qa.qi.callback.banner.title": "Critical results need a clinician callback",
  "qa.qi.callback.banner.subtitle": "{count, plural, one {# saved critical result on this page has no callback logged — read-back required (TJC NPSG.02.03.01).} other {# saved critical results on this page have no callback logged — read-back required (TJC NPSG.02.03.01).}}",
  "qa.qi.callback.modal.title": "Log critical callback",
  "qa.qi.callback.field.recipientName": "Person notified",
  "qa.qi.callback.field.recipientName.placeholder": "Name of clinician or ward contacted",
  "qa.qi.callback.field.status": "Callback outcome",
  "qa.qi.callback.status.CONFIRMED": "Confirmed with read-back",
  "qa.qi.callback.status.REACHED_NO_READBACK": "Reached, no read-back",
  "qa.qi.callback.status.UNABLE_TO_REACH": "Unable to reach",
  "qa.qi.callback.save.success": "Callback logged",
  "qa.qi.callback.save.fail": "Failed to log callback",
  "qa.qi.callback.title": "Critical Callback Compliance — Detail",
  "qa.qi.callback.subtitle": "Released critical results and whether each was phoned to a clinician with read-back inside the callback target window.",
  "qa.qi.callback.distribution.title": "Time-to-acknowledge distribution",
  "qa.qi.callback.distribution.0-5": "0–5 min",
  "qa.qi.callback.distribution.5-15": "5–15 min",
  "qa.qi.callback.distribution.15-30": "15–30 min",
  "qa.qi.callback.distribution.30-60": "30–60 min",
  "qa.qi.callback.distribution.over60": "60+ min",
  "qa.qi.callback.distribution.noAck": "No ack",
  "qa.qi.callback.failures.title": "Failures ({count}) by reason",
  "qa.qi.callback.failures.overTarget": "Over target",
  "qa.qi.callback.failures.unableToReach": "Unable to reach",
  "qa.qi.callback.failures.noReadback": "No read-back recorded",
  "qa.qi.callback.failures.noCallback": "No callback recorded",
  "qa.qi.callback.list.title": "Critical results in window",
  "qa.qi.callback.rate.label": "Callback compliance (read-back within {minutes} min)",
  "qa.qi.callback.status.notLogged": "Not logged",
  "qa.qi.callback.column.status": "Callback status",
  "qa.qi.callback.column.timeToCallback": "Time to callback",
  "qa.qi.callback.column.loggedBy": "Logged by",
  "qa.qi.dashboard.tile.callback.label": "Critical Callback Compliance",
  "qa.qi.dashboard.tile.callback.tooltip": "Released critical results with a confirmed read-back callback within the lab's callback target window. Opt-in — enable in QI Configuration. Compliance is recomputed from current critical ranges.",
  "qa.qi.dashboard.tile.callback.secondary": "{confirmed} of {critical} critical results acknowledged within target",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.callback.empty": "No critical results in this window.",
  "qa.qi.dashboard.tile.callback.error": "Callback data is unavailable.",
  "qa.qi.dashboard.tile.callback.disabled": "Not enabled — turn on in QI Configuration.",
  "qa.empty.callback.title": "No critical results in this window",
  "qa.empty.callback.subhead": "Released critical results appear here with their callback documentation status.",
  "qa.overview.rejection.caption": "rejected at results entry (30d)",
  "qa.overview.rejection.ofStarted": "{rejected} of {total} started",
  "qa.overview.callback.caption": "critical read-back compliance (30d)",
  "qa.overview.callback.ofCritical": "{confirmed} of {critical} confirmed",
  "qa.overview.callback.none": "no critical results in window",
  "qa.overview.week.confirmedCount": "{count} confirmed",
  "qa.overview.amendment.caption": "amended after report (30d)",
  "qa.overview.amendment.ofReleased": "{amended} of {released} released",
  "qa.future.subtitle": "Future feature — design exists; build not yet scheduled.",
  "qa.future.questionLabel": "The question this feature answers",
  "qa.future.whyLabel": "Why it matters",
  "qa.future.readDesignDoc": "Read design doc on GitHub",
  "qa.future.reagentQc.question": "Has this reagent lot been verified before we use it on patients?",
  "qa.future.reagentQc.summary": "Per-lot QC frequency tracking. Before a new reagent lot is used clinically, the system requires documented verification samples comparing the new lot against the old lot or a peer-comparison reference.",
  "qa.future.reagentQc.why": "Without lot verification, a bad reagent lot can ruin a week of patient results before anyone notices. Most labs do this informally today; shipping it as a system feature catches the cases where the informal process fails.",
  "qa.future.manualQc.question": "Did the technician run a daily control on this instrument today, and did it pass?",
  "qa.future.manualQc.summary": "Daily PASS/FAIL log per instrument. Different instruments have different daily checks; the system holds them all to one shape: a daily PASS/FAIL log with a signer, a timestamp, and a block on instrument use if FAIL.",
  "qa.future.manualQc.why": "The first thing an inspector asks when they walk into a lab is 'show me your daily QC log for this instrument.' A signed log per instrument per day, every day. Forgetting it is what fails inspections.",
  "qa.overview.subtitle": "Daily snapshot for the QA Officer",
  "qa.overview.comingSoon": "Coming soon",
  "qa.overview.section.attention": "Attention Required",
  "qa.overview.section.thisWeek": "This Week",
  "qa.overview.section.pillars": "Pillar Status",
  "qa.overview.section.activity": "Recent Activity",
  "qa.overview.section.inspector": "Inspector readiness — five ISO 15189 quality questions",
  "qa.overview.attention.criticalNce": "Critical NCEs pending acknowledgment",
  "qa.overview.attention.criticalResults": "Critical results in last 24 hours",
  "qa.overview.attention.overdueCapas": "Overdue CAPAs",
  "qa.overview.attention.qcViolations": "QC violations in last 24 hours",
  "qa.overview.attention.effectivenessReview": "CAPA effectiveness reviews due",
  "qa.overview.attention.eqaDue": "EQA submissions due in next 14 days",
  "qa.overview.attention.nceSla": "NCEs nearing acknowledgment SLA",
  "qa.overview.tile.criticalCallback": "Critical Callback",
  "qa.overview.week.newNces": "New NCEs",
  "qa.overview.week.ncesResolved": "NCEs resolved",
  "qa.overview.week.capasCompleted": "CAPAs completed",
  "qa.overview.week.qcViolations": "QC violations",
  "qa.overview.week.criticalResults": "Critical results",
  "qa.overview.week.eqaSubmissions": "EQA submissions",
  "qa.overview.week.auditEntries": "Audit log entries",
  "qa.overview.week.signatureEvents": "Signature events",
  "qa.overview.inspector.q1": "Are runs in control?",
  "qa.overview.inspector.q2": "How did EQA perform last cycle?",
  "qa.overview.inspector.q3": "Are QIs on target?",
  "qa.overview.inspector.q4": "Open critical NCEs?",
  "qa.overview.inspector.q5": "Accreditation status?",
  "qa.overview.inspector.q1.answer": "{inControl} of {total} instruments in control (30d)",
  "qa.overview.inspector.q3.answer": "Avg TAT {tat} vs prior 30d",
  "qa.overview.inspector.q4.answer": "{count} critical NCEs pending acknowledgment",
  "qa.overview.inspector.q5.answer": "{active} of {total} in force, {expiring} expiring, {expired} expired",
  "qa.overview.inspector.q5.noData": "No accrediting bodies configured",
  "qa.overview.week.severityBreakdown": "{critical} critical · {major} major · {minor} minor",
  "qa.overview.week.overdueCount": "{count} overdue",
  "qa.overview.week.currentlyOpen": "currently open",
  "qa.overview.pillar.qc.text": "{inControl} of {total} instruments in control",
  "qa.overview.pillar.qc.noData": "No QC data yet",
  "qa.overview.pillar.qi.text": "Avg TAT {tat}",
  "qa.overview.pillar.qi.noData": "No TAT data yet",
  "qa.overview.pillar.qi.disabled": "Not currently tracked",
  "qa.overview.pillar.qms.text": "{critical} critical pending · {capa} in corrective action",
  "qa.overview.activity.viewAudit": "View full audit trail",
  "qa.overview.activity.empty": "No activity in the last 24 hours",
  "qa.empty.activity.subhead": "Attested actions across all pillars appear here as they happen.",
  "qa.empty.attention.title": "Nothing needs attention right now",
  "qa.empty.attention.subhead": "Critical NCEs, overdue CAPAs, and QC violations surface here when they occur.",
  "qa.empty.amendment.title": "No amendments in this window",
  "qa.empty.amendment.subhead": "Amendments appear here when a released result is corrected.",
  "qa.empty.rejection.title": "No rejections in this window",
  "qa.empty.rejection.subhead": "Rejections appear here when a test is rejected at results entry or validation.",
  "qa.empty.capaRegister.title": "No CAPAs match these filters",
  "qa.empty.capaRegister.subhead": "Corrective and preventive actions appear here as they are recorded against non-conforming events.",
  "qa.empty.accreditation.bodies.title": "No accrediting bodies yet",
  "qa.empty.accreditation.bodies.subhead": "Add the bodies that accredit this laboratory to start tracking per-test accreditation.",
  "qa.empty.accreditation.enrollments.title": "No enrollments match these filters",
  "qa.empty.accreditation.enrollments.subhead": "Enroll tests under an accrediting body to show its logo on patient reports.",
  "qa.empty.accreditation.eqa.title": "Nothing to compare yet",
  "qa.empty.accreditation.eqa.subhead": "Once tests are enrolled under an accrediting body, their EQA coverage is compared here.",
  "qa.empty.esigLog.title": "No signatures in this window",
  "qa.empty.esigLog.subhead": "Signatures appear here as results are authored and validated. Try a wider date range or fewer filters.",
  "qa.empty.tat.title": "No results in this window",
  "qa.empty.tat.subhead": "Turnaround times appear here as test orders are completed and validated. Try a different date range.",
  "qa.empty.sparse.labUnits": "{count, plural, one {# lab unit} other {# lab units}} this period",
  "qa.overview.activity.yesterday": "Yesterday {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "authored results for",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "validated & released",
  "qa.overview.activity.meaning.REJECTED": "rejected",
  "qa.overview.activity.qc": "QC alert: {rule} ({severity}) on {instrument}",
  "qa.overview.activity.nce.CREATED": "{actor} reported {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} acknowledged {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} assigned {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} added a note to {nce}",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} updated the status of {nce}",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} updated corrective action on {nce}",
  "qa.overview.activity.nce.RESOLVED": "{actor} resolved {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} updated {nce}",
  "sidenav.title.statusreport": "患者状态报告",
  "systemAudit.filter.startDate": "开始日期",
  "systemAudit.filter.endDate": "结束日期",
  "systemAudit.filter.entityType": "实体类型",
  "systemAudit.filter.action": "操作",
  "systemAudit.filter.search": "搜索",
  "systemAudit.filter.export": "导出翻译",
  "systemAudit.table.heading.time": "时间",
  "systemAudit.table.heading.entityType": "实体类型",
  "systemAudit.table.heading.entityId": "实体 ID",
  "systemAudit.table.heading.action": "操作",
  "systemAudit.table.heading.user": "用户",
  "systemAudit.table.heading.changes": "变更",
  "systemAudit.noResults": "根据给定的过滤器，否找到任何系统事件。",
  "systemAudit.filter.all": "所有分析仪",
  "systemAudit.filter.user": "用户",
  "systemAudit.filter.searchText": "搜索",
  "systemAudit.filter.searchText.placeholder": "按实体 ID 搜索...",
  "systemAudit.filter.exportPdf": "导出PDF",
  "systemAudit.filter.selectedPatient": "已选择的患者",
  "systemAudit.filter.selectedPatient.none": "无",
  "systemAudit.filter.selectPatient": "选择患者",
  "systemAudit.filter.selectAnotherPatient": "选择另一位患者",
  "systemAudit.action.insert": "插入",
  "systemAudit.action.update": "更新",
  "systemAudit.action.delete": "删除",
  "site.branding.cancel": "取消",
  "site.branding.color.format.error": "颜色格式无效",
  "site.branding.color.hex.label": "十六进制颜色值",
  "site.branding.colorPicker.helperText": "选择颜色或输入十六进制值",
  "site.branding.colorPicker.placeholder": "选择颜色...",
  "site.branding.confirm.remove": "确认移除",
  "site.branding.confirm.remove.message": "您确定要移除此图标吗？",
  "site.branding.current.logo": "当前Logo",
  "site.branding.description": "自定义站点的外观，包括Logo、颜色和网站图标",
  "site.branding.error.remove": "移除失败",
  "site.branding.favicon": "网站图标",
  "site.branding.favicon.description": "显示在浏览器标签中的图标",
  "site.branding.file.format.error": "文件格式不支持",
  "site.branding.file.pending": "文件待上传",
  "site.branding.file.size.error": "文件大小超过限制",
  "site.branding.formats": "文件格式：PNG、SVG、JPG（最大2MB）",
  "site.branding.header.color": "页眉颜色",
  "site.branding.header.color.description": "应用程序页眉栏的背景颜色",
  "site.branding.header.logo": "页眉Logo",
  "site.branding.header.logo.description": "显示在应用程序页眉中的Logo",
  "site.branding.login.logo": "登录页Logo",
  "site.branding.login.logo.description": "显示在登录页面上的Logo",
  "site.branding.login.using.header.logo": "登录页使用页眉Logo",
  "site.branding.logo.upload.success": "Logo上传成功",
  "site.branding.no.logo": "未设置Logo",
  "site.branding.preview": "预览",
  "site.branding.primary.color": "主色调",
  "site.branding.primary.color.description": "应用程序的主要颜色",
  "site.branding.remove.favicon": "移除网站图标",
  "site.branding.remove.header.logo": "移除页眉Logo",
  "site.branding.remove.login.logo": "移除登录页Logo",
  "site.branding.remove.logo": "移除Logo",
  "site.branding.reset.confirmation": "您确定要将所有品牌设置恢复为默认值吗？",
  "site.branding.reset.error": "重置品牌设置失败",
  "site.branding.reset.success": "品牌设置已恢复为默认值",
  "site.branding.reset.to.defaults": "恢复默认设置",
  "site.branding.save": "保存",
  "site.branding.save.error": "保存品牌设置失败",
  "site.branding.save.success": "品牌设置保存成功",
  "site.branding.secondary.color": "辅色调",
  "site.branding.secondary.color.description": "应用程序的辅助颜色",
  "site.branding.section.colors": "颜色",
  "site.branding.section.logos": "品牌徽标",
  "site.branding.title": "站点品牌",
  "site.branding.unsaved.changes": "未保存的更改",
  "site.branding.unsaved.changes.warning": "您有未保存的更改。离开此页面将丢失这些更改。",
  "site.branding.upload.favicon": "上传网站图标",
  "site.branding.upload.header.logo": "上传页眉Logo",
  "site.branding.upload.login.logo": "上传登录页Logo",
  "site.branding.upload.logo": "上传Logo",
  "site.branding.use.header.logo.for.login": "将页眉Logo用于登录页",
  "siteInfo.description.default.barcode": "指示每次订单和标本应打印的默认条码标签数量。",
  "siteInfo.description.dimensions": "指示打印时条码标签应符合的尺寸。",
  "siteInfo.description.elements": "勾选应出现在订单和样本条码标签上的可选元素旁边的框。",
  "siteInfo.description.max.barcode": "指示每个订单或标本可以打印的最大条码标签数量。达到最大值后，用户将无法打印更多标签。",
  "siteInfo.elements.mandatory": "必需元素",
  "siteInfo.elements.optional": "可选元素",
  "siteInfo.section.altAccession": "预印条码订单号",
  "siteInfo.section.elements": "条码标签元素",
  "siteInfo.section.number": "条码标签数量",
  "siteInfo.section.size": "条码标签尺寸",
  "siteInfo.title.default.barcode": "默认条码标签",
  "siteInfo.title.default.barcode.block": "块",
  "siteInfo.title.default.barcode.height": "高度",
  "siteInfo.title.default.barcode.order": "订单",
  "siteInfo.title.default.barcode.order.none": "无",
  "siteInfo.title.default.barcode.slide": "幻灯片",
  "siteInfo.title.default.barcode.specimen": "标本",
  "siteInfo.title.default.barcode.freezer": "冰箱",
  "siteInfo.title.default.barcode.width": "宽度",
  "siteInfo.title.max.barcode": "最大条码标签",
  "started.date": "开始日期",
  "status": "状态",
  "status.in.progress": "进行中",
  "status.unknown": "未知",
  "stillThere.message": "用户会话即将超时。点击任意位置以保持登录状态。",
  "stillThere.title": "还在吗？",
  "stock.available": "可用",
  "stock.level": "库存水平",
  "stock.status": "库存状态",
  "stock.status.expired": "已过期",
  "stock.status.expiring": "即将过期",
  "stock.status.expiringIn": "Expiring ({days}d)",
  "stock.status.inStock": "有库存",
  "stock.status.lowStock": "低库存",
  "stock.status.outOfStock": "缺货",
  "storage.active": "活跃",
  "storage.add.device": "添加设备",
  "storage.add.location": "位置",
  "storage.add.location.option": "添加位置...",
  "storage.add.new.device": "添加新设备",
  "storage.add.rack": "添加货架",
  "storage.add.box": "添加框",
  "storage.add.room": "添加房间",
  "storage.add.shelf": "添加货架",
  "storage.allAssigned.title": "所有样本均已分配",
  "storage.assign.button": "分配位置",
  "storage.assign.title": "分配存储位置",
  "storage.assigned": "已分配",
  "storage.assigned.by": "分配者",
  "storage.assigned.date": "分配日期",
  "storage.barcode.scan.placeholder": "扫描条码或手动输入",
  "storage.bulk.move.auto.assigned": "自动分配的位置（可编辑）",
  "storage.bulk.move.preview": "批量移动预览",
  "storage.cannotDelete.hasAssignments": "无法删除 {entityType} '{name}'：有 {count} 个分配的样本",
  "storage.cannotDelete.hasChildren": "无法删除 {entityType} '{name}'：包含 {count} 个 {childType}",
  "storage.capacity.calculated": "计算",
  "storage.capacity.manual": "手动限制",
  "storage.capacity.undetermined.tooltip": "无法计算容量：某些子位置缺少定义的容量",
  "storage.capacity.warning": "{location} 已满 {percentage}%。请考虑使用其他存储。",
  "storage.code.change.acknowledge": "我理解并希望继续进行代码更改",
  "storage.code.change.warning": "警告",
  "storage.code.change.warning.message": "更改代码将使之前打印的此位置的所有标签无效。",
  "storage.confirm.add.device": "您要创建新设备 '{name}' 吗？",
  "storage.conditionNotes": "状况备注",
  "storage.conditionNotes.placeholder": "请输入有关存储条件的任何备注……",
  "storage.confirm.delete": "确认删除",
  "storage.create.room.error": "创建房间失败",
  "storage.create.room.success": "房间创建成功",
  "storage.current.location": "当前位置",
  "storage.currentLocation": "当前位置",
  "storage.delete.admin.only": "只有全局管理员可以删除位置",
  "storage.delete.are.you.sure": "您确定要删除",
  "storage.delete.cannot.be.undone": "此操作无法撤销。",
  "storage.delete.cascade.confirm": "确认级联删除",
  "storage.delete.cascade.confirmation.checkbox": "我确认要删除此位置及其所有子位置。所有样本将被取消分配。此操作无法撤销。",
  "storage.delete.cascade.summary": "这将删除 {childCount} 个 {childType} 并取消分配 {sampleCount} 个样本。您确定要继续吗？",
  "storage.delete.cascade.warning": "级联删除警告",
  "storage.delete.checking": "检查约束...",
  "storage.delete.confirmation.checkbox": "我确认要删除此位置。此操作无法撤销。",
  "storage.delete.constraints.title": "无法删除",
  "storage.delete.device": "删除设备",
  "storage.delete.error": "删除位置失败",
  "storage.delete.location": "删除位置",
  "storage.delete.rack": "删除货架",
  "storage.delete.room": "删除房间",
  "storage.delete.shelf": "删除货架",
  "storage.device.code": "代码",
  "storage.device.communicationProtocol": "通信协议",
  "storage.device.communicationProtocol.helper": "用于设备通信的协议（例如，BACnet）",
  "storage.device.ipAddress": "IP地址",
  "storage.device.ipAddress.helper": "网络连接设备的IPv4或IPv6地址",
  "storage.device.label": "设备",
  "storage.device.name": "名称",
  "storage.device.placeholder": "选择或键入以创建设备...",
  "storage.device.port": "端口",
  "storage.device.port.helper": "通信端口号（1-65535）",
  "storage.device.room": "房间",
  "storage.device.type": "类型",
  "storage.edit.device": "编辑设备",
  "storage.edit.error.loadLocation": "无法加载位置",
  "storage.edit.error.saveFailed": "保存失败",
  "storage.edit.error.saveHttp": "保存失败（HTTP {status}）",
  "storage.edit.rack": "编辑货架",
  "storage.edit.room": "编辑房间",
  "storage.edit.shelf": "编辑货架",
  "storage.edit.selectParent": "选择 {parent}",
  "storage.editbox.error.loadBox": "无法加载框",
  "storage.editbox.selectRack": "选择货架",
  "storage.box.capacity": "容量",
  "storage.box.gridSize": "Grid size",
  "storage.box.rows": "行",
  "storage.box.columns": "列",
  "storage.box.preset": "尺寸预设",
  "storage.box.preset.select": "选择尺寸",
  "storage.error.location.inactive": "不能分配到非活跃位置",
  "storage.error.name.duplicate": "在选定的父位置中已存在具有此名称的 {entityType}",
  "storage.error.position.occupied": "位置已被占用",
  "storage.expanded.capacityLimit": "容量限制",
  "storage.expanded.createdBy": "创建者",
  "storage.expanded.createdDate": "创建日期",
  "storage.expanded.description": "描述",
  "storage.expanded.lastModifiedBy": "最后修改者",
  "storage.expanded.lastModifiedDate": "最后修改日期",
  "storage.expanded.notAvailable": "不适用",
  "storage.expanded.positionSchemaHint": "位置架构提示",
  "storage.expanded.temperatureSetting": "温度设置",
  "storage.filter.by.locations": "按位置过滤",
  "storage.filter.by.locations.placeholder": "按位置过滤...",
  "storage.filter.device": "按设备过滤",
  "storage.filter.room": "按房间过滤",
  "storage.filter.status": "按状态过滤",
  "storage.hierarchical.path": "位置路径",
  "storage.inline.add.device": "添加新设备",
  "storage.inline.add.rack": "添加新货架",
  "storage.inline.add.room": "添加新房间",
  "storage.inline.add.shelf": "添加新货架",
  "storage.location": "位置",
  "storage.location.active": "活跃",
  "storage.location.add.button": "添加位置",
  "storage.location.add.title": "添加存储位置",
  "storage.location.current": "存储位置",
  "storage.location.code": "位置代码",
  "storage.location.code.helper": "最多10个字符，字母数字，可包含连字符/下划线",
  "storage.location.description": "描述",
  "storage.location.label": "存储位置",
  "storage.location.name": "位置名称",
  "storage.location.skipped": "跳过存储",
  "storage.location.tempMax": "最高温度",
  "storage.location.tempMin": "最低温度",
  "storage.location.type": "位置类型",
  "storage.location.unassigned": "未分配",
  "storage.location.notAssigned": "Not assigned",
  "storage.location.move": "Move storage location",
  "storage.location.assign": "Assign storage location",
  "storage.manageLocation.error.saveFailed": "保存失败",
  "storage.manageLocation.error.selectTarget": "保存前请先选择设备、货架、机架或箱子",
  "storage.nav.box": "Box",
  "storage.nav.device": "设备",
  "storage.nav.room": "房间",
  "storage.nav.shelf": "货架",
  "storage.picker.currentLocation": "当前位置",
  "storage.picker.heading.assignLocation": "分配存储位置",
  "storage.picker.heading.move": "Move Item",
  "storage.picker.newLocation": "新位置",
  "storage.picker.notes": "备注",
  "storage.picker.orBrowse": "Or pick level by level",
  "storage.picker.position.optional": "位置（可选）",
  "storage.picker.select": "选择{level}",
  "storage.picker.selectDeviceType": "Select device type",
  "storage.picker.addNewLevel": "添加新{level}",
  "storage.picker.inlineCreate.heading": "创建新的{level}",
  "storage.picker.inlineCreate.error.title": "无法创建位置",
  "storage.picker.inlineCreate.error": "无法创建位置",
  "storage.picker.occupant.identifier": "标识符",
  "storage.picker.occupant.heading": "项目",
  "storage.picker.occupant.status": "状态",
  "storage.picker.occupant.type": "设备类型",
  "storage.picker.storageLocation": "存储位置",
  "storage.metrics.active": "活跃",
  "storage.metrics.disposed": "已处置",
  "storage.metrics.total.samples": "总样本项",
  "storage.mode.autocomplete": "提前输入搜索",
  "storage.mode.barcode": "条码扫描",
  "storage.mode.cascading": "级联下拉菜单",
  "storage.move.button": "移动样本",
  "storage.move.reason.label": "移动原因",
  "storage.nav.boxes": "储物盒",
  "storage.nav.boxes.tooltip": "管理储物盒",
  "storage.nav.dashboard": "仪表板",
  "storage.nav.devices": "设备",
  "storage.nav.devices.tooltip": "管理存储设备",
  "storage.nav.locations": "位置",
  "storage.nav.locations.tooltip": "管理存储位置",
  "storage.nav.racks": "货架",
  "storage.nav.racks.tooltip": "管理货架",
  "storage.nav.rooms": "房间",
  "storage.nav.rooms.tooltip": "管理存储房间",
  "storage.nav.sample.items": "样本项",
  "storage.nav.sample.items.tooltip": "管理存储中的样本项",
  "storage.nav.samples": "样本",
  "storage.nav.samples.tooltip": "管理存储中的样本",
  "storage.nav.shelves": "架层",
  "storage.nav.shelves.tooltip": "管理架层",
  "storage.no.data": "无可用数据",
  "storage.occupancy": "占用率",
  "storage.position.label": "位置",
  "storage.rack.device": "设备",
  "storage.rack.dimensions": "尺寸",
  "storage.rack.label": "货架",
  "storage.rack.placeholder": "选择或键入以创建货架...",
  "storage.rack.room": "房间",
  "storage.rack.shelf": "货架",
  "storage.room.code": "代码",
  "storage.room.devices": "设备",
  "storage.room.label": "房间",
  "storage.room.name": "名称",
  "storage.room.placeholder": "选择或键入以创建房间...",
  "storage.room.samples": "样本",
  "storage.sampleitem.id": "样本项ID",
  "storage.search.boxes.placeholder": "Search boxes by label or code...",
  "storage.search.devices.placeholder": "按设备名称或代码搜索...",
  "storage.search.location.minLength": "Keep typing, at least 2 characters",
  "storage.search.location.searching": "搜索中...",
  "storage.search.location.error": "Could not search locations. Please try again.",
  "storage.search.location.noResults": "No storage locations match \"{query}\"",
  "storage.search.placeholder": "按样本ID或位置搜索...",
  "storage.search.racks.placeholder": "按货架标签搜索...",
  "storage.search.rooms.placeholder": "按房间名称或代码搜索...",
  "storage.search.lots.placeholder": "Search by lot number, barcode, item or location...",
  "storage.search.samples.placeholder": "按样本ID或位置搜索...",
  "storage.search.shelves.placeholder": "按货架标签搜索...",
  "storage.select.location": "选择位置",
  "storage.selectSample": "选择样本",
  "storage.shelf.device": "设备",
  "storage.shelf.label": "货架",
  "storage.shelf.placeholder": "选择或键入以创建货架...",
  "storage.shelf.room": "房间",
  "storage.status": "状态",
  "storage.status.disposed": "已处置",
  "storage.success.assigned": "样本成功分配到存储位置",
  "storage.success.moved": "样本成功移动到新位置",
  "storage.tab.ariaLabel": "Storage management tabs",
  "storage.tab.dashboard": "仪表板",
  "storage.tab.inventoryLots": "Inventory Lots",
  "storage.tab.samples": "样本项",
  "storage.target.location": "目标位置",
  "storage.unassigned.title": "未分配样本",
  "storage.skipAssignment": "无需存储——样本将立即进行处理",
  "success.add.edited.msg": "成功添加/编辑",
  "success.delete.msg": "成功删除",
  "success.import.patient": "患者成功导入",
  "success.report.status": "成功生成报告",
  "success.save.msg": "成功保存",
  "success.save.patient": "患者保存成功",
  "systemuser.firstName": "系统用户名",
  "systemuser.isActive": "是否活跃",
  "systemuser.lastName": "系统用户姓",
  "systemuser.loginName": "系统用户登录名",
  "systemuser.role": "角色",
  "systemuserrole.apply": "应用",
  "systemuserrole.allLabUnits.confirm.body": "Switching this row to All Lab Units removes these lab unit permissions. The All Lab Units row starts with no permissions ticked.",
  "systemuserrole.allLabUnits.confirm.noPermissions": "no permissions ticked",
  "systemuserrole.allLabUnits.confirm.primary": "Replace permissions",
  "systemuserrole.allLabUnits.confirm.title": "Replace lab unit permissions?",
  "systemuserrole.allLabUnits.exclusive.error": "All Lab Units cannot be combined with individual lab units. Nothing was saved.",
  "systemuserrole.allLabUnits.exclusive.info": "All Lab Units cannot be combined with individual lab units: selecting it replaces every lab-unit-specific permission.",
  "systemuserrole.copypermissions": "从用户复制权限",
  "systemuserrole.copypermissions.placeholder": "复制用户权限",
  "systemuserrole.instruction.1": "有两种类型的角色。为整个应用程序设置的全局角色和可以为所有实验室单元或特定实验室单元设置的实验室单元角色。",
  "systemuserrole.instruction.2": "可用的全局角色有：全局管理员（访问所有管理功能）、审计跟踪（访问所有审计跟踪）、用户账户管理员（可以访问所有用户账户管理功能，但不能访问任何其他管理功能）。",
  "systemuserrole.instruction.3": "实验室单元角色有：接收（访问订单、患者和不符合选项卡）、结果（访问工作计划、不符合和结果选项卡）、验证（访问验证和不符合选项卡）、报告（访问报告选项卡，但CSV导出仅适用于全局管理员）。",
  "systemuserrole.instruction.4": "要分配实验室单元角色，请从下拉列表中选择所有实验室单元或特定实验室单元，并选择您要设置的任何角色。",
  "systemuserrole.instruction.5": "您也可以使用复制权限功能复制现有用户的权限。确保您已填写上述所有信息，并在框中输入要复制其权限的用户名，然后单击应用。",
  "systemuserrole.newpermissions": "添加新权限",
  "systemuserrole.rmpermissions": "移除权限",
  "systemuserrole.roles.global": "全局角色",
  "systemuserrole.roles.labunit": "实验室单元角色",
  "test.add.copy.name": "从检测名称复制",
  "test.antimicrobialResistance": "抗菌素耐药性",
  "test.description.active": "如果检测处于活跃状态，它可以在订单表单上订购或作为检测算法的一部分。如果它不活跃，则不能订购或作为检测算法的一部分",
  "test.description.name": "检测在openELIS中显示的名称。需要英文和法文",
  "test.description.orderable": "如果检测处于活跃状态且可订购，则可以在订单表单上订购。如果它处于活跃状态但不可订购，则只有当它从另一个检测反射时才会执行",
  "test.description.panel": "如果此检测是检测面板的一部分，则可以在此处添加面板。一个检测可以属于多个面板，但这不常见",
  "test.description.reportName": "检测在报告中显示的名称。需要英文和法文。如果名称和报告名称相同，请单击按钮复制名称",
  "test.description.testSection": "将执行检测的检测科室",
  "test.description.uom": "检测的测量单位。这通常仅适用于数值或字母数字结果类型",
  "test.field.active": "活跃",
  "test.field.orderable": "可订购",
  "test.inLabOnly": "仅限实验室内部",
  "test.modify.en": "英文",
  "test.modify.fr": "法文",
  "test.modify.header.modify": "请选择要修改的检测！",
  "test.modify.header.test": "检测",
  "test.name": "检测名称",
  "test.notifyResults": "通知患者结果",
  "test.section": "检测科室",
  "test.section.label": "检测科室",
  "test.show.guide": "显示指南",
  "testcalculation.label.calculation": "计算",
  "testcalculation.label.finalresult": "最终结果",
  "testcalculation.label.insertOperation": "插入操作",
  "testcalculation.label.integer": "整数",
  "testcalculation.label.mathFucntion": "数学函数",
  "testcalculation.label.name": "计算名称",
  "testcalculation.label.patientAttribute": "患者属性",
  "testcalculation.label.searchNumericTest": "搜索数值检测",
  "testcalculation.label.selectDictionaryValue": "选择字典值",
  "testcalculation.label.testResult": "检测结果",
  "testcalculation.label.textValue": "文本值",
  "testCatalog.header.ageRange": "年龄范围",
  "testCatalog.header.criticalRange": "危急范围",
  "testCatalog.header.field": "字段",
  "testCatalog.header.gender": "性别",
  "testCatalog.header.normalRange": "正常范围",
  "testCatalog.header.reportingRange": "报告范围",
  "testCatalog.header.validRange": "有效范围",
  "testCatalog.header.value": "值",
  "admin.testCatalog.methods.title": "方法",
  "admin.testCatalog.methods.column.name": "方法名称",
  "admin.testCatalog.methods.column.code": "位置代码",
  "admin.testCatalog.methods.column.default": "默认值",
  "admin.testCatalog.methods.column.effectiveDate": "生效日期",
  "admin.testCatalog.methods.column.actions": "操作",
  "admin.testCatalog.methods.action.edit": "编辑",
  "admin.testCatalog.methods.action.remove": "移除",
  "admin.testCatalog.methods.btn.linkMethod": "+ 链接方法",
  "admin.testCatalog.methods.btn.createMethod": "+ 创建新方法",
  "admin.testCatalog.methods.btn.copyFromTest": "从“检测”中复制",
  "admin.testCatalog.methods.modal.link.title": "链接方法",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "选择一种链接方式",
  "admin.testCatalog.methods.modal.link.noAvailable": "所有活跃方法均已关联",
  "admin.testCatalog.methods.inline.nameEnglish": "方法名称（英文）",
  "admin.testCatalog.methods.inline.nameFrench": "方法名称（法文）",
  "admin.testCatalog.methods.inline.code": "短代码",
  "admin.testCatalog.methods.inline.codeHint": "3–10个大写字母和数字，不包含空格",
  "admin.testCatalog.methods.inline.createAndLink": "创建与关联",
  "admin.testCatalog.methods.copyFromTest.label": "从测试中复制方法",
  "admin.testCatalog.methods.copyFromTest.placeholder": "选择源检测",
  "admin.testCatalog.methods.effectiveDate.label": "生效日期",
  "admin.testCatalog.methods.default.label": "设为默认值",
  "admin.testCatalog.methods.error.duplicateLink": "该方法已与检测相关联",
  "admin.testCatalog.methods.error.codeFormat": "位置代码必须由 3 至 10 个大写字母和数字组成，且不能包含空格",
  "admin.testCatalog.methods.error.effectiveDateRequired": "必须填写生效日期",
  "admin.testCatalog.methods.error.duplicateCode": "A method with this code already exists. Enter a different code.",
  "admin.testCatalog.methods.error.invalidRequest": "The request was refused. Check the fields and try again.",
  "admin.testCatalog.methods.error.server": "The server could not complete the request. Try again.",
  "admin.testCatalog.methods.linked": "Method linked.",
  "admin.testCatalog.methods.created": "Method created and linked.",
  "admin.testCatalog.methods.copied": "From {source}: {count, plural, one {# method} other {# methods}} copied.",
  "admin.testCatalog.methods.copyNothing": "No methods copied: {source} has no methods that are not already linked to this test.",
  "admin.testCatalog.methods.empty": "未关联任何方法。请使用“+ 关联方法”或“+ 创建新方法”来添加一个。",
  "testnotification.bcc": "密送",
  "testnotification.instructionis.variables.body": "[testName]：此检测的名称",
  "testnotification.instructionis.variables.body.0": "[testResult]：检测结果",
  "testnotification.instructionis.variables.body.1": "[patientFirstName]：患者名",
  "testnotification.instructionis.variables.body.2": "[patientLastNameInitial]：患者姓的首字母",
  "testnotification.instructionis.variables.header": "变量列表：",
  "testnotification.instructions.body": "创建通知时，首先检查是否为收件人/消息类型定义了消息模板。",
  "testnotification.instructions.body.0": "如果不存在，它将使用检测默认消息。",
  "testnotification.instructions.body.1": "如果不存在，它将使用系统默认消息。",
  "testnotification.instructions.body.2": "变量将在消息正文和主题中被其相应的值替换。",
  "testnotification.instructions.body.3": "变量应始终包含方括号且不应有空格。",
  "testnotification.instructions.header": "说明：",
  "testnotification.messagetemplate": "消息",
  "testnotification.options": "单独消息",
  "testnotification.patient.email": "患者电子邮件",
  "testnotification.patient.sms": "患者短信",
  "testnotification.patiententry.header": "结果报告",
  "testnotification.patiententry.info": "如果OpenELIS无法连接到传输结果的收件人，它将将它们排队。大且不断增长的队列是出现问题的迹象，应进行故障排除，包括联系接收方。",
  "testnotification.provider.email": "提供者电子邮件",
  "testnotification.provider.sms": "提供者短信",
  "testnotification.subjecttemplate": "主题",
  "testnotification.systemdefault.template": "系统默认消息",
  "testnotification.testdefault.editIcon": "编辑检测通知",
  "testnotification.testdefault.template": "检测的默认消息",
  "testnotificationconfig.browse.title": "检测通知配置",
  "tests.not.assigned": "未分配的检测",
  "testsection.testSectionName": "检测部分名称",
  "testUnit.existing": "现有检测单元",
  "testUnit.existing.inactive": "非活跃检测单元。分配检测以激活。",
  "testUnit.new": "新单元检测",
  "text.length.max": "文本长度不应大于200",
  "title.notestfoundmatching": "未找到匹配的检测",
  "to.title": "到",
  "tooltip.banner.menu.generic.sample.results": "为通用样本输入检测结果",
  "tooltip.banner.menu.workplan.batch": "Batch Workplan",
  "total.quantity": "总数量",
  "transaction.date": "日期",
  "transaction.quantity": "数量",
  "transaction.type": "类型",
  "transaction.user": "用户",
  "true.label": "真",
  "unifiedSystemUser.add.user": "添加用户",
  "unifiedSystemUser.browser.button.add": "添加新用户",
  "unifiedSystemUser.browser.search": "按用户名搜索",
  "unifiedSystemUser.browser.search.placeholder": "按用户名搜索...",
  "unifiedSystemUser.browser.title": "用户管理",
  "unifiedSystemUser.edit.user": "修改用户",
  "unifiedSystemUser.select": "选择",
  "unknown.section": "未知部分",
  "unknown.test": "未知检测",
  "uom.browse.title": "测量单位",
  "uom.create.heading.confirmation": "确认",
  "uom.existing": "当前测量单位",
  "uom.existing.inactive": "非活跃测量单位。分配检测到此测量单位以激活它。",
  "uom.new": "创建新的测量单位",
  "uom.new.added": "新测量单位将被添加",
  "uom.notification.duplicate": "测量单位已存在",
  "uom.notification.save": "新测量单位已保存。",
  "uom.uomName": "测量单位名称",
  "training.installation.message": "这是培训/演示系统，请勿录入真实患者数据",
  "translation.edit.title": "编辑翻译",
  "translation.export": "导出翻译",
  "translation.export.success": "翻译导出成功",
  "translation.fallback": "备用值",
  "translation.management.description": "管理应用程序的翻译和本地化",
  "translation.management.title": "翻译管理",
  "translation.missing": "缺失翻译",
  "translation.search": "搜索翻译",
  "translation.selectLocale": "选择语言环境",
  "translation.showMissing": "仅显示缺失项",
  "translation.stats.title": "翻译统计",
  "translation.stats.total": "总计",
  "translation.update.error": "更新翻译失败",
  "translation.update.success": "翻译更新成功",
  "translation.value": "翻译值",
  "usage.analysisId": "分析ID",
  "usage.date": "使用日期",
  "usage.error.quantityPositive": "数量必须大于0",
  "usage.fefo.note": "The quantity is deducted from this item's earliest-expiring QC-passed lot (FEFO), which may not be the lot you opened this from.",
  "usage.item": "项目",
  "usage.notes": "备注",
  "usage.notes.placeholder": "添加关于此使用情况的任何备注",
  "usage.quantityUsed": "使用数量",
  "usage.quantityUsed.helper": "输入消耗的单位数量",
  "usage.record.button": "记录使用情况",
  "usage.record.error": "Error recording usage",
  "usage.record.success": "使用情况记录成功",
  "usage.record.title": "记录库存使用情况",
  "usage.testResultId": "检测结果ID（可选）",
  "usage.testResultId.placeholder": "链接到检测结果以进行追溯",
  "user.select.instruction": "选择要修改或停用的用户。您可以设置过滤器、搜索用户或添加用户以及顶部的控件。",
  "validation.accept.all": "保存所有结果",
  "validation.accept.normal": "保存所有正常",
  "validation.field.required": "此字段为必填项",
  "validation.ignore.all": "忽略所有结果",
  "validation.label.nonconform": "= 样本或订单不符合或检测已被拒绝",
  "validation.legend.qcHold": "= A quality control covering this result failed; the non-conformity is still open",
  "validation.qcHold.tooltip": "A control run for this test in this lab unit failed. Review the non-conformity before releasing this result.",
  "validation.password.match": "密码不匹配",
  "validation.password.minLength": "密码长度不足",
  "validation.password.notSameAsOld": "新密码不能与旧密码相同",
  "validation.password.specialChar": "密码必须包含至少一个特殊字符",
  "validation.no.records.display": "无可显示的记录",
  "validation.reject.all": "重新检测所有检测",
  "validation.save.error": "结果验证成功",
  "validation.save.success": "结果验证成功",
  "validation.search.noresult": "未找到要验证的结果",
  "validation.search.noresult.analyser": "未找到结果：",
  "vl.arvRegimen": "ARV治疗方案",
  "vl.durationOnARV": "抗逆转录病毒治疗持续时间（月）",
  "vl.durationOnARV.placeholder": "输入治疗月数",
  "vl.indication": "VL检测的适应症",
  "vl.lastVLDate": "上次VL结果日期",
  "vl.lastVLResult": "上次VL检测结果（拷贝/毫升）",
  "vl.lastVLResult.placeholder": "例如，150",
  "vl.pregnancyStatus": "怀孕/哺乳状态",
  "workplan.batch.action.activate": "激活",
  "workplan.batch.action.archive": "归档",
  "workplan.batch.action.complete": "完成",
  "workplan.batch.batches": "Batches",
  "workplan.batch.batches.empty": "No batches found",
  "workplan.batch.column.actions": "操作",
  "workplan.batch.column.count": "检测项目",
  "workplan.batch.column.created": "创建时间",
  "workplan.batch.column.method": "方法",
  "workplan.batch.column.name": "Batch",
  "workplan.batch.column.sampleType": "样本类型",
  "workplan.batch.column.status": "状态",
  "workplan.batch.column.test": "检测",
  "workplan.batch.column.unit": "单位",
  "workplan.batch.create": "Create batch ({count})",
  "workplan.batch.create.error": "Batch could not be created",
  "workplan.batch.create.success": "Batch created",
  "workplan.batch.pending.empty": "No pending tests found",
  "workplan.batch.pendingTests": "Pending Tests",
  "workplan.batch.refresh": "刷新",
  "workplan.batch.selectPage": "Select page",
  "workplan.batch.selectTest": "选择{accessionNumber}",
  "workplan.batch.status.ACTIVE": "活跃",
  "workplan.batch.status.ARCHIVED": "归档",
  "workplan.batch.status.COMPLETED": "已完成",
  "workplan.batch.status.DRAFT": "草稿",
  "workplan.batch.status.error": "Batch status could not be updated",
  "workplan.batch.status.success": "Batch status updated",
  "workplan.batch.tabs": "Batch workplan tabs",
  "workplan.batch.title": "Batch Workplan",
  "workplan.page.title": "工作计划 {0}",
  "workplan.panel.selection.error.msg": "这是无效的错误消息。",
  "workplan.panel.title": "按面板的工作计划",
  "workplan.panel.types": "面板类型",
  "workplan.print": "打印工作计划",
  "workplan.priority.list": "优先级",
  "workplan.priority.title": "按优先级的工作计划",
  "workplan.run": "获取工作计划",
  "workplan.test.title": "按检测的工作计划",
  "workplan.test.types": "检测类型",
  "workplan.title": "工作计划",
  "workplan.unit.title": "按单元的工作计划",
  "workplan.unit.types": "单元类型",
  "yes.option": "是",
  "shipment.module.title": "样本转运",
  "shipment.breadcrumb": "转运",
  "shipment.nav.dashboard": "仪表板",
  "shipment.nav.createBox": "创建转运箱",
  "shipment.nav.receiveBox": "接收转运箱",
  "shipment.dashboard.title": "样本转运管理",
  "shipment.dashboard.description": "管理样本的转运和分发",
  "shipment.dashboard.tabs.shipments": "转运列表",
  "shipment.dashboard.tabs.unassigned": "未分配样本",
  "shipment.tab.boxes": "转运箱",
  "shipment.tab.unassignedSamples": "未分配样本",
  "shipment.label.boxId": "箱子编号",
  "shipment.label.createdDate": "创建日期",
  "shipment.label.daysUnassigned": "未分配天数",
  "shipment.label.destination": "目标机构",
  "shipment.label.priority": "优先级",
  "shipment.label.referralTest": "转诊检测",
  "shipment.label.sampleCount": "样本数量",
  "shipment.label.state": "状态",
  "shipment.label.tests": "检测项目",
  "shipment.filter.state": "状态筛选",
  "shipment.filter.facility": "机构筛选",
  "shipment.action.addSelected": "添加已选择内容",
  "shipment.action.addToBox": "加入转运箱",
  "shipment.action.cancelReferral": "取消转诊",
  "shipment.action.confirmRejection": "确认拒绝",
  "shipment.action.createBox": "创建转运箱",
  "shipment.action.markAsLost": "标记为丢失",
  "shipment.action.printManifest": "打印清单",
  "shipment.action.rejectSample": "拒绝样本",
  "shipment.action.saveAndMarkReady": "保存并标记为待发",
  "shipment.action.saveBox": "保存转运箱",
  "shipment.action.saveDraft": "保存为草稿",
  "shipment.action.scanSample": "扫描样本",
  "shipment.box.addSample": "添加样本",
  "shipment.box.addSampleDescription": "扫描或搜索样本以添加到此转运箱",
  "shipment.box.addSamples": "添加样本",
  "shipment.box.details": "包装详情",
  "shipment.box.autoGenerate": "自动生成",
  "shipment.box.capacity": "容量",
  "shipment.box.capacityValue": "{used}/{total}",
  "shipment.box.create": "创建",
  "shipment.box.createDescription": "填写以下信息创建新的转运箱",
  "shipment.box.created": "创建时间",
  "shipment.box.createdBy": "创建人",
  "shipment.box.createdDate": "创建日期",
  "shipment.box.destination": "目标机构",
  "shipment.box.downloadLabel": "下载标签",
  "shipment.box.downloadManifest": "下载清单",
  "shipment.box.generateLabel": "生成标签",
  "shipment.box.generateManifest": "生成清单",
  "shipment.box.id": "箱子编号",
  "shipment.box.labelDownloaded": "标签已下载",
  "shipment.box.labelPrefix": "标签前缀",
  "shipment.box.labelPrefixHelper": "设置转运箱标签的前缀",
  "shipment.box.manifest": "转运清单",
  "shipment.box.manifestDownloaded": "清单已下载",
  "shipment.box.noSamples": "此转运箱暂无样本",
  "shipment.box.noUnassignedSamples": "暂无未分配的样本",
  "shipment.box.notes": "备注",
  "shipment.box.notesPlaceholder": "输入转运备注（可选）",
  "shipment.box.number": "箱号",
  "shipment.box.readyConfirmation": "确认将此转运箱标记为待发送？",
  "shipment.box.readySampleCount": "此转运箱包含 {count} 个样本",
  "shipment.box.readyToSend": "准备发送",
  "shipment.box.reconcile": "核对",
  "shipment.box.removeSample": "移除样本",
  "shipment.box.removeSampleConfirmation": "确认从转运箱中移除此样本？",
  "shipment.box.resendManifest": "重新发送清单",
  "shipment.box.sampleCount": "样本数量",
  "shipment.box.sampleProgress": "{added}/{capacity} 个样本",
  "shipment.box.samplesAdded": "已添加样本",
  "shipment.box.samplesSelected": "已选择 {count} 个样本",
  "shipment.box.scanExisting": "扫描现有",
  "shipment.box.scanExistingId": "扫描现有箱编号",
  "shipment.box.scanExistingIdPlaceholder": "扫描或输入现有箱编号",
  "shipment.box.sendBox": "发送转运箱",
  "shipment.box.sendConfirmation": "确认发送此转运箱？",
  "shipment.box.sendSampleCount": "将发送 {count} 个样本",
  "shipment.box.state": "状态",
  "shipment.box.summary": "转运箱摘要",
  "shipment.box.temperature": "储存温度",
  "shipment.box.title": "转运箱详情",
  "shipment.box.useExistingId": "使用现有编号",
  "shipment.dashboard.boxNotFound": "未找到转运箱",
  "shipment.dashboard.scanBoxPlaceholder": "扫描箱子编号",
  "shipment.error.addSample": "添加样本失败",
  "shipment.error.assignToBox": "分配至转运箱失败",
  "shipment.error.boxFull": "转运箱已满",
  "shipment.error.boxNotEmpty": "转运箱不为空",
  "shipment.error.boxNotFound": "未找到转运箱",
  "shipment.error.cancelReferral": "取消转诊失败",
  "shipment.error.confirmReception": "确认接收失败",
  "shipment.error.createBox": "创建转运箱失败",
  "shipment.error.exceedsCapacity": "超出转运箱容量",
  "shipment.error.fetchBox": "获取转运箱信息失败",
  "shipment.error.fetchBoxes": "获取转运箱列表失败",
  "shipment.error.generateLabel": "生成标签失败",
  "shipment.error.generateManifest": "生成清单失败",
  "shipment.error.invalidState": "转运箱状态无效",
  "shipment.error.markAsLost": "标记丢失失败",
  "shipment.error.markReady": "标记待发送失败",
  "shipment.error.noDestinationFacility": "未设置目标机构",
  "shipment.error.noReferralId": "未找到转诊编号",
  "shipment.error.noSampleSelected": "请先选择样本",
  "shipment.error.partialReception": "部分接收",
  "shipment.error.partialSampleAdd": "Only {added} of {total} samples were added to the box. It was left as a draft so you can add the rest.",
  "shipment.error.reasonRequired": "原因为必填项",
  "shipment.error.reconcile": "核对失败",
  "shipment.error.removeSample": "移除样本失败",
  "shipment.error.sampleAlreadyAssigned": "样本已分配至其他转运箱",
  "shipment.error.sampleAlreadyInBox": "样本已在转运箱中",
  "shipment.error.sampleNotFound": "未找到样本",
  "shipment.error.saveFailed": "保存失败",
  "shipment.error.searchFailed": "搜索失败，请重试",
  "shipment.error.selectBox": "请先选择转运箱",
  "shipment.error.sendBox": "发送转运箱失败",
  "shipment.filter.clear": "清除筛选",
  "shipment.filter.dateFrom": "开始日期",
  "shipment.filter.dateTo": "结束日期",
  "shipment.filter.referenceLab": "参考实验室",
  "shipment.label.addedDate": "添加日期",
  "shipment.label.position": "位置",
  "shipment.label.samples": "样本",
  "shipment.label.shippingLabel": "转运标签",
  "shipment.manifest.generated": "生成时间",
  "shipment.manifest.number": "清单编号",
  "shipment.manifest.recallExpired": "清单召回已过期",
  "shipment.manifest.regenerationExpired": "清单已过期，请重新生成",
  "shipment.manifest.serviceLocation": "服务地点",
  "shipment.manifest.specimenBarcodes": "样本条码",
  "shipment.manifest.title": "转运清单",
  "shipment.manifest.totalSamples": "样本总数",
  "shipment.modal.addToBox.existingBox": "加入现有箱",
  "shipment.modal.addToBox.mode": "加入方式",
  "shipment.modal.addToBox.newBox": "创建新箱",
  "shipment.modal.addToBox.newBoxInfo.message": "将创建新转运箱并将此样本加入",
  "shipment.modal.addToBox.newBoxInfo.title": "新建转运箱",
  "shipment.modal.addToBox.noDraftBoxes.message": "没有可用的草稿转运箱，请先创建新箱",
  "shipment.modal.addToBox.noDraftBoxes.title": "暂无草稿转运箱",
  "shipment.modal.addToBox.selectBox": "选择转运箱",
  "shipment.modal.addToBox.title": "加入转运箱",
  "shipment.modal.cancelReferral.reason": "取消原因",
  "shipment.modal.cancelReferral.reasonPlaceholder": "输入取消转诊的原因",
  "shipment.modal.cancelReferral.title": "取消转诊",
  "shipment.modal.cancelReferral.warning.message": "取消转诊后，相关检测将被退回，无法恢复",
  "shipment.modal.cancelReferral.warning.title": "警告",
  "shipment.modal.createBox.cancel": "取消",
  "shipment.modal.createBox.submit": "创建",
  "shipment.modal.createBox.title": "创建转运箱",
  "shipment.modal.markAsLost.reason": "丢失原因",
  "shipment.modal.markAsLost.reasonPlaceholder": "输入丢失原因",
  "shipment.modal.markAsLost.title": "标记为丢失",
  "shipment.modal.markAsLost.warning.message": "将此样本标记为丢失后，将无法再进行后续操作",
  "shipment.modal.markAsLost.warning.title": "警告",
  "shipment.modal.rejectSample": "拒绝样本",
  "shipment.modal.rejectSampleMessage": "确认拒绝此样本？",
  "shipment.nav.referenceLabResults": "参考实验室检测结果",
  "shipment.nav.reports": "报告",
  "shipment.nav.settings": "设置",
  "shipment.notification.boxCreated": "转运箱创建成功",
  "shipment.notification.boxReadyToSend": "转运箱已标记为待发送",
  "shipment.notification.boxReconciled": "转运箱核对完成",
  "shipment.notification.boxSent": "转运箱已成功发送",
  "shipment.notification.error": "操作失败，请重试",
  "shipment.notification.partialSamplesAdded": "部分样本已添加（部分样本已存在或超出容量）",
  "shipment.notification.receptionComplete": "转运箱接收完成",
  "shipment.notification.referralCancelled": "转诊已取消",
  "shipment.notification.sampleAdded": "样本添加成功",
  "shipment.notification.sampleAssignedToBox": "样本已分配到转运箱",
  "shipment.notification.sampleMarkedAsLost": "样本已标记为丢失",
  "shipment.notification.sampleRejected": "样本已拒收",
  "shipment.notification.sampleRemoved": "样本已移除",
  "shipment.notification.samplesAdded": "{count, plural, other {{count}个样本已添加}}",
  "shipment.notification.samplesRemovedDueToCapacity": "部分样本因超出容量而被移除",
  "shipment.reception.acceptSample": "接受样本",
  "shipment.reception.applyToAll": "应用到全部",
  "shipment.reception.awaitingAcceptance": "等待确认",
  "shipment.reception.confirmMessage": "确认完成此转运箱的接收？",
  "shipment.reception.confirmReception": "确认接收",
  "shipment.reception.damaged": "损坏",
  "shipment.reception.description": "扫描或输入箱子编号进行接收",
  "shipment.reception.enterBoxId": "输入箱子编号",
  "shipment.reception.generalNotes": "总体备注",
  "shipment.reception.generalNotesPlaceholder": "输入接收总体备注",
  "shipment.reception.importError": "FHIR导入失败",
  "shipment.reception.importFromFhir": "从FHIR导入",
  "shipment.reception.importResult": "导入成功",
  "shipment.reception.incomingBoxes": "待收货",
  "shipment.reception.leaked": "泄漏",
  "shipment.reception.markAllMissing": "全部标记为缺失",
  "shipment.reception.markAllReceived": "全部标记为已接收",
  "shipment.reception.missing": "缺失",
  "shipment.reception.noIncomingBoxes": "没有新到货。请点击“从FHIR导入”以查看是否有新到货。",
  "shipment.reception.notes": "备注",
  "shipment.reception.notesPlaceholder": "输入样本状态备注",
  "shipment.reception.notesRequired": "请注明拒收/损坏原因",
  "shipment.reception.notesRequiredPlaceholder": "输入原因...",
  "shipment.reception.openBox": "待处理",
  "shipment.reception.originFacility": "来源",
  "shipment.reception.pending": "待处理",
  "shipment.reception.pendingAcceptance": "待接受的标本",
  "shipment.reception.received": "已接收",
  "shipment.reception.referralOrder": "转介令",
  "shipment.reception.rejected": "已拒收",
  "shipment.reception.sampleCountSummary": "{accepted} 已接受 / 预期为 {expected}",
  "shipment.reception.sampleNotFound": "未找到此样本",
  "shipment.reception.sampleScanned": "样本已扫描",
  "shipment.reception.sampleVerification": "样本核查",
  "shipment.reception.scanBox": "扫描箱子",
  "shipment.reception.scanBoxPlaceholder": "扫描或输入箱子编号",
  "shipment.reception.scanButton": "扫描",
  "shipment.reception.scanSample": "扫描样本",
  "shipment.reception.scanSampleButton": "扫描",
  "shipment.reception.scanSamplePlaceholder": "扫描样本条码",
  "shipment.reception.shipped": "已发货",
  "shipment.reception.specimen": "标本",
  "shipment.reception.status": "状态",
  "shipment.reception.title": "接收转运箱",
  "shipment.reception.unresolved": "没有匹配的订单",
  "shipment.rejection.damaged": "损坏",
  "shipment.rejection.expired": "已过期",
  "shipment.rejection.insufficientVolume": "量不足",
  "shipment.rejection.other": "其他原因",
  "shipment.rejection.reason": "拒绝原因",
  "shipment.rejection.wrongType": "类型错误",
  "shipment.report.contents": "内容",
  "shipment.report.description": "查看和导出转运报告",
  "shipment.report.export.excel": "导出Excel",
  "shipment.report.export.pdf": "导出PDF",
  "shipment.report.generate": "生成报告",
  "shipment.report.noResults": "暂无报告数据",
  "shipment.report.receivedDate": "接收日期",
  "shipment.report.receivedStatus": "接收状态",
  "shipment.report.receiver": "接收方",
  "shipment.report.receivingUser": "接收人",
  "shipment.report.sender": "发送方",
  "shipment.report.sentDate": "发送日期",
  "shipment.report.title": "转运报告",
  "shipment.report.totalBoxes": "总箱数",
  "shipment.report.totalSamples": "样本总数",
  "shipment.sample.accessionNumber": "订单号",
  "shipment.sample.multipleMatches": "有多个匹配的样本——请选择要添加的样本",
  "shipment.sample.remove": "移除样本",
  "shipment.sample.search": "搜索样本",
  "shipment.sample.searchPlaceholder": "搜索样本...",
  "shipment.sample.status": "状态",
  "shipment.sample.type": "样本类型",
  "shipment.settings.administration": "管理",
  "shipment.settings.boxLabelSection": "转运箱标签设置",
  "shipment.settings.description": "配置样本转运系统",
  "shipment.settings.fhirConfig": "FHIR配置",
  "shipment.settings.fhirConfigDesc": "配置FHIR集成设置",
  "shipment.settings.fhirConfigNote": "FHIR配置用于与外部系统集成进行样本数据交换",
  "shipment.settings.fhirConfigSaveError": "FHIR配置保存失败",
  "shipment.settings.fhirConfigSaved": "FHIR配置保存成功",
  "shipment.settings.fhirContainerType": "FHIR容器类型",
  "shipment.settings.fhirDisplayName": "显示名称",
  "shipment.settings.fhirNonConformity": "不符合代码",
  "shipment.settings.fhirSnomedCode": "SNOMED代码",
  "shipment.settings.manageFacilities": "管理机构",
  "shipment.settings.manageFacilitiesDesc": "配置参与转运的机构",
  "shipment.settings.manageUsers": "管理用户",
  "shipment.settings.manageUsersDesc": "配置转运系统用户权限",
  "shipment.settings.prefixHelperText": "标签前缀用于标识转运箱，最多4个字符",
  "shipment.settings.prefixPlaceholder": "输入前缀（最多4个字符）",
  "shipment.settings.prefixPreview": "标签预览",
  "shipment.settings.prefixRequired": "前缀为必填项",
  "shipment.settings.prefixSaveError": "前缀保存失败",
  "shipment.settings.prefixSaved": "前缀保存成功",
  "shipment.settings.siteOrgDescription": "配置此站点关联的机构",
  "shipment.settings.siteOrgLabel": "关联机构",
  "shipment.settings.siteOrgSaveError": "站点机构保存失败",
  "workflow.clinical": "临床",
  "workflow.environmental": "环境 / 其他原因",
  "provider.name": "供应商名称",
  "provider.name.placeholder": "输入供应商名称",
  "provider.phone": "供应商电话",
  "provider.search.helper": "输入供应商名称或电话号码，然后点击“搜索”。",
  "site.search": "站内搜索",
  "site.name": "站点名称",
  "site.name.placeholder": "输入站点名称",
  "site.location": "位置",
  "site.type": "设备类型",
  "site.department": "科室 / 病区 / 病房",
  "site.department.selectFirst": "请先选择设施...",
  "site.department.choose": "请选择一个部门...",
  "site.department.none": "没有可用子单元",
  "sample.filterByLabUnit": "按实验室单元筛选",
  "sample.allLabUnits": "所有实验室单元",
  "sample.orderPanels": "订单面板",
  "sample.orderTests": "订单检测",
  "sample.referToReferenceLab": "将检测转诊到参考实验室",
  "sample.optional.info": "在此步骤中，样本和检测项目的选择为可选。检测项目和样本类型可在后续采样过程中指定。",
  "panel.search.placeholder": "选择可用面板",
  "test.search.placeholder": "选择可用检测",
  "test.timeHolding": "SOP 最大值保持时间（分钟）",
  "select.regimen": "选择治疗方案...",
  "select": "选择...",
  "generating": "生成中...",
  "label.order": "订单标签行",
  "label.sample": "标签样本",
  "label.slide": "幻灯片标签",
  "label.block": "块标签",
  "label.freezer": "冰箱标签",
  "environmental.coming.soon": "环境工作流",
  "environmental.location.info": "此处将提供位置层次结构字段（区域/地区/城镇-村）和GPS定位功能。",
  "env.collectionConditions.title": "默认催收条款",
  "env.collectionConditions.subtitle": "默认设置已应用到该批次中的所有样本。",
  "env.collectionMethod": "收款方式",
  "env.waterTemp": "水温（°C）",
  "env.ambientTemp": "环境温度（°C）",
  "env.weather": "天气",
  "env.preservationMethod": "保存方法",
  "env.preservationMethod.placeholder": "例如：HNO3酸化、4°C冷却器",
  "env.fieldNotes": "实地笔记",
  "env.fieldNotes.placeholder": "输入实地观察结果……",
  "env.sample.manifest.title": "每样本转运清单",
  "env.sample.manifest.subtitle": "一行 = 一个实物样本",
  "env.sample.container": "容器",
  "env.sample.gpsLat": "GPS纬度",
  "env.sample.gpsLat.placeholder": "例如 -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "例如 106.8456",
  "env.sample.locationDetails": "位置详情",
  "env.sample.locationDetails.placeholder": "例如：Inlet、Bank……",
  "env.sample.collected": "已采样",
  "env.sample.duplicate": "重复样本",
  "env.sample.addRow": "+ 添加样本行",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} in this batch",
  "env.sample.testsAndPanels": "检测项目/组合",
  "env.sample.tests.required": "必填",
  "env.complianceStandards.title": "适用的合规标准",
  "env.complianceStandards.subtitle": "请选择适用于本订单的监管标准。",
  "env.complianceStandards.label": "合规标准",
  "env.complianceStandards.placeholder": "选择标准...",
  "env.complianceStandards.empty": "未配置任何有效的合规标准。请在“管理”→“合规标准”中添加。",
  "order.dashboard.samplingSite": "样本采样点",
  "order.search.placeholder.env": "按站点名称或实验室编号搜索...",
  "order.filter.dateFrom": "来源",
  "order.filter.dateTo": "到",
  "program.placeholder": "输入内容进行筛选，或从列表中选择",
  "program.helper": "输入内容进行筛选，或从列表中选择。选择某个项目后，其具体的“附加订单信息”字段将显示在下方。",
  "patient.externalSearch": "外部搜索",
  "patient.results": "患者结果",
  "patient.id.helper": "请输入受试者编号、国家ID或ST编号。",
  "patient.id.placeholder": "输入患者ID",
  "patient.lastName.placeholder": "输入患者姓",
  "patient.firstName.placeholder": "输入患者名",
  "patient.natId": "唯一健康识别码",
  "patient.dataSource": "数据来源",
  "patient.noResults": "0-0（共0项）",
  "patient.new.info": "请在下方输入新患者的信息。保存医嘱后，系统将自动创建该患者的信息。",
  "pagination.showing": "显示 {start}-{end}（共 {total} 个检测项目）",
  "results.found.for": "搜索“{term}”得到的结果",
  "selected": "已选择",
  "shipment.settings.siteOrgSaved": "站点机构保存成功",
  "shipment.settings.siteOrgSection": "站点机构设置",
  "shipment.settings.title": "转运设置",
  "shipment.state.cancelled": "已取消",
  "shipment.state.draft": "草稿",
  "shipment.state.inTransit": "运输中",
  "shipment.state.lostInTransit": "运输中丢失",
  "shipment.state.partiallyReceived": "部分接收",
  "shipment.state.readyToSend": "准备发送",
  "shipment.state.received": "已接收",
  "shipment.state.reconciled": "已核对",
  "shipment.state.sent": "已发送",
  "shipment.stats.delivered": "已送达",
  "shipment.stats.inTransit": "运输中",
  "shipment.stats.reconciled": "已核对",
  "shipment.stats.totalSamples": "样本总数",
  "shipment.temperature.ambient": "常温",
  "shipment.temperature.deepFrozen": "深冷冻（-80°C）",
  "shipment.temperature.dryIce": "干冰",
  "shipment.temperature.frozen": "冷冻（-20°C）",
  "shipment.temperature.refrigerated": "冷藏（2-8°C）",
  "shipment.validation.addSample": "请至少添加一个样本",
  "shipment.validation.selectDestination": "请选择目标机构",
  "qc.dashboard.title": "质控仪表板",
  "qc.dashboard.lastUpdate": "最后更新时间",
  "qc.dashboard.complianceStatus": "合规状态",
  "qc.dashboard.compliant": "符合要求的",
  "qc.dashboard.warning": "警告",
  "qc.dashboard.nonCompliant": "不符合要求",
  "qc.dashboard.violationsCount": "{count} 违规记录",
  "qc.dashboard.lastResult": "最新结果",
  "qc.dashboard.noInstruments": "未配置任何仪器",
  "qc.dashboard.subtitle": "监控仪器的QC状态和警报",
  "qc.dashboard.loading": "正在加载仪表板数据...",
  "qc.dashboard.refresh": "刷新",
  "qc.dashboard.lastUpdated": "最后更新时间",
  "qc.dashboard.export.title": "Export QC Data",
  "qc.dashboard.export.selectInstrument": "Select an instrument",
  "qc.dashboard.export.dateError": "End date must be on or after the start date.",
  "qc.dashboard.error.title": "错误",
  "qc.dashboard.error.loadFailed": "无法加载仪表板数据。请重试。",
  "qc.dashboard.tab.instruments": "仪器",
  "qc.dashboard.tab.alerts": "警报",
  "qc.dashboard.summary.inControl": "“仪器在控制之中”",
  "qc.dashboard.summary.warningStatus": "警告状态",
  "qc.dashboard.summary.outOfControl": "失控",
  "qc.dashboard.summary.passRate": "总体QC合格率",
  "qc.dashboard.summary.ofTotal": "{percentage}占乐器总数的百分比",
  "qc.dashboard.instruments.title": "仪器质控状态",
  "qc.dashboard.instruments.subtitle": "监控所有实验室仪器的合规状态和QC表现",
  "qc.dashboard.instruments.search": "搜索仪器……",
  "qc.dashboard.instruments.col.id": "仪器编号",
  "qc.dashboard.instruments.col.name": "仪器名称",
  "qc.dashboard.instruments.col.type": "设备类型",
  "qc.dashboard.instruments.col.location": "位置",
  "qc.dashboard.instruments.col.status": "状态",
  "qc.dashboard.instruments.col.analytes": "分析物",
  "qc.dashboard.instruments.col.violations": "近期违规记录",
  "qc.dashboard.instruments.col.lastUpdate": "最后更新",
  "qc.dashboard.instruments.col.actions": "操作",
  "qc.dashboard.instruments.view": "查看",
  "qc.dashboard.instruments.status.green": "掌控之中",
  "qc.dashboard.instruments.status.yellow": "警告",
  "qc.dashboard.instruments.status.red": "失控",
  "qc.dashboard.instruments.status.notConfigured": "未配置",
  "qc.dashboard.instruments.status.unknown": "未知",
  "qc.dashboard.instruments.noViolations": "无违规记录",
  "qc.dashboard.instruments.empty": "未找到乐器",
  "qc.dashboard.alerts.title": "质控违规记录与警报",
  "qc.dashboard.alerts.subtitle": "显示来自{period}的违规记录",
  "qc.dashboard.alerts.timePeriod": "时间段",
  "qc.dashboard.alerts.timePeriod.24h": "过去24小时",
  "qc.dashboard.alerts.timePeriod.72h": "过去72小时",
  "qc.dashboard.alerts.timePeriod.7d": "最近7天",
  "qc.dashboard.alerts.timePeriod.30d": "最近30天",
  "qc.dashboard.alerts.timePeriod.all": "历史总计",
  "qc.dashboard.alerts.active": "当前存在的QC违规记录",
  "qc.dashboard.alerts.active.count": "{count} 需要处理的未确认违规记录",
  "qc.dashboard.alerts.active.empty": "无未解决的违规记录",
  "qc.dashboard.alerts.acknowledge": "确认",
  "qc.dashboard.alerts.acknowledged": "已确认的违规记录",
  "qc.dashboard.alerts.acknowledged.count": "{count} 已确认存在违规行为",
  "qc.dashboard.alerts.acknowledged.empty": "未确认存在违规记录",
  "qc.dashboard.alerts.col.severity": "严重程度",
  "qc.dashboard.alerts.col.time": "时间",
  "qc.dashboard.alerts.col.instrument": "乐器",
  "qc.dashboard.alerts.col.analyte": "分析物",
  "qc.dashboard.alerts.col.rule": "规则",
  "qc.dashboard.alerts.col.acknowledgedBy": "已确认",
  "qc.dashboard.alerts.col.acknowledgedDate": "已确认日期",
  "qc.dashboard.banner.title": "{count} active QC violation(s) require attention",
  "qc.dashboard.banner.viewAll": "View all alerts",
  "qc.violations.error.acknowledgeFailed": "Failed to acknowledge violation",
  "qc.chart.axis.date": "日期时间",
  "qc.chart.axis.run": "Run",
  "qc.chart.axis.value": "标准差（σ）",
  "qc.instrument.notFound": "Instrument not found",
  "qc.chart.stats.sd": "SD",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "Sigma performance",
  "qc.chart.sigma.notCalculable": "Not calculable — TEa not configured",
  "qc.chart.sigma.bias": "Bias not applied (no peer data)",
  "qc.chart.sigma.WORLD_CLASS": "World-class",
  "qc.chart.sigma.ACCEPTABLE": "可接受",
  "qc.chart.sigma.MARGINAL": "Marginal",
  "qc.chart.sigma.POOR": "Poor",
  "qc.chart.title": "Quality Control Chart",
  "qc.chart.loading": "Loading control chart…",
  "qc.chart.error.title": "Unable to load control chart",
  "qc.chart.tabs.label": "Control chart levels",
  "qc.chart.filter.allLevels": "All levels",
  "qc.chart.filter.selectLot": "Select lot",
  "qc.chart.action.zoomIn": "Zoom in",
  "qc.chart.action.zoomOut": "Zoom out",
  "qc.chart.action.zoomReset": "Reset zoom",
  "qc.chart.legend.normal": "正常",
  "qc.chart.legend.violation": "违规记录",
  "qc.chart.mean": "均值",
  "qc.chart.noData": "无可用数据",
  "qc.chart.tooltip.date": "日期",
  "qc.chart.tooltip.value": "值",
  "qc.chart.tooltip.violations": "违规记录",
  "qc.chart.tooltip.zScore": "Z分数",
  "qc.charts.title": "控制图",
  "qc.charts.leveyJennings": "莱维-詹宁斯图",
  "qc.charts.dateRange": "日期范围",
  "qc.charts.controlLevel": "控制级别",
  "qc.charts.export": "导出图表",
  "qc.charts.noData": "无可用数据",
  "qc.violations.title": "QC违规记录",
  "qc.violations.severity": "严重程度",
  "qc.violations.rule": "规则",
  "qc.violations.date": "日期",
  "qc.violations.status": "状态",
  "qc.violations.unresolved": "未解决",
  "qc.violations.resolved": "已解决",
  "qc.violations.acknowledged": "已确认",
  "qc.correctiveActions.title": "纠正措施",
  "qc.correctiveActions.create": "创建纠正措施",
  "qc.correctiveActions.type": "措施类型",
  "qc.correctiveActions.description": "描述",
  "qc.correctiveActions.assignedTo": "分配给",
  "qc.correctiveActions.status": "状态",
  "qc.correctiveActions.pending": "待处理",
  "qc.correctiveActions.inProgress": "进行中",
  "qc.correctiveActions.completed": "已完成",
  "qc.correctiveActions.resolutionNotes": "决议备注",
  "qc.alerts.title": "QC警报",
  "qc.alerts.markAsRead": "标记为已读",
  "qc.alerts.viewDetails": "查看详情",
  "qc.rules.title": "Westgard规则配置",
  "qc.rules.enable": "启用",
  "qc.rules.disable": "禁用",
  "qc.rules.preset": "预设配置",
  "qc.rules.basic": "基础",
  "qc.rules.standard": "标准",
  "qc.rules.comprehensive": "全面",
  "qc.rules.1₂ₛ.description": "一个对照值超出±2个标准差",
  "qc.rules.1₃ₛ.description": "一个对照值超出±3个标准差",
  "qc.rules.2₂ₛ.description": "连续两次对照值在同一方向上超出±2个标准差",
  "qc.rules.R₄ₛ.description": "两个控制变量之间的范围超过4个标准差",
  "qc.rules.4₁ₛ.description": "连续四个控制值均超出±1个标准差，且方向一致",
  "qc.rules.10ₓ.description": "均值同一侧的连续十个对照值",
  "qc.rules.3₁ₛ.description": "连续三次控制值均超出±1个标准差，且方向一致",
  "qc.rules.7ₜ.description": "连续七次检测结果呈相同趋势",
  "qc.ruleConfig.title": "规则配置",
  "qc.ruleConfig.subtitle": "根据分析仪和检测组合配置Westgard规则",
  "qc.ruleConfig.field.analyzer": "分析仪",
  "qc.ruleConfig.field.selectAnalyzer": "选择分析仪",
  "qc.ruleConfig.field.test": "检测",
  "qc.ruleConfig.field.selectTest": "选择一项检测",
  "qc.ruleConfig.field.severity": "严重程度",
  "qc.ruleConfig.severity.warning": "警告",
  "qc.ruleConfig.severity.rejection": "拒绝",
  "qc.ruleConfig.category.rejection": "拒绝规则",
  "qc.ruleConfig.category.warning": "警告规则",
  "qc.ruleConfig.action.reset": "重置到默认值",
  "qc.ruleConfig.loading": "正在加载规则配置……",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "选择一台分析仪和一项检测，以配置Westgard规则。",
  "qc.ruleConfig.error.title": "错误",
  "qc.ruleConfig.error.selectAnalyzerTest": "请同时选择分析仪和检测项目。",
  "qc.ruleConfig.error.saveFailed": "保存失败。",
  "qc.ruleConfig.success.title": "成功",
  "qc.ruleConfig.success.saved": "规则配置已成功保存。",
  "qc.ruleConfig.table.title": "已配置的规则集",
  "qc.ruleConfig.table.empty": "未找到任何规则配置。",
  "qc.ruleConfig.field.enabledRules": "已启用的规则",
  "qc.ruleConfig.unconfigured.title": "未配置的控制映射",
  "qc.ruleConfig.unconfigured.subtitle": "未配置Westgard规则的对照批次",
  "qc.ruleConfig.unconfigured.configure": "配置",
  "qc.ruleConfig.unconfigured.activeLots": "活跃地块",
  "qc.ruleConfig.modal.title.edit": "编辑规则配置",
  "qc.ruleConfig.modal.title.create": "创建规则配置",
  "button.saving": "保存中...",
  "qc.controlLots.title": "对照组",
  "qc.controlLots.create": "创建控制批次",
  "qc.controlLots.productName": "产品名称",
  "qc.controlLots.lotNumber": "批号",
  "qc.controlLots.level": "控制级别",
  "qc.controlLots.statisticsMethod": "统计计算方法",
  "qc.controlLots.initialRuns": "初期运行",
  "qc.controlLots.rolling": "滑动窗口",
  "qc.controlLots.manufacturerFixed": "制造商已修复",
  "qc.controlLots.activationDate": "激活日期",
  "qc.controlLots.expirationDate": "过期日期",
  "qc.controlLots.status.active": "活跃",
  "qc.controlLots.status.establishment": "成立",
  "qc.controlLots.status.expired": "已过期",
  "qc.controlLots.subtitle": "管理用于Westgard规则评估的质量控制批次",
  "qc.controlLots.empty": "未找到对照组",
  "qc.controlLot.filter.allStatuses": "所有状态",
  "qc.controlLot.status.establishment": "成立",
  "qc.controlLot.status.active": "活跃",
  "qc.controlLot.status.expired": "已过期",
  "qc.controlLot.field.lotNumber": "批号",
  "qc.controlLot.field.lotNumberPlaceholder": "输入批号",
  "qc.controlLot.field.material": "对照材料",
  "qc.controlLot.field.materialPlaceholder": "输入材料名称",
  "qc.controlLot.field.manufacturer": "制造商",
  "qc.controlLot.field.level": "控制级别",
  "qc.controlLot.field.selectLevel": "选择级别",
  "qc.controlLot.field.expiration": "过期日期",
  "qc.controlLot.field.analyzer": "分析仪",
  "qc.controlLot.field.selectAnalyzer": "选择分析仪",
  "qc.controlLot.field.analyzerHelper": "Optional. Choose \"Bench / no analyzer\" for a manual method run at the bench without an instrument.",
  "qc.controlLot.analyzer.bench": "Bench / no analyzer (manual method)",
  "qc.controlLot.field.test": "检测",
  "qc.controlLot.field.selectTest": "选择检测",
  "qc.controlLot.field.isActive": "状态",
  "qc.controlLot.field.inactive": "非活跃",
  "qc.controlLot.field.active": "活跃",
  "qc.controlLot.field.status": "状态",
  "qc.controlLot.loading": "加载中...",
  "qc.controlLot.error.title": "错误",
  "qc.controlLot.error.saveFailed": "保存失败",
  "qc.controlLot.error.statsRequired": "Manufacturer-fixed lots need a mean and standard deviation. Click \"Configure\" to enter them before saving.",
  "qc.controlLot.error.benchNeedsFixedStats": "A bench lot has no analyzer accumulating runs, so it must use manufacturer-fixed statistics. Click \"Configure\" to enter a mean and standard deviation, or select an analyzer for this lot.",
  "qc.controlLot.new.title": "新对照组",
  "qc.controlLot.viewChart": "View chart",
  "qc.controlLot.new.subtitle": "创建新的QC批次",
  "qc.controlLot.edit.title": "编辑控制地块",
  "qc.controlLot.edit.subtitle": "更新控制批次配置",
  "qc.controlLot.validation.lotNumberRequired": "必须填写批号",
  "qc.controlLot.validation.materialRequired": "需要材料",
  "qc.controlLot.validation.levelRequired": "需要控制级别",
  "qc.controlLot.validation.expirationRequired": "必须填写过期日期",
  "qc.controlLot.validation.analyzerRequired": "分析仪为必填项",
  "qc.controlLot.validation.testRequired": "需要进行检测",
  "qc.controlLot.level.low": "低",
  "qc.controlLot.level.normal": "正常",
  "qc.controlLot.level.high": "高",
  "qc.controlLot.statistics.title": "统计配置",
  "qc.controlLot.statistics.configure": "配置",
  "qc.controlLot.statistics.method": "计算方法",
  "qc.controlLot.statistics.mean": "均值",
  "qc.controlLot.statistics.sd": "标准差",
  "qc.controlLot.statistics.config.title": "统计配置",
  "qc.controlLot.statistics.config.label": "配置统计信息的方法",
  "qc.controlLot.statistics.method.manufacturer_fixed": "制造商已修复",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "使用制造商提供的均值和标准差值",
  "qc.controlLot.statistics.method.rolling": "滑动窗口",
  "qc.controlLot.statistics.method.rolling.description": "根据最近的 N 次结果重新计算",
  "qc.controlLot.statistics.method.initial_runs": "初期运行",
  "qc.controlLot.statistics.method.initial_runs.description": "从前 N 次建立运行中计算一次",
  "qc.controlLot.statistics.manufacturerValues": "制造商价值观",
  "qc.controlLot.statistics.rollingConfig": "滚动配置",
  "qc.controlLot.statistics.windowSize": "窗口大小",
  "qc.controlLot.statistics.windowSize.helper": "计算中应包含的近期结果数量",
  "qc.controlLot.statistics.initialRunsConfig": "初始运行配置",
  "qc.controlLot.statistics.initialRunsRequired": "所需跑垒数",
  "qc.controlLot.statistics.initialRunsRequired.helper": "在计算统计数据之前执行的建立次数",
  "qc.instrumentDetail.analytesMonitored": "监测的分析物",
  "qc.instrumentDetail.analyte.cv": "简历：{value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {# violation} other {# violations}}",
  "qc.instrumentDetail.tab.activityTimeline": "活动时间轴",
  "qc.instrumentDetail.tab.controlChart": "控制图",
  "qc.instrumentDetail.timeline.empty": "在已选择的时间段内未记录任何警报或纠正措施",
  "qc.instrumentDetail.timeline.violation": "违规记录",
  "qc.instrumentDetail.timeline.correctiveAction": "纠正措施",
  "qc.instrumentDetail.timeline.loading": "正在加载活动时间轴...",
  "qc.instrumentDetail.chart.selectAnalyte": "选择分析物",
  "qc.instrumentDetail.chart.loading": "正在加载控制图...",
  "qc.instrumentDetail.chart.noData": "该分析物无可用数据",
  "qc.instrumentDetail.chart.activeRules": "有效的QC规则",
  "qc.instrumentDetail.chart.noRules": "未配置任何有效的规则",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "均值 (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "标准差 (s)",
  "qc.instrumentDetail.error.loadFailed": "无法加载乐器详情",
  "qc.instrumentDetail.notConfigured.title": "未配置运行QC",
  "qc.instrumentDetail.notConfigured.description": "该分析仪未关联任何有效对照组或QC结果。",
  "question.text.required": "必须填写问题内容",
  "compliance.legend.limitTypes": "限制类型：",
  "compliance.limitType.borderlineShort": "边缘型 ⚑",
  "compliance.limitType.descriptiveShort": "定性",
  "compliance.limitType.MAXIMUM": "最高限额 ≤",
  "compliance.limitType.MINIMUM": "下限 ≥",
  "compliance.limitType.RANGE": "正常范围",
  "compliance.limitType.BORDERLINE": "边缘型 🚩",
  "compliance.limitType.DESCRIPTIVE": "定性",
  "compliance.limitType.EXACT": "精确",
  "compliance.limitType.SELECT_MAP": "值映射",
  "compliance.status.ACTIVE": "活跃",
  "compliance.status.DRAFT": "草稿",
  "compliance.status.SUPERSEDED": "已废止",
  "compliance.status.ARCHIVED": "归档",
  "compliance.standard.placeholder.name": "例如，第22/2021号总统令——水质",
  "compliance.standard.placeholder.issuingBody": "例如，印度尼西亚政府",
  "compliance.standard.placeholder.regulationNumber": "例如，PP 22/2021",
  "compliance.standard.placeholder.version": "例如，2021年",
  "compliance.standard.placeholder.countryRegion": "例如，印度尼西亚",
  "compliance.standard.placeholder.description": "可选。对标准适用范围的完整描述。",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "较低 / 最小",
  "compliance.threshold.placeholder.upper": "上层 / 最大值",
  "compliance.threshold.placeholder.unit": "单位",
  "compliance.standard.archive": "归档",
  "compliance.standard.archiveHeading": "归档合规标准",
  "compliance.standard.archivePrompt": "将此标准归档？现有评估结果仍会与该标准保持关联，以便进行审计，但该标准将从活动选择列表中隐藏。通过将该标准的状态编辑回“活跃”状态，可以撤销此操作。",
  "compliance.standard.archived": "合规标准已归档。",
  "compliance.standard.archiveError": "无法归档此标准。",
  "button.complianceStandard.copy": "复制标准",
  "compliance.standard.copied": "合规标准已复制为新的草稿。",
  "compliance.standard.copyError": "无法复制此标准。",
  "compliance.standard.viewLinkedTests": "查看相关检测项目",
  "compliance.testEditor.groupBy": "按……分组",
  "compliance.testEditor.section.configuration": "配置",
  "compliance.testEditor.section.organization": "机构",
  "compliance.testEditor.section.resources": "资源",
  "compliance.testEditor.section.automation": "自动化",
  "compliance.testEditor.section.compliance": "合规",
  "compliance.testEditor.tab.compliance": "合规",
  "compliance.testEditor.tabPlaceholder": "随“测试编辑器”界面一同提供——目前请通过“修改检测”页面进行管理。",
  "compliance.parameterGroup.editBtn": "编辑",
  "compliance.parameterGroup.moveUp": "向上移动",
  "compliance.parameterGroup.moveDown": "向下移动",
  "compliance.parameterGroup.updateError": "无法更新参数组。",
  "compliance.testEditor.standardInactiveBanner": "该测试的阈值与 {name} 相关联，该链接现已更改为 {status}。测试结果将不再依据该标准进行评估。",
  "compliance.standard.viewLinkedTests.heading": "相关检测项目 — {name}",
  "compliance.standard.viewLinkedTests.empty": "目前尚无任何检测项目与该标准相关联。",
  "compliance.filter.status": "状态",
  "compliance.filter.region": "区域",
  "compliance.filter.allStatuses": "所有状态",
  "compliance.filter.allRegions": "所有区域",
  "compliance.filter.sampleType": "样本类型",
  "compliance.filter.allSampleTypes": "所有样本类型",
  "compliance.sampleTypes.addLabel": "添加样本类型",
  "compliance.sampleTypes.noneConfigured": "无配置",
  "compliance.sampleTypes.noneTitle": "尚未配置任何样本类型。",
  "compliance.sampleTypes.noneSubtitle": "在链接检测之前，请至少添加一种样本类型。",
  "compliance.sampleTypes.counter": "{count, plural, one {# sample type configured} other {# sample types configured}}",
  "compliance.standard.default": "默认值",
  "compliance.standard.groups": "组",
  "compliance.standard.tests": "检测项目",
  "compliance.standard.expiryDate": "过期日期",
  "compliance.parameterGroups.heading": "参数组与关联检测项目",
  "compliance.parameterGroups.requireSampleTypes": "首先配置标准的字段和样本类型，然后关联检测项目。",
  "compliance.button.save": "保存",
  "compliance.button.saving": "正在保存……",
  "compliance.parameterGroup.createError": "无法添加参数组。",
  "compliance.parameterGroup.deleteHeading": "删除参数组",
  "compliance.parameterGroup.deletePrompt": "是否要删除参数组“{name}”及其所有阈值？此操作无法撤销。",
  "compliance.parameterGroup.deleteWarning": "{count, plural, one {# test is} other {# tests are}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "无法保存此行。",
  "compliance.threshold.deleteError": "无法移除此行。",
  "compliance.validation.required": "此字段为必填项.",
  "compliance.validation.expiryAfterEffective": "过期日期必须在生效日期之后。",
  "compliance.validation.missingUpper": "必须设定上限。",
  "compliance.validation.missingLower": "必须设定下限。",
  "compliance.validation.missingBounds": "需要同时指定下界和上界。",
  "compliance.validation.lowerGtUpper": "下界必须小于或等于上界。",
  "compliance.validation.missingDescriptive": "必须填写定性值。",
  "compliance.linkTest.selectNoOptions": "此测试为下拉列表类型，但在测试目录中未配置任何选项。请在将其与合规标准关联之前，先在测试管理中添加结果选择列表。",
  "compliance.linkTest.resultTypeLegend": "结果类型",
  "compliance.linkTest.resultType.numeric": "数值（使用极限值）",
  "compliance.linkTest.resultType.select": "选择列表（将选项映射到状态）",
  "compliance.linkTest.optionsHint": "添加此测试的结果选项（例如“缺失”、“存在”）。下一步将引导您将每个选项与相应的合规状态进行映射。",
  "compliance.linkTest.optionLabel": "期权价值",
  "compliance.linkTest.optionPlaceholder": "例如：缺席",
  "compliance.linkTest.optionsRequired": "在映射状态之前，请在上面添加至少一个选项。",
  "compliance.admin.title": "合规标准管理",
  "compliance.admin.tile.explain": "管理合规标准、参数组和各项检测项目的阈值（例如 PP 22/2021、WHO 饮用水标准）。",
  "compliance.tabs.standardsAdmin": "合规标准清单",
  "compliance.tabs.testThresholds": "“合规”选项卡（测试编辑器）",
  "compliance.testEditor.back": "返回",
  "compliance.testEditor.editTest": "编辑检测：",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "样本类型:",
  "compliance.testEditor.resultType": "结果类型：",
  "compliance.testEditor.saveTest": "保存检测",
  "compliance.testEditor.saveDisabledHint": "本版本中，其他测试编辑器选项卡尚未接入。",
  "compliance.testEditor.thresholdsHeading": "合规阈值",
  "compliance.testEditor.addThreshold": "添加阈值",
  "compliance.testEditor.addThresholdHeading": "将 {name} 与一项合规标准关联起来",
  "compliance.testEditor.pickStandard": "合规标准",
  "compliance.testEditor.pickStandardPlaceholder": "-- 选择一个标准 --",
  "compliance.testEditor.pickGroup": "参数组",
  "compliance.testEditor.pickGroupPlaceholder": "-- 选择一个参数组 --",
  "compliance.testEditor.pickGroupHint": "请从上方选择一个标准和参数组来配置阈值。",
  "compliance.testEditor.unlink": "取消关联",
  "compliance.testEditor.unlinkHeading": "解除关联阈值",
  "compliance.testEditor.unlinkPrompt": "是否要从{test}中移除此阈值？阈值本身仍保留在标准的参数组中；仅移除指向此特定检测项目的链接。",
  "compliance.testEditor.linkedBanner": "This test is linked to {count, plural, one {# compliance standard} other {# compliance standards}}. Thresholds are evaluated at validation time.",
  "compliance.testEditor.expandRow": "展开行",
  "compliance.testEditor.col.standard": "标准",
  "compliance.testEditor.col.parameterGroup": "参数组",
  "compliance.testEditor.col.limitType": "限额类型",
  "compliance.testEditor.col.thresholdRange": "阈值 / 范围",
  "compliance.testEditor.col.unit": "单位",
  "compliance.testEditor.col.effective": "生效",
  "compliance.testEditor.col.status": "状态",
  "compliance.testThresholds.selectHint": "选择一项检测，查看其跨标准关联的合规阈值。",
  "compliance.testThresholds.overviewHeading": "与合规标准相关的检测项目",
  "compliance.testThresholds.overviewCount": "{filtered} of {total} test{total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "目前尚无任何检测项目与合规标准相关联。",
  "compliance.testThresholds.overviewEmptyHint": "在参数组级别通过 CSV 设置的阈值显示在“表 1（合规标准管理）”中，而非此处。请在上方搜索，从目录中选择一项检测，并将其与某项标准关联。",
  "compliance.testThresholds.noLinkedMatches": "没有与“{q}”匹配的关联检测项目。",
  "compliance.testThresholds.addSection": "在合规性中添加一项检测项目",
  "compliance.testThresholds.col.test": "检测",
  "compliance.testThresholds.col.code": "位置代码",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "样本类型",
  "compliance.testThresholds.col.thresholdCount": "# 阈值",
  "compliance.testThresholds.col.standardCount": "# 标准",
  "compliance.testThresholds.openEditor": "待处理",
  "compliance.testThresholds.title": "检测合规阈值",
  "compliance.testThresholds.tile.explain": "查看与特定检测项目相关的合规阈值，按标准和参数组分类。",
  "compliance.testThresholds.searchLabel": "搜索检测",
  "compliance.testThresholds.searchPlaceholder": "筛选检测项目列表……",
  "compliance.testThresholds.test": "检测",
  "compliance.testThresholds.selectPlaceholder": "-- 选择检测 --",
  "compliance.testThresholds.empty": "此检测目前尚未关联任何合规阈值。请点击上方的“+ 添加阈值”，将其关联到某项合规标准的参数组。",
  "compliance.testThresholds.parameter": "参数",
  "compliance.testThresholds.type": "限额类型",
  "compliance.testThresholds.value": "值",
  "compliance.testThresholds.note": "备注",
  "compliance.testThresholds.unknownStandard": "未知标准",
  "compliance.button.openAdmin": "开放合规标准管理",
  "compliance.button.addStandard": "添加标准",
  "compliance.button.saveStandard": "保存标准",
  "compliance.button.linkTest": "将检测链接到组",
  "compliance.button.saveLimits": "保存限制",
  "compliance.button.saveMapping": "保存映射",
  "compliance.search": "搜索标准",
  "compliance.search.placeholder": "按名称、颁发机构、法规、国家等进行搜索……",
  "compliance.list.empty": "目前尚无合规标准。",
  "compliance.standard.name": "标准名称",
  "compliance.standard.issuingBody": "签发机构",
  "compliance.standard.regulationNumber": "法规编号",
  "compliance.standard.version": "版本",
  "compliance.standard.countryRegion": "国家/区域",
  "compliance.standard.status": "状态",
  "compliance.standard.effectiveDate": "生效日期",
  "compliance.standard.description": "描述",
  "compliance.standard.addNew": "添加新的合规标准",
  "compliance.standard.edit": "编辑合规标准",
  "compliance.standard.preSeeded": "预先种子",
  "compliance.standard.saved": "已保存合规标准。",
  "compliance.standard.saveError": "无法保存标准。",
  "compliance.standard.saveBeforeGroups": "在添加参数组之前，请先保存该标准。",
  "compliance.standard.deleted": "已删除合规标准。",
  "compliance.standard.deleteError": "无法删除该标准（可能是预设的，或者与阈值相关联）。",
  "compliance.standard.deleteHeading": "删除合规标准",
  "compliance.standard.deletePrompt": "您确定要删除此标准吗？预设标准和带有关联阈值的标准无法删除。",
  "compliance.sampleTypes.heading": "适用样本类型",
  "compliance.sampleTypes.explicitHint": "说明本标准适用于哪些样本类型类别。在链接测试时，这些选项将决定测试过滤器的设置。",
  "compliance.sampleTypes.empty": "尚未声明任何样本类型。",
  "compliance.sampleTypes.selectPlaceholder": "选择样本类型...",
  "compliance.sampleTypes.addBtn": "添加样本类型",
  "compliance.sampleTypes.remove": "移除",
  "compliance.parameterGroups": "参数组",
  "compliance.parameterGroups.empty": "尚未定义任何参数组。",
  "compliance.parameterGroups.add": "添加参数组",
  "compliance.parameterGroup.name": "组名称",
  "compliance.parameterGroup.description": "描述",
  "compliance.parameterGroup.deleteBtn": "删除",
  "compliance.label.tests": "检测项目",
  "compliance.linkedTest.name": "检测",
  "compliance.linkedTest.sampleTypes": "样本类型",
  "compliance.linkedTest.limits": "已配置的限额",
  "compliance.linkedTest.editLimits": "编辑限制",
  "compliance.linkedTest.unlink": "从群组中移除",
  "compliance.linkedTest.unlinkHeading": "将“检测”从组中移除",
  "compliance.linkedTest.unlinkConfirm": "移除",
  "compliance.linkedTest.unlinkPrompt": "将此检测项目从该组中移除？该组中此检测项目的所有阈值定义都将被删除。",
  "compliance.group.noTests": "目前尚未与此组关联任何检测项目。请关联检测项目以定义评估的合规阈值。",
  "compliance.linkTest.heading": "将检测链接到组",
  "compliance.linkTest.step1": "步骤 1 — 按样本类型筛选",
  "compliance.linkTest.step2": "第 2 步 — 搜索并选择检测",
  "compliance.linkTest.step3Numeric": "第 3 步 — 配置限制",
  "compliance.linkTest.step3Select": "第 3 步 — 合规价值映射",
  "compliance.linkTest.filterByST": "按样本类型筛选：",
  "compliance.linkTest.searchTest": "搜索检测目录",
  "compliance.linkTest.searchPlaceholder": "输入名称或代码进行搜索...",
  "compliance.linkTest.noResults": "未找到匹配的检测项目。",
  "compliance.linkTest.selectListBadge": "选择列表",
  "compliance.linkTest.clearSelection": "清除选择",
  "compliance.multiLimit.editHeading": "配置限制",
  "compliance.multiLimit.hint": "为该测试启用一种或多种限值类型。必须至少启用一种限值类型。",
  "compliance.multiLimit.type": "限额类型",
  "compliance.multiLimit.lower": "较低",
  "compliance.multiLimit.upper": "上部",
  "compliance.multiLimit.unit": "单位",
  "compliance.multiLimit.note": "备注 / 提示",
  "compliance.multiLimit.descriptive.placeholder": "例如：否气味、缺失、清晰",
  "compliance.multiLimit.note.placeholder": "可选备注",
  "compliance.limitType.high": "最高限额 ≤",
  "compliance.limitType.high.hint": "若结果超过上限，则视为不符合要求",
  "compliance.limitType.low": "下限 ≥",
  "compliance.limitType.low.hint": "如果结果低于下限，则视为不符合要求",
  "compliance.limitType.range": "正常范围",
  "compliance.limitType.range.hint": "符合下限至上限范围",
  "compliance.limitType.borderline": "边缘型（提示）",
  "compliance.limitType.borderline.hint": "建议区域——触发审查标记，而非失败",
  "compliance.limitType.descriptive": "定性 / 描述性",
  "compliance.limitType.descriptive.hint": "由分析师评估的文本值",
  "compliance.selectMap.editHeading": "合规映射",
  "compliance.selectMap.hint": "将每个结果选项与其合规状态进行映射。这些选项来自检测目录。",
  "compliance.selectMap.option": "结果选项",
  "compliance.selectMap.status": "合规状态",
  "compliance.selectMap.preview": "预览",
  "compliance.selectMap.badge": "值映射",
  "compliance.selectMap.optionsLabel": "选项已映射",
  "compliance.selectMap.statusForOption": "{option} 的合规状态",
  "compliance.status.compliant": "符合要求的",
  "compliance.status.borderline": "边缘型",
  "compliance.status.nonCompliant": "不符合要求",
  "compliance.status.compliantWithIcon": "符合要求 ✓",
  "compliance.status.borderlineWithIcon": "边缘型 ⚑",
  "compliance.status.nonCompliantWithIcon": "不符合要求 ✗",
  "compliance.linkedTest.noLimits": "否配置任何限制",
  "compliance.threshold.savedThresholds": "与该检测项目相关的合规阈值。",
  "compliance.threshold.savedValueMap": "已保存值映射阈值。",
  "compliance.threshold.savedPartialError": "某些阈值无法保存。请检查已高亮显示的行。",
  "compliance.threshold.unlinked": "阈值与检测脱钩。",
  "compliance.threshold.unlinkError": "无法解除此阈值的关联。",
  "notification.title.success": "成功",
  "notification.title.error": "错误",
  "sidenav.label.admin.vectorSurveillance": "病媒监测",
  "vector.admin.title": "病媒监测系统的设置中",
  "vector.admin.groups": "生物体类群",
  "vector.admin.group.code": "位置代码",
  "vector.admin.group.label": "标签",
  "vector.admin.group.colorTag": "颜色标签",
  "vector.admin.group.description": "描述",
  "vector.admin.active": "活跃",
  "vector.admin.system": "系统",
  "vector.admin.trapTypes": "陷阱类型",
  "vector.admin.trapType.name": "名称",
  "vector.admin.trapType.description": "描述",
  "vector.admin.species": "物种",
  "vector.admin.selectGroup": "在左侧选择一个组，以管理该组的陷阱类型和物种。",
  "vector.admin.newGroup": "新群组（未保存）",
  "vector.admin.newTrapType": "新型陷阱设备类型",
  "vector.admin.newSpecies": "新物种",
  "vector.admin.saveGroup": "保存组",
  "vector.admin.saveTrap": "保存陷阱",
  "vector.admin.saveSpecies": "保存物种",
  "vector.admin.addGroup": "+ 添加群组",
  "vector.admin.addTrapType": "+ 添加陷阱类型",
  "vector.admin.addSpecies": "+ 添加物种",
  "vector.admin.locked": "已锁定",
  "vector.admin.systemGroup": "系统受保护组",
  "vector.admin.systemGroup.desc": "该代码已被锁定，因为核心报告和初始数据引用了此组。您仍可编辑标签、颜色和描述。",
  "vector.admin.usedBy": "由……使用",
  "vector.admin.status": "状态",
  "vector.admin.status.active": "活跃",
  "vector.admin.status.inactive": "非活跃",
  "vector.admin.group": "生物类群",
  "vector.admin.trapType.group": "目标生物群",
  "vector.admin.trapType.groups": "生物体类群",
  "vector.admin.trapType.sampleTypes": "样本类型",
  "vector.admin.sampleType": "样本类型",
  "vector.admin.search.groups": "按代码或标签搜索...",
  "vector.admin.search.traps": "搜索陷阱名称或描述...",
  "vector.admin.search.species": "搜索属或种……",
  "vector.admin.samplingSites": "样本点",
  "vector.admin.samplingSite.newSite": "新网站",
  "vector.admin.samplingSite.allSites": "所有站点",
  "vector.admin.samplingSite.code": "位置代码",
  "vector.admin.samplingSite.name": "站点名称",
  "vector.admin.samplingSite.type": "场地类型",
  "vector.admin.samplingSite.region": "区域",
  "vector.admin.samplingSite.district": "地区",
  "vector.admin.samplingSite.contactName": "联系人",
  "vector.admin.samplingSite.contactPhone": "联系电话",
  "vector.admin.samplingSite.gpsLatitude": "GPS纬度",
  "vector.admin.samplingSite.gpsLongitude": "GPS经度",
  "vector.admin.samplingSite.environmentalZone": "环保区",
  "vector.admin.samplingSite.address": "地址",
  "vector.admin.samplingSite.description": "描述",
  "vector.admin.samplingSite.source": "来源",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "最后一个系列",
  "vector.admin.samplingSite.search": "按代码、名称、区域等搜索...",
  "vector.admin.samplingSite.saveSite": "保存网站",
  "vector.admin.samplingSites.registry": "样本登记册",
  "vector.admin.samplingSite.deactivate": "停用",
  "vector.admin.samplingSite.activate": "激活",
  "vector.admin.samplingSite.location": "位置",
  "vector.admin.samplingSite.allTypes": "所有类型",
  "vector.admin.samplingSite.subtype": "亚型",
  "vector.admin.samplingSite.subtype.placeholder": "例如：河流、水井、BG-Sentinel、固定站",
  "vector.admin.samplingSite.city": "城市",
  "vector.admin.samplingSite.addressLocation": "地址位置",
  "vector.admin.samplingSite.addressSearch.placeholder": "搜索位置以自动填充下拉菜单……",
  "vector.admin.samplingSite.gpsCoordinates": "GPS信息",
  "vector.admin.samplingSite.lastModified": "最后修改",
  "label.noResults": "未找到结果",
  "vector.admin.addSite": "+ 新网站",
  "vector.order.title": "新矢量订单",
  "vector.order.subtitle": "实验室单元：病媒监测实验室——病媒区域处于活跃状态。",
  "vector.order.samplingSite": "样本采样点",
  "vector.order.site.code": "站点位置代码",
  "vector.order.site.helper": "搜索结果中仅显示处于活跃状态的监测点。GPS信息已根据监测点记录预先填入。",
  "vector.order.site.name": "站点名称",
  "vector.order.site.placeholder": "按站点名称或位置代码搜索...",
  "vector.order.site.type": "场地类型",
  "vector.order.specimen": "标本",
  "vector.order.organism": "动物 / 生物体",
  "vector.order.organism.hint": "通用名称——例如：蚊子、蜱、啮齿动物、沙蝇。",
  "vector.order.organism.placeholder": "搜索生物体或物种……",
  "vector.order.quantity": "数量",
  "vector.order.quantity.hint": "该水池中的生物体数量。",
  "vector.order.requester.section": "请求者 / 订购项目",
  "vector.order.requester": "请求者",
  "vector.order.requester.placeholder": "按机构名称或代码搜索...",
  "vector.order.panels": "订单面板",
  "vector.order.panels.search": "选择可用面板",
  "vector.order.tests": "订单检测",
  "vector.order.tests.search": "选择可用检测",
  "vector.order.collectionContext": "采集背景（可选——生物经济学采集）",
  "vector.order.timeOfDay": "时间",
  "vector.order.timeOfDay.dawn": "黎明",
  "vector.order.timeOfDay.day": "日",
  "vector.order.timeOfDay.dusk": "黄昏",
  "vector.order.timeOfDay.night": "夜晚",
  "vector.order.restingContext": "静止上下文",
  "vector.order.restingContext.outdoor": "户外（喜光型）",
  "vector.order.restingContext.indoor": "室内（喜室内环境）",
  "vector.order.restingContext.peridomestic": "家宅周边",
  "vector.order.humanBitingCatch": "咬人的捕获物",
  "vector.order.humanBitingCatch.hint": "该标本来源一次人类登陆采集",
  "vector.order.collectionNotes": "藏品备注",
  "vector.order.collectionNotes.placeholder": "天气、陷阱状况、异常情况……",
  "vector.admin.group.code.placeholder": "例如，SANDFLY",
  "vector.admin.group.label.placeholder": "例如，沙蝇",
  "vector.species.genus.placeholder": "例如，曼索尼亚",
  "vector.species.species.placeholder": "例如，uniformis",
  "vector.species.subspecies.placeholder": "例如，diardii",
  "vector.species.genus": "属",
  "vector.species.species": "物种",
  "vector.species.subspecies": "亚种",
  "vector.species.pathogensOfInterest": "重点关注的病原体",
  "vector.species.lifecycleStages": "生命周期阶段",
  "vector.species.pathogenCategory": "病原体类别",
  "vector.species.lifecycleCategory": "生命周期类别",
  "workflow.vector": "病媒监测",
  "vector.sampleType": "样本类型",
  "vector.organismGroup": "生物类群",
  "vector.species": "物种",
  "vector.animalOrganism": "动物/生物体",
  "vector.animalOrganism.add": "添加动物/生物体",
  "vector.animalOrganism.remove": "移除动物/生物体",
  "vector.collectedVolume": "池中的数量",
  "vector.lifecycleStage": "生命周期阶段",
  "vector.trapCount": "陷阱已布设",
  "vector.trapNights": "部署的夜间",
  "vector.trapType": "陷阱类型",
  "vector.poolingMethod": "池化方法",
  "vector.poolCount": "池的数量",
  "vector.samplesPerPool": "每组标本数量",
  "vector.totalSpecimens": "标本总数",
  "vector.pathogensOfInterest": "重点关注的病原体",
  "vector.homogeneous": "均质",
  "vector.random": "随机",
  "vector.collectionSite": "回收点",
  "vector.collectionSiteName": "回收点站点名称",
  "vector.gpsLatitude": "GPS纬度",
  "vector.gpsLongitude": "GPS经度",
  "patient.search.merged.tag": "已合并",
  "patient.merged.banner.title": "该病历已合并",
  "patient.merged.banner.subtitle": "患者{target}上保存着有效的记录。",
  "patient.merged.banner.subtitle.noTarget": "该记录已与另一位患者的记录合并。",
  "admin.testCatalog.tabs.ariaLabel": "检测项目详细信息选项卡",
  "admin.testCatalog.tabs.details": "详情",
  "admin.testCatalog.tabs.labels": "标签",
  "admin.testCatalog.labels.masterOverride.label": "允许覆盖订单录入",
  "admin.testCatalog.labels.masterOverride.on": "手动输入已开启",
  "admin.testCatalog.labels.masterOverride.off": "手动输入已关闭",
  "admin.testCatalog.labels.linkedPresets.title": "关联标签预设",
  "admin.testCatalog.labels.linkedPresets.empty": "未关联任何标签预设。请使用下方的下拉菜单添加一个。",
  "admin.testCatalog.labels.col.presetName": "预设名称",
  "admin.testCatalog.labels.col.defaultQty": "默认值",
  "admin.testCatalog.labels.col.maxQty": "最大数量",
  "admin.testCatalog.labels.col.allowOverride": "允许覆盖",
  "admin.testCatalog.labels.col.actions": "操作",
  "admin.testCatalog.labels.action.remove": "移除预设链接",
  "admin.testCatalog.labels.addPreset.label": "添加标签类型",
  "admin.testCatalog.labels.addPreset.placeholder": "选择标签预设",
  "admin.testCatalog.labels.preview.title": "订单录入预览",
  "admin.testCatalog.labels.preview.col.locked": "锁定",
  "admin.testCatalog.labels.preview.locked": "锁定",
  "admin.testCatalog.labels.preview.unlocked": "可编辑",
  "admin.testCatalog.labels.save.success": "标签配置已保存。",
  "admin.testCatalog.labels.save.error": "保存失败：标签配置。",
  "orderEntry.labels.orderTable.title": "订单标签行",
  "orderEntry.labels.sampleTable.title": "标签样本",
  "orderEntry.labels.col.row": "行",
  "orderEntry.labels.col.sample": "样本",
  "orderEntry.labels.col.quantity": "数量",
  "orderEntry.labels.orderRow.header": "接收样本",
  "orderEntry.labels.sampleRow.header": "样本 {number}",
  "orderEntry.labels.input.sample": "样本 {number} {column} 数量",
  "orderEntry.labels.source.test": "来源",
  "orderEntry.labels.source.presetDefault": "预设默认值",
  "orderEntry.labels.locked.tooltipFor": "{label} 该选项已被测试配置锁定，无法更改。",
  "orderEntry.labels.total": "标签总数：{total}",
  "orderEntry.labels.heading": "LABELS",
  "label.patientHistory.filterByCategory": "按测试类别筛选",
  "label.patientHistory.testCategories": "检测类别",
  "label.patientHistory.tree": "树",
  "label.patientHistory.showTree": "显示树形图",
  "label.patientHistory.resetTree": "重置树",
  "label.patientHistory.viewResults": "查看{count}的比赛结果",
  "label.patientHistory.emptyState": "该患者没有可显示的{displayText}",
  "label.patientHistory.record": "记录 {displayText}",
  "label.patientHistory.dataLoadError": "数据加载错误",
  "label.patientHistory.errorCopy": "抱歉，显示此信息时出现了一些问题。您可以尝试重新加载页面，或联系网站管理员并提供上述错误代码。",
  "label.patientHistory.backToTimeline": "返回时间轴",
  "label.patientHistory.returnToTimeline": "返回时间轴",
  "label.patientHistory.timeOfTest": "检测时间",
  "label.patientHistory.observations": "观察结果",
  "label.patientHistory.range.oneDay": "1天",
  "label.patientHistory.range.fiveDays": "5天",
  "label.patientHistory.range.oneMonth": "1个月",
  "label.patientHistory.range.sixMonths": "6个月",
  "label.patientHistory.range.oneYear": "1年份",
  "label.patientHistory.range.fiveYears": "5年份",
  "label.patientHistory.range.all": "所有分析仪",
  "label.patientHistory.date": "日期",
  "address.search.no.results": "未找到“{term}”的地址",
  "address.search.placeholder": "搜索地址（请输入至少2个字符）...",
  "address.search.results.count": "{count} 找到的结果",
  "alert.error": "错误",
  "alert.warning": "警告",
  "analyzer.errorDetails.noLogsAvailable": "没有日志可用",
  "analyzer.fieldSelector.placeholder": "搜索并选择字段...",
  "analyzer.fieldSelector.title": "选择 OpenELIS 字段",
  "analyzer.form.columnMappings": "列映射（JSON）",
  "analyzer.form.columnMappings.helperText": "将文件中的列名称映射到内部字段名称",
  "analyzer.form.delimiter": "分隔符",
  "analyzer.form.fileFormat": "文件格式",
  "analyzer.form.fileImport.title": "文件导入设置",
  "analyzer.form.filePattern": "文件名模式",
  "analyzer.form.filePattern.helperText": "用于匹配结果文件的Glob模式",
  "analyzer.form.hasHeader": "文件包含表头行",
  "analyzer.form.importDirectory": "导入目录",
  "analyzer.form.importDirectory.helperText": "桥接器监听传入结果文件的目录",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/my-analyzer/incoming",
  "analyzer.form.validation.columnMappings.invalid": "列映射必须是有效的 JSON",
  "analyzer.form.validation.importDirectory.required": "基于文件的分析仪需要导入目录",
  "analyzer.form.validation.port.invalid": "端口号必须是1到65535之间的一个数字（简体中文（大陆））",
  "analyzer.qc.batch.failure.subtitle": "该批次的质量控制检测存在不合格情况。在接受患者结果前，请先查看以下QC结果。",
  "analyzer.qc.batch.failure.title": "QC控制失败",
  "analyzer.qc.controls.hidden": "患者无法查看QC措施",
  "analyzer.qc.controls.section.title": "QC Controls（{count}）",
  "audittrail.table.heading": "订单信息",
  "barcode.label.info.labnumber": "实验室编号",
  "button.close": "关闭",
  "button.collapse": "折叠",
  "button.expand": "展开",
  "button.home": "首页",
  "button.new.search": "新搜索",
  "column.name.labNo": "实验编号 #",
  "env.collectionConditions.helper": "搜索现有采样点或创建新的采样点。采样点可在不同订单中重复使用——就像临床工作流程中的患者一样。",
  "env.collectionMethod.placeholder": "例如：随机样本、24小时混合样本",
  "env.conditions": "环境条件",
  "env.conditions.placeholder": "例如：20°C，晴天，旱季",
  "env.regulatoryReference": "监管参考",
  "env.regulatoryReference.placeholder": "例如，第22/2021号总统令《水质》",
  "env.samplingSite.title": "主题 — 采样点",
  "env.site.address": "地址",
  "env.site.addressSearch.placeholder": "搜索位置以自动填充下方的下拉菜单……",
  "env.site.code": "站点位置代码",
  "env.site.code.placeholder": "自动生成（或手动输入）",
  "env.site.contactPerson": "联系人",
  "env.site.contactPerson.placeholder": "网站管理员或联系人的名称",
  "env.site.contactPhone": "联系电话",
  "env.site.description": "站点描述",
  "env.site.description.placeholder": "例如，水闸下游附近的监测点",
  "env.site.helperText": "注册一个新的采样点。该采样点将保存在“采样点注册表”中，并可在今后的订单中重复使用。",
  "env.site.name": "站点名称",
  "env.site.name.placeholder": "例如，西里旺河——芒加莱",
  "env.site.newTab": "新网站",
  "env.site.saveAndSelect": "保存并选择站点",
  "env.site.searchLabel": "站点名称",
  "env.site.searchPlaceholder": "例如，西里旺河——曼加拉伊",
  "env.site.searchTab": "站内搜索",
  "env.site.streetAddress": "地址",
  "env.site.streetAddress.placeholder": "街道地址或位置参考",
  "env.site.subtype": "亚型",
  "env.site.subtype.placeholder": "例如：河流、水井、BG-Sentinel、固定站",
  "env.site.type": "场地类型",
  "env.site.type.select": "选择设备类型...",
  "env.site.zone": "环保区",
  "env.site.zone.select": "选择区域...",
  "error.dateRange.start": "请选择开始日期和结束日期。",
  "error.loading.metrics": "加载指标时出错",
  "error.nonconform.report.data.found": "没有找到数据",
  "error.report.csv.dateType": "请选择日期类型。",
  "error.required.fields": "请填写所有必填项",
  "error.save.sample": "保存样本时发生错误",
  "error.validation.failed": "验证失败",
  "error.value": "请选择一个值。",
  "esig.context.saveResults": "保存 {count} 中与登记号 {accession} 相关的结果",
  "esig.context.saveResultsMulti": "保存{accessionCount}中各种质资源的{count}结果",
  "esig.context.validateResults": "验证 {count} 网站中编号为 {accession} 的结果",
  "esig.context.validateResultsMulti": "验证{count}在{accessionCount}各接穗中的结果",
  "fhir.questionnaire.title": "附加信息",
  "genericSample.default.fields.title": "样本信息",
  "genericSample.import.success": "导入成功",
  "genericSample.notebook.label": "选择笔记本",
  "genericSample.order.newOrder": "创建另一个样本",
  "genericSample.search.title": "按订单号搜索",
  "http.success": "成功!",
  "label.button.assign": "分配",
  "label.button.create": "创建",
  "label.button.saving": "保存中...",
  "label.button.view": "查看报告",
  "label.code": "位置代码",
  "label.editing": "编辑",
  "label.label": "标签",
  "label.name": "名称",
  "label.panel": "面板",
  "label.tests": "检测项目",
  "loading.label": "加载中...",
  "loading.metrics": "正在加载指标...",
  "locale.save.error": "保存语言失败",
  "logging.management.tail.clear": "清除位置",
  "logging.management.tail.disconnected": "流媒体连接已断开。请关闭后重新打开以重新连接。",
  "logging.management.tail.label": "实时应用程序日志",
  "logging.management.tail.off": "手动输入已关闭",
  "logging.management.tail.on": "手动输入已开启",
  "logging.management.tail.stream": "直播",
  "nationalID.title": "外部ID",
  "nce.button.linkSelected": "“已选样本”链接",
  "nce.button.submit": "提交 NCE",
  "nce.error.numberGeneration": "无法生成NCE数字。请重试。",
  "nce.field.dateOfEvent": "事件日期",
  "nce.field.description": "描述",
  "nce.field.nceNumber": "NCE 数字",
  "nce.field.proposedAction.helper": "与在纠正措施工作流中分配的CAPA措施分开处理",
  "nce.field.proposedAction.placeholder": "建议的下一步操作...",
  "nce.field.reporterName": "记者名称",
  "nce.field.reportingUnit": "报告单元",
  "nce.field.subcategory": "子类别",
  "nce.field.suspectedCauses.helper": "仅为初步评估——正式的根本原因将在调查过程中确定",
  "nce.field.suspectedCauses.placeholder": "记者",
  "nce.form.subtitle": "记录质量事件，并关联相关样本和结果",
  "nce.form.title": "报告不符合事件",
  "nce.linkSamples.helper": "搜索上面的订单，将样本与该NCE关联。此步骤为可选操作。",
  "nce.section.attachments": "附件",
  "nce.section.classification": "分类",
  "nce.section.details": "详情",
  "nce.section.linkSamples": "样本/结果链接（可选）",
  "nce.section.reporterContext": "记者与事件背景",
  "nce.select.subcategory": "选择子类别...",
  "nce.severity.critical.desc": "患者安全风险、违规行为",
  "nce.severity.major.desc": "对质量或运营产生重大影响",
  "nce.severity.minor.desc": "影响有限，易于纠正",
  "nonconform.corrective.requiredFields": "请填写所有纠正措施字段（措施、负责人、完成日期以及至少一种措施类型），或者将该行完全留空。",
  "nonconform.view.requiredFields": "“实验室组件”、“NCE类别”、“NCE类型”、“严重程度与后果”以及“复发情况”均为必填项。",
  "notebook.sample.create": "创建",
  "notebook.sample.create.title": "创建新样本",
  "notebook.sample.edit": "编辑",
  "notebook.sample.edit.title": "编辑样本",
  "notebook.sample.import": "导入",
  "notebook.sample.import.title": "导入样本",
  "notebook.sample.order.info": "该样本将与当前笔记本相关联。",
  "notification.warning": "警告",
  "order.entry.setup.batch": "批量订单录入",
  "order.legend.patient1": "患者信息",
  "pagination.next": "下一页",
  "pagination.previous": "上一页",
  "patient.fetch.error": "无法加载患者信息。患者ID可能无效，或者无法连接到服务器。",
  "patient.firstName": "名",
  "patient.lastName": "姓",
  "print.barcode.all": "打印所有条码（{count}）",
  "sample.item.id": "样本项目编号",
  "sample.label": "样本",
  "sample.noPanels": "此样本类型无面板可用",
  "sample.noTests": "此样本类型暂无可用检测项目",
  "sample.selectType.first": "请在上方选择样本类型，查看可用的检测面板和检测项目",
  "sample.testsCount": "{count} 可用检测",
  "sample.types": "样本",
  "save.error.msg": "保存时错误",
  "saving.label": "保存中...",
  "select.label.analyzer": "选择分析仪",
  "site.code": "位置代码",
  "steps.complete": "步骤",
  "storage.audit.empty": "目前尚未记录到该样本的任何移动情况。",
  "storage.audit.empty.title": "否",
  "storage.audit.fetch.error": "无法加载审计跟踪。",
  "storage.audit.fetch.error.title": "错误",
  "storage.audit.from": "来源",
  "storage.audit.movedBy": "由……发起",
  "storage.audit.movementDate": "移动日期",
  "storage.audit.reason": "理由",
  "storage.audit.to": "到",
  "storage.box.code.helper": "最多 10 个字符",
  "storage.confirm.disposal": "确认处置",
  "storage.dashboard.title": "存储",
  "storage.disposal.method": "处置方法",
  "storage.disposal.method.placeholder": "选择方法...",
  "storage.disposal.notes": "备注（可选）",
  "storage.disposal.notes.placeholder": "请输入任何其他备注……",
  "storage.disposal.reason": "处置原因",
  "storage.disposal.reason.placeholder": "选择原因...",
  "storage.dispose.confirmation": "我确认希望永久处置该样本。此操作无法撤销。",
  "storage.dispose.error": "Disposal failed",
  "storage.dispose.instructions.subtitle": "请确保按照实验室安全规程执行正确的处置程序。",
  "storage.dispose.instructions.title": "处置说明",
  "storage.dispose.location.note": "处置时，将从该位置移除样本",
  "storage.dispose.sample": "处置样本",
  "storage.dispose.sample.subtitle": "永久处置样本 {sampleId}",
  "storage.dispose.warning.subtitle": "该样本将被标记为已处置，并从存储中移除。",
  "storage.dispose.warning.title": "此操作无法撤销",
  "storage.edit.heading": "编辑 {type}",
  "storage.edit.title": "编辑",
  "storage.editbox.heading": "编辑框",
  "storage.error": "错误",
  "storage.error.save": "保存失败",
  "storage.filter.select.location": "选择位置...",
  "storage.filter.selected": "已选择:",
  "storage.location.assigned.error": "无法分配位置",
  "storage.location.assigned.success": "位置已成功分配",
  "storage.location.created": "{level} created",
  "storage.location.deleted": "{level} deleted",
  "storage.location.no.results": "未找到任何位置",
  "storage.location.type.devices": "设备",
  "storage.location.type.racks": "货架",
  "storage.location.type.rooms": "房间",
  "storage.location.type.shelves": "架层",
  "storage.location.updated": "{level} updated",
  "storage.manage.location": "管理位置",
  "storage.nav.rack": "货架",
  "storage.sample.actions": "样本操作",
  "storage.sampleitem.accession": "样本订单号",
  "storage.sampleitem.location": "存储位置",
  "storage.sampleitem.status": "状态",
  "storage.sampleitem.type": "设备类型",
  "storage.search.location.label": "搜索存储位置",
  "storage.search.location.placeholder": "输入 2 个及以上字符进行搜索……",
  "storage.skipRemaining": "跳过未分配样本的存储（{count}）——将立即处理",
  "storage.view.audit": "查看审计报告",
  "storage.view.audit.subtitle": "样本{sampleId}的移动历史",
  "storage.view.audit.title": "存储审计跟踪",
  "systemDefaultPayloadTemplate.messageTemplate": "消息模板",
  "systemDefaultPayloadTemplate.subjectTemplate": "主题模板",
  "tests.count": "{count, plural, one {test} other {tests}}",
  "validation.invalid.ip": "IP地址格式无效（IPv4 或 IPv6）",
  "validation.invalid.port": "端口号必须在 1 到 65535 之间",
  "validation.required": "此字段为必填项",
  "common.accept": "接受",
  "common.accessionNumber": "订单号",
  "common.action": "操作",
  "common.actions": "操作",
  "common.active": "活跃",
  "common.addTests": "添加检测",
  "common.aliquots": "分装样本",
  "common.all": "所有分析仪",
  "common.allStatuses": "所有状态",
  "common.analyzer": "分析仪",
  "common.analyzers": "分析仪列表",
  "common.auditTrail": "审计跟踪",
  "common.back": "返回",
  "common.boxId": "箱子编号",
  "common.byUnit": "按单元",
  "common.cancel": "取消",
  "common.category": "类别",
  "common.clinical": "临床",
  "common.code": "位置代码",
  "common.collected": "已采样",
  "common.collectionDate": "采集日期",
  "common.complete": "完成",
  "common.completed": "已完成",
  "common.confirm": "确认",
  "common.correctiveActions": "纠正措施",
  "common.createAliquot": "创建分装样本",
  "common.critical": "紧急",
  "common.dashboard": "仪表板",
  "common.date": "日期",
  "common.dateRange": "日期范围",
  "common.deactivate": "停用",
  "common.delete": "删除",
  "common.description": "描述",
  "common.draft": "草稿",
  "common.edit": "编辑",
  "common.editOrder": "编辑样本",
  "common.email": "电子邮件",
  "common.enterResults": "录入结果",
  "common.error": "错误",
  "common.expired": "已过期",
  "common.exportPdf": "导出PDF",
  "common.failed": "失败数量",
  "common.filterByStatus": "状态",
  "common.firstName": "名",
  "common.from": "来源",
  "common.generateReport": "生成报告",
  "common.home": "首页",
  "common.inProgress": "进行中",
  "common.inactive": "非活跃",
  "common.labNumber": "实验室编号",
  "common.lastName": "姓",
  "common.loading": "加载中...",
  "common.location": "位置",
  "common.mean": "均值",
  "common.name": "名称",
  "common.nationalId": "外部ID",
  "common.new": "新",
  "common.none": "无",
  "common.normal": "正常",
  "common.normalRange": "正常范围",
  "common.notes": "备注",
  "common.order": "接收样本",
  "common.overdue": "已逾期",
  "common.panels": "检测面板",
  "common.participants": "参与者管理",
  "common.patient": "患者",
  "common.pending": "待处理",
  "common.position": "位置",
  "common.printLabel": "打印标签",
  "common.priority": "优先级",
  "common.program": "计划",
  "common.programName": "项目名称",
  "common.provider": "供应商",
  "common.quantity": "数量",
  "common.received": "已接收",
  "common.referenceLab": "参考实验室",
  "common.reject": "拒绝",
  "common.remove": "移除",
  "common.removeSelection": "移除{name}",
  "common.reports": "报告",
  "common.requester": "请求者",
  "common.result": "结果",
  "common.results": "结果",
  "common.room": "房间",
  "common.routine": "常规",
  "common.sample": "样本",
  "common.sampleId": "样本编号",
  "common.sampleManagement": "样本管理",
  "common.sampleType": "样本类型",
  "common.samples": "样本",
  "common.samplingSite": "样本采样点",
  "common.save": "保存",
  "common.saveFailed": "保存失败",
  "common.saving": "保存中...",
  "common.search": "搜索",
  "common.select": "选择",
  "common.severity": "严重程度",
  "common.siteName": "站点名称",
  "common.species": "物种",
  "common.standard": "标准",
  "common.status": "状态",
  "common.storageLocation": "存储位置",
  "common.study": "研究",
  "common.test": "检测",
  "common.testName": "检测名称",
  "common.tests": "检测项目",
  "common.type": "设备类型",
  "common.unit": "单位",
  "common.user": "用户",
  "common.value": "值",
  "common.view": "查看",
  "common.warning": "警告",
  "label.testCatalog.alerts.field.component": "结果组件",
  "label.testCatalog.alerts.field.componentHelp": "此警报监视的结果。若不进行设置，则监视该测试的所有组件。",
  "label.testCatalog.alerts.field.sampleType": "样本类型",
  "label.testCatalog.alerts.field.sampleTypeHelp": "此警报监控的标本。若不进行设置，则监控该检测项目运行的所有标本类型。",
  "label.testCatalog.alerts.scope.anyComponent": "任何组件",
  "label.testCatalog.alerts.scope.anySampleType": "任何样本类型",
  "label.testCatalog.alerts.col.scope": "适用范围",
  "label.testCatalog.alerts.scope.wholeTest": "完整检测",
  "microbiology.ast.breakpointStandard": "断点标准",
  "microbiology.ast.hint": "记录MIC或区域读数，审查解释结果，并在生产线上记录覆盖操作。",
  "microbiology.ast.noOverride": "否覆盖",
  "microbiology.ast.reading": "AST读数",
  "microbiology.case.isolates.hint": "在AST之前，添加并识别具有临床意义的肿瘤生长。",
  "microbiology.isolate.contaminant": "污染物",
  "microbiology.isolate.edit": "编辑分离株",
  "microbiology.isolate.identificationStatus": "身份状态",
  "microbiology.isolate.normalFlora": "正常菌群",
  "microbiology.isolate.organism": "生物体",
  "microbiology.isolate.organism.freeText": "以自由文本形式输入生物体名称",
  "microbiology.isolate.significant": "具有临床意义",
  "microbiology.isolate.unknown": "未知",
  "microbiology.isolate.update": "保存身份信息",
  "microbiology.enum.AST_REVIEW_REQUIRED": "需要进行AST审核",
  "microbiology.enum.AWAITING_RESULTS": "等待结果",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "需要进行抗生素分布图绘制",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "需结案",
  "microbiology.enum.AMENDED": "修订版",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "修改操作失败",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "培养方案协议变更",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "修正案已待处理",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "修订历史加载失败",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "修订进行中",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "修订需进行新的AST运行",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "不接受修改",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "修改原因（必填）",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "修正案需最终发布",
  "microbiology.enum.ACKNOWLEDGED": "已确认",
  "microbiology.enum.AMENDMENT_CANCELLED": "修正案已取消",
  "microbiology.enum.AMENDMENT_OPENED": "修正案已公开征询意见",
  "microbiology.enum.AMENDMENT_RELEASED": "修正案已发布",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "修订来源 AST 必须为应报告项目",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "已确认分析仪标志",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "分析仪QC失败",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "已接收分析仪结果",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "AST 考试原因（必填）",
  "microbiology.enum.AST_ENTRY": "AST 条目",
  "microbiology.enum.AST_IN_PROGRESS": "AST 进行中",
  "microbiology.enum.AST_READY": "已准备好进行AST",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "需重复或重新检测",
  "microbiology.enum.AST_REVIEW": "AST 评论",
  "microbiology.enum.AST_REVIEWED": "AST 已审核",
  "microbiology.enum.AST_READING_OVERRIDDEN": "AST 读取被覆盖",
  "microbiology.enum.AST_READING_RECORDED": "AST读数已记录",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "已选择应报告的AST",
  "microbiology.enum.AST_RUN_CREATED": "已创建 AST 运行",
  "microbiology.enum.AST_RUN_INVALIDATED": "AST 运行无效",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "AST 运行方法不匹配",
  "microbiology.enum.AST_QC_OVERRIDDEN": "AST QC 被覆盖",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "AST 设置中不可用",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "需要对AST源运行进行审查",
  "microbiology.enum.ANALYZER": "分析仪",
  "microbiology.enum.BROTH_MICRODILUTION": "肉汤微量稀释法",
  "microbiology.enum.CASE": "案例",
  "microbiology.enum.CASE_CREATED": "案例已创建",
  "microbiology.enum.CASE_REVIEW": "案例回顾",
  "microbiology.enum.CANCELLED": "已取消",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "具有临床意义",
  "microbiology.enum.CLOSED": "已关闭",
  "microbiology.enum.CONFIRMED": "已确认",
  "microbiology.enum.CONTAMINANT": "污染物",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "已确认紧急通信",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "紧急通信已关闭",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "已记录紧急通信",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "需要紧急随访",
  "microbiology.enum.DISK_DIFFUSION": "盘扩散",
  "microbiology.enum.EMAIL": "电子邮件",
  "microbiology.enum.EMERGENCY": "紧急情况",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "失败数量",
  "microbiology.enum.FINAL": "最终确定版",
  "microbiology.enum.FINAL_REPORT_RELEASED": "最终报告发布",
  "microbiology.enum.GROWTH_DETECTED": "检测到生长",
  "microbiology.enum.HIGH": "高",
  "microbiology.enum.IDENTIFICATION": "身份识别",
  "microbiology.enum.ICU": "ICU",
  "microbiology.enum.INCUBATING": "孵化",
  "microbiology.enum.INPATIENT": "住院患者",
  "microbiology.enum.IN_PROGRESS": "进行中",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "当面",
  "microbiology.enum.INOCULATION_RECORDED": "接种记录",
  "microbiology.enum.ISOLATE": "隔离",
  "microbiology.enum.ISOLATE_CREATED": "已创建分离株",
  "microbiology.enum.ISOLATE_ID": "分离株编号",
  "microbiology.enum.ISOLATE_REQUIRED": "需进行隔离",
  "microbiology.enum.ISOLATE_UPDATED": "“Isolate”已更新",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "未指定MIC技术",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "未指定区域技术",
  "microbiology.enum.MANUAL_NOTE": "手册备注",
  "microbiology.enum.MANUAL_ENTRY": "手动录入条目",
  "microbiology.enum.MIC": "MIC",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "无法记录接种审核情况",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "无法记录协议审计",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "选择其他协议",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "在选择协议之前分配工作流",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "亚文化来源必须属于本案",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "无法记录工作流审计",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "确认保留现有作品",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "需对工作流进行分类",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "培养方法与工作流不兼容",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "不支持此工作流",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "该工作流已有先例",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "选择其他工作流",
  "microbiology.enum.NO_GROWTH_READY": "否增长准备",
  "microbiology.enum.NORMAL_FLORA": "正常菌群",
  "microbiology.enum.NEEDS_WORKFLOW": "需要工作流",
  "microbiology.enum.NOT_READY": "尚未准备好",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "已报告不符合项",
  "microbiology.enum.NONE": "无",
  "microbiology.enum.OPEN": "待处理",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "需要进行生物体测绘",
  "microbiology.enum.ORGANISM": "生物体",
  "microbiology.enum.ORIGINAL": "原文",
  "microbiology.enum.OTHER": "其他原因",
  "microbiology.enum.OUTPATIENT": "门诊",
  "microbiology.enum.PENDING": "待处理",
  "microbiology.enum.PASSED": "通过",
  "microbiology.enum.PHOENIX": "凤凰",
  "microbiology.enum.PHONE": "电话",
  "microbiology.enum.POSITIVE_SIGNAL": "积极信号",
  "microbiology.enum.PRELIM_RELEASED": "初步发布",
  "microbiology.enum.PRELIMINARY": "初步",
  "microbiology.enum.PRELIMINARY_RELEASED": "初步发布",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "初步报告发布",
  "microbiology.enum.QC_FAILED": "QC未通过",
  "microbiology.enum.RECEIVED": "已接收",
  "microbiology.enum.RELEASED": "已发布",
  "microbiology.enum.REPEAT": "重复",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "必须运行可报告的AST",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "必须审核需报告的AST运行情况",
  "microbiology.enum.RESULT": "结果",
  "microbiology.enum.RESULTS_IN": "结果见",
  "microbiology.enum.RETEST": "重新检测",
  "microbiology.enum.REVIEW_READY": "已准备好审核",
  "microbiology.enum.REVIEWED": "已审核",
  "microbiology.enum.INTERMEDIATE": "中级",
  "microbiology.enum.LOST_SPECIMEN": "丢失的标本",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "丢失的标本——阳性培养结果",
  "microbiology.enum.NO_BREAKPOINT": "否断点",
  "microbiology.enum.RESISTANT": "耐受性",
  "microbiology.enum.ROUTINE": "常规",
  "microbiology.enum.SAMPLE_ITEM": "样本项",
  "microbiology.enum.SETUP": "设置中",
  "microbiology.enum.SETUP_RECORDED": "设置中已记录",
  "microbiology.enum.SMS": "短信",
  "microbiology.enum.SPECIMEN_LOST": "标本丢失",
  "microbiology.enum.STAGE_CHANGED": "阶段已切换",
  "microbiology.enum.SUBCULTURE_RECORDED": "《亚文化记录》",
  "microbiology.enum.UNASSIGNED": "未分配",
  "microbiology.enum.UNKNOWN_ERROR": "未知错误",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "工作流已变更",
  "microbiology.enum.ZONE": "区域",
  "microbiology.enum.FINAL_RELEASED": "最终版发布",
  "microbiology.enum.SUSCEPTIBLE": "易感",
  "microbiology.enum.UNKNOWN": "未知",
  "rulebuilder.label.selectComponent": "选择组件",
  "testcalculation.label.selectComponent": "选择组件",
  "testcalculation.label.finalComponent": "结果组件",
  "qc.dashboard.tab.bench": "Bench QC",
  "qc.bench.source.all": "All bench sources",
  "qc.bench.source.manual": "Manual quantitative",
  "qc.bench.source.rdt": "Rapid test (RDT)",
  "qc.bench.column.runs": "Controls run",
  "qc.bench.column.lastRun": "Last run",
  "qc.bench.empty": "No manual or rapid-test controls were recorded in this period.",
  "microbiology.case.activityNote": "活动说明",
  "microbiology.case.accessionNumber": "订单号",
  "microbiology.case.actionError": "无法完成文化操作",
  "microbiology.case.action.markNoGrowth": "标记为“未准备好增长”",
  "microbiology.case.action.recordGrowth": "检测到记录级的增长",
  "microbiology.case.action.rejectCase": "拒绝案件",
  "microbiology.case.action.setIncubating": "设置培养",
  "microbiology.case.action.startInoculation": "开始接种",
  "microbiology.case.createIsolate": "创建分离株",
  "microbiology.case.cultureAction": "文化行动",
  "microbiology.case.atmosphere": "氛围",
  "microbiology.case.eyebrow": "微生物学实验台",
  "microbiology.case.sectionExpanded": "{section} 展开",
  "microbiology.case.sectionStatus": "章节状态",
  "microbiology.case.error": "微生物学案例错误",
  "microbiology.case.isolateLabel": "分离标签",
  "microbiology.case.isolates": "分离株",
  "microbiology.case.isolates.empty": "未记录任何分离株",
  "microbiology.case.loadError": "无法加载微生物学案例",
  "microbiology.case.lastActivityBy": "最后一次活动时间：",
  "microbiology.case.incubation": "孵化",
  "microbiology.case.media": "培养基或瓶子",
  "microbiology.case.nextStage": "下一个阶段",
  "microbiology.case.patient": "患者",
  "microbiology.case.nonconformanceCount": "{count, plural, one {# NCE} other {# NCEs}}",
  "microbiology.case.relatedWorkflows": "相关的标本工作流",
  "microbiology.case.requestingLocation": "请求位置",
  "microbiology.case.preliminaryOrganism": "原始生物",
  "microbiology.case.recordActivity": "记录活动",
  "microbiology.case.sampleItem": "示例项目",
  "microbiology.case.setup": "接种",
  "microbiology.case.setup.hint": "请记录该培养案例的初始设置中、培养基或培养步骤。",
  "microbiology.case.significance": "意义",
  "microbiology.case.specimenType": "标本类型",
  "microbiology.case.timeline": "案件时间线",
  "microbiology.case.timeline.addNote": "添加备注",
  "microbiology.case.timeline.auto": "汽车",
  "microbiology.case.timeline.culturePurposeChange": "{from} 发送至 {to}",
  "microbiology.case.timeline.culturePurposeChanged": "文化宗旨已变更",
  "microbiology.case.timeline.empty": "未记录任何病例动态",
  "microbiology.case.timeline.hint": "记录在案的病例动态按时间顺序显示。",
  "microbiology.case.timeline.manual": "手册",
  "microbiology.case.timeline.note": "备注或观察",
  "microbiology.case.timeline.noteExpanded": "备注展开",
  "microbiology.case.timeline.performedBy": "演唱：{actor}",
  "microbiology.case.timeline.saveNote": "保存备注",
  "microbiology.case.timeline.showAll": "显示所有{count}活动",
  "microbiology.case.timeline.showRecent": "显示{count}的近期活动",
  "microbiology.case.events": "活动",
  "microbiology.case.finalLocked.message": "最终发布后，隔离和AST更改功能已禁用。",
  "microbiology.case.finalLocked.title": "最后一个案例是只读的",
  "microbiology.case.title": "微生物学案例",
  "microbiology.case.workflow": "工作流",
  "microbiology.inoculation.addSubculture": "添加亚文化",
  "microbiology.inoculation.empty": "尚未记录任何培养基。请开始接种以启动培养。",
  "microbiology.inoculation.hint": "对每瓶或每块培养皿进行记录，并保留其培养系谱。",
  "microbiology.inoculation.identifier": "瓶子或盘子的ID",
  "microbiology.inoculation.identifierHint": "扫描或输入标识符。",
  "microbiology.inoculation.parent": "父级媒体",
  "microbiology.inoculation.parentPlaceholder": "选择源瓶或源盘",
  "microbiology.inoculation.primaryExpanded": "接种表已展开",
  "microbiology.inoculation.primary": "主要",
  "microbiology.inoculation.recorded": "录制媒体",
  "microbiology.inoculation.save": "保存媒体文件",
  "microbiology.inoculation.source": "来源",
  "microbiology.inoculation.start": "开始接种",
  "microbiology.inoculation.subcultureExpanded": "亚文化形式扩展",
  "microbiology.inoculation.subculture": "亚文化",
  "microbiology.amendment.actionError": "无法完成修改操作",
  "microbiology.amendment.cancel": "取消修订",
  "microbiology.amendment.cancelReason": "取消原因",
  "microbiology.amendment.cancelled": "修改已取消；该最终案例再次被锁定",
  "microbiology.amendment.correctsVersion": "更正版本 {number}",
  "microbiology.amendment.hint": "在不替换其已发布版本历史记录的情况下，更正最终报告。",
  "microbiology.amendment.history": "修订历史",
  "microbiology.amendment.inProgress.message": "记录更正内容，并发布或取消此修订，以再次锁定该案件。",
  "microbiology.amendment.inProgress.title": "正在进行中",
  "microbiology.amendment.noReportVersions": "未记录任何最终报告版本",
  "microbiology.amendment.none": "未记录任何修正案",
  "microbiology.amendment.number": "修正案",
  "microbiology.amendment.numberValue": "修正案{number}",
  "microbiology.amendment.open": "待处理修正案",
  "microbiology.amendment.opened": "修订功能已开启；现已启用临床更正功能",
  "microbiology.amendment.reason": "修改原因",
  "microbiology.amendment.release": "发布修订后的报告",
  "microbiology.amendment.released": "修订版报告已发布；该案件再次被锁定",
  "microbiology.amendment.reportVersions": "已发布的报告版本",
  "microbiology.amendment.status": "状态",
  "microbiology.amendment.status.closed": "无待审议的修正案",
  "microbiology.amendment.status.open": "待处理修正案",
  "microbiology.amendment.title": "修正案",
  "microbiology.amendment.version": "版本{number}",
  "microbiology.ast.antibiotic": "抗生素",
  "microbiology.ast.acceptResults": "接受结果",
  "microbiology.ast.acknowledgeFlags": "确认已审核的标记",
  "microbiology.ast.analyzer": "分析仪",
  "microbiology.ast.analyzerOrganism": "分析对象：{organism}（{confidence}%）",
  "microbiology.ast.analyzerProvenance": "卡片或面板 {card} · 软件 {version}",
  "microbiology.ast.analyzerResolutionReason": "原因及纠正措施",
  "microbiology.ast.actionError": "无法完成 AST 操作",
  "microbiology.ast.adjustPanel": "调整面板",
  "microbiology.ast.orderedAntibiotics": "待检测的抗生素",
  "microbiology.ast.actions": "操作",
  "microbiology.ast.applyOverride": "应用覆盖",
  "microbiology.ast.attempt": "尝试",
  "microbiology.ast.attemptMethod": "尝试方法",
  "microbiology.ast.attemptNumber": "尝试访问 {number}",
  "microbiology.ast.attemptReason": "理由",
  "microbiology.ast.attemptScope": "重复范围",
  "microbiology.ast.attempts": "AST 尝试次数",
  "microbiology.ast.attemptType": "尝试类型",
  "microbiology.ast.awaitingAnalyzerResults": "等待分析仪结果",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "当已连接的分析仪发送结果时，结果将自动显示。未匹配的事件将保留在“分析仪导入问题”中。",
  "microbiology.ast.awaitingSetupCount": "{count} 等待设置中",
  "microbiology.ast.cardId": "卡或面板 ID",
  "microbiology.ast.entryMode": "结果录入",
  "microbiology.ast.entryMode.analyzer": "联网分析仪",
  "microbiology.ast.entryMode.manual": "手动输入",
  "microbiology.ast.expertFlags": "分析仪专家标记需要审核",
  "microbiology.ast.hideOriginal": "隐藏历史记录",
  "microbiology.ast.historyTo": "到",
  "microbiology.ast.interpretation": "解释",
  "microbiology.ast.instrumentInterpretation": "分析仪：{interpretation}",
  "microbiology.ast.invalidateAndRepeat": "无效并开始新轮次",
  "microbiology.ast.includedInReport": "报告中包含的内容",
  "microbiology.ast.initialAttemptReason": "首次尝试",
  "microbiology.ast.isolate": "隔离",
  "microbiology.ast.method": "方法",
  "microbiology.ast.matchedBy": "匹配的断点",
  "microbiology.ast.measurement.mic": "MIC（微克/毫升）",
  "microbiology.ast.measurement.zone": "区域直径（毫米）",
  "microbiology.ast.noBreakpointGuidance": "无标准断点。请根据当地标准操作规程（SOP）解释该检测结果。",
  "microbiology.ast.noBreakpointTitle": "需要本地化解释",
  "microbiology.ast.noIsolate": "在记录AST之前创建分离株",
  "microbiology.ast.noSourceAttempt": "原始尝试",
  "microbiology.ast.notIncludedInReport": "不包括在内",
  "microbiology.ast.newAttempt": "新复诊或重新检测",
  "microbiology.ast.noRunsYet": "目前尚未得分",
  "microbiology.ast.antibioticToRepeat": "需继续服用抗生素",
  "microbiology.ast.override": "解释的优先适用",
  "microbiology.ast.overrideHistory": "覆盖历史记录",
  "microbiology.ast.optionsExpanded": "{section} 选项已展开。",
  "microbiology.ast.overrideReason": "覆盖原因",
  "microbiology.ast.orderedPanel": "已订购AST检测项目",
  "microbiology.ast.organismMismatch": "分析用菌株与该病例的分离株不同",
  "microbiology.ast.organismMismatchDetail": "分析仪的鉴定结果仅供参考。请核对差异；确认病例的分离株结果仍具权威性。",
  "microbiology.ast.overrideQc": "覆盖QC标志",
  "microbiology.ast.panel": "AST 面板",
  "microbiology.ast.panelAdjustmentReason": "调整面板的原因",
  "microbiology.ast.panelProvenance.organismDefault": "按已识别生物体的配置默认值排序",
  "microbiology.ast.rawValue": "值",
  "microbiology.ast.qcFailed": "分析仪QC失败",
  "microbiology.ast.qcFailedDetail": "QC参考编号：{reference}。在本次检测无效或主管记录了覆盖操作之前，结果将无法被接受。",
  "microbiology.ast.replacementCardId": "新的卡片或面板 ID",
  "microbiology.ast.resultsReady": "分析仪结果已准备就绪，可供审查",
  "microbiology.ast.resultsReadyDetail": "在接受这些结果之前，请检查其中的差异、缺失的断点以及专家标记。",
  "microbiology.ast.runsComplete": "{complete} / “{total}” 已完成",
  "microbiology.ast.pendingIdentificationCount": "{count} 待处理",
  "microbiology.ast.reasonForAttempt": "重复或重新检测的原因",
  "microbiology.ast.recordReading": "记录AST读数",
  "microbiology.ast.reviewRun": "审查 AST 运行情况",
  "microbiology.ast.repeat": "重复",
  "microbiology.ast.revertOverride": "恢复为原始版本",
  "microbiology.ast.revertReason": "撤销覆盖操作的原因",
  "microbiology.ast.reporting": "报告",
  "microbiology.ast.retest": "重新检测",
  "microbiology.ast.selectAntibiotic": "选择抗生素",
  "microbiology.ast.singleAntibiotic": "单一抗生素",
  "microbiology.ast.wholePanel": "整个面板",
  "microbiology.ast.runStatus": "AST 运行状态",
  "microbiology.ast.startRun": "开始 AST 运行",
  "microbiology.ast.startAttempt": "开始{type}尝试",
  "microbiology.ast.sourceAttempt": "来源",
  "microbiology.ast.source": "阅读来源",
  "microbiology.ast.showOriginal": "显示原文",
  "microbiology.ast.title": "手动AST",
  "microbiology.ast.useAttemptForReporting": "请使用{number}进行报告",
  "microbiology.ast.useForReporting": "用于报告",
  "microbiology.ast.view": "查看",
  "microbiology.ast.viewAttempt": "查看尝试记录 {number}",
  "microbiology.ast.viewing": "查看",
  "microbiology.ast.viewingAttempt": "查看尝试 {number}",
  "microbiology.critical.acknowledge": "确认",
  "microbiology.critical.followUp": "需要跟进",
  "microbiology.critical.hint": "记录紧急结果回调，并在代码中直接确认这些回调。",
  "microbiology.critical.log": "日志通信",
  "microbiology.critical.logForIsolate": "为{isolate}记录紧急通知",
  "microbiology.critical.logNotification": "记录紧急通知",
  "microbiology.critical.method": "通信方式",
  "microbiology.critical.message": "消息",
  "microbiology.critical.messageRequired": "必须填写消息",
  "microbiology.critical.none": "未记录任何紧急通信",
  "microbiology.critical.recipient": "收件人",
  "microbiology.critical.recipientContact": "收件人联系人",
  "microbiology.critical.required": "选择一个目标，并填写收件人和消息内容。",
  "microbiology.critical.resolution": "分辨率备注",
  "microbiology.critical.resolutionRequired": "在关闭沟通之前，必须提供一份解决方案备注。",
  "microbiology.critical.close": "密切沟通",
  "microbiology.critical.target": "关键结果目标",
  "microbiology.critical.targetId": "目标记录",
  "microbiology.critical.title": "紧急沟通",
  "microbiology.caseInfo.no": "否",
  "microbiology.caseInfo.notProvided": "未提供",
  "microbiology.caseInfo.summary": "案件信息摘要",
  "microbiology.caseInfo.yes": "是",
  "microbiology.currentStep.open": "打开 {step}",
  "microbiology.currentStep.title": "当前步骤",
  "microbiology.cultureAction.error": "无法更新培养状态。",
  "microbiology.cultureAction.noGrowth.confirm": "确认无增殖",
  "microbiology.cultureAction.noGrowth.detail": "确认已完成规定的培养时间，且未检测到菌落生长。",
  "microbiology.cultureAction.noGrowth.title": "将“培养基”标记为“否生长”",
  "microbiology.cultureAction.positive.confirm": "确认正信号",
  "microbiology.cultureAction.positive.detail": "确认阳性结果。下一个操作是进行传代培养并记录革兰氏染色结果。",
  "microbiology.cultureAction.positive.title": "标记为“文化积极”",
  "microbiology.nce.category": "类别",
  "microbiology.nce.configurationBlockerTitle": "需要进行配置",
  "microbiology.nce.configurationLoadError": "无法加载NCE类别和报告单元。",
  "microbiology.nce.critical": "紧急",
  "microbiology.nce.description": "描述",
  "microbiology.nce.disposition": "处置",
  "microbiology.nce.errorTitle": "无法报告不符合项",
  "microbiology.nce.flagOnly": "仅标记",
  "microbiology.nce.immediateAction": "立即采取行动",
  "microbiology.nce.lostTypeMissing": "当前的NCE配置中不包含“标本丢失”类型。",
  "microbiology.nce.major": "专业",
  "microbiology.nce.markLost": "马克输了",
  "microbiology.nce.markLostHint": "记录该实物标本为丢失，并拒绝受影响的未完成检测项目。",
  "microbiology.nce.markLostTitle": "标记标本丢失",
  "microbiology.nce.minor": "次要的",
  "microbiology.nce.rejectTests": "拒绝受影响的检测项目",
  "microbiology.nce.retest": "重新检测AST",
  "microbiology.nce.retestLoadError": "无法加载已审核的AST运行结果。请在选择“重新检测AST”之前重试。",
  "microbiology.nce.sourceAstRun": "AST运行以进行重新检测",
  "microbiology.nce.report": "NCE报告",
  "microbiology.nce.reportHint": "针对该标本记录一项不符合项，并选择其处置方式。",
  "microbiology.nce.reportingUnit": "报告单元",
  "microbiology.nce.reportTitle": "报告不符合项",
  "microbiology.nce.required": "请选择类别、报告单元和严重程度，并填写描述。",
  "microbiology.nce.sectionTitle": "不符合项",
  "microbiology.nce.severity": "严重程度",
  "microbiology.nce.submitError": "无法保存该不符合项。",
  "microbiology.nce.title": "标题",
  "microbiology.nce.type": "设备类型",
  "microbiology.isolate.identify": "鉴定生物体",
  "microbiology.isolate.reidentify": "重新识别",
  "microbiology.isolate.identified": "已识别",
  "microbiology.isolate.pending": "身份待处理",
  "microbiology.isolate.gramStain": "革兰氏染色",
  "microbiology.isolate.colonyMorphology": "菌落形态",
  "microbiology.isolate.identification": "身份识别",
  "microbiology.isolate.identificationMethod": "ID 方法",
  "microbiology.isolate.identificationConfidence": "ID置信度（%）",
  "microbiology.isolate.identificationChange": "{previous} 发送至 {next}：{reason}",
  "microbiology.isolate.identificationHistory": "识别历史",
  "microbiology.isolate.identificationReason": "重新识别的原因",
  "microbiology.isolate.organism.select": "选择一种生物体",
  "microbiology.isolate.unidentified": "未识别",
  "microbiology.ast.identificationRequired": "在进行抗菌药物敏感性试验（AST）前，应先鉴定该分离株。",
  "microbiology.next.createIsolate": "接种记录已登记。若出现显著生长，请添加记录；若无生长，请标记该样本，以便后续处理。",
  "microbiology.next.completeAmendment": "修订已开放。记录更正内容，审核报告，然后发布修订版。",
  "microbiology.next.classifyWorkflow": "在开始针对特定配置文件的工作之前，请选择正确的工作流和培养方法。",
  "microbiology.next.finalReleased": "最终报告已发布。导出前请审查监测准备情况。",
  "microbiology.next.incubating": "培养中。当出现生长迹象时，将该样本标记为阳性；当规定的培养期完成时，标记为无生长。",
  "microbiology.next.subculturePositive": "检测到阳性信号。将培养瓶中的培养物进行传代培养，并记录革兰氏染色结果。",
  "microbiology.next.recordSetup": "已接收案例。记录初始设置，开始孵化。",
  "microbiology.next.release": "AST已完成审核。确认报告已准备就绪，并发布最终报告。",
  "microbiology.next.noGrowthRelease": "未记录到任何增长。请审核并发布最终的否定报告。",
  "microbiology.next.reviewAst": "已记录菌株。发布前请完成并审核AST报告。",
  "microbiology.next.title": "下一步",
  "microbiology.navigation.backToWorklist": "返回微生物学工作列表",
  "microbiology.navigation.menu": "微生物学",
  "microbiology.navigation.worklist": "微生物学工作清单",
  "microbiology.orderEntry.discardConfirm": "忽略详细信息",
  "microbiology.orderEntry.discardHeading": "移除微生物学工作流？",
  "microbiology.orderEntry.discardMessage": "移除最后的培养检测将导致该订单中已输入的微生物学项目详情被删除。",
  "microbiology.orderEntry.programDerived": "微生物学结果来源于已选择的培养试验。",
  "microbiology.orderEntry.programDiscardHeading": "是否忽略微生物学相关信息？",
  "microbiology.orderEntry.programDiscardMessage": "您已输入微生物学的相关信息。若更改计划，这些信息将被清空。",
  "order.context.workflowProgress": "订单工作流进度",
  "microbiology.orderEntry.hint": "这些详细信息会随送检培养基一同传输，因此实验室无需重新输入订单信息即可开始设置中工作。",
  "microbiology.orderEntry.incomplete": "在保存此培养单之前，请先配置微生物学计划。",
  "microbiology.orderEntry.programMissingMessage": "该订单工作流中未配置微生物学项目。",
  "microbiology.orderEntry.programMissingTitle": "需要进行计划配置",
  "microbiology.orderEntry.routingMessage": "这将创建一个用于培养和药敏试验的微生物学病例。",
  "microbiology.orderEntry.routingTitle": "已选择培养工作流",
  "microbiology.orderEntry.title": "微生物学计划详情",
  "microbiology.culturePurpose.clinical": "临床诊断或治疗",
  "microbiology.culturePurpose.label": "文化宗旨",
  "microbiology.culturePurpose.screening": "活跃筛查或携带",
  "microbiology.culturePurpose.unspecified": "未指定",
  "microbiology.orderDetail.antibioticExposure": "患者近期（2周内）曾使用过抗生素",
  "microbiology.orderDetail.admissionDate": "入学日期",
  "microbiology.orderDetail.admissionDateFuture": "入学日期不能是未来的时间。",
  "microbiology.orderDetail.admissionDateHelper": "住院日期。如不清楚，请留空。",
  "microbiology.orderDetail.admissionDateOutpatient": "门诊患者不纳入住院统计——按“社区来源”记录。",
  "microbiology.orderDetail.collectionDateContext": "采集日期：{date}",
  "microbiology.orderDetail.collectionTimingHospital": "入院后{days}天已采样的数据——用于监测的医院来源数据。",
  "microbiology.orderDetail.collectionTimingCommunity": "入院后{days}已采样天——来自社区，用于监测。",
  "microbiology.orderDetail.clinicalHistory": "病史",
  "microbiology.orderDetail.cultureMethod": "文化协议",
  "microbiology.orderDetail.hint": "记录实验室进行培养准备和关键结果随访所需的订单信息。",
  "microbiology.orderDetail.numberOfSets": "组数",
  "microbiology.orderDetail.numberOfSets.helper": "采样组，例如从不同部位采集的两套血培养样本。并非指标本的数量或体积。",
  "microbiology.orderDetail.patientOrigin": "患者来源",
  "microbiology.orderDetail.protocolDerived": "派生",
  "microbiology.orderDetail.protocolHelper": "来源：已订购的检查单。如果检测项目有差异，请在操作台进行调整。",
  "microbiology.orderDetail.protocolUnset": "未设置——系统将自动选择协议",
  "microbiology.orderDetail.protocolUnsetTitle": "协议未设置",
  "microbiology.orderDetail.save": "保存订单详情",
  "microbiology.orderDetail.title": "订单详情",
  "microbiology.patientOrigin.emergency": "急诊科",
  "microbiology.patientOrigin.icu": "重症监护室",
  "microbiology.patientOrigin.inpatient": "住院病房",
  "microbiology.patientOrigin.other": "其他原因",
  "microbiology.patientOrigin.outpatient": "门诊部",
  "microbiology.progress.ast": "AST结果",
  "microbiology.progress.caseInfo": "案件信息",
  "microbiology.progress.inoculation": "接种",
  "microbiology.progress.isolates": "分离株",
  "microbiology.progress.reports": "报告",
  "microbiology.progress.review": "专家评审",
  "microbiology.progress.timeline": "时间轴",
  "microbiology.progress.title": "案件进度",
  "microbiology.protocol.change": "更改协议",
  "microbiology.protocol.error": "无法更改协议",
  "microbiology.protocol.field": "培养方案",
  "microbiology.protocol.helper": "该协议控制着计划中的培养基和培养方案。已记录的接种数据绝不会被覆盖。",
  "microbiology.protocol.inactive": "非活跃",
  "microbiology.protocol.loading": "加载协议",
  "microbiology.protocol.noChoices": "没有其他有效的协议与该有序检测和工作流相关联。",
  "microbiology.protocol.noneMessage": "该委托检测未提供默认值。请在实验台前选择一种检测方案。",
  "microbiology.protocol.noneTitle": "未设置协议",
  "microbiology.protocol.placeholder": "选择一种协议",
  "microbiology.protocol.reason": "更改协议的原因",
  "microbiology.protocol.save": "保存协议",
  "microbiology.protocol.set": "设置协议",
  "microbiology.protocol.title": "培养方案",
  "microbiology.protocol.updated": "协议已更新",
  "microbiology.case.timeline.protocolChanged": "培养方案已从 {from} 更改为 {to}：{reason}",
  "microbiology.workflowChange.apply": "应用工作流",
  "microbiology.workflowChange.error": "无法更改工作流",
  "microbiology.workflowChange.help": "在保留本案例现有历史记录的同时，修正工作流和“文化法”。",
  "microbiology.workflowChange.methodPlaceholder": "选择一种培养方法",
  "microbiology.workflowChange.preserveConfirmation": "在修正后的工作流中，保留设置中已有的配置、隔离及AST历史记录",
  "microbiology.workflowChange.preserveWarning": "该病例已包含临床资料。当前阶段及既往病史记录将予以保留。",
  "microbiology.workflowChange.preserveWarningTitle": "现有成果将予以保留",
  "microbiology.workflowChange.reason": "变更原因",
  "microbiology.workflowChange.requiredMessage": "在该病例分类确定之前，将暂缓进行培养、分离、抗生素敏感性试验（AST）及报告工作。",
  "microbiology.workflowChange.requiredTitle": "需要对工作流进行分类",
  "microbiology.workflowChange.title": "更改工作流",
  "microbiology.workflowChange.unassignedHelp": "在开始培养准备、隔离操作、抗菌药物敏感性试验（AST）或报告之前，请先对该病例进行分类。",
  "microbiology.workflowChange.workflow": "工作流",
  "microbiology.workflowChange.workflowPlaceholder": "选择一个工作流",
  "microbiology.readiness.blocked": "最终发布被阻止",
  "microbiology.readiness.ready": "最终版本已准备发布",
  "microbiology.reagentLots.blocked": "被屏蔽：{reason}",
  "microbiology.reagentLots.context": "板凳席背景",
  "microbiology.reagentLots.context.AST_SETUP": "AST 设置中",
  "microbiology.reagentLots.context.CULTURE_SETUP": "培养基配制",
  "microbiology.reagentLots.empty": "此检测未关联任何试剂。",
  "microbiology.reagentLots.fefo": "FEFO——先用先出",
  "microbiology.reagentLots.fifo.tooltip": "批次按到期日最早的顺序排列；若无法确定到期日，则按接收日期排序。",
  "microbiology.reagentLots.hint": "请为每个关联的试剂或耗材选择其确切的批号。",
  "microbiology.reagentLots.history": "记录的批号使用情况",
  "microbiology.reagentLots.legend": "{reagent} 可可用地块",
  "microbiology.reagentLots.lot": "Lot",
  "microbiology.reagentLots.noExpiry": "未记录到期日",
  "microbiology.reagentLots.noLots": "该试剂目前无库存。",
  "microbiology.reagentLots.option": "{lot}，{quantity} {unit} 可用，有效期至 {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "每次检测的数量：{quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "{reagent} 地块{lot}已过期；请选择另一个地块。",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "{reagent} 批次{lot}的数量已不足；请选择另一个批次。",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "{reagent} 批号{lot}失败了QC；请选择一个通过QC的批次。",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "{reagent} 批次{lot}未通过QC；请选择一个通过QC的批次。",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "{reagent} 编号{lot}的房源已售罄；请刷新页面并选择另一套房源。",
  "microbiology.reagentLots.qc.FAILED": "QC未通过",
  "microbiology.reagentLots.qc.PASSED": "QC通过",
  "microbiology.reagentLots.qc.PENDING": "待处理QC",
  "microbiology.reagentLots.qc.QUARANTINED": "QC 已被隔离",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "已消耗",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "已过期",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "非活跃",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "数量不足",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "QC未通过",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "QC未通过",
  "microbiology.reagentLots.reagent": "试剂或耗材",
  "microbiology.reagentLots.recorded": "已记录",
  "microbiology.reagentLots.role.PRIMARY": "主要",
  "microbiology.reagentLots.role.SECONDARY": "中学",
  "microbiology.reagentLots.scan.ambiguous": "该批号与多个关联试剂匹配。请在试剂列表中选择该批号。",
  "microbiology.reagentLots.scan.label": "扫描或输入批号",
  "microbiology.reagentLots.scan.notFound": "没有与该批号匹配的关联地块。",
  "microbiology.reagentLots.scan.placeholder": "扫描或输入确切的批号",
  "microbiology.reagentLots.scan.selected": "已选择拍品编号{lot}。",
  "microbiology.reagentLots.status": "当前批次状态",
  "microbiology.reagentLots.status.ACTIVE": "活跃",
  "microbiology.reagentLots.status.CONSUMED": "已消耗",
  "microbiology.reagentLots.status.IN_USE": "使用中",
  "microbiology.reagentLots.title": "试剂和批次可追溯性",
  "microbiology.reagentLots.used": "使用数量",
  "microbiology.release.failed": "无法发布该报告。请查看相关要求，然后重试。",
  "microbiology.release.final": "发布最终报告",
  "microbiology.release.finalReleased": "最终报告发布",
  "microbiology.release.hint": "仅在就绪检查通过后发布报告。",
  "microbiology.release.mappingConfigured": "已配置患者报告映射",
  "microbiology.release.mappingRequired": "最终发布需要患者报告映射",
  "microbiology.release.noReportableContent": "尚无可报告的微生物学内容。",
  "microbiology.release.notEvaluated": "尚未对准备情况进行评估",
  "microbiology.release.patientReport": "患者报告预览",
  "microbiology.release.preliminary": "发布初步报告",
  "microbiology.release.readinessChecks": "最终发布准备情况",
  "microbiology.release.title": "报告准备情况",
  "microbiology.release.viewPatientResults": "查看患者结果",
  "microbiology.release.useAmendment": "“修订”部分中的修正版本来源",
  "microbiology.release.whonetChecks": "WHONET 准备情况",
  "microbiology.whonet.blocked": "WHONET 导出被阻止",
  "microbiology.whonet.ready": "WHONET 已准备好导出",
  "microbiology.worklist.clearFilters": "清除筛选条件",
  "microbiology.worklist.column.action": "操作",
  "microbiology.worklist.column.context": "上下文",
  "microbiology.worklist.column.due": "应采取的操作",
  "microbiology.worklist.column.flags": "国旗",
  "microbiology.worklist.column.isolate": "隔离",
  "microbiology.worklist.column.labNumber": "实验编号 #",
  "microbiology.worklist.column.lastActivity": "最后一次活动时间：",
  "microbiology.worklist.column.organism": "生物体",
  "microbiology.worklist.column.panel": "面板",
  "microbiology.worklist.column.patient": "患者",
  "microbiology.worklist.column.priority": "优先级",
  "microbiology.worklist.column.sample": "示例项目",
  "microbiology.worklist.column.specimen": "标本",
  "microbiology.worklist.column.stage": "阶段",
  "microbiology.worklist.column.started": "已开始",
  "microbiology.worklist.column.status": "状态",
  "microbiology.worklist.column.urgency": "紧迫性",
  "microbiology.worklist.column.workflow": "工作流",
  "microbiology.worklist.critical": "紧急沟通",
  "microbiology.worklist.dueDetail.ast_entry": "针对已鉴定出的分离株设置AST。",
  "microbiology.worklist.dueDetail.ast_review": "审查报告中的易感性结果。",
  "microbiology.worklist.dueDetail.case_review": "审查报告的准备情况及发布事宜。",
  "microbiology.worklist.dueDetail.isolate_id": "记录生长情况并鉴定菌株。",
  "microbiology.worklist.dueDetail.incubating": "{day} 的 {max} 天",
  "microbiology.worklist.dueDetail.setup": "记录初始培养设置。",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "进行培养，并记录革兰氏染色结果。",
  "microbiology.worklist.empty.ast": "没有匹配的AST运行记录。请清除搜索结果或选择其他状态。",
  "microbiology.worklist.empty.cultures": "没有匹配的文化。请清除搜索条件或选择其他状态。",
  "microbiology.worklist.expertRulesUnavailable": "OpenELIS 专家规则标记在第 1B 阶段可用。如有分析仪报告的标记，则会显示出来。",
  "microbiology.worklist.filters": "工作列表过滤器",
  "microbiology.worklist.filter.allActions": "所有操作",
  "microbiology.worklist.filter.allStages": "所有阶段",
  "microbiology.worklist.filter.allUrgencies": "所有紧急程度",
  "microbiology.worklist.filter.allWorkflows": "所有工作流",
  "microbiology.worklist.filter.activeAst": "活跃工作",
  "microbiology.worklist.filter.astStatus": "AST状态",
  "microbiology.worklist.filter.dueAction": "应采取的操作",
  "microbiology.worklist.filter.reviewed": "已审核",
  "microbiology.worklist.filter.stage": "阶段",
  "microbiology.worklist.filter.urgency": "紧迫性",
  "microbiology.worklist.filter.workflow": "工作流",
  "microbiology.worklist.flagsUnavailable": "专家规则（第1B阶段）",
  "microbiology.worklist.loadError.subtitle": "无法加载队列。请尝试刷新页面。",
  "microbiology.worklist.loadError.title": "无法加载微生物学工作单",
  "microbiology.worklist.linkedWorkflows": "相关链接 · {count} 工作流",
  "microbiology.worklist.editAst": "编辑 AST",
  "microbiology.worklist.grain.ast": "AST运行",
  "microbiology.worklist.grain.cultures": "文化",
  "microbiology.worklist.notSet": "未设置",
  "microbiology.worklist.notStarted": "待处理的订单",
  "microbiology.worklist.markLost": "马克输了",
  "microbiology.worklist.markNoGrowth": "标记为“无增长”",
  "microbiology.worklist.markPositive": "标记为“积极”",
  "microbiology.worklist.openCase": "已立案",
  "microbiology.worklist.newAstAttempt": "设置新的 AST 运行",
  "microbiology.worklist.newPositive": "新增确诊病例",
  "microbiology.worklist.phase1b": "第一阶段B期可用",
  "microbiology.worklist.print": "打印列表",
  "microbiology.worklist.qcDashboard": "QC仪表板",
  "microbiology.worklist.queueStatus": "共享队列",
  "microbiology.worklist.refresh": "立即刷新",
  "microbiology.worklist.rowActions": "行操作",
  "microbiology.worklist.recentActivity.empty": "近期没有微生物学方面的活动。",
  "microbiology.worklist.recentActivity.title": "最近的活动 ({count})",
  "microbiology.worklist.resistance.hint": "分析仪报告的标记今天已完成处理；OpenELIS专家规则检测仍处于第1B阶段。",
  "microbiology.worklist.resistance.title": "今天的阻力位",
  "microbiology.worklist.search.ast": "搜索实验室编号、患者、分离株、病原体或检测项目组合",
  "microbiology.worklist.search.cultures": "搜索实验室编号、患者、标本或工作流",
  "microbiology.worklist.sharedQueue": "共享实验室队列",
  "microbiology.worklist.siblings": "兄弟工作流",
  "microbiology.worklist.setupAst": "设置 AST",
  "microbiology.worklist.sort": "排序",
  "microbiology.worklist.sort.newest": "最新动态",
  "microbiology.worklist.sort.priority": "优先级",
  "microbiology.worklist.sort.workflow": "工作流",
  "microbiology.worklist.subtitle": "根据工作流阶段、紧急程度和所需的实验室操作，对培养病例进行优先级排序。",
  "microbiology.worklist.summary.astReview": "AST 评论",
  "microbiology.worklist.summary.astInProgress": "进行中",
  "microbiology.worklist.summary.astInQueue": "正在排队",
  "microbiology.worklist.summary.astPendingSetup": "待处理设置",
  "microbiology.worklist.summary.astResultsIn": "结果即将公布——敬请关注",
  "microbiology.worklist.summary.caseReview": "已准备好进行案例审查",
  "microbiology.worklist.summary.critical": "查看紧急后续事项",
  "microbiology.worklist.summary.growthDetected": "检测到增长",
  "microbiology.worklist.summary.hint": "选择一个队列以更新案件列表。",
  "microbiology.worklist.summary.identification": "身份识别正在进行中",
  "microbiology.worklist.summary.incubating": "孵化",
  "microbiology.worklist.summary.positive": "积极的",
  "microbiology.worklist.summary.expertFlags": "专家标记 (1B)",
  "microbiology.worklist.summary.title": "需要采取行动的工作",
  "microbiology.worklist.summary.totalPending": "待处理总数",
  "microbiology.worklist.table.hint": "案件按紧急程度和下一个所需采取的行动进行排序。",
  "microbiology.worklist.table.astTitle": "AST运行",
  "microbiology.worklist.table.title": "待处理微生物学案件",
  "microbiology.worklist.viewAudit": "查看审计报告",
  "microbiology.worklist.viewReviewedAst": "查看已审核的AST",
  "microbiology.worklist.whonetExport": "导出到 WHONET",
  "microbiology.worklist.surveillance.title": "监控范围",
  "microbiology.worklist.surveillance.description": "按报告期和结构化监测字段筛选AST行。操作队列过滤器不会改变导出数据集。",
  "microbiology.worklist.ast.automaticResults": "分析仪的结果会自动发送过来",
  "microbiology.worklist.ast.automaticResultsDetail": "已连接的仪器会将结果直接发送至病例。失败或无法匹配的事件将保留在“分析仪导入问题”中。",
  "microbiology.worklist.ast.awaitingResults": "等待分析仪结果",
  "microbiology.worklist.ast.pendingIdentification": "身份待处理",
  "microbiology.worklist.ast.resultsInBadge": "结果在",
  "microbiology.worklist.title": "微生物学工作清单",
  "microbiology.worklist.updated": "{seconds}秒前更新 · 30秒自动刷新",
  "microbiology.admin.action.deactivate": "停用",
  "microbiology.admin.action.moveDown": "向下移动",
  "microbiology.admin.action.moveUp": "向上移动",
  "microbiology.admin.action.reactivate": "重新激活",
  "microbiology.admin.actions": "行操作",
  "microbiology.admin.antibiotics.add": "添加抗生素",
  "microbiology.admin.antibiotics.description": "AST检测面板使用的抗菌药物术语及阈值规则。",
  "microbiology.admin.antibiotics.edit": "抗生素",
  "microbiology.admin.antibiotics.title": "抗生素",
  "microbiology.admin.astPanels.add": "添加 AST 面板",
  "microbiology.admin.astPanels.antibiotic": "抗生素",
  "microbiology.admin.astPanels.behavior.always": "永远",
  "microbiology.admin.astPanels.behavior.cascade": "级联",
  "microbiology.admin.astPanels.behavior.resistant": "只有在具有抗性时",
  "microbiology.admin.astPanels.current": "当前",
  "microbiology.admin.astPanels.confirmDeactivate": "将版本{version}标记为“不适用于新作品”？现有AST运行将保留其原始面板版本。",
  "microbiology.admin.astPanels.confirmPublish": "发布版本 {version}？现有的 AST 运行将保留其原始面板版本。",
  "microbiology.admin.astPanels.confirmTitle": "确认专题文章的发布",
  "microbiology.admin.astPanels.historical": "历史",
  "microbiology.admin.astPanels.loadingEditor": "正在加载 AST 面板管理界面。",
  "microbiology.admin.astPanels.publishVersion": "发布新版本",
  "microbiology.admin.astPanels.readOnly": "此历史版本为只读版本。请打开当前版本以发布更改。",
  "microbiology.admin.astPanels.reportBehavior": "报告行为",
  "microbiology.admin.astPanels.tier": "层级",
  "microbiology.admin.astPanels.title": "AST面板",
  "microbiology.admin.astPanels.version": "版本",
  "microbiology.admin.astPanels.versionNotice": "保存操作会创建一个新的面板版本；现有的 AST 运行将保留其原始版本。",
  "microbiology.admin.astPanels.viewVersion": "查看版本",
  "microbiology.admin.breakpoints.activate": "激活标准",
  "microbiology.admin.breakpoints.applyValid": "应用有效的行",
  "microbiology.admin.breakpoints.archive": "归档标准",
  "microbiology.admin.breakpoints.archiveConfirm": "该标准仍可用于历史上的AST运行，但不能用于新项目。",
  "microbiology.admin.breakpoints.back": "返回标准",
  "microbiology.admin.breakpoints.breakpointType": "断点类型",
  "microbiology.admin.breakpoints.chooseFile": "选择CSV文件",
  "microbiology.admin.breakpoints.correction.add": "添加局部校正",
  "microbiology.admin.breakpoints.correction.edit": "编辑局部修正",
  "microbiology.admin.breakpoints.count.imported": "{count} 进口的",
  "microbiology.admin.breakpoints.count.skipped": "{count} 跳过",
  "microbiology.admin.breakpoints.count.unchanged": "{count} 未作更改",
  "microbiology.admin.breakpoints.count.valid": "{count} 有效",
  "microbiology.admin.breakpoints.csv": "断点 CSV",
  "microbiology.admin.breakpoints.description": "已加载的断点标准以及新AST运行所采用的版本。",
  "microbiology.admin.breakpoints.detail": "断点规则",
  "microbiology.admin.breakpoints.downloadRejected": "下载被拒收的行",
  "microbiology.admin.breakpoints.effectiveDate": "生效日期",
  "microbiology.admin.breakpoints.import": "导入CSV",
  "microbiology.admin.breakpoints.intermediate": "中级",
  "microbiology.admin.breakpoints.intermediateLower": "中下级",
  "microbiology.admin.breakpoints.intermediateUpper": "中高阶",
  "microbiology.admin.breakpoints.groupOption": "群组：{name}",
  "microbiology.admin.breakpoints.method.all": "所有方法",
  "microbiology.admin.breakpoints.method.zone": "区域",
  "microbiology.admin.breakpoints.organism": "生物体或群体",
  "microbiology.admin.breakpoints.organismGroup": "生物类群",
  "microbiology.admin.breakpoints.publisher": "出版商",
  "microbiology.admin.breakpoints.resistant": "耐受性",
  "microbiology.admin.breakpoints.rowError": "第{row}行",
  "microbiology.admin.breakpoints.rules": "规则",
  "microbiology.admin.breakpoints.source": "来源",
  "microbiology.admin.breakpoints.source.imported": "进口的",
  "microbiology.admin.breakpoints.source.local": "局部修正",
  "microbiology.admin.breakpoints.source.manual": "手册",
  "microbiology.admin.breakpoints.specimen": "标本上下文",
  "microbiology.admin.breakpoints.specimen.any": "任何标本",
  "microbiology.admin.breakpoints.status.active": "活跃",
  "microbiology.admin.breakpoints.status.archived": "归档",
  "microbiology.admin.breakpoints.status.loaded": "已加载",
  "microbiology.admin.breakpoints.susceptible": "易感",
  "microbiology.admin.breakpoints.title": "断点标准",
  "microbiology.admin.breakpoints.units": "单位",
  "microbiology.admin.breakpoints.view": "查看规则",
  "microbiology.admin.filter.all": "所有分析仪",
  "microbiology.admin.sort": "排序",
  "microbiology.admin.sort.nameAsc": "名称（A-Z）",
  "microbiology.admin.sort.nameDesc": "名称 Z-A",
  "microbiology.admin.cultureSetups.add": "添加培养设置",
  "microbiology.admin.cultureSetups.description": "与现有实验室方法相关的培养默认值。",
  "microbiology.admin.cultureSetups.edit": "培养基配制",
  "microbiology.admin.cultureSetups.title": "培养方法",
  "microbiology.admin.deactivate.impact": "{name} is used by {count, plural, one {# existing workflow record} other {# existing workflow records}}. Deactivation prevents new selection but preserves those historical references.",
  "microbiology.admin.deactivate.title": "审查停用影响",
  "microbiology.admin.deactivated": "引用已停用",
  "microbiology.admin.empty": "没有匹配的参考记录",
  "microbiology.admin.error.save": "无法保存该参考记录。",
  "microbiology.admin.error.title": "无法完成请求",
  "microbiology.admin.field.active": "可用以承接新项目",
  "microbiology.admin.field.atmosphere": "“Atmosphere”的默认值",
  "microbiology.admin.field.class": "班级",
  "microbiology.admin.field.code": "位置代码",
  "microbiology.admin.field.defaultPanel": "默认 AST 面板",
  "microbiology.admin.field.defaultPanelId": "默认值 AST 面板 ID",
  "microbiology.admin.field.gramStain": "革兰氏染色",
  "microbiology.admin.field.group": "生物类群",
  "microbiology.admin.field.incubation": "孵化默认值",
  "microbiology.admin.field.incubationHours": "常规读数间隔（小时）",
  "microbiology.admin.field.subcultureAtHours": "亚文化（时间）",
  "microbiology.admin.field.maxIncubationDays": "最长孵化期（天）",
  "microbiology.admin.field.media": "媒体默认值",
  "microbiology.admin.field.method": "方法",
  "microbiology.admin.field.methodId": "方法 ID",
  "microbiology.admin.field.name": "名称",
  "microbiology.admin.field.notes": "备注",
  "microbiology.admin.field.oclCode": "OCL代码",
  "microbiology.admin.field.reportableAnalyteId": "应报告的分析物ID",
  "microbiology.admin.field.route": "路线",
  "microbiology.admin.field.shortName": "简称",
  "microbiology.admin.field.significance": "最初的意义",
  "microbiology.admin.field.whonetCode": "WHONET 位置代码",
  "microbiology.admin.field.workflow": "工作流",
  "microbiology.admin.organisms.add": "添加生物体",
  "microbiology.admin.organisms.description": "菌种鉴定和抗菌谱试验（AST）中使用的生物体术语。",
  "microbiology.admin.organisms.edit": "生物体",
  "microbiology.admin.organisms.title": "生物体",
  "microbiology.admin.patientOrigins.description": "在微生物学检查单录入和WHONET导出过程中使用的已配置患者来源选项。",
  "microbiology.admin.patientOrigins.title": "患者来源",
  "microbiology.admin.reactivated": "引用已重新激活",
  "microbiology.admin.route.both": "口服和静脉注射",
  "microbiology.admin.route.iv": "IV",
  "microbiology.admin.route.oral": "口服",
  "microbiology.admin.route.topical": "时事",
  "microbiology.admin.saved": "参考资料已保存",
  "microbiology.admin.search": "搜索参考数据",
  "microbiology.admin.sections": "微生物学参考章节",
  "microbiology.admin.significance.possible": "可能的病原体",
  "microbiology.admin.significance.rare": "罕见病原体",
  "microbiology.admin.significance.usually": "通常是显著的",
  "microbiology.admin.status": "状态",
  "microbiology.admin.status.active": "活跃",
  "microbiology.admin.status.all": "所有状态",
  "microbiology.admin.status.inactive": "非活跃",
  "microbiology.admin.title": "微生物学参考数据",
  "microbiology.admin.workflow.all": "所有工作流",
  "microbiology.workflow.bacteriology": "细菌学",
  "microbiology.workflow.mycobacteriology": "分枝杆菌学",
  "microbiology.workflow.mycology": "真菌学",
  "microbiology.workflow.parasitology": "寄生虫学",
  "button.add": "添加",
  "button.remove": "移除",
  "sidenav.label.microbiology": "微生物学",
  "sidenav.label.microbiology.worklist": "微生物学工作清单",
  "sidenav.label.microbiology.whonet": "WHONET 导出",
  "microbiology.whonet.title": "WHONET 导出",
  "microbiology.whonet.eyebrow": "常规细菌学监测",
  "microbiology.whonet.subtitle": "在生成用于 WHONET 验证的当前 OpenELIS 监测 CSV 文件之前，请审核已最终确定的培养和抗菌药物敏感性试验（AST）数据。",
  "microbiology.whonet.progress": "WHONET 导出进度",
  "microbiology.whonet.step.configure": "配置",
  "microbiology.whonet.step.preview": "预览",
  "microbiology.whonet.step.generate": "生成",
  "microbiology.whonet.configure.title": "配置导出",
  "microbiology.whonet.configure.description": "选择报告期间及要纳入的菌株。",
  "microbiology.whonet.from": "来源",
  "microbiology.whonet.to": "致",
  "microbiology.whonet.date.placeholder": "yyyy-mm-dd",
  "microbiology.whonet.period.invalid": "结束日期必须在开始日期之后或与之相同。",
  "microbiology.whonet.period.preset": "报告期",
  "microbiology.whonet.period.thisMonth": "本月",
  "microbiology.whonet.period.lastMonth": "上月",
  "microbiology.whonet.period.thisQuarter": "本季度",
  "microbiology.whonet.period.custom": "自定义",
  "microbiology.whonet.source.worklist.title": "AST工作列表提供的范围",
  "microbiology.whonet.source.worklist.description": "报告期间和结构化监测过滤器来源于AST工作列表。在此处仍可对其进行编辑。",
  "microbiology.whonet.source.worklist.clear": "清除工作列表范围",
  "microbiology.whonet.significance": "包容性",
  "microbiology.whonet.significance.clinical": "具有临床意义的分离株",
  "microbiology.whonet.significance.all": "所有分离株",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "具有临床意义",
  "microbiology.whonet.significance.CONTAMINANT": "污染物",
  "microbiology.whonet.significance.NORMAL_FLORA": "正常菌群",
  "microbiology.whonet.significance.UNKNOWN": "未分类",
  "microbiology.whonet.culturePurpose.description": "临床培养样本默认包含在内。当监测问题有此要求时，请明确添加其他人群。",
  "microbiology.whonet.culturePurpose.includeScreening": "包括主动筛查或携带者培养",
  "microbiology.whonet.culturePurpose.includeUnspecified": "包含目的未明的历史文化",
  "microbiology.whonet.culturePurpose.title": "文化宗旨",
  "microbiology.whonet.filter.specimen": "标本类型",
  "microbiology.whonet.filter.organism": "生物体",
  "microbiology.whonet.filter.origin": "患者来源",
  "microbiology.whonet.filter.any": "任何",
  "microbiology.whonet.filter.choose": "选择值",
  "microbiology.whonet.dedup": "去重",
  "microbiology.whonet.dedup.apply": "应用“先隔离后筛选”原则",
  "microbiology.whonet.dedup.apply.help": "在所选时间范围内，合并同一患者和同一生物体的重复分离株。",
  "microbiology.whonet.dedup.advanced": "调整“先隔离”政策",
  "microbiology.whonet.dedup.window": "窗口长度",
  "microbiology.whonet.dedup.window.help": "在已选择日期的精确分界处出现重复时，将打开一个新窗口。",
  "microbiology.whonet.dedup.sevenDay": "7天",
  "microbiology.whonet.dedup.fourteenDay": "14天",
  "microbiology.whonet.dedup.thirtyDay": "30天",
  "microbiology.whonet.dedup.basis": "窗口日期",
  "microbiology.whonet.dedup.basis.collection": "标本采集日期",
  "microbiology.whonet.dedup.basis.release": "最终结果公布日期",
  "microbiology.whonet.dedup.basis.help": "请选择该时间段是基于样本采集时间还是最终结果发布时间。报告周期始终以采集日期为准。",
  "microbiology.whonet.dedup.scope": "标本来源范围",
  "microbiology.whonet.dedup.scope.any": "任何标本来源",
  "microbiology.whonet.dedup.scope.same": "仅限同一标本来源",
  "microbiology.whonet.dedup.scope.help": "任何来源都会在不同标本类型之间对患者和生物体进行比较；同一来源则在每种标本类型内部进行比较。",
  "microbiology.whonet.dedup.contaminants": "在选择前排除可能的污染物",
  "microbiology.whonet.dedup.contaminants.help": "在选择第一个具有代表性的分离株之前，应移除可能的污染物。",
  "microbiology.whonet.dedup.profile": "易感性特征",
  "microbiology.whonet.dedup.profile.insensitive": "忽略已更改的S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "将已更改的S/I/R视为新的",
  "microbiology.whonet.dedup.profile.help": "“基于谱型的选择”会将窗口内不同审查结果的抗生素敏感性/耐药性（S/I/R）模式视为新的分离株。",
  "microbiology.whonet.dedup.none": "否进行去重",
  "microbiology.whonet.preview.action": "导出预览",
  "microbiology.whonet.preview.title": "预览",
  "microbiology.whonet.preview.description": "生成 CSV 文件时将使用这些数量和行。",
  "microbiology.whonet.generate.action": "生成 CSV",
  "microbiology.whonet.count.cases": "最终确定案件",
  "microbiology.whonet.count.clinicalPurpose": "临床培养",
  "microbiology.whonet.count.screeningPurpose": "筛选培养物",
  "microbiology.whonet.count.unspecifiedPurpose": "未指明的培养物",
  "microbiology.whonet.count.purposeIncluded": "培养目的确定后",
  "microbiology.whonet.count.isolates": "发现的分离株",
  "microbiology.whonet.count.specimen": "标本过滤器后",
  "microbiology.whonet.count.organism": "生物过滤后",
  "microbiology.whonet.count.origin": "来源过滤器后",
  "microbiology.whonet.count.included": "分离株包括",
  "microbiology.whonet.count.deduplicated": "去重后",
  "microbiology.whonet.count.mappable": "可图谱化的分离株",
  "microbiology.whonet.count.rows": "符合条件的行",
  "microbiology.whonet.count.excluded": "已排除的行",
  "microbiology.whonet.mapping.title": "绘图准备情况",
  "microbiology.whonet.mapping.excluded": "{count, plural, one {# row excluded} other {# rows excluded}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "修复生物体映射",
  "microbiology.whonet.mapping.fixAntibiotic": "修复抗生素映射",
  "microbiology.whonet.mapping.fixSpecimen": "修复标本映射",
  "microbiology.whonet.table.title": "符合条件的 AST 行",
  "microbiology.whonet.table.description": "已审核、需报告的AST读数，并包含此导出所需的映射关系。",
  "microbiology.whonet.table.accession": "实验室编号",
  "microbiology.whonet.table.specimen": "标本",
  "microbiology.whonet.table.organism": "生物体",
  "microbiology.whonet.table.antibiotic": "抗生素",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "方法",
  "microbiology.whonet.error.title": "无法完成 WHONET 导出",
  "microbiology.whonet.error.invalidRequest": "请检查报告期间和导出选项，然后重试。",
  "microbiology.whonet.error.blocked": "已无有效行。在生成 CSV 文件之前，请先解决列出的就绪问题。",
  "microbiology.whonet.error.network": "无法访问该导出服务。请在连接可用后重试。",
  "microbiology.whonet.error.generic": "无法完成导出请求。",
  "microbiology.whonet.preview.loading": "正在准备导出预览。",
  "microbiology.whonet.preview.announced": "Preview ready with {count, plural, one {# eligible row} other {# eligible rows}}.",
  "microbiology.whonet.generated.title": "已生成CSV文件",
  "microbiology.whonet.generated.subtitle": "已审核的导出文件已下载，并记录了其审核摘要。",
  "catalog.import.title": "Import Catalog (CSV)",
  "catalog.import.description": "Load test catalog files without editing tests one at a time. Preview checks each file against the catalog as it stands and keeps nothing, so a row that needs a lab unit, specimen or test another file in the same upload creates is listed as skipped until you apply. Apply loads the files in order and saves them with the configuration, so the next restart loads exactly what you applied.",
  "catalog.import.dropzone": "Add CSV files",
  "catalog.import.preview": "预览",
  "catalog.import.apply": "应用",
  "catalog.import.remove": "移除",
  "catalog.import.plan.title": "What these files would do",
  "catalog.import.result.title": "What was loaded",
  "catalog.import.column.file": "File",
  "catalog.import.column.domain": "Catalog area",
  "catalog.import.column.created": "创建时间",
  "catalog.import.column.updated": "更新",
  "catalog.import.column.skipped": "Skipped",
  "catalog.import.column.name": "Name in the file",
  "catalog.import.column.where": "Where it appeared",
  "catalog.import.column.use": "Use this record",
  "catalog.import.file.error": "This file could not be read",
  "catalog.import.applied": "The catalog files were applied.",
  "catalog.import.applied.partial": "Some catalog files were not loaded. The table says which, and why.",
  "catalog.import.apply.failed": "The catalog files were not applied.",
  "catalog.import.apply.hint": "Preview the files first. Apply opens once the preview shows no file errors.",
  "catalog.import.failed": "The catalog files could not be sent.",
  "catalog.import.unresolved.title": "Needs your decision",
  "catalog.import.unresolved.description": "Names the import could not match to a record. Point each one at the record it means, or skip it. Remembering a name resolves it by itself next time.",
  "catalog.import.unresolved.empty": "Nothing is waiting for a decision.",
  "catalog.import.remember": "Remember this name",
  "catalog.import.resolve": "Use",
  "catalog.import.skip": "跳过",
  "sidenav.label.admin.catalogImport": "Import Catalog (CSV)",
  "reporting.design.subtitle": "Create a CSV for a new question or rerun a familiar report for a new period.",
  "reporting.design.overview": "Export overview",
  "reporting.design.newTitle": "Create a new export",
  "reporting.design.newHelp": "Choose the kind of report, the fields you need, and a reporting period. Your work remains available if you visit the queue or return later.",
  "reporting.design.savedTitle": "Use a saved report",
  "reporting.design.savedHelp": "Reuse saved fields and filters, then choose a fresh reporting period.",
  "reporting.design.start": "Start a new export",
  "reporting.design.continue": "Continue current export",
  "reporting.design.newExport": "New export",
  "reporting.design.useReport": "Use report",
  "reporting.design.savedFields": "{count} saved fields · reporting period is never saved",
  "reporting.design.steps": "Export steps",
  "reporting.design.chooseColumns": "Choose columns",
  "reporting.design.setFilters": "Set Filters",
  "reporting.design.reviewSubmit": "Review & Submit",
  "reporting.design.typeQuestion": "What kind of information do you need?",
  "reporting.design.typeHelp": "Choose one report type so every CSV row has a clear meaning. You can change the type until you select fields.",
  "reporting.design.type.SAMPLE_TESTING": "Sample & Testing",
  "reporting.design.type.REFERRALS": "转诊",
  "reporting.design.type.NON_CONFORMANCE": "Non-Conformance",
  "reporting.design.typeHelp.SAMPLE_TESTING": "Orders, results, patients & turnaround times",
  "reporting.design.typeHelp.REFERRALS": "Tests referred to other labs · preserves returned results and pending referrals",
  "reporting.design.typeHelp.NON_CONFORMANCE": "Rejected samples & non-conforming events · preserves linked specimens and separate occurrences",
  "reporting.design.pending": "Not yet connected",
  "reporting.design.building": "You’re building a {type} report.",
  "reporting.design.changeType": "Change type and clear fields",
  "reporting.design.chooseType": "Choose a report type to see its fields.",
  "reporting.design.configuredReports": "Configured reports",
  "reporting.design.chooseConfigured": "Choose a configured report",
  "reporting.design.available": "Available fields",
  "reporting.design.findField": "Find a field",
  "reporting.design.searchPlaceholder": "Search all fields and groups…",
  "reporting.design.clearSearch": "Clear search",
  "reporting.design.fieldCount": "{count} fields across {groups} groups",
  "reporting.design.matchCount": "{count} matching fields across {groups} groups",
  "reporting.design.expansion": "Expand or collapse field groups",
  "reporting.design.expandAll": "Expand all",
  "reporting.design.collapseAll": "Collapse all",
  "reporting.design.groupCount": "{added} / {total} added",
  "reporting.design.scrollCatalog": "Scrollable field catalog",
  "reporting.design.addShown": "Add all shown",
  "reporting.design.removeShown": "Remove shown",
  "reporting.design.addShownGroup": "Add all shown {group} fields",
  "reporting.design.removeShownGroup": "Remove all shown {group} fields",
  "reporting.design.addField": "Add {field}",
  "reporting.design.addedField": "Added {field}",
  "reporting.design.add": "+ Add",
  "reporting.design.added": "Added",
  "reporting.design.noFields": "No fields match your search.",
  "reporting.design.selectedCount": "Your CSV columns ({count})",
  "reporting.design.orderHelp": "Drag a handle to change column order, or use the arrows. Arrow keys move the focused handle; Home and End move it to the first or last position.",
  "reporting.design.columnOrder": "CSV columns in order",
  "reporting.design.drag": "Drag {field} to reorder",
  "reporting.design.move": "Move {field}",
  "reporting.design.emptyColumns": "Add fields to build your CSV.",
  "reporting.design.addedMessage": "{field} added. {count} columns.",
  "reporting.design.removedMessage": "{field} removed. {count} columns.",
  "reporting.design.columnViews": "Column builder views",
  "reporting.design.yourColumns": "Your columns ({count})",
  "reporting.design.csvPreview": "CSV preview",
  "reporting.design.previewHelp": "Column layout in the order it will appear in your downloaded CSV.",
  "reporting.design.scrollPreview": "Scrollable CSV preview",
  "reporting.design.nextFilters": "Next: Set Filters",
  "reporting.design.nextReview": "Next: Review & Submit",
  "reporting.design.scopeFilters": "Scope Filters (Optional)",
  "reporting.design.periodDays": "{count, plural, one {# day} other {# days}}",
  "reporting.design.moreFilters": "Show more filters",
  "reporting.design.hideFilters": "Hide more filters",
  "reporting.design.sampleStatus": "Sample Status",
  "reporting.design.referringSite": "Referring Site",
  "reporting.design.reviewConfiguration": "Review Configuration",
  "reporting.design.dateFilters": "Date Range and filters",
  "reporting.design.testStatus": "Test and status",
  "reporting.design.change": "更改",
  "reporting.design.deliveryHelp": "Your CSV will be generated in the background. Download it here when ready, or return to My Report Queue.",
  "reporting.design.fileName": "文件名称",
  "reporting.design.customFileName": "Custom file name",
  "reporting.design.fileNamePending": "A file name is generated automatically. Custom names are not yet connected.",
  "reporting.design.saveLater": "Save these report settings for later",
  "reporting.design.saveSettings": "Save report settings",
  "reporting.design.queueHelp": "View and download your queued CSV exports.",
  "reporting.design.queue.jobName": "Job Name",
  "reporting.design.queue.report": "报告",
  "reporting.design.queue.size": "Rows / File Size",
  "reporting.design.queue.submitted": "Submitted At",
  "reporting.design.queuePending": "Active jobs refresh automatically. Retry failed exports, cancel queued work or rerun expired reports with fresh dates. Job deletion is not yet connected.",
  "reporting.design.details": "详情",
  "reporting.design.expires": "Available until {date}",
  "reporting.design.jobsShown": "Showing {count} jobs",
  "reporting.design.jobAction.EXPIRED": "Re-run",
  "reporting.design.labScope": "Lab Scope",
  "reporting.design.reviewFields": "Selected Fields ({count})",
  "reporting.recovery.cancelTitle": "Cancel export",
  "reporting.recovery.keepQueued": "Keep queued",
  "reporting.recovery.cancelHelp": "Cancel this queued export? If processing has already started, it will continue and you can return to its result.",
  "reporting.job.cannotCancel": "This export has already started or finished and cannot be cancelled.",
  "reporting.job.cannotRetry": "Only a failed export can be retried. Use the current job or start a new export.",
  "reporting.job.interrupted": "Processing was interrupted. Retry this export to generate a new file.",
  "reporting.job.claimLost": "This export is no longer assigned to the current worker. Return to the queue for its status.",
  "sidenav.section.main": "Main Menu",
  "sidenav.section.patientOrders": "Patient & Orders",
  "sidenav.section.administration": "管理",
  "sidenav.workflow.orderTest": "Order Test",
  "sidenav.workflow.resultsValidation": "Results Validation",
  "sidenav.workflow.patientManagement": "Patient Management",
  "sidenav.moreTools": "More tools",
  "reporting.menu.otherReports": "Other reports",
  "reporting.menu.patientPrintQueue": "Patient Report Print Queue",
  "common.icon": "Icon",
  "menu.presentation.style": "Display as",
  "menu.presentation.item": "Menu item",
  "menu.presentation.section": "Section heading",
  "menu.configuration.managed": "Managed by instance configuration",
  "menu.configuration.description": "Update menu visibility, section headings and icons. Settings managed by this instance are read-only here.",
  "menu.configuration.loadError": "Menu settings could not be loaded.",
  "menu.configuration.saved": "Menu settings saved.",
  "menu.presentation.sectionHint": "Section headings group their child menu items without a link.",
  "menu.presentation.sectionIconHint": "Icons are shown on menu items, not section headings."
}
